var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareCoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.38 242.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3781c3;}.cls-2{fill:#6f9ad1;}.cls-3{fill:#2e8ece;}.cls-4{fill:#445fa9;}.cls-5{fill:#4263ad;}.cls-6{fill:#455aa5;}.cls-7{fill:#48509e;}.cls-8{fill:#3d70b6;}.cls-9{fill:#494e9d;}.cls-10{fill:#4657a3;}.cls-11{fill:#4068b1;}.cls-12{fill:#3f6bb3;}.cls-13{fill:#3681c3;}.cls-14{fill:#308bcb;}.cls-15{fill:#3287c8;}.cls-16{fill:#3c75ba;}.cls-17{fill:#3a77bc;}.cls-18{fill:#3385c7;}.cls-19{fill:#4754a1;}.cls-20{fill:#3386c7;}.cls-21{fill:#387bbf;}.cls-22{fill:#377ec1;}.cls-23{fill:#484f9e;}.cls-24{fill:#318acb;}.cls-25{fill:#3a7abe;}.cls-26{fill:#3c74ba;}.cls-27{fill:#3f6db5;}.cls-28{fill:#3e71b7;}.cls-29{fill:#4463ad;}.cls-30{fill:#446bb2;}.cls-31{fill:#4955a1;}.cls-32{fill:#6ca0d6;}.cls-33{fill:#67a0d6;}.cls-34{fill:#4293d0;}.cls-35{fill:#719ad1;}.cls-36{fill:#647bbc;}.cls-37{fill:#4194d1;}.cls-38{fill:#6596cf;}.cls-39{fill:#6797d0;}.cls-40{fill:#5294d0;}.cls-41{fill:#505aa5;}.cls-42{fill:#5997d1;}.cls-43{fill:#6078ba;}.cls-44{fill:#5e84c3;}.cls-45{fill:#5661aa;}.cls-46{fill:#5a9dd5;}.cls-47{fill:#5e97d1;}.cls-48{fill:#5d9ed6;}.cls-49{fill:#4997d2;}.cls-50{fill:#4a96d2;}.cls-51{fill:#5c9cd5;}.cls-52{fill:#6687c4;}.cls-53{fill:#4b73b8;}.cls-54{fill:#4379bd;}.cls-55{fill:#5b9dd5;}.cls-56{fill:#5763ab;}.cls-57{fill:#8182be;}.cls-58{fill:#689dd4;}.cls-59{fill:#556bb1;}.cls-60{fill:#6187c5;}.cls-61{fill:#488bc9;}.cls-62{fill:#636bb0;}.cls-63{fill:#4870b6;}.cls-64{fill:#7496ce;}.cls-65{fill:#649dd4;}.cls-66{fill:#727aba;}.cls-67{fill:#7591ca;}.cls-68{fill:#667fbe;}.cls-69{fill:#5873b7;}.cls-70{fill:#656db2;}.cls-71{fill:#6f90ca;}.cls-72{fill:#546bb1;}.cls-73{fill:#416ab2;}.cls-74{fill:#649ad3;}.cls-75{fill:#494798;}.cls-76{fill:#4a4496;}.cls-77{fill:#494b9a;}.cls-78{fill:#484f9d;}.cls-79{fill:#47529f;}.cls-80{fill:#494b9b;}.cls-81{fill:#387dc0;}.cls-82{fill:#3d73b9;}.cls-83{fill:#397abe;}.cls-84{fill:#348bcb;}.cls-85{fill:#5983c3;}.cls-86{fill:#6693cd;}.cls-87{fill:#6d9dd4;}.cls-88{fill:#51509e;}.cls-89{fill:#6c86c3;}.cls-90{fill:#71a2d7;}.cls-91{fill:#6d9ed4;}.cls-92{fill:#7090ca;}.cls-93{fill:#6376b8;}.cls-94{fill:#7297cf;}.cls-95{fill:#7191ca;}.cls-96{fill:#6995ce;}.cls-97{fill:#4795d1;}.cls-98{fill:#51519f;}.cls-99{fill:#6f8bc6;}.cls-100{fill:#6389c6;}.cls-101{fill:#69a0d7;}.cls-102{fill:#6a8dc8;}.cls-103{fill:#3d91cf;}.cls-104{fill:#6a93cd;}.cls-105{fill:#6f9ed4;}.cls-106{fill:#6698d1;}.cls-107{fill:#639fd6;}.cls-108{fill:#6b8bc7;}.cls-109{fill:#6d94cd;}.cls-110{fill:#3f86c7;}.cls-111{fill:#4f7cbf;}.cls-112{fill:#397cc0;}.cls-113{fill:#6194ce;}.cls-114{fill:#709ed4;}.cls-115{fill:#6d88c4;}.cls-116{fill:#6ea1d6;}.cls-117{fill:#70a4d9;}.cls-118{fill:#70a5d9;}.cls-119{fill:#6c9fd5;}.cls-120{fill:#539ad4;}.cls-121{fill:#679fd6;}.cls-122{fill:#7099d0;}.cls-123{fill:#6ea4d9;}.cls-124{fill:#70a4d8;}.cls-125{fill:#549ad3;}.cls-126{fill:#6ea0d6;}.cls-127{fill:#585ea8;}.cls-128{fill:#6ca2d7;}.cls-129{fill:#6b9fd5;}.cls-130{fill:#5f98d1;}.cls-131{fill:#3a84c5;}.cls-132{fill:#6298d1;}.cls-133{fill:#6d96cf;}.cls-134{fill:#6989c6;}.cls-135{fill:#698ec9;}.cls-136{fill:#6294ce;}.cls-137{fill:#6da0d6;}.cls-138{fill:#6b96cf;}.cls-139{fill:#68a2d8;}.cls-140{fill:#6c9ad1;}.cls-141{fill:#70a6da;}.cls-142{fill:#6ca3d8;}.cls-143{fill:#5c95d0;}.cls-144{fill:#3d81c3;}.cls-145{fill:#6aa0d6;}.cls-146{fill:#6c95ce;}.cls-147{fill:#5f9bd3;}.cls-148{fill:#6f9cd3;}.cls-149{fill:#7080bf;}.cls-150{fill:#6a8ec9;}.cls-151{fill:#4277bc;}.cls-152{fill:#505fa8;}.cls-153{fill:#6da2d7;}.cls-154{fill:#6e9fd5;}.cls-155{fill:#69a3d8;}.cls-156{fill:#5c90cc;}.cls-157{fill:#507ec0;}.cls-158{fill:#6da1d7;}.cls-159{fill:#649dd5;}.cls-160{fill:#4d78bb;}.cls-161{fill:#4672b8;}.cls-162{fill:#3f75ba;}.cls-163{fill:#688fca;}.cls-164{fill:#6ea2d7;}.cls-165{fill:#556fb4;}.cls-166{fill:#7199d0;}.cls-167{fill:#649fd6;}.cls-168{fill:#5685c4;}.cls-169{fill:#659ed5;}.cls-170{fill:#6199d2;}.cls-171{fill:#69a3d9;}.cls-172{fill:#5c6fb4;}.cls-173{fill:#7393cb;}.cls-174{fill:#668ec9;}.cls-175{fill:#3e77bb;}.cls-176{fill:#5099d4;}.cls-177{fill:#5f9cd5;}.cls-178{fill:#71a7da;}.cls-179{fill:#7091cb;}.cls-180{fill:#66a0d6;}.cls-181{fill:#5c76b9;}.cls-182{fill:#7594cc;}.cls-183{fill:#6585c3;}.cls-184{fill:#62a0d7;}.cls-185{fill:#569bd5;}.cls-186{fill:#6a91cb;}.cls-187{fill:#7089c5;}.cls-188{fill:#6da3d8;}.cls-189{fill:#6b84c1;}.cls-190{fill:#67a3d8;}.cls-191{fill:#687dbd;}.cls-192{fill:#6da5d9;}.cls-193{fill:#6aa2d8;}.cls-194{fill:#6e92cc;}.cls-195{fill:#6f99d1;}.cls-196{fill:#6280c0;}.cls-197{fill:#6ea6da;}.cls-198{fill:#63a1d8;}.cls-199{fill:#69a1d7;}.cls-200{fill:#686db1;}.cls-201{fill:#597bbd;}.cls-202{fill:#6ea3d8;}.cls-203{fill:#6fa6da;}.cls-204{fill:#68a3d8;}.cls-205{fill:#709cd3;}.cls-206{fill:#6e90ca;}.cls-207{fill:#5f94cf;}.cls-208{fill:#6579ba;}.cls-209{fill:#6d8bc7;}.cls-210{fill:#486fb5;}.cls-211{fill:#477fc1;}.cls-212{fill:#4c78bb;}.cls-213{fill:#5e94cf;}.cls-214{fill:#6993cd;}.cls-215{fill:#6477b9;}.cls-216{fill:#5e87c5;}.cls-217{fill:#718cc7;}.cls-218{fill:#6595ce;}.cls-219{fill:#6989c5;}.cls-220{fill:#6f8dc8;}.cls-221{fill:#6e7cbb;}.cls-222{fill:#697fbe;}.cls-223{fill:#6c84c1;}.cls-224{fill:#6b7ebd;}.cls-225{fill:#4568b0;}.cls-226{fill:#4956a3;}.cls-227{fill:#4660aa;}.cls-228{fill:#6a99d1;}.cls-229{fill:#5572b6;}.cls-230{fill:#6c8cc7;}.cls-231{fill:#6b93cc;}.cls-232{fill:#6b7bbb;}.cls-233{fill:#697cbc;}.cls-234{fill:#6b72b5;}.cls-235{fill:#6c7fbe;}.cls-236{fill:#6e8dc8;}.cls-237{fill:#3584c6;}.cls-238{fill:#456bb2;}.cls-239{fill:#3a7cbf;}.cls-240{fill:#7294cc;}.cls-241{fill:#4857a3;}.cls-242{fill:#699ed5;}.cls-243{fill:#7192cb;}.cls-244{fill:#6e95cd;}.cls-245{fill:#6c87c4;}.cls-246{fill:#6e78b9;}.cls-247{fill:#5155a1;}.cls-248{fill:#3490ce;}.cls-249{fill:#6da0d5;}.cls-250{fill:#6e7bbb;}.cls-251{fill:#6f7fbe;}.cls-252{fill:#6a9ad2;}.cls-253{fill:#6e8ac6;}.cls-254{fill:#6c8dc8;}.cls-255{fill:#4c54a1;}.cls-256{fill:#475ca7;}.cls-257{fill:#6d87c3;}.cls-258{fill:#6b90ca;}.cls-259{fill:#71a0d6;}.cls-260{fill:#6684c2;}.cls-261{fill:#5064ac;}.cls-262{fill:#6b98d0;}.cls-263{fill:#7193cc;}.cls-264{fill:#5390cd;}.cls-265{fill:#378fce;}.cls-266{fill:#719dd3;}.cls-267{fill:#6293cd;}.cls-268{fill:#709ad1;}.cls-269{fill:#5f64ac;}.cls-270{fill:#6a82c0;}.cls-271{fill:#7396ce;}.cls-272{fill:#6775b7;}.cls-273{fill:#6f7fbd;}.cls-274{fill:#6b8cc7;}.cls-275{fill:#5067af;}.cls-276{fill:#5979bb;}.cls-277{fill:#466fb6;}.cls-278{fill:#6e95ce;}.cls-279{fill:#6990ca;}.cls-280{fill:#928bc2;}.cls-281{fill:#6977b9;}.cls-282{fill:#6b95ce;}.cls-283{fill:#6696cf;}.cls-284{fill:#7283c0;}.cls-285{fill:#6498d1;}.cls-286{fill:#738dc7;}.cls-287{fill:#7379b9;}.cls-288{fill:#4b4e9c;}.cls-289{fill:#6c84c2;}.cls-290{fill:#7195cd;}.cls-291{fill:#6d83c1;}.cls-292{fill:#6696d0;}.cls-293{fill:#6c89c5;}.cls-294{fill:#4e54a1;}.cls-295{fill:#6b9cd3;}.cls-296{fill:#6672b5;}.cls-297{fill:#6a8bc7;}.cls-298{fill:#6d68ae;}.cls-299{fill:#697bbb;}.cls-300{fill:#6c83c1;}.cls-301{fill:#6d81bf;}.cls-302{fill:#666cb1;}.cls-303{fill:#348dcd;}.cls-304{fill:#6d95ce;}.cls-305{fill:#72a1d6;}.cls-306{fill:#6f9dd3;}.cls-307{fill:#6491cc;}.cls-308{fill:#709fd5;}.cls-309{fill:#667bbc;}.cls-310{fill:#6e96cf;}.cls-311{fill:#487dc0;}.cls-312{fill:#6464ab;}.cls-313{fill:#4766af;}.cls-314{fill:#6d7fbe;}.cls-315{fill:#6aa4d9;}.cls-316{fill:#6fa1d7;}.cls-317{fill:#4769b1;}.cls-318{fill:#4760aa;}.cls-319{fill:#4679bc;}.cls-320{fill:#688cc8;}.cls-321{fill:#3786c7;}.cls-322{fill:#5e8fcb;}.cls-323{fill:#4b6db4;}.cls-324{fill:#827fbc;}.cls-325{fill:#6974b6;}.cls-326{fill:#6f84c1;}.cls-327{fill:#6d69ae;}.cls-328{fill:#7086c3;}.cls-329{fill:#7087c4;}.cls-330{fill:#6c6baf;}.cls-331{fill:#6b67ad;}.cls-332{fill:#6f82c0;}.cls-333{fill:#6f79ba;}.cls-334{fill:#318fce;}.cls-335{fill:#3e73b9;}.cls-336{fill:#5099d3;}.cls-337{fill:#387ec1;}.cls-338{fill:#6b90cb;}.cls-339{fill:#3a8dcc;}.cls-340{fill:#4595d2;}.cls-341{fill:#da308a;}.cls-342{fill:#4a4596;}.cls-343{fill:#4559a5;}.cls-344{fill:#445da8;}.cls-345{fill:#4360aa;}.cls-346{fill:#455ba6;}.cls-347{fill:#4265ae;}.cls-348{fill:#4362ac;}.cls-349{fill:#4168b0;}.cls-350{fill:#406ab2;}.cls-351{fill:#3e6eb5;}.cls-352{fill:#3d73b8;}.cls-353{fill:#328aca;}.cls-354{fill:#542785;}.cls-355{fill:#6273b7;}.cls-356{fill:#427abe;}.cls-357{fill:#739dd3;}.cls-358{fill:#6d8ac4;}.cls-359{fill:#4b4496;}.cls-360{fill:#612986;}.cls-361{fill:#f29485;}.cls-362{fill:#7588c3;}.cls-363{fill:#719ed4;}.cls-364{fill:#ed685f;}.cls-365{fill:#4e337b;}.cls-366{fill:#f8beb1;}.cls-367{fill:#495ea9;}.cls-368{fill:#5d2e88;}.cls-369{fill:#512785;}.cls-370{fill:#502785;}.cls-371{fill:#e74c58;}.cls-372{fill:#e84d54;}.cls-373{fill:#e54763;}.cls-374{fill:#e44666;}.cls-375{fill:#e2426e;}.cls-376{fill:#e64a5e;}.cls-377{fill:#e13f74;}.cls-378{fill:#e03e75;}.cls-379{fill:#e03d77;}.cls-380{fill:#e2426f;}.cls-381{fill:#e94d52;}.cls-382{fill:#e6495f;}.cls-383{fill:#e64861;}.cls-384{fill:#de3a7d;}.cls-385{fill:#df3b7a;}.cls-386{fill:#e74b5a;}.cls-387{fill:#db3288;}.cls-388{fill:#df3c79;}.cls-389{fill:#e14171;}.cls-390{fill:#e3446c;}.cls-391{fill:#522885;}.cls-392{fill:#e44568;}.cls-393{fill:#dd387f;}.cls-394{fill:#db3386;}.cls-395{fill:#e74b5d;}.cls-396{fill:#e14073;}.cls-397{fill:#dc3584;}.cls-398{fill:#dd3682;}.cls-399{fill:#e3446a;}.cls-400{fill:#e94e50;}.cls-401{fill:#de397d;}.cls-402{fill:#e94e52;}.cls-403{fill:#e4456a;}.cls-404{fill:#dd3880;}.cls-405{fill:#e74b5c;}.cls-406{fill:#e54766;}.cls-407{fill:#3d83c4;}.cls-408{fill:#dd3782;}.cls-409{fill:#397cbf;}.cls-410{fill:#e64962;}.cls-411{fill:#3f6eb5;}.cls-412{fill:#3c77bc;}.cls-413{fill:#e2436e;}.cls-414{fill:#e3436d;}.cls-415{fill:#512885;}.cls-416{fill:#da318a;}.cls-417{fill:#e74b5b;}.cls-418{fill:#3586c7;}.cls-419{fill:#e24171;}.cls-420{fill:#e3466d;}.cls-421{fill:#e84f5a;}.cls-422{fill:#e24472;}.cls-423{fill:#e14173;}.cls-424{fill:#476ab2;}.cls-425{fill:#522785;}.cls-426{fill:#4185c5;}.cls-427{fill:#e95556;}.cls-428{fill:#e34673;}.cls-429{fill:#562885;}.cls-430{fill:#7d2e88;}.cls-431{fill:#592885;}.cls-432{fill:#7b2d88;}.cls-433{fill:#d6328a;}.cls-434{fill:#dd428e;}.cls-435{fill:#d5318a;}.cls-436{fill:#e2629d;}.cls-437{fill:#dd3f8f;}.cls-438{fill:#e15694;}.cls-439{fill:#dd4190;}.cls-440{fill:#752d88;}.cls-441{fill:#f29388;}.cls-442{fill:#e14e88;}.cls-443{fill:#ea575b;}.cls-444{fill:#604674;}.cls-445{fill:#e04f90;}.cls-446{fill:#612b87;}.cls-447{fill:#5e71b5;}.cls-448{fill:#d02e89;}.cls-449{fill:#e9535b;}.cls-450{fill:#e56e9d;}.cls-451{fill:#e577aa;}.cls-452{fill:#e15797;}.cls-453{fill:#ee796e;}.cls-454{fill:#dd3e8d;}.cls-455{fill:#7f2e88;}.cls-456{fill:#e85c70;}.cls-457{fill:#5a4192;}.cls-458{fill:#cb2e89;}.cls-459{fill:#e96b81;}.cls-460{fill:#ea616e;}.cls-461{fill:#792c87;}.cls-462{fill:#4f5ca7;}.cls-463{fill:#e56996;}.cls-464{fill:#e2578f;}.cls-465{fill:#eb6262;}.cls-466{fill:#e265a1;}.cls-467{fill:#df5196;}.cls-468{fill:#e34370;}.cls-469{fill:#e14275;}.cls-470{fill:#e15594;}.cls-471{fill:#5e2c87;}.cls-472{fill:#e05597;}.cls-473{fill:#e2609c;}.cls-474{fill:#782d88;}.cls-475{fill:#ea514d;}.cls-476{fill:#ed6d69;}.cls-477{fill:#6299d2;}.cls-478{fill:#e34874;}.cls-479{fill:#e45e8e;}.cls-480{fill:#e25992;}.cls-481{fill:#db348a;}.cls-482{fill:#e76384;}.cls-483{fill:#df5694;}.cls-484{fill:#e272a9;}.cls-485{fill:#ba348b;}.cls-486{fill:#de438c;}.cls-487{fill:#ed7a81;}.cls-488{fill:#ce2f89;}.cls-489{fill:#e46c9f;}.cls-490{fill:#de4a94;}.cls-491{fill:#de4690;}.cls-492{fill:#e15996;}.cls-493{fill:#eb5550;}.cls-494{fill:#db348b;}.cls-495{fill:#e36195;}.cls-496{fill:#e474a9;}.cls-497{fill:#e25b95;}.cls-498{fill:#dc378a;}.cls-499{fill:#e36ca4;}.cls-500{fill:#ec7684;}.cls-501{fill:#ed695e;}.cls-502{fill:#e0559a;}.cls-503{fill:#e86984;}.cls-504{fill:#e46ea0;}.cls-505{fill:#e35f95;}.cls-506{fill:#e6668e;}.cls-507{fill:#e267a1;}.cls-508{fill:#e14682;}.cls-509{fill:#ea5350;}.cls-510{fill:#5b4093;}.cls-511{fill:#f0aec6;}.cls-512{fill:#c82e89;}.cls-513{fill:#e15896;}.cls-514{fill:#ed828f;}.cls-515{fill:#ea6c7d;}.cls-516{fill:#d44c7a;}.cls-517{fill:#e4699c;}.cls-518{fill:#ef8180;}.cls-519{fill:#ed757b;}.cls-520{fill:#e5547d;}.cls-521{fill:#e65f83;}.cls-522{fill:#ec7888;}.cls-523{fill:#e36da7;}.cls-524{fill:#e36ba3;}.cls-525{fill:#df4f95;}.cls-526{fill:#ed7c85;}.cls-527{fill:#e04c8d;}.cls-528{fill:#e85261;}.cls-529{fill:#de4893;}.cls-530{fill:#e76d94;}.cls-531{fill:#ec7c8c;}.cls-532{fill:#ed7274;}.cls-533{fill:#e779a5;}.cls-534{fill:#e96277;}.cls-535{fill:#eb5c55;}.cls-536{fill:#e2467a;}.cls-537{fill:#eb5e57;}.cls-538{fill:#e96b85;}.cls-539{fill:#e87090;}.cls-540{fill:#ed6c63;}.cls-541{fill:#e66a91;}.cls-542{fill:#e572a1;}.cls-543{fill:#eb7383;}.cls-544{fill:#5e5077;}.cls-545{fill:#ed6c67;}.cls-546{fill:#e9596e;}.cls-547{fill:#f39585;}.cls-548{fill:#ef8381;}.cls-549{fill:#ee97ac;}.cls-550{fill:#ee8d98;}.cls-551{fill:#e05799;}.cls-552{fill:#e36fa2;}.cls-553{fill:#eb93b6;}.cls-554{fill:#f08577;}.cls-555{fill:#ef7d77;}.cls-556{fill:#e2c6c9;}.cls-557{fill:#752b87;}.cls-558{fill:#e2649d;}.cls-559{fill:#ae378c;}.cls-560{fill:#ec8093;}.cls-561{fill:#e25e95;}.cls-562{fill:#e46394;}.cls-563{fill:#e7749d;}.cls-564{fill:#ec7175;}.cls-565{fill:#e15a9c;}.cls-566{fill:#ec645b;}.cls-567{fill:#ea87a8;}.cls-568{fill:#e87596;}.cls-569{fill:#eb5953;}.cls-570{fill:#f9dae1;}.cls-571{fill:#9b2d88;}.cls-572{fill:#e3629b;}.cls-573{fill:#f5c7d4;}.cls-574{fill:#efb2cf;}.cls-575{fill:#f1bfda;}.cls-576{fill:#eb5a53;}.cls-577{fill:#e65e80;}.cls-578{fill:#ed7479;}.cls-579{fill:#e6709a;}.cls-580{fill:#623f54;}.cls-581{fill:#e15e9c;}.cls-582{fill:#ea91b4;}.cls-583{fill:#ee7a79;}.cls-584{fill:#efacc8;}.cls-585{fill:#ea5550;}.cls-586{fill:#d82f89;}.cls-587{fill:#f7bdb0;}.cls-588{fill:#f7d7e4;}.cls-589{fill:#ef8687;}.cls-590{fill:#f18e85;}.cls-591{fill:#f39888;}.cls-592{fill:#e885b1;}.cls-593{fill:#e88ab5;}.cls-594{fill:#6e70b3;}.cls-595{fill:#787f96;}.cls-596{fill:#f4cce2;}.cls-597{fill:#dc3c8c;}.cls-598{fill:#ea524e;}.cls-599{fill:#e45884;}.cls-600{fill:#792d88;}.cls-601{fill:#f18677;}.cls-602{fill:#ed7981;}.cls-603{fill:#e04287;}.cls-604{fill:#e04c8f;}.cls-605{fill:#ec7b71;}.cls-606{fill:#e36ea8;}.cls-607{fill:#de4e96;}.cls-608{fill:#ea5051;}.cls-609{fill:#f1bad7;}.cls-610{fill:#e87499;}.cls-611{fill:#f19494;}.cls-612{fill:#f5cfe1;}.cls-613{fill:#eea3bc;}.cls-614{fill:#f7bcb0;}.cls-615{fill:#f3c4dd;}.cls-616{fill:#e5719f;}.cls-617{fill:#e64b6b;}.cls-618{fill:#ee7975;}.cls-619{fill:#e67fb1;}.cls-620{fill:#ec6f76;}.cls-621{fill:#ea6875;}.cls-622{fill:#e36fa8;}.cls-623{fill:#e86e94;}.cls-624{fill:#ea524f;}.cls-625{fill:#df4588;}.cls-626{fill:#ee7064;}.cls-627{fill:#4267af;}.cls-628{fill:#f08886;}.cls-629{fill:#f8d5dd;}.cls-630{fill:#5b2d87;}.cls-631{fill:#5a2c87;}.cls-632{fill:#582b86;}.cls-633{fill:#484e9d;}.cls-634{fill:#6e2c87;}.cls-635{fill:#792e88;}.cls-636{fill:#5b2885;}.cls-637{fill:#7e2e88;}.cls-638{fill:#e25f9c;}.cls-639{fill:#772c87;}.cls-640{fill:#bb2e89;}.cls-641{fill:#652e88;}.cls-642{fill:#e575a5;}.cls-643{fill:#e1619f;}.cls-644{fill:#76388c;}.cls-645{fill:#e15c9c;}.cls-646{fill:#de5398;}.cls-647{fill:#e2619e;}.cls-648{fill:#872e88;}.cls-649{fill:#e15b9b;}.cls-650{fill:#852d88;}.cls-651{fill:#e263a0;}.cls-652{fill:#ea5d60;}.cls-653{fill:#e2649e;}.cls-654{fill:#e44a74;}.cls-655{fill:#e05698;}.cls-656{fill:#8b2d88;}.cls-657{fill:#882e88;}.cls-658{fill:#e0569a;}.cls-659{fill:#e95d67;}.cls-660{fill:#682e88;}.cls-661{fill:#dc5f9f;}.cls-662{fill:#e7576f;}.cls-663{fill:#5f2986;}.cls-664{fill:#e0589b;}.cls-665{fill:#eb6064;}.cls-666{fill:#de3f85;}.cls-667{fill:#782e88;}.cls-668{fill:#e36b96;}.cls-669{fill:#e7729d;}.cls-670{fill:#e64c67;}.cls-671{fill:#772a86;}.cls-672{fill:#e15c9d;}.cls-673{fill:#e368a2;}.cls-674{fill:#692e88;}.cls-675{fill:#ee7e83;}.cls-676{fill:#e2609d;}.cls-677{fill:#e04e8d;}.cls-678{fill:#743d90;}.cls-679{fill:#652d88;}.cls-680{fill:#e671a0;}.cls-681{fill:#e13f77;}.cls-682{fill:#e15c99;}.cls-683{fill:#ea6267;}.cls-684{fill:#e35a8d;}.cls-685{fill:#ec6765;}.cls-686{fill:#e76a8d;}.cls-687{fill:#e25d96;}.cls-688{fill:#e6587b;}.cls-689{fill:#e15a9b;}.cls-690{fill:#f3958b;}.cls-691{fill:#e36ca6;}.cls-692{fill:#df3e7d;}.cls-693{fill:#902f89;}.cls-694{fill:#ed7b88;}.cls-695{fill:#6b2b87;}.cls-696{fill:#d52f89;}.cls-697{fill:#e25892;}.cls-698{fill:#ee8a95;}.cls-699{fill:#eb5e5f;}.cls-700{fill:#9c2c88;}.cls-701{fill:#e266a2;}.cls-702{fill:#ea6979;}.cls-703{fill:#c22d89;}.cls-704{fill:#e3659d;}.cls-705{fill:#e570a0;}.cls-706{fill:#eb6e7c;}.cls-707{fill:#ea5958;}.cls-708{fill:#eb7585;}.cls-709{fill:#e36aa4;}.cls-710{fill:#8a2b87;}.cls-711{fill:#eb615e;}.cls-712{fill:#e45f8e;}.cls-713{fill:#eb5d5d;}.cls-714{fill:#e46496;}.cls-715{fill:#762e88;}.cls-716{fill:#e471a5;}.cls-717{fill:#e65070;}.cls-718{fill:#ee7976;}.cls-719{fill:#e97492;}.cls-720{fill:#872f89;}.cls-721{fill:#de3c83;}.cls-722{fill:#e46c8d;}.cls-723{fill:#e7698d;}.cls-724{fill:#e46da1;}.cls-725{fill:#d46b97;}.cls-726{fill:#e05798;}.cls-727{fill:#e87093;}.cls-728{fill:#c72e89;}.cls-729{fill:#e56e9e;}.cls-730{fill:#e46298;}.cls-731{fill:#e573a4;}.cls-732{fill:#ba2f89;}.cls-733{fill:#e5577f;}.cls-734{fill:#e46fa3;}.cls-735{fill:#e7739a;}.cls-736{fill:#e55d88;}.cls-737{fill:#bd2c88;}.cls-738{fill:#e04a8b;}.cls-739{fill:#e74f67;}.cls-740{fill:#e268a3;}.cls-741{fill:#e8627c;}.cls-742{fill:#eb7a90;}.cls-743{fill:#e1508f;}.cls-744{fill:#e3649d;}.cls-745{fill:#ed8597;}.cls-746{fill:#eb7990;}.cls-747{fill:#e75061;}.cls-748{fill:#e470a3;}.cls-749{fill:#e05a9b;}.cls-750{fill:#e85d71;}.cls-751{fill:#e34e7d;}.cls-752{fill:#e44972;}.cls-753{fill:#ec747f;}.cls-754{fill:#e96680;}.cls-755{fill:#eb7482;}.cls-756{fill:#9e2c87;}.cls-757{fill:#e369a2;}.cls-758{fill:#e95d6c;}.cls-759{fill:#e15c9e;}.cls-760{fill:#ea6779;}.cls-761{fill:#e265a2;}.cls-762{fill:#e56fa1;}.cls-763{fill:#ed747a;}.cls-764{fill:#e44c79;}.cls-765{fill:#f09192;}.cls-766{fill:#df5098;}.cls-767{fill:#e8647f;}.cls-768{fill:#8e2d88;}.cls-769{fill:#e76c92;}.cls-770{fill:#b82f89;}.cls-771{fill:#e36fa6;}.cls-772{fill:#e266a3;}.cls-773{fill:#f08175;}.cls-774{fill:#ec6763;}.cls-775{fill:#e7749b;}.cls-776{fill:#e5628b;}.cls-777{fill:#ea7288;}.cls-778{fill:#e36196;}.cls-779{fill:#ea758d;}.cls-780{fill:#c32d88;}.cls-781{fill:#ee7a78;}.cls-782{fill:#e95a69;}.cls-783{fill:#e86986;}.cls-784{fill:#e5557d;}.cls-785{fill:#ee716a;}.cls-786{fill:#ee7d7c;}.cls-787{fill:#e15e9e;}.cls-788{fill:#e36aa5;}.cls-789{fill:#ea728a;}.cls-790{fill:#5d4c71;}.cls-791{fill:#e369a0;}.cls-792{fill:#df5198;}.cls-793{fill:#e36ea4;}.cls-794{fill:#f18b85;}.cls-795{fill:#e56999;}.cls-796{fill:#e161a0;}.cls-797{fill:#e7739c;}.cls-798{fill:#f18c86;}.cls-799{fill:#e8607a;}.cls-800{fill:#e85368;}.cls-801{fill:#7d2a86;}.cls-802{fill:#e46ca1;}.cls-803{fill:#eb7b93;}.cls-804{fill:#e66c97;}.cls-805{fill:#e66a94;}.cls-806{fill:#e368a3;}.cls-807{fill:#e46da3;}.cls-808{fill:#ea748b;}.cls-809{fill:#ea6474;}.cls-810{fill:#ea7b96;}.cls-811{fill:#ec7a8a;}.cls-812{fill:#9d2f89;}.cls-813{fill:#f6cdda;}.cls-814{fill:#e86d8b;}.cls-815{fill:#e5587d;}.cls-816{fill:#eb7a92;}.cls-817{fill:#e15d9e;}.cls-818{fill:#e76e93;}.cls-819{fill:#e03f7e;}.cls-820{fill:#e26aa5;}.cls-821{fill:#e04280;}.cls-822{fill:#e46a9e;}.cls-823{fill:#ea5452;}.cls-824{fill:#ef7d7b;}.cls-825{fill:#ed7b89;}.cls-826{fill:#e36ea5;}.cls-827{fill:#bc2f89;}.cls-828{fill:#e76d92;}.cls-829{fill:#ea7995;}.cls-830{fill:#e8647b;}.cls-831{fill:#e66995;}.cls-832{fill:#e15f9f;}.cls-833{fill:#e2639d;}.cls-834{fill:#e267a3;}.cls-835{fill:#ed6e67;}.cls-836{fill:#e66c9a;}.cls-837{fill:#e76d93;}.cls-838{fill:#e46ca2;}.cls-839{fill:#ec7a87;}.cls-840{fill:#eb7e92;}.cls-841{fill:#e3466f;}.cls-842{fill:#e46ba0;}.cls-843{fill:#ed6c66;}.cls-844{fill:#e263a1;}.cls-845{fill:#e267a2;}.cls-846{fill:#eeadcd;}.cls-847{fill:#e97590;}.cls-848{fill:#f4cde2;}.cls-849{fill:#b72f89;}.cls-850{fill:#b22c88;}.cls-851{fill:#ec6c6d;}.cls-852{fill:#e4689b;}.cls-853{fill:#e8769c;}.cls-854{fill:#ea7b9a;}.cls-855{fill:#eb788f;}.cls-856{fill:#ec7c8b;}.cls-857{fill:#e05b9d;}.cls-858{fill:#932c88;}.cls-859{fill:#e66e97;}.cls-860{fill:#e268a4;}.cls-861{fill:#e2629f;}.cls-862{fill:#ea7892;}.cls-863{fill:#ee7d80;}.cls-864{fill:#ea7690;}.cls-865{fill:#ea534e;}.cls-866{fill:#e269a5;}.cls-867{fill:#5e3577;}.cls-868{fill:#5f396b;}.cls-869{fill:#603a63;}.cls-870{fill:#5e337e;}.cls-871{fill:#603d57;}.cls-872{fill:#603b60;}.cls-873{fill:#603967;}.cls-874{fill:#603a66;}.cls-875{fill:#5e3285;}.cls-876{fill:#5e2f86;}.cls-877{fill:#633e59;}.cls-878{fill:#613c5e;}.cls-879{fill:#603e5d;}.cls-880{fill:#5d407c;}.cls-881{fill:#d83684;}.cls-882{fill:#603c60;}.cls-883{fill:#5b3f8f;}.cls-884{fill:#5c3a8c;}.cls-885{fill:#5c398d;}.cls-886{fill:#744591;}.cls-887{fill:#5b3e8c;}.cls-888{fill:#5c3d8c;}.cls-889{fill:#594694;}.cls-890{fill:#7f397f;}.cls-891{fill:#5c3989;}.cls-892{fill:#5d4374;}.cls-893{fill:#5c4692;}.cls-894{fill:#5c3c8e;}.cls-895{fill:#5b3b8e;}.cls-896{fill:#71a2d6;}.cls-897{fill:#5b458a;}.cls-898{fill:#5f4367;}.cls-899{fill:#753d85;}.cls-900{fill:#5b4e80;}.cls-901{fill:#5c4780;}.cls-902{fill:#595287;}.cls-903{fill:#5c447f;}.cls-904{fill:#5d4772;}.cls-905{fill:#5c4d77;}.cls-906{fill:#5f4567;}.cls-907{fill:#5d4f6d;}.cls-908{fill:#4755a2;}.cls-909{fill:#494999;}.cls-910{fill:#4a4798;}.cls-911{fill:#502882;}.cls-912{fill:#502880;}.cls-913{fill:#5f96d0;}.cls-914{fill:#7281bf;}.cls-915{fill:#6d70b3;}.cls-916{fill:#4657a4;}.cls-917{fill:#584b91;}.cls-918{fill:#594a8a;}.cls-919{fill:#5c4b70;}.cls-920{fill:#5a537c;}.cls-921{fill:#de659b;}.cls-922{fill:#67598e;}.cls-923{fill:#d8308a;}.cls-924{fill:#7a2e88;}.cls-925{fill:#772e88;}.cls-926{fill:#7a2d88;}.cls-927{fill:#6e2e88;}.cls-928{fill:#7b2e88;}.cls-929{fill:#7c2e88;}.cls-930{fill:#724896;}.cls-931{fill:#7c2d88;}.cls-932{fill:#762d88;}.cls-933{fill:#7b3089;}.cls-934{fill:#603579;}.cls-935{fill:#722e88;}.cls-936{fill:#5f4468;}.cls-937{fill:#7d2f89;}.cls-938{fill:#5a4593;}.cls-939{fill:#7e2f89;}.cls-940{fill:#742c87;}.cls-941{fill:#5b3f92;}.cls-942{fill:#8a2f89;}.cls-943{fill:#5e3c7b;}.cls-944{fill:#562986;}.cls-945{fill:#5d438c;}.cls-946{fill:#694292;}.cls-947{fill:#5e3f70;}.cls-948{fill:#7b2c87;}.cls-949{fill:#bd2f89;}.cls-950{fill:#613a65;}.cls-951{fill:#7c2f89;}.cls-952{fill:#5a4394;}.cls-953{fill:#d12f89;}.cls-954{fill:#525da7;}.cls-955{fill:#6e4476;}.cls-956{fill:#7b2f89;}.cls-957{fill:#d72f89;}.cls-958{fill:#762f89;}.cls-959{fill:#614987;}.cls-960{fill:#732f89;}.cls-961{fill:#624596;}.cls-962{fill:#cf2e89;}.cls-963{fill:#5a4693;}.cls-964{fill:#792f89;}.cls-965{fill:#682d88;}.cls-966{fill:#8c2f89;}.cls-967{fill:#992e89;}.cls-968{fill:#db3287;}.cls-969{fill:#852f89;}.cls-970{fill:#e46ea5;}.cls-971{fill:#e56fa2;}.cls-972{fill:#ea5e68;}.cls-973{fill:#e269a4;}.cls-974{fill:#e3659f;}.cls-975{fill:#e8789c;}.cls-976{fill:#5d2f86;}.cls-977{fill:#d83089;}.cls-978{fill:#5c4879;}.cls-979{fill:#594595;}.cls-980{fill:#7d2f88;}.cls-981{fill:#9b2f89;}.cls-982{fill:#602e88;}.cls-983{fill:#712b87;}.cls-984{fill:#503289;}.cls-985{fill:#756baf;}.cls-986{fill:#be2e89;}.cls-987{fill:#b02e88;}.cls-988{fill:#cd2d89;}.cls-989{fill:#bd2e89;}.cls-990{fill:#503876;}.cls-991{fill:#d82f8a;}.cls-992{fill:#7a2f85;}.cls-993{fill:#842e88;}.cls-994{fill:#502f78;}.cls-995{fill:#513159;}.cls-996{fill:#892986;}.cls-997{fill:#de428e;}.cls-998{fill:#e35e96;}.cls-999{fill:#e97693;}.cls-1000{fill:#eb7488;}.cls-1001{fill:#ef909c;}.cls-1002{fill:#ec737f;}.cls-1003{fill:#e24170;}.cls-1004{fill:#54306a;}.cls-1005{fill:#553169;}.cls-1006{fill:#e74a5c;}.cls-1007{fill:#e64961;}.cls-1008{fill:#e75065;}.cls-1009{fill:#e05091;}.cls-1010{fill:#df4487;}.cls-1011{fill:#d34e8f;}.cls-1012{fill:#df488e;}.cls-1013{fill:#e04f92;}.cls-1014{fill:#df4990;}.cls-1015{fill:#e24e83;}.cls-1016{fill:#df5787;}.cls-1017{fill:#f1b9d1;}.cls-1018{fill:#e85366;}.cls-1019{fill:#eb778a;}.cls-1020{fill:#fad9d6;}.cls-1021{fill:#e879a2;}.cls-1022{fill:#e8759a;}.cls-1023{fill:#ec737e;}.cls-1024{fill:#e14071;}.cls-1025{fill:#532f6e;}.cls-1026{fill:#542e71;}.cls-1027{fill:#e96984;}.cls-1028{fill:#eb7386;}.cls-1029{fill:#de458f;}.cls-1030{fill:#e97494;}.cls-1031{fill:#e36299;}.cls-1032{fill:#e44769;}.cls-1033{fill:#ea6f88;}.cls-1034{fill:#e97495;}.cls-1035{fill:#e14172;}.cls-1036{fill:#e3446b;}.cls-1037{fill:#e4689e;}.cls-1038{fill:#ed7f89;}.cls-1039{fill:#e3659e;}.cls-1040{fill:#eb7992;}.cls-1041{fill:#512883;}.cls-1042{fill:#542883;}.cls-1043{fill:#532883;}.cls-1044{fill:#552a81;}.cls-1045{fill:#982f84;}.cls-1046{fill:#d33186;}.cls-1047{fill:#7f2f89;}.cls-1048{fill:#dc3587;}.cls-1049{fill:#e6648b;}.cls-1050{fill:#ec7584;}.cls-1051{fill:#e66791;}.cls-1052{fill:#ea7891;}.cls-1053{fill:#e96c87;}.cls-1054{fill:#ef7d7e;}.cls-1055{fill:#ea778e;}.cls-1056{fill:#ee7573;}.cls-1057{fill:#e14376;}.cls-1058{fill:#e571a4;}.cls-1059{fill:#e46ea2;}.cls-1060{fill:#ea555b;}.cls-1061{fill:#f7d2de;}.cls-1062{fill:#f1a7b4;}.cls-1063{fill:#ea7088;}.cls-1064{fill:#e87597;}.cls-1065{fill:#b92c88;}.cls-1066{fill:#7e2c87;}.cls-1067{fill:#a82c88;}.cls-1068{fill:#822e88;}.cls-1069{fill:#5b3783;}.cls-1070{fill:#dd3780;}.cls-1071{fill:#de4992;}.cls-1072{fill:#f8cdcd;}.cls-1073{fill:#e76c91;}.cls-1074{fill:#e36398;}.cls-1075{fill:#5e2e87;}.cls-1076{fill:#7c2e87;}.cls-1077{fill:#712c87;}.cls-1078{fill:#e46ba2;}.cls-1079{fill:#522d74;}.cls-1080{fill:#ee7c7c;}.cls-1081{fill:#eb7589;}.cls-1082{fill:#ed7e88;}.cls-1083{fill:#e97694;}.cls-1084{fill:#dc398b;}.cls-1085{fill:#df4185;}.cls-1086{fill:#e66e9a;}.cls-1087{fill:#df4a8d;}.cls-1088{fill:#522c78;}.cls-1089{fill:#522c77;}.cls-1090{fill:#87357c;}.cls-1091{fill:#c7387c;}.cls-1092{fill:#b8387b;}.cls-1093{fill:#e1518f;}.cls-1094{fill:#e6719d;}.cls-1095{fill:#e44569;}.cls-1096{fill:#e87da4;}.cls-1097{fill:#f6cdd8;}.cls-1098{fill:#e6729d;}.cls-1099{fill:#522b7b;}.cls-1100{fill:#eb7384;}.cls-1101{fill:#ee736e;}.cls-1102{fill:#e97596;}.cls-1103{fill:#58397d;}.cls-1104{fill:#7a2c87;}.cls-1105{fill:#7c2c87;}.cls-1106{fill:#722a87;}.cls-1107{fill:#712a86;}.cls-1108{fill:#732986;}.cls-1109{fill:#5d2b87;}.cls-1110{fill:#512a7d;}.cls-1111{fill:#822e7e;}.cls-1112{fill:#dd438f;}.cls-1113{fill:#e66c99;}.cls-1114{fill:#525883;}.cls-1115{fill:#512a7e;}.cls-1116{fill:#4b4b9a;}.cls-1117{fill:#6f9bd2;}.cls-1118{fill:#50387d;}.cls-1119{fill:#50397a;}.cls-1120{fill:#674394;}.cls-1121{fill:#832e88;}.cls-1122{fill:#dc6997;}.cls-1123{fill:#e4689d;}.cls-1124{fill:#ef7e76;}.cls-1125{fill:#e15d9a;}.cls-1126{fill:#ea687c;}.cls-1127{fill:#ed7d86;}.cls-1128{fill:#e75059;}.cls-1129{fill:#e677a7;}.cls-1130{fill:#e05394;}.cls-1131{fill:#e77097;}.cls-1132{fill:#e66f9d;}.cls-1133{fill:#e56fa0;}.cls-1134{fill:#ed767b;}.cls-1135{fill:#684383;}.cls-1136{fill:#e0659b;}.cls-1137{fill:#c1545c;}.cls-1138{fill:#532985;}.cls-1139{fill:#782c87;}.cls-1140{fill:#d32f89;}.cls-1141{fill:#a32e88;}.cls-1142{fill:#a12d88;}.cls-1143{fill:#672e88;}.cls-1144{fill:#db358b;}.cls-1145{fill:#932d88;}.cls-1146{fill:#503077;}.cls-1147{fill:#dc3b8b;}.cls-1148{fill:#e36ba5;}.cls-1149{fill:#533467;}.cls-1150{fill:#e24379;}.cls-1151{fill:#f8d7e6;}.cls-1152{fill:#ee756f;}.cls-1153{fill:#e64f6c;}.cls-1154{fill:#ed6962;}.cls-1155{fill:#e2467b;}.cls-1156{fill:#593a74;}.cls-1157{fill:#563b90;}.cls-1158{fill:#594368;}.cls-1159{fill:#5c3a52;}.cls-1160{fill:#f08680;}.cls-1161{fill:#574276;}.cls-1162{fill:#b25396;}.cls-1163{fill:#6290cc;}.cls-1164{fill:#702b87;}.cls-1165{fill:#5b59a3;}.cls-1166{fill:#b62d88;}.cls-1167{fill:#523863;}.cls-1168{fill:#732b87;}.cls-1169{fill:#e24579;}.cls-1170{fill:#5f3479;}.cls-1171{fill:#5f3674;}.cls-1172{fill:#db3a7b;}.cls-1173{fill:#7f347a;}.cls-1174{fill:#5b3e8d;}.cls-1175{fill:#ba3877;}.cls-1176{fill:#a33775;}.cls-1177{fill:#843677;}.cls-1178{fill:#5c497b;}.cls-1179{fill:#c53976;}.cls-1180{fill:#5f386d;}.cls-1181{fill:#5c497d;}.cls-1182{fill:#5d3f7b;}.cls-1183{fill:#5b408c;}.cls-1184{fill:#753b64;}.cls-1185{fill:#813c65;}.cls-1186{fill:#763962;}.cls-1187{fill:#893c66;}.cls-1188{fill:#5e3280;}.cls-1189{fill:#5f337b;}.cls-1190{fill:#7f347e;}.cls-1191{fill:#68468e;}.cls-1192{fill:#863e6c;}.cls-1193{fill:#e64c5b;}.cls-1194{fill:#5c4580;}.cls-1195{fill:#5c388d;}.cls-1196{fill:#5f3772;}.cls-1197{fill:#5f3870;}.cls-1198{fill:#5e3084;}.cls-1199{fill:#5e3181;}.cls-1200{fill:#744b68;}.cls-1201{fill:#676db1;}.cls-1202{fill:#d03f7d;}.cls-1203{fill:#522b7a;}.cls-1204{fill:#51376f;}.cls-1205{fill:#513361;}.cls-1206{fill:#773d8e;}.cls-1207{fill:#503370;}.cls-1208{fill:#4753a0;}.cls-1209{fill:#582a86;}.cls-1210{fill:#5f435e;}.cls-1211{fill:#5e4a69;}.cls-1212{fill:#5d62aa;}.cls-1213{fill:#d93089;}.cls-1214{fill:#da3485;}.cls-1215{fill:#5f3288;}.cls-1216{fill:#532f6c;}.cls-1217{fill:#e25e98;}.cls-1218{fill:#e9687c;}.cls-1219{fill:#ec676e;}.cls-1220{fill:#e76587;}.cls-1221{fill:#f5a9a5;}.cls-1222{fill:#e96579;}.cls-1223{fill:#ec6a66;}.cls-1224{fill:#e64e6a;}.cls-1225{fill:#e4679b;}.cls-1226{fill:#e15897;}.cls-1227{fill:#e66c95;}.cls-1228{fill:#de4a92;}.cls-1229{fill:#e36da5;}.cls-1230{fill:#e04684;}.cls-1231{fill:#e85666;}.cls-1232{fill:#ef8486;}.cls-1233{fill:#ed7c86;}.cls-1234{fill:#ee7973;}.cls-1235{fill:#e3679f;}.cls-1236{fill:#e14b82;}.cls-1237{fill:#e54863;}.cls-1238{fill:#e75470;}.cls-1239{fill:#e9738e;}.cls-1240{fill:#e97493;}.cls-1241{fill:#dc398c;}.cls-1242{fill:#e84e60;}.cls-1243{fill:#522e70;}.cls-1244{fill:#522f71;}.cls-1245{fill:#543458;}.cls-1246{fill:#543357;}.cls-1247{fill:#793673;}.cls-1248{fill:#713574;}.cls-1249{fill:#ec7580;}.cls-1250{fill:#512981;}.cls-1251{fill:#712b84;}.cls-1252{fill:#d33384;}.cls-1253{fill:#dd3781;}.cls-1254{fill:#de3c80;}.cls-1255{fill:#e04381;}.cls-1256{fill:#604590;}.cls-1257{fill:#823e8a;}.cls-1258{fill:#762d87;}.cls-1259{fill:#532d75;}.cls-1260{fill:#512c86;}.cls-1261{fill:#512d86;}.cls-1262{fill:#713174;}.cls-1263{fill:#d9387f;}.cls-1264{fill:#512b85;}.cls-1265{fill:#512e84;}.cls-1266{fill:#512d85;}.cls-1267{fill:#772f7a;}.cls-1268{fill:#822e7b;}.cls-1269{fill:#7f327a;}.cls-1270{fill:#523469;}.cls-1271{fill:#533257;}.cls-1272{fill:#e54666;}.cls-1273{fill:#e34977;}.cls-1274{fill:#da5497;}.cls-1275{fill:#502f87;}.cls-1276{fill:#da5989;}.cls-1277{fill:#572980;}.cls-1278{fill:#632f82;}.cls-1279{fill:#7b3081;}.cls-1280{fill:#dd5b8e;}.cls-1281{fill:#7a307f;}.cls-1282{fill:#782e82;}.cls-1283{fill:#db3e75;}.cls-1284{fill:#de387f;}.cls-1285{fill:#603676;}.cls-1286{fill:#69347c;}.cls-1287{fill:#8b367a;}.cls-1288{fill:#7c3679;}.cls-1289{fill:#893777;}.cls-1290{fill:#84357c;}.cls-1291{fill:#86357c;}.cls-1292{fill:#e7759d;}.cls-1293{fill:#603870;}.cls-1294{fill:#da4070;}.cls-1295{fill:#84357e;}.cls-1296{fill:#5f4a95;}.cls-1297{fill:#7b357c;}.cls-1298{fill:#5b438b;}.cls-1299{fill:#5c4681;}.cls-1300{fill:#5b3c8f;}.cls-1301{fill:#743183;}.cls-1302{fill:#5b448e;}.cls-1303{fill:#5f4664;}.cls-1304{fill:#5d4577;}.cls-1305{fill:#4667af;}.cls-1306{fill:#522e72;}.cls-1307{fill:#7b317e;}.cls-1308{fill:#e1659e;}.cls-1309{fill:#da6977;}.cls-1310{fill:#53345d;}.cls-1311{fill:#e87191;}.cls-1312{fill:#7f3f74;}.cls-1313{fill:#e368a4;}.cls-1314{fill:#e3659a;}.cls-1315{fill:#5f3773;}.cls-1316{fill:#de4993;}.cls-1317{fill:#ed7e91;}.cls-1318{fill:#e45c8b;}.cls-1319{fill:#ec635e;}.cls-1320{fill:#e9505d;}.cls-1321{fill:#522f77;}.cls-1322{fill:#543353;}.cls-1323{fill:#6f408d;}.cls-1324{fill:#5e407d;}.cls-1325{fill:#e3619a;}.cls-1326{fill:#e46ea3;}.cls-1327{fill:#e367a1;}.cls-1328{fill:#e15a98;}.cls-1329{fill:#ea7289;}.cls-1330{fill:#e66f9b;}.cls-1331{fill:#903777;}.cls-1332{fill:#bc3978;}.cls-1333{fill:#e6719c;}.cls-1334{fill:#96367d;}.cls-1335{fill:#7b2f84;}.cls-1336{fill:#763176;}.cls-1337{fill:#733174;}.cls-1338{fill:#51366a;}.cls-1339{fill:#51356e;}.cls-1340{fill:#7e3774;}.cls-1341{fill:#95357e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.26,146c-.51-.5-.41-1.17-.51-1.79a12.06,12.06,0,0,0-1-3c-.61-1,0-2.09-.42-3.08a8.65,8.65,0,0,1-.1-1.83,3.16,3.16,0,0,0-.14-1.14,6.57,6.57,0,0,1-.09-1.47,4.18,4.18,0,0,0-.17-1.78c0-.12-.12,0-.09,0,.29.53-.16.57-.49.69-2.51.15-5,0-7.53.07-1.66,0-1.71,0-1.58,1.61.18,2.1.17,4.22.42,6.31,0,1.07.32,2.11.33,3.17,0,.39.13,1-.62.76a6.76,6.76,0,0,1-.4-2.8c.08-2.25-.41-4.47-.32-6.72a2.09,2.09,0,0,0-.49-1.73V132a3.11,3.11,0,0,0,.18-2.08,4.76,4.76,0,0,1,0-1.41c.1-1.41,0-2.82,0-4.23,0-.42-.09-.87.24-1.23a1.67,1.67,0,0,1,1-.27c3,0,5.89,0,8.84,0a2.13,2.13,0,0,1,.7.14c.75.39.32,1,.32,1.68,0,.07.28,0,.13-.06s0,0-.05-.07c-.11-.27,0-.42.26-.51.47,0,.64.2.63.64a37.78,37.78,0,0,1-.09,4.12,35.77,35.77,0,0,1,.19,4,1.58,1.58,0,0,0,0,1.19l.48,5.51a6.1,6.1,0,0,0,0,2.13,8.76,8.76,0,0,1,.48,3.13,3.18,3.18,0,0,0-.07,1A.26.26,0,0,1,52.26,146Z",
    transform: "translate(-8.9 -13.51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.59,123.15c-.12,1.84.24,3.7-.21,5.52-.17-.12-.14-.31-.15-.48,0-.4.13-.83-.12-1.21v-3.11c.25-.39.07-.83.12-1.25,0-.19,0-.39.22-.47C39.93,122.42,39.84,122.78,39.59,123.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.46,15.15c3,.74,6,1.4,9,2.22a130.16,130.16,0,0,1,20,7.09c4.7,2.15,9,4.93,13.62,7.25,2.28,1.15,4.21,3,6.39,4.35C227.13,39,231,42.89,235.14,46.5a113.13,113.13,0,0,1,12.12,13.28c6.65,8.06,11.59,17.13,16,26.52a75.48,75.48,0,0,1,5.07,14.42c.15.62.56,1.16.46,1.84-2.23-.21-4.46-.09-6.69-.12-.82,0-1.21.26-1,1.15.12.45.28,1-.36,1.21s-.91-.44-1-.92c-.18-1.27-1-1.46-2.06-1.45-4.63,0-9.26,0-13.88,0a2,2,0,0,1-.94-.11c-.48-1.47-.9-3-1.45-4.41a51.37,51.37,0,0,0-8-14.41c-2.29-2.85-4-6.08-6.13-9a28.24,28.24,0,0,0-3.35-4.19c-1.52-1.41-3-2.86-4.39-4.39-.86-.93-2.11-1.36-2.85-2.44-2.12-3.1-5.16-5.25-8-7.61-.08-.31.84-.64,0-.93a65.46,65.46,0,0,0-11.3-6.88c-1.61-.76-2.82-2.15-4.61-2.71-4.25-1.33-8.21-3.43-12.5-4.69a5.56,5.56,0,0,1-1-.57c-.14-.47.33-.26.48-.42.3-.44-.14-.43-.33-.48-1-.29-2-.54-3-.81a13.84,13.84,0,0,1-1.79-.36c-.36-.08-.34-.13-.11-.58a21.54,21.54,0,0,1,4.52.74c.64.06.42-.41.45-.73.32-.3.71-.12,1.07-.15a.93.93,0,0,1,.58.2,4,4,0,0,0,1.15.47c.4.16.86.22,1.11.63.4.11-.68.38.06.45a.84.84,0,0,1,.61.3,1.79,1.79,0,0,0,1.12.47,1.93,1.93,0,0,1-1.14-.49.41.41,0,0,1,.3-.37,6,6,0,0,1,2.77.62c2.23.84,4.45,1.7,6.67,2.55-3.79-1.46-7.6-2.88-11.35-4.43a6.4,6.4,0,0,0-1.2-.52c-.6-.15-1.13-.57-1.8-.46a1.78,1.78,0,0,1-.65,0,6.83,6.83,0,0,0-3-.66c-1.25,0-1.82-1.16-2.92-1.27a1.59,1.59,0,0,1-.3-.06,2.14,2.14,0,0,0-.79-.38c-.2,0-.39-.1-.59-.12s-.16,0-.24,0a6.23,6.23,0,0,1-.74-.09c.18.12.47.13.43.47a.79.79,0,0,1-1.06.22c-.79-.11-1.56-.74-2.39,0-.16.14-.43,0-.64-.15-.48-.37,0,.29-.23.22-1.86-.2-3.73-.08-5.59-.39a21,21,0,0,0-3-.14,24.06,24.06,0,0,1-5.65-.43,23.61,23.61,0,0,0-8.42.08c-3.39.44-6.77.91-10.15,1.39-.28,0-.64.34-.73-.23l2.59-.53c.3-.44.76-.31,1.17-.33s.78-.33,1.22-.24.87-.22,1.32-.18c-.45-.08-.86.31-1.32.17s-.82.18-1.24.24a11.84,11.84,0,0,0-1.88.09c-3.58,0-6.93,1.22-10.36,2-4.23,1-8.11,2.94-12,4.73l-1.5.7c-.39-.09-.77.77-1.17,0a40.44,40.44,0,0,1,7.57-3.61,1.69,1.69,0,0,0,1-.88c.28-.24.47-.62.93-.56.72.37,1.28-.18,1.89-.36s1.2-.54,1.94-.76c-1.31.32-2.35,1.14-3.63,1.23-.27-.28-.62-.07-.92-.16a20,20,0,0,0-6.49,2.85,36.73,36.73,0,0,1-4.1,2.21,20.89,20.89,0,0,0-3.29,1.94,2,2,0,0,1-1.47.93c-3.49,1.64-6.39,4.18-9.47,6.4-2.9,2.1-5.46,4.71-8.33,6.82-4.4,3.24-7.65,7.44-10.71,11.78-2.26,3.19-4.89,6.09-6.92,9.44S63.24,86,61.27,89.6a67.71,67.71,0,0,0-4.92,11.89,2.58,2.58,0,0,1-.87,1.11,3.65,3.65,0,0,1-1,.31c-3,0-5.89.18-8.84-.09-1-.53-.95-1.53-1.11-2.44,1.12-1.37,2.19-2.77,2.13-4.68a2.25,2.25,0,0,1,.23-.88c.05-.15,0-.26,0-.11s-.19,0-.08.08-.23.13-.07.1c-.28.88-.32,1.92-1.42,2.29a1.25,1.25,0,0,0-.23,1.28,3,3,0,0,1-.56,1.84,3.34,3.34,0,0,1-.55,2.34,9.33,9.33,0,0,0-2.23.88,26.58,26.58,0,0,1,1.7-7.6c1-2.85,1.74-5.78,2.58-8.67.37-1.28,1.11-2.38,1.59-3.6,2.38-6,5.7-11.55,8.91-17.14A78.3,78.3,0,0,1,65,55a71.21,71.21,0,0,1,4.89-5.81c2.16-2.06,4.42-4,6.47-6.2S81,39.61,83,37.56c2.47-2.53,5.79-3.76,8.48-5.88,4.28-3.36,9.3-5.3,14-7.75,2.06-1.07,4.39-1.62,6.5-2.65,3.9-1.92,8.15-2.92,12.31-4a95.84,95.84,0,0,1,18.33-3.12c4.41-.26,8.81-.79,13.24-.64.89.27,1.81,0,2.7.18h.5a1.9,1.9,0,0,1,1.18,0l1.63,0c.47.24,1,0,1.48.18A79.68,79.68,0,0,0,172,15C172.45,15.22,173,15,173.46,15.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M254.66,196.88l-1.24,2.39c-1.26,1.85-2.82,3.47-4,5.35a.92.92,0,0,1-1,.32c-10.16,0-20.31,0-30.47,0-.81,0-1.7.19-2.31-.61a84.09,84.09,0,0,0,7.71-8.52,2.09,2.09,0,0,1,.86-.61,4.66,4.66,0,0,1,1.24-1,1.64,1.64,0,0,1,1.25-.3c8.34,0,16.68,0,25,0C253.59,193.88,254.54,194.86,254.66,196.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.66,196.88c-.4-.69-1-1.2-1.11-2.12-.05-.68-.79-.51-1.29-.51q-12.56,0-25.13,0c-.63,0-1.34-.36-1.92.23-.13-.08-.15-.17,0-.28,1.75-3.11,4.15-5.75,6.18-8.66l.6-.88a2.76,2.76,0,0,1,1.71-.38c8,0,16,0,24,0,.8,0,1.81-.26,2.23.85l-.72,2.13c-.16.71-.16,1.49-.89,1.93-1.08,2.07-2.38,4-3,6.33A3,3,0,0,1,254.66,196.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.62,204.3a6.67,6.67,0,0,0,2,.25h29.77a2.53,2.53,0,0,1,1.51.24c.07.84-.65,1.28-1,1.91a20.67,20.67,0,0,1-1.44,2,38.61,38.61,0,0,0-3,3.94h0a.52.52,0,0,1-.74.27,11.72,11.72,0,0,0-2.14-.13H221.75a5.43,5.43,0,0,1-2.12-.22c-.39-.19-.63-.45-.36-1-.69.37-1,1.11-1.73,1.23a1.33,1.33,0,0,1-.4,0q-4.84,0-9.67,0a2.6,2.6,0,0,1-2.21-.63,11.38,11.38,0,0,1,3.31-2c1.51-.45,2.76-1.79,4-2.92A34.31,34.31,0,0,1,215.62,204.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M124.13,225.89c2.25.31,4.34,1.29,6.62,1.49.53,0,1-.12,1.5-.08,3.84.26,7.78.11,11.48,1a49,49,0,0,0,12.5,1.32,27.81,27.81,0,0,0,4.54-.83,7.45,7.45,0,0,1,.95-.08c.26,0,.38.48.73.26l1.89-.25c.2,0,.46,0,.48-.27.07-1.06,1.06-1,1.51-.84,1.59.46,3-.2,4.39-.58,2.76-.73,5.49-1.56,8.23-2.35a1.86,1.86,0,0,0,.9.41c.72.12,1.59-.26,2.06.64-.06.34-.35.45-.61.58a11.61,11.61,0,0,1-1.19.53,9.25,9.25,0,0,0,1.22-.51c.44-.14.85-.36,1.27-.53,1-.27,1.81-1,2.9-.81,4.14,0,8.27,0,12.41,0a2.88,2.88,0,0,1,2,.44c.41.6-.1.85-.46,1.09a15.23,15.23,0,0,1-2.11,1.22c-.94.44-1.87.91-2.79,1.4a35.67,35.67,0,0,0-4,1.94c-.71.35-1.48.54-2.2.85-.89.25-1.72.81-2.71.48a6.78,6.78,0,0,0-2.37-.21c-6.64,0-13.29,0-19.93,0a6.7,6.7,0,0,0-1.79.06c-3.91-.13-7.82,0-11.73-.06-.62,0-1.3.13-1.81-.41,2.2-.34,4.45-.22,6.64-.68a4.66,4.66,0,0,0,1.57-.51c-2.37.12-4.73.37-7.09.34-5-.09-10.09.15-15.12-.62A92.31,92.31,0,0,1,123.18,228c-.08-.06-.11-.1-.07-.14a.12.12,0,0,1,.09-.06c1.38-.19,2.66.41,4,.5.44,0,.9.16,1.23-.28,0,0,.06-.07.09-.07s.16-.11.13-.12a30.74,30.74,0,0,1-3.65-1C124.57,226.7,123.88,226.69,124.13,225.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M267.84,161.22a38.13,38.13,0,0,1-2.16,8.61,8,8,0,0,0-3.46-.37,8.49,8.49,0,0,1-1.75-.1c-.45-.51-.85,0-1.28,0-2.67.18-5.33.06-8,.08-3.22,0-6.44,0-9.66,0-.62,0-1.29.12-1.81-.4a25.16,25.16,0,0,1,1.62-3.82,27.11,27.11,0,0,0,1.86-6c.32-.61.9-.6,1.45-.6q7.28,0,14.53,0a1.8,1.8,0,0,1,1.53.52,1.3,1.3,0,0,1,.21.77,6,6,0,0,0-.21,1.65c.18-.29-.08-.75.17-1.09a.68.68,0,0,1,.34-.42.62.62,0,0,1,.85.53,2.25,2.25,0,0,1-.08.93c-.17.32-.11.71-.25,1-.14.62-.32,1.22-.5,1.82-.26.19-.09.54-.27.76s0,.53-.23.73,0-.06-.08.07a.46.46,0,0,0-.1.18c0,.08,0,.06,0-.06s.05-.07.05-.09c.33-.16.19-.48.25-.72.31-.19.11-.58.32-.81a12.07,12.07,0,0,0,.54-1.8c.14-.3.07-.65.22-.95s.07-.71.28-1a.87.87,0,0,1,.32-.22,1.89,1.89,0,0,1,.41-.1,34.35,34.35,0,0,1,3.93,0C267.34,160.44,268.07,160.33,267.84,161.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M148,231.79l12.25,0a3.25,3.25,0,0,1,1.51.24c.42-.27.94.06,1.37-.22l21.26,0a1.73,1.73,0,0,1,1.53.49c-.07.65-.68.57-1.07.79-1.27.39-2.47,1-3.76,1.36-1,.38-1.9.85-2.89,1.16a7.93,7.93,0,0,0-1.27.34c-.23.07-.44.16-.66.24-1.05.25-2,1-3.14.67a6.08,6.08,0,0,0-1.9-.11c-4.91.06-9.82.09-14.72.06-6.34,0-12.69,0-19-.08a3.76,3.76,0,0,0-1.76.21,2.72,2.72,0,0,1-.79.21,2.1,2.1,0,0,1-.75,0,1.94,1.94,0,0,0-1.18-.25,62.18,62.18,0,0,1-9.09-1.69,5.25,5.25,0,0,1-.92-.38s-.2-.19-.07,0c0,.06.09.11.08.2a.47.47,0,0,1-.21.25,2.9,2.9,0,0,1-1.84,0,32.8,32.8,0,0,1-3.22-.78,1.58,1.58,0,0,1-.81-.63c.15-.57-.37-.49-.65-.65l-.31-.14a12.46,12.46,0,0,1-2-1.06c-.26-.21-.68-.42-.45-.83s.62-.07.94,0a1.87,1.87,0,0,1,.22.07c.69.26,1.4.46,1.94.66-.44-.23-1.1-.35-1.71-.6-.35-.22-.92-.05-1.07-.61.74-.27,1.41.26,2.13.19a1.09,1.09,0,0,1,.83.06,14.44,14.44,0,0,0,4.41.86c2.37.33,4.64,1.1,7,1.56a11.86,11.86,0,0,0,1.18.14,2.27,2.27,0,0,1,1.34,0c.82.24,1.73,0,2.51.41,5.9.2,11.8.47,17.67-.5,1.22-.79,2.58-.28,3.87-.43a3.18,3.18,0,0,0,1.23-.14.58.58,0,0,1,.31,0c-.38-.08-.68.17-1,.18h-.58c-2.3-.1-4.6.32-6.9,0l-1-.08c-.57-.21-1.19.05-1.75-.17a8.1,8.1,0,0,1-2.93-.69C144.16,232.16,146.07,231.72,148,231.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M219.19,212.19a6.7,6.7,0,0,0,2,.26q10.22,0,20.44,0c.44,0,1.09-.33,1.29.45,0,.8-.86,1-1.15,1.57a37.22,37.22,0,0,0-2.5,3.1,1.78,1.78,0,0,1-1.75,1,28.56,28.56,0,0,0-4.89-.22c-6.38,0-12.76,0-19.14,0a5.71,5.71,0,0,0-2.05.54,1.42,1.42,0,0,1-.46,0,6.08,6.08,0,0,0-2.36-.27c-3.63,0-7.26,0-10.89,0-.65,0-1.39.12-1.8-.63,1.89-1.39,3.65-3,6.06-3.51,1.07-.25,1.71-1.37,2.66-1.93.2-.11.34-.34.61-.31,3.62.57,7.27.12,10.91.27.46,0,1-.16,1.37.21a.68.68,0,0,1-.19.42,1.44,1.44,0,0,0,.8-.52C218.45,212.31,218.75,212.05,219.19,212.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M259.93,185.16a2.85,2.85,0,0,0-2-.49H232c1.28-2.35,3-4.46,4-6.94a2.69,2.69,0,0,1,2.57-1.11c5.48,0,11,0,16.46,0a3.19,3.19,0,0,1,1.85.3c.19.38.19.38.85-.16a27,27,0,0,1,4.76-.09,1,1,0,0,1,.84.38.54.54,0,0,1,0,.43c-1,2.28-2,4.57-3,6.85A7.19,7.19,0,0,1,259.93,185.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M257.05,177.25a2.62,2.62,0,0,0-1.51-.24H239.21c-1.12,0-2.29-.21-3.2.72.83-1.67,1.54-3.4,2.51-5,.71-1.16.58-2.52,1.2-3.66l20,0c.16,0,.33-.16.49,0h4.38c.54,0,1.07,0,1.13.72a54.84,54.84,0,0,1-1.77,5.86c-.07.26-.11.53-.17.79s.16.79-.44.8c-.72-.53-1.53-.21-2.29-.25-1.15-.06-2.3,0-3.45,0a5.54,5.54,0,0,1,.19-1.32C257.59,176.26,257.65,176.9,257.05,177.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M271.39,126.5l.08.73a1.9,1.9,0,0,1,0,1,9.57,9.57,0,0,0,0,2.14,1.49,1.49,0,0,1-.31,1.23,16.56,16.56,0,0,1-5.44.16c-.49-.18-.85-.66-1.44-.64a7.63,7.63,0,0,0-2.13-.21c-4.42,0-8.85,0-13.27,0-1,0-1.84.06-2,1.3,0,.16-.19.24-.36.25.14-2.64-.33-5.25-.29-7.89a1,1,0,0,1-.12-.57c0-1.56.08-1.72,1.63-1.72q7.28,0,14.54,0a2.56,2.56,0,0,1,1.6.36c.61.82.44,1.81.53,2.73a5.21,5.21,0,0,0,.32,1.55c-.23-.82-.64-1.76,0-2.73a18.38,18.38,0,0,1,5.34-.11c.25,0,.62.78.74-.12,0-.15.23-.17.39-.07a1.34,1.34,0,0,1,.22.69C271.59,125.24,271.09,125.84,271.39,126.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M242.89,102.35a2.67,2.67,0,0,1,1.5-.26c4.58,0,9.16,0,13.74,0,1.17,0,2,.22,1.88,1.61,0,.21.22.42.26.64s.12.47.44.35.28-.29.23-.58c-.39-2-.38-2,1.66-2,1.63,0,3.26,0,4.89,0,.5,0,1,0,1.26.48a29.57,29.57,0,0,1,1.47,6.71c-.45.44-1,.34-1.56.36-1.93.05-3.87-.09-5.79.1a1.48,1.48,0,0,1-.42,0,.6.6,0,0,1-.45-.34c-.18-.63-.36-1.26-.48-1.9-.13-.29-.07-.62-.22-.88a3.69,3.69,0,0,0,.27,1.1c.05.59.3,1.13.4,1.71s.6,1.18.12,1.83a1.1,1.1,0,0,1-1.13.09c-.68-.55-.49-1.4-.71-2.11.07.33-.15.4-.38.47-5.18,0-10.35-.17-15.52.08A19.1,19.1,0,0,1,242.89,102.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M244.35,109.77a1.68,1.68,0,0,1,1.52-.5c4.26,0,8.53,0,12.79,0a8.46,8.46,0,0,1,1.52.25c.39-.06.31.23.35.45a33.8,33.8,0,0,0,.75,4.2,7.23,7.23,0,0,1-.38-3h1.17l.12.08c.11,0,.06.34.28.15.07-.64-.44-1.3.09-1.91a5.31,5.31,0,0,1,2.56-.23c1.7,0,3.4,0,5.1,0a77.17,77.17,0,0,1,1.44,8.4c.11,1.1.31,2.19.37,3.3-.09.49-.52.49-.62.18-.16-.49-.41.1-.52-.13a.86.86,0,0,1-.28-.77,3.86,3.86,0,0,0,0-2.88,4.53,4.53,0,0,1,.24,1.58.32.32,0,0,1-.24.21c-.25,0-.37-.22-.53-.38s-.42-.36-.38-.68a3,3,0,0,0,.15-.66c.06-.55-.17-.43-.47-.25-1.72.25-3.47-.14-5.17.26-1.12-.1-.67-1.16-1-1.69,0-.19-.19-.05,0-.09s0,0,0,.09a.9.9,0,0,1,0,.91c-.35.24-.67.07-1-.08a1.5,1.5,0,0,1-.41-.71c0-.09-.07-.19-.1-.28-.29-.39-.52.05-.78.06a5.64,5.64,0,0,1-1.78.21H247a2.38,2.38,0,0,1-1.7-.38A30.81,30.81,0,0,1,244.35,109.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M260.66,159.56c-.22-.51-.66-.5-1.11-.5H244.23a2,2,0,0,0-1,.24c-.24-3.07,1-5.81,1.93-8.62a.93.93,0,0,1,1-.81c5.22,0,10.44-.2,15.65.1.83.44.53,1.21.54,1.89a.11.11,0,0,0,0,.09s.08,0,.12,0a1.23,1.23,0,0,1,1,.08.6.6,0,0,1,.21.48c0,.24-.08.47-.09.7a11.86,11.86,0,0,1-.28,1.56,17,17,0,0,0-.68,3.24,8.59,8.59,0,0,1-.31,2.76h0a.33.33,0,0,1-.48,0c0-.47-.35-.49-.7-.48-.47-.59.14-1.13.06-1.7C261,158.85,261.38,159.53,260.66,159.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M263.5,152.12h-1.16c-.38-.6.34-1.34-.24-1.91H246.5c-.52,0-1-.07-1.37.47-.52-2.28.2-4.47.47-6.69a2,2,0,0,1,1.58-.38h14.65a4.36,4.36,0,0,1,2.3.47c.45.53.07,1.22.34,1.68a5.41,5.41,0,0,1-.1-1.26.31.31,0,0,1,.33-.32c.39,0,0,.91.64.52a25,25,0,0,1,4.24-.07,1.58,1.58,0,0,1,1.08.4,1.49,1.49,0,0,1,.24.77,2.66,2.66,0,0,1-.41,1.31c-.45,2.05-.41,4.17-1,6.2a6.42,6.42,0,0,0-2.91-.36,8,8,0,0,1-2.48-.17.64.64,0,0,1-.33-.47,2.18,2.18,0,0,1,0-.57,2.73,2.73,0,0,0,.21-1.19,2.63,2.63,0,0,1,0-.49,2.51,2.51,0,0,0,.13-1.21,1.12,1.12,0,0,1-.05-.31,1.33,1.33,0,0,1,.15-.7,1.56,1.56,0,0,0-.15.92,1.22,1.22,0,0,1,0,.33,7.76,7.76,0,0,0-.15,1.36,4.17,4.17,0,0,1,0,.71C263.78,151.46,263.82,151.87,263.5,152.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M39.38,122.19c0-1.12,0-2.24-.07-3.36a37.18,37.18,0,0,1,.78-5.74c.45-.72,1.11-.57,1.77-.4.43.27.4.71.45,1.13a.69.69,0,0,1-.09.31.76.76,0,0,0,.18-.26c.31-.44.22-1,.46-1.46a1.06,1.06,0,0,1,.6-.52,77.92,77.92,0,0,1,8.23-.08c.36,0,.83,0,.85.6a73.57,73.57,0,0,0-1,15,2.25,2.25,0,0,1-.17,1.28c0-1.23,0-2.46,0-3.69,0-.51,0-1-.71-.93-.26-.43-.08-.9-.13-1.35.21-1.33.33-2.67.53-4-.23,1.28-.29,2.58-.53,3.86a.76.76,0,0,1-.13.53H39.59C39.55,122.83,39.69,122.46,39.38,122.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M195.93,217.92a2.63,2.63,0,0,0,1.51.26h11.95a2.16,2.16,0,0,1,1.68.43c-.23.65-.87.86-1.32,1.28-2.79,2.12-5.86,3.82-8.74,5.8-.28.2-.59.46-1,.12a2,2,0,0,0-1.66-.45H186.46c-.42,0-.89.15-1.25-.21,0-.12.16-.24.15-.3s-.13,0-.19,0c-.92.26-1.78.68-2.68,1-.22,0-.44.15-.64,0-.54-.78-1.59-.1-2.17-.74-.07-.06-.09-.1-.05-.13a.1.1,0,0,1,.09,0c4.18-1.47,8.57-2.41,12.37-4.88C193.31,219.23,194.65,218.61,195.93,217.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M262.1,116.45a1.41,1.41,0,0,1,.91.24c1,1.23.78,2.79,1.05,4.2.12.64.58,1.39-.1,2a2.21,2.21,0,0,0-1.38-.24H248.16c-2.21,0-1.83-.22-1.88,1.91-.13-3-1.12-6-1-9.1h12.5a14,14,0,0,0,3.54-.24c.29.2.21.56.37.81s.08.25.13.38A.26.26,0,0,0,262.1,116.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M264.25,144.47A4,4,0,0,0,262,144H245.6l.27-3.57a7.1,7.1,0,0,0,.28-2.59c0-.79.32-1.08,1-1.12.44,0,.87,0,1.31,0,4.35,0,8.7,0,13.05,0a8.38,8.38,0,0,1,2.12-.09l.15.15c0,.06,0,.13.05.19a9.47,9.47,0,0,0-.59,3c0,.9,0,1.8,0,2.7,0-.87,0-1.74,0-2.61,0-.68-.12-1.4.41-2a.85.85,0,0,1,.82.08c.49.76.24,1.6.29,2.41a24.24,24.24,0,0,0,.08,2.69,2,2,0,0,1,.15.55.41.41,0,0,1-.33.4l-.23.25C264.4,144.57,264.32,144.56,264.25,144.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M263.76,136.8a6.4,6.4,0,0,1-2.61.23H249c-2.7,0-2.7,0-2.71,2.65a2,2,0,0,1,0,.82c-.16.35-.25-.08-.39-.1.28-2.64,0-5.33.7-7.93.46-.53-.17-1.42.41-1.76s1.56-.14,2.34-.14c4.58,0,9.15,0,13.72,0a2.2,2.2,0,0,1,1.66.49c.66.85.23,1.85.36,2.77a9,9,0,0,1-.21,2.13c-.16.76.21,1.6-.38,2.28h-.71c-.32-.4-.16-.79,0-1.19h0c.25-.33,0-.71.1-.9s-.24-.1-.1-.16.09,0,.09.07C263.86,136.3,264,136.57,263.76,136.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M93.68,232.69A22.23,22.23,0,0,1,90,230.17a33.44,33.44,0,0,1-6.14-4,.77.77,0,0,1-.43-.78c.09-.41.46-.51.82-.55a5.67,5.67,0,0,1,1.54,0c1.28.76,2.86.82,4.11,1.67.8.06,1.42.64,2.18.82a3.3,3.3,0,0,1,.84.47,4,4,0,0,0,1,.66c.17.09.34.18.51.25a.59.59,0,0,0,.19,0,.19.19,0,0,0-.14-.13l-.61-.34a1.83,1.83,0,0,1-.36-.32,1.38,1.38,0,0,1-.4-1.07c.08-.16.19-.29.39-.19a3.67,3.67,0,0,0,2.13.92c.4.22.5.81,1,.86-.19-.12-.39-.24-.33-.52l.22-.09c.74-.22,1.26.44,1.93.48,2.44.49,4.54,1.8,6.81,2.7a75.77,75.77,0,0,0,8.05,2.65,3.93,3.93,0,0,1,1.7.25c.79.26,1.62.38,2.41.67a1.11,1.11,0,0,1,.32.21c.13.16.23.33.09.54-1.14.61-2.38.21-3.56.31s-2.2-.73-3.29-1.12c-.13,0-.22-.17-.34-.23,0,.1.14.18.15.31a.66.66,0,0,1-.13.31,2,2,0,0,1-1.93-.12c-.61-.27-1.19-.6-1.81-.88-.43-.19-.83-.27-1.12.22-.75.69-1.69.53-2.58.55s-2.06-.21-2.74.87c-.17.27-.55.27-.88.19a1.46,1.46,0,0,1-.59-.42C97.25,234.56,95.47,233.62,93.68,232.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M52.54,112.41c-.33-.42-.81-.26-1.22-.26H43.19c-.46-.61,0-1.19.05-1.78s.25-1.31.36-2a1.7,1.7,0,0,1,.26-.69,7.68,7.68,0,0,0,.78-2.43,3,3,0,0,1,.71-2.71l10.13,0c-1,2.25-1.31,4.68-2,7A15.26,15.26,0,0,1,52.54,112.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M40.32,144.46c.7-.69.15-1.49.13-2.21,0-.52-.13-1.07-.13-1.62a2,2,0,0,1,1.46-.37c2.31,0,4.62,0,6.93,0,.62,0,1.3-.06,1.68.64a.7.7,0,0,1,0,.45,26.19,26.19,0,0,0,.62,4.09c.63,2,.57,4.14,1,6.18.12.18.13.4-.06.5s-.34-.11-.5-.2a2.93,2.93,0,0,1-.68-1.92c-.1-.29-.38-.54-.36-.85,0-.78-.31-.07-.45-.13-2.23.22-4.45.07-6.68.1a5.74,5.74,0,0,0-2.32.4A30.94,30.94,0,0,1,40.32,144.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M41,149.52c.08-.8.66-.76,1.24-.76h8.1a.93.93,0,0,1,0,1,8.28,8.28,0,0,0,.55,4.07,15.2,15.2,0,0,1,.59,5c-1-1-2.2-.85-3.41-.83s-2.69-.07-4,.07a1.08,1.08,0,0,1-.9-.19L42.7,156c-.3-.35.1-.85-.27-1.18v0c0-.41-.72-.27-.66-.77A12.11,12.11,0,0,1,41,149.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M51.33,178.42c-1.35-.25-1.63-1.59-2.21-2.46-2.11-3.11-2.88-6.79-3.81-10.38-.23-.65.23-.94.7-1a26.52,26.52,0,0,1,5.84,0,.85.85,0,0,1,.64.5c.13.28,0,.66.3.87a5.6,5.6,0,0,0,.36,1.62c.07.31.37.42.55.63a34.61,34.61,0,0,1,1.5,4.29,3.18,3.18,0,0,0-.06.43c.12.7.78,1.22.65,2a.39.39,0,0,1-.36.28c-.6-.26-.7-.93-1.09-1.37-.19-.17-.17-.65-.63-.41a13.46,13.46,0,0,0-2.15.52c-.17-.07-.39-.24-.51-.19-.29.12,0,.31.05.46.35,1,.73,2.06,1.09,3.09.19.54.25,1-.57,1C51.52,178.3,51.47,178.44,51.33,178.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M52.49,165c-2.16-.49-4.33-.19-6.49-.16a.7.7,0,0,0-.69.7,54,54,0,0,1-2.11-7.72c2.32-.46,4.66-.13,7-.25.89,0,1.09.59,1.35,1.2-.73,1.5-.06,2.92.25,4.35A13.82,13.82,0,0,0,52.49,165Z",
    transform: "translate(-8.9 -13.51)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M60.93,185.59c1.21,1.26,2.22,2.71,3.52,3.91a18.87,18.87,0,0,1,2,2.53c.26.33.39.8.88.89.78.57,1,1.67,2,2a3.52,3.52,0,0,1,1,1.71c.2.89,1.06,1.19,1.65,1.72a3.28,3.28,0,0,1,.95,1.42.85.85,0,0,1-.15.69.24.24,0,0,1-.34,0c-2.29-2.29-4.93-4.27-6.7-7.05-.35-.55-1-.63-1.39-1.07A44.72,44.72,0,0,1,59,184.91c.09-1,.42-1.15,1.46-.45C60.76,184.77,60.62,185.27,60.93,185.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M60.36,184.67c-.55-.43-1.1-.92-1.37.24l-.49-.7c-.74-.22-.79-1.15-1.47-1.43a32.71,32.71,0,0,1-2.84-5.28c-.62-.67-.81-1.68-1.7-2.13a3.22,3.22,0,0,1-.93-1.47c.6-.85,1.51-.69,2.36-.72.3.18.38.55.64.77A46.07,46.07,0,0,0,58,180.84a8.89,8.89,0,0,0,.64,1c.52.58,1,1.22,1.55,1.77C60.35,183.94,60.8,184.24,60.36,184.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M85.76,224.9a2.71,2.71,0,0,1-1.51.23c-.24,0-.52,0-.63.24s.18.48.39.63a56.25,56.25,0,0,0,5.74,3.84c.15.08.3.12.22.33a12.35,12.35,0,0,1-4.22-2.24c-1.34-.94-2.65-1.93-4-2.9a11.22,11.22,0,0,0-2.14-1.86,13.93,13.93,0,0,1-3-2.59c.29-.68.64-.25,1-.1,0-.28-1-.48-.12-.92,2.46,1.53,4.93,3.06,7.38,4.6C85.19,224.37,85.6,224.49,85.76,224.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M107.61,229.68c-1.36-.39-2.73-.68-3.72-1.92-.42-.53-1.29-.69-1.9-1.13a43.44,43.44,0,0,1,5.64,2.11c.41,0,.64.2.55.65C108.06,229.63,107.78,229.54,107.61,229.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M71.43,216.54c-.34-.26-.27-.51,0-.76a.41.41,0,0,1,.26-.2l.44,0c.91-.2,1.2.84,2,1a13.28,13.28,0,0,1,2.19,1.91c-.41.2-.75.61-1.29.4s-.7-.76-1.28-.76a3.6,3.6,0,0,1-1.2-.92C72.19,216.85,72,216.43,71.43,216.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M115.09,234.21a3.58,3.58,0,0,1-1.72-.44c.16-.17.59-.3.07-.55l-1.17-.54c.22-.21.42-.12.61-.1.88.16,1.82-.07,2.64.41a1,1,0,0,0,.72,0l.22.06a3.1,3.1,0,0,0,.56.64l.64.51c.4.25.43.5,0,.73a.8.8,0,0,1-.21-.05C116.76,234.31,115.86,234.46,115.09,234.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M172.74,34.58a1,1,0,0,1,1.37.24c.38.6.72,1,1.48,1a5.62,5.62,0,0,1,2.3.33c.29.1.65.09.84.4a.77.77,0,0,1-.61.37,4.72,4.72,0,0,1-2.75-.81c-1.1-.14-2.11-.83-3.28-.55-.4.27-.59.12-.64-.31s.29-.39.53-.47c.47-.06.87.35,1.35.19.16,0,0-.19,0,0s0,.06-.1,0C173,34.89,172.66,35.07,172.74,34.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M75,218.63c.46.24.81-.17,1.23-.22l1.22,1.15c-.28.73.68.8.73,1.35-.6.34-.85-.85-1.49-.35-1-.06-1.44-.83-1.83-1.61A.55.55,0,0,1,75,218.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M171.54,35.07a.43.43,0,0,0,.55.44.48.48,0,0,1,.49.39A42.4,42.4,0,0,1,167.5,35c.55-.9,1.38-.5,2.13-.46.32.24.64,0,1,0l.14,0C171,34.77,171.34,34.8,171.54,35.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.24,231.8a7.34,7.34,0,0,1-4.54-.65c-.14-.3,0-.46.27-.58l1.65.31c.33.12.72.08,1,.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M116.24,233c-.06.3-.12.6-.49.23-.6-.32-1.29-.41-1.89-.71a.73.73,0,0,0-.51-.76c-.22-.11-.4-.25-.37-.54.07-.13.23-.24.1-.41.23-.23.52-.14.79-.15l1.15.43c.06.22,0,.33-.25.26l-1.36-.23C114.3,232.22,115.53,232.27,116.24,233Z",
    transform: "translate(-8.9 -13.51)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M72.66,199.76l-.76-1.37c1.14,1.14,2.66,1.88,3.54,3.29-.16.24-.43.24-.68.28l-.47-.48c-.12-.17-.29-.29-.42-.45a1.92,1.92,0,0,0-.82-.67C72.74,200.28,72.82,200,72.66,199.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M93.52,226.77l-.32.35c-.7.17-1.11-.44-1.67-.64-.51-.41-1.22-.63-1.36-1.4,0-.55.34-.28.54-.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M57.52,176.82l-.69-1.22c-.32-.34-.83-.6-.48-1.2.34-.24.62-.3.81.19.26.66.56,1.31.85,2A.66.66,0,0,1,57.52,176.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M53.26,155.94l.64,1.7a.92.92,0,0,0,.26.94c0,.23.14.52-.12.64s-.39-.15-.41-.33c-.12-1-.78-1.9-.83-2.95A.3.3,0,0,1,53.26,155.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M56.35,174.4l.48,1.2c-.3.1-.47-.18-.71-.26a.5.5,0,0,1-.36-.52c0-.81-.67-1.39-.85-2.14l.29-.23C55.8,173,55.92,173.77,56.35,174.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M108.12,229.36c0-.33-.39-.36-.49-.62l0,0c.73-.21,1.45-.39,1.93.46l.7.78.08.09-.07.09-1.19-.29C108.64,229.89,108.28,229.81,108.12,229.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M129.4,233.28a4.36,4.36,0,0,1,3.38.2c-.47.76-1.13.22-1.71.26C130.51,233.6,129.89,233.69,129.4,233.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M59.3,179.14l1.82,2.91a.37.37,0,0,1-.49,0A15.92,15.92,0,0,1,59,179.4C59.08,179.28,59.11,179.13,59.3,179.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M175.09,36.3a13.35,13.35,0,0,1,2.69.92,5.34,5.34,0,0,1-2.84-.51C174.58,36.58,174.83,36.37,175.09,36.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M74.08,216.5c0,.35-.15.4-.43.18-.5-.39-1-.76-1.52-1.14,0-.54.28-.64.67-.28S73.65,216.09,74.08,216.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M104.5,44l.44-.07a1.59,1.59,0,0,1,1.09.31,1.52,1.52,0,0,1-.83.66c-.63-.12-1.25.46-1.89,0l.1-.22A1.84,1.84,0,0,1,104.5,44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M110.19,228.74h-.41c-.75.29-1.16-.13-1.47-.72l0-.2c.14,0,.3-.07.42,0a9.51,9.51,0,0,1,2.11.88A.46.46,0,0,1,110.19,228.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M103.31,44.88c.63.08,1.25-.58,1.89,0-.67.59-1.54.34-2.32.61A.56.56,0,0,1,103.31,44.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M57.52,176.82a.46.46,0,0,1,.49-.27c.23.47.46.95.7,1.43a.69.69,0,0,1-.46.27A2.1,2.1,0,0,1,57.52,176.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M53,167.67a1.63,1.63,0,0,1-.2-1.76,5.38,5.38,0,0,1,.68,1.77A.34.34,0,0,1,53,167.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M74.76,202c.15-.3.41-.29.68-.28l.87.91c-.11.25-.37.15-.55.24A2.07,2.07,0,0,1,74.76,202Z",
    transform: "translate(-8.9 -13.51)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M91.65,227.07c-.61,0-1-.52-1.54-.69-.08-.26-.69-.09-.49-.59.61,0,1,.46,1.49.73C91.48,226.52,91.68,226.69,91.65,227.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M58.25,178.25a.45.45,0,0,1,.46-.27l.59,1.16-.29.26-.26-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M162.45,229a1.49,1.49,0,0,1-.38.22c-.19,0-.46.06-.56,0s.51-.11.21-.44a1.05,1.05,0,0,1,.95-.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M72.66,199.76l.45.47a1.66,1.66,0,0,1,.82.87c0,.18-.18.24-.32.3l-.25,0c-.2-.32-.54-.54-.68-.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M75.76,202.83c.13-.2.34-.21.55-.24l1,.94A2.33,2.33,0,0,1,75.76,202.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M60.63,182.05h.49c.23.35.45.7.81,1.24C61.08,183.07,61,182.43,60.63,182.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M53.26,155.94H52.8c-.11-.23-.22-.46-.32-.69l.49-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M110.25,230.13a1.09,1.09,0,0,1,0-.18c.43.1.91.1,1.18.54l.09.06-.07.07C111.05,230.44,110.56,230.5,110.25,230.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M52,141.57a2.59,2.59,0,0,1,0-2.13A7.24,7.24,0,0,1,52,141.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M50.4,149.78c0-.34,0-.67,0-1,0-.1.13-.39.2-.2a7.53,7.53,0,0,1,.27,1.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M113.12,231.12l.23.67a2.53,2.53,0,0,1-1.16-.41,1.18,1.18,0,0,1,.19-.25C112.63,231,112.87,230.88,113.12,231.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M113.12,231.12a.61.61,0,0,0-.59.23c-.2-.06-.25-.22-.29-.4a.54.54,0,0,1,.15-.3c.28-.09.47.11.69.19S113.3,231,113.12,231.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.13,232.81c.58,0,1.2-.21,1.75.17A3.26,3.26,0,0,1,145.13,232.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M225.18,194.21l0,.28c-.4.13-.55.64-1,.68A1.47,1.47,0,0,1,225.18,194.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M72.68,200.47a1.15,1.15,0,0,1,.68.91,2.16,2.16,0,0,1-1-.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M54.16,158.58c-.62-.17-.51-.53-.26-.94C54,158,54.23,158.22,54.16,158.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M112.4,230.84a1.08,1.08,0,0,1-1-.37v0c.36-.16.66,0,1,.16C112.39,230.71,112.4,230.77,112.4,230.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M53,167.67h.48a.42.42,0,0,1,.23.48C53.36,168.16,53,168.16,53,167.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M52.54,145.89l-.25-.1c0-.37-.11-.76.18-1.09C52.5,145.1,52.52,145.49,52.54,145.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M73.61,201.4l.26-.23a.37.37,0,0,1,.21-.23.5.5,0,0,1,.21.54A.82.82,0,0,1,73.61,201.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M51.53,133.93a.87.87,0,0,1,0-1.19A2.1,2.1,0,0,1,51.53,133.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M244.13,112.76c-.33-.14-.34-.54-.18-.64s.16.21.23.33S244.31,112.67,244.13,112.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M203.17,244l-.75.26c-2.14,1.14-4.38,2.1-6.48,3.33a8.11,8.11,0,0,1-2.6.76c-1.13.39-2.14,1.13-3.4,1.11a25.23,25.23,0,0,0-2.75,0H134.92a10,10,0,0,0-2.38.15c-.76.25-1.55-.33-2.31.06-.41.19-.81.48-1.29.15a.38.38,0,0,1-.06-.31.55.55,0,0,1,.69-.27c-.15-.11-.32,0-.47,0s-.56-.05-.84-.06a5.06,5.06,0,0,1-2.93-1,118.78,118.78,0,0,1-18.92-5.61c-.31-.59.07-.8.53-.92a5.71,5.71,0,0,1,1.54-.1h15.4a5.08,5.08,0,0,0,2.44-.35,1.88,1.88,0,0,1,.67,0c3.42.64,6.88,1.05,10.31,1.58a47.51,47.51,0,0,0,7.81.5,52.78,52.78,0,0,0,6.4.43c1.73.07,3.45.48,5,.09-.07,0-.42,0-.5-.25s.22-.38.43-.44a6.37,6.37,0,0,1,1.31-.1,53.21,53.21,0,0,0,5.36-.14,3.16,3.16,0,0,1,.92,0,7,7,0,0,0,1.65.18c11.8-.09,23.6,0,35.4,0a5.76,5.76,0,0,1,1.55.11C203.15,243.18,203.47,243.42,203.17,244Z",
    transform: "translate(-8.9 -13.51)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M132,249.52a1.89,1.89,0,0,1,1.41-.47h55.84c.35,0,.72-.09,1,.21-.9.92-2.14,1.08-3.29,1.45a3.35,3.35,0,0,0-1.72,0c-1.11.25-2.22.46-3.34.61a.72.72,0,0,1-.15,0l.1.07c.2.21.5.4.15.72-1.62.6-3.34.87-5,1.41-1,.34-2.16-.29-3.27-.08-.53.1-1.09.13-1.63.24a6.1,6.1,0,0,0-1.48.16c-.43.16-.86-.23-1.28,0l-.09,0-.08.05c-.39.28-.89,0-1.29.22l-.07,0-.07,0c-.46.34-1,0-1.51.24l-.09,0-.08,0c-.46.32-1,0-1.5.24l-2.34.31c-.74.19-1.52-.08-2.25.16a2,2,0,0,0-1.1,0c-2.09.23-4.19.33-6.3.45h-.4c-.47.31-1,0-1.52.23h-2.23c-1-.29-2.15.11-3.2-.22a2.76,2.76,0,0,0-1.34,0,8.34,8.34,0,0,0-2.82,0,18.39,18.39,0,0,0-3.4,0c-.41-.23-.91.06-1.31-.24l-.08,0-.08,0c-.89-.28-1.82-.26-2.71-.48l-.07-.05-.07.05c-.49-.25-1.06.08-1.54-.22l-.08-.05-.09,0c-.47-.25-1,.06-1.5-.21a24.37,24.37,0,0,1-5.57-.72c-.41-.32-1,.08-1.38-.27a28.44,28.44,0,0,1-6.38-1.48c-.85-.54-2-.36-2.73-1.2a.17.17,0,0,1,0-.11.19.19,0,0,1,.2-.07,52.55,52.55,0,0,1,8.72,1.36,5.48,5.48,0,0,0,1.26.12c1,.15,2.09,0,3.12.21a27.88,27.88,0,0,0,7.08,1.11,5.66,5.66,0,0,1,1.52.33,3.65,3.65,0,0,0,2.33,0,4.78,4.78,0,0,1,2.41-.18,48.33,48.33,0,0,1-6.09-.47c-1.65-.29-3.32-.39-4.95-.79a35.28,35.28,0,0,1-6.76-1.31,38.22,38.22,0,0,0-6.18-1.43c-.28-.68.42-.66.68-1a.82.82,0,0,1,.35,0c1.12.12,2.19.5,3.32.55a2.21,2.21,0,0,1,.37,0,1.37,1.37,0,0,1,.35.08c.41.15.87.09,1.25.33a27.62,27.62,0,0,0,7.33,1.21,25.11,25.11,0,0,0,3.95.69,51.85,51.85,0,0,0,9.88.69,5.68,5.68,0,0,1-.62,0,8.18,8.18,0,0,0-1.4,0,59.24,59.24,0,0,1-7.17-.59,39.3,39.3,0,0,1-4.71-.82,20.16,20.16,0,0,1-7.24-1.31c0-.44,0-.72.56-.5.44-.16.77.32,1.2.2,1-.52,1.84,0,2.75.15.46.09,1,0,1.33.4s.8-.09,1.2,0C130.74,249.2,131.36,249.45,132,249.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M163.17,243.11c-1.82.45-3.67.09-5.51.2-.4-.24-.85-.07-1.27-.12-.25,0-.48,0-.41-.39,1.39-.7,2.94-.54,4.41-.8a71.73,71.73,0,0,0,9.15-2.1,4.8,4.8,0,0,0,1.37-.41,1.16,1.16,0,0,1,.52-.15,67,67,0,0,0,9.67-2.51c1.14-.22,2.16-.79,3.26-1.11a2.19,2.19,0,0,1,1.61-.12,6.57,6.57,0,0,0,2.25.15c6.25,0,12.51,0,18.76,0a5.29,5.29,0,0,1,1.12-.15c2.16.28,4.34,0,6.5.17.52,0,1.41-.27,1.27.85A46.22,46.22,0,0,1,210,240.3c-2.22,1.29-4.52,2.46-6.78,3.69,0-1-.73-.66-1.21-.66-6.38,0-12.75,0-19.12,0h-17a6.08,6.08,0,0,1-2-.25.23.23,0,0,1,0-.3c.77,0,1.51-.28,2.28-.3-.76,0-1.48.31-2.23.25C163.7,242.85,163.32,242.75,163.17,243.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M215.87,236.64c-.1-.67-.62-.5-1-.5-1.63,0-3.26,0-4.9,0a6.08,6.08,0,0,1-2-.25c-.06-.51.41-.6.67-.86a6.9,6.9,0,0,0,.87-.52c.06,0,.15-.15.14-.16s-.21.1-.34.11c-.77.46-1.63.78-2,1.67H187c-.5,0-1.07.14-1.34-.5.38-.87,1.4-.78,2-1.33a4.84,4.84,0,0,1,1.93-.77c.5-.2,1-.27,1.55-.48.76-.3,1.46-.77,2.24-1-1.25-.23-2.24.58-3.36.86s-2.26,1.18-3.6.93c.18-1.19,1.3-1.24,2.08-1.7a24.56,24.56,0,0,0,2.61-.93c1.43-.35,2.45-1.39,3.64-2.16.44-.17.79-.57,1.32-.52.76.21,1.59,0,2.34.35s1.33-.44,2-.35c4.57.16,9.13,0,13.69.08a3.64,3.64,0,0,1,2,.28.51.51,0,0,1,.24.51,5.46,5.46,0,0,1-1.4,1.08c-.3.17-.47.52-.69.55a3.17,3.17,0,0,0,.57-.45,8.68,8.68,0,0,0,1.23-.85c.66-.31,1-1.15,1.83-1.19,2.19.14,4.39,0,6.58.09.59,0,1.34-.09,1.42.85A79.19,79.19,0,0,1,215.87,236.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M225.93,229.46c-.24-.56-.73-.51-1.2-.51-1.78,0-3.55,0-5.32,0a5.81,5.81,0,0,1-1.86-.25c-.42.11-.59.81-1.19.49a2.67,2.67,0,0,0-1.5-.25H201.94a6.31,6.31,0,0,1-1.88-.25c-.57.1-1,.68-1.67.5-.71-.6-1.68,0-2.4-.49.15-.8,1-.68,1.44-1.09,2.83-1.27,5.26-3.2,7.91-4.78a2.43,2.43,0,0,1,1.76-.55c4.68.15,9.35,0,14,.06a2.65,2.65,0,0,1,2.5,1c.85.51,1.06-.43,1.57-.7a1.54,1.54,0,0,1,1.05-.44c1.95.2,3.91,0,5.86.14.47,0,1.31-.27,1.22.76A51.76,51.76,0,0,1,225.93,229.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M126.57,241.37a4.84,4.84,0,0,1-2.75.52c-5.43,0-10.86,0-16.28,0-.46,0-1.13-.25-1.13.63a70.64,70.64,0,0,1-6.49-3c-.27-.51-1-.72-.94-1.46l0-.24c.35-.28.65-.05,1,.1s.54.24.81.35c-.21-.13-.52,0-.69-.29-1-.54-2-1.09-3-1.59a.92.92,0,0,1-.48-.45A8.55,8.55,0,0,1,94,234.61c-.09-.05-.2-.08-.16-.22s.16-.22.32-.18a3.52,3.52,0,0,0,1.36.28c.33.2.67-.05,1,0a10,10,0,0,0,1,.2,5.9,5.9,0,0,1,1.22.5,2.75,2.75,0,0,1,.69.43c.58,0,1.11,0,1.24-.75s.66-.4,1.06-.44c1.39-.14,2.85.36,4.16-.47.89-.2,1.54.43,2.3.69a4.87,4.87,0,0,0,2,.51c1.41.33,2.71,1,4.08,1.42a11.25,11.25,0,0,0,1.63.46,16.75,16.75,0,0,1,2.31.73,12.46,12.46,0,0,0,1.56.43,1.76,1.76,0,0,1,.33.07,7.58,7.58,0,0,0,.82.21c.52.14,1.05.19,1.57.3,1.38.37,2.81.52,4.18.92a18.71,18.71,0,0,0,2,.49,14.56,14.56,0,0,0,1.61.25,3,3,0,0,0,.9.13h.58a20.36,20.36,0,0,1,4.48.24,3.1,3.1,0,0,1,.61.09,22.56,22.56,0,0,0,3.38.38c.58.09,1.29-.23,1.67.52-.34.45-.9.35-1.35.55a36,36,0,0,1-5.19-.27c-.81-.06-1.65-.06-2.46-.2s-1.76-.14-2.61-.4a19.71,19.71,0,0,1-4.32-.59c-.41-.1-.8-.26-1.22-.35s-.87-.28-1.32-.36c-.16,0,0,.12,0,.11.43-.1.79.16,1.19.24.23,0,.44.12.67.16C125.65,241,126.36,240.72,126.57,241.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M223.77,224.16c-.65-1.32-1.76-1.49-3.14-1.46-4.13.09-8.26,0-12.39,0a2.71,2.71,0,0,1-1.51-.25c-.07-.46.28-.62.58-.8.85-.51,1.58-1.18,2.4-1.74a14.43,14.43,0,0,0,1.63-1.29,3.14,3.14,0,0,1,2.36-.73c7.22,0,14.43,0,21.65,0a7.57,7.57,0,0,1,2.54.43c-.35,1-1.28,1.52-2,2.24-.3.31-.69.52-.89.92l-1.7,1.63c-.11-.59-.59-.42-.94-.42-1.58,0-3.16,0-4.73,0a6.36,6.36,0,0,1-1.74-.25c-.12-.23,0-.36.23-.57L225,223A3.79,3.79,0,0,0,223.77,224.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M265.44,131.53h5.74c.23.17.24.44.34.67a2.39,2.39,0,0,0,.21.34l.17.2v1.36c-.27.8,0,1.64-.18,2.45l-.07,1.85c-.27.49.12,1.1-.26,1.59a13.09,13.09,0,0,0-4.74-.45,2.89,2.89,0,0,1-1.39-.22A.83.83,0,0,1,265,139a9.76,9.76,0,0,1-.11-2.35,10.76,10.76,0,0,1,.21-1.48C265.27,134,264.77,132.69,265.44,131.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M264,152.6h4.58c.52,0,1,0,.92.71a46.48,46.48,0,0,1-1.67,7.92c-.11-.66-.64-.47-1-.48-1.42,0-2.84,0-4.26,0-.45-.64.17-1.27,0-1.9.09-1.22.64-2.34.73-3.55a13.59,13.59,0,0,0,.24-1.68A1.38,1.38,0,0,1,264,152.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M265.2,139.19c1.31,0,2.62,0,3.93,0a2.61,2.61,0,0,1,2.29.73,2.3,2.3,0,0,1,.05,1.42l-.54,3.31c-.12.16-.05.41-.25.53-1.88-.48-3.81-.13-5.71-.23a.9.9,0,0,1,0-.95l-.24-.25c-.38-1.28.17-2.56,0-3.84C264.78,139.59,264.68,139.19,265.2,139.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M42,112.86a3.77,3.77,0,0,0-1.88.23,41,41,0,0,1,1.63-9.57c.3-1.26,1.32-.92,2.17-1a1.13,1.13,0,0,1,.23,1.16c-.24.51,0,1.06-.1,1.58a31.13,31.13,0,0,1-1.16,4c-.06.45-.31.85-.34,1.31a9.43,9.43,0,0,0-.24,1.58A.87.87,0,0,1,42,112.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M246.26,208.6l2.63-3.82a33.3,33.3,0,0,1,4.53-5.51c.08.26-.07.45-.2.65-2.23,3.27-4.46,6.53-6.88,9.66a5.93,5.93,0,0,1-.53.47C245.38,209.38,246.29,209.14,246.26,208.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M235,221.53c.61-1.37,1.92-2.1,2.86-3.16,1.27-.55,1.72-1.87,2.6-2.79a7.53,7.53,0,0,1,1.23-1.23.16.16,0,0,1,.28,0C240.08,217.15,238,219.79,235,221.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M75,218.91a6.36,6.36,0,0,0,1.7,1.65L79.8,223c.11.28.24.55,0,.84-1.47-.38-2.41-1.56-3.6-2.37a4.53,4.53,0,0,0-1.88-1.85,1.8,1.8,0,0,0-.08-.21C74.44,219.12,74.6,218.81,75,218.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M114.05,248.72l-4-1.43c-.36-.73.13-.74.63-.74a3.24,3.24,0,0,1,2.16.34,10.88,10.88,0,0,1,1.09.52,7.48,7.48,0,0,0,1,.56c.29.19.71.39.57.76s-.58.08-.89,0A1.77,1.77,0,0,0,114.05,248.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M184,251.93c-.26,0-.53,0-.72-.21a6.93,6.93,0,0,1,3.6-1.22l3.35-1.23c1.09-.13,2-.84,3.11-.93A42.83,42.83,0,0,1,184,251.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M121.61,249.3h0c-.42-.34-1-.2-1.44-.44s-.8-.21-1.2-.29a24.78,24.78,0,0,1-4-1c-.25-.19-.59-.32-.47-.74l9.11,2a.43.43,0,0,0-.47.45.29.29,0,0,1-.27.15A8,8,0,0,0,121.61,249.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M114.29,250.48c.18.65.85.45,1.25.71s1,.1,1.25.67c-2-.26-3.85-1.19-5.79-1.74l-1.23-.36c-.1-.25,0-.38.24-.47A26.65,26.65,0,0,1,114.29,250.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M271,121c.19-.09.44-1,.56,0,0,.07.26.12.39.19.43.5.18,1.1.22,1.66l0,.74a.63.63,0,0,1-.23.16.78.78,0,0,1-.4,0c-.14-.1-.2.06-.3.1-.46.39,0,1.08-.54,1.54-.25-.33-.12-.72-.18-1.05-.19-.52-.78-1.16.4-1.27,0,0-.08-.19-.1-.3A1.81,1.81,0,0,1,271,121Z",
    transform: "translate(-8.9 -13.51)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M195.94,247.58c0-.08-.07-.21-.05-.22,2.13-1.14,4.13-2.54,6.53-3.11A21.2,21.2,0,0,1,195.94,247.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M246.26,208.6c.53.7-.66.85-.45,1.45a10.69,10.69,0,0,1-2.41,2.61,2.27,2.27,0,0,1,.81-1.65A21.39,21.39,0,0,1,246.26,208.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M98.73,235.43a3.26,3.26,0,0,1-1.22-.54c-.26-.11-.55-.13-.81-.26a.93.93,0,0,1-.61-.37,13.66,13.66,0,0,1-2.41-1.57c.11,0,.25-.14.32-.11l5.24,2.6C99.14,235.39,99,235.55,98.73,235.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M114.05,248.72c.43-.38.86.08,1.3,0,0-.43-.46-.37-.58-.64a.71.71,0,0,1,.52-.27c.76.13,1.59.07,2.15.78.06.51-.73.32-.69.82A6.22,6.22,0,0,1,114.05,248.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M97.08,236.13a15.5,15.5,0,0,1,3.1,1.68.49.49,0,0,1-.23.24l-1-.24a13.67,13.67,0,0,1-2.26-1.22C96.71,236.33,96.9,236.24,97.08,236.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M71.43,216.54c.08-.61.36-.49.69-.19l1.71,1.6c.24.36.09.59-.26.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M110.79,246.63c-.43,0-.84.07-.78.66-.77-.43-1.79-.34-2.4-1.1a3.15,3.15,0,0,1,1.92,0,1.43,1.43,0,0,0,1.12.25A.18.18,0,0,1,110.79,246.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M79.83,223.84c0-.28-.23-.55,0-.84.78.56,1.73,1,2,2A4.89,4.89,0,0,1,79.83,223.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M73.57,218.71c.09-.26.17-.51.26-.76.75-.39.85.37,1.21.68v.28c-.25.17-.38.52-.76.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M96.34,241.67l.28-.29,2.8,1.09a.25.25,0,0,1-.18.32A8.54,8.54,0,0,1,96.34,241.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M271.46,123.63h.46a5.71,5.71,0,0,1,.1,1.75l-.11.16c-.82,0-.32.65-.52,1-.4-.61-.12-1.28-.2-1.92C271.47,124.32,271.14,123.88,271.46,123.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M74.35,219.62c.94.3,2,.52,1.88,1.85A6.26,6.26,0,0,1,74.35,219.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M271.41,132.48c-.33-.25-.18-.62-.23-.95.12-1.11-.23-2.26.22-3.36.17,0,.19.19.24.32l.07,1.39,0,.17c0,.46,0,.93,0,1.4S271.76,132.2,271.41,132.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M272.12,122.9c-.42-.51-.12-1.11-.22-1.66.06-1.2-.39-2.36-.24-3.57a22.32,22.32,0,0,1,.53,3.34,5.83,5.83,0,0,1,0,1.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M111.19,245.69l2.88,1a.26.26,0,0,1,.06.2c0,.06,0,.1,0,.1-.5.51-.92,0-1.38-.09s-1.11-.25-1.51-.7l-.31-.24C110.89,245.75,111,245.63,111.19,245.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M93.73,235.89l2.18,1.18a.39.39,0,0,1-.3.3,8,8,0,0,1-2.14-1.22C93.41,235.92,93.47,235.81,93.73,235.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M242,214.37l-.28,0,1.2-1.45c.16-.07.31-.15.46-.23C243.18,213.45,242.53,213.86,242,214.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M108.8,249.3a2.09,2.09,0,0,1-1.39-.49c0-.63.42-.24.66-.28l1,.51A.32.32,0,0,1,108.8,249.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M95.61,237.37l.3-.3,1.15.54-.47.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M108.8,249.3l.28-.26c.33,0,.67,0,.93.25l-.24.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M272.16,125.3c-.07.07-.12.21-.25.07,0-.58,0-1.16,0-1.73h.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M173.71,254.34c-.14-.09-.17-.17,0-.26s.55-.17.7.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M50.38,138.94l-.06,2.15c-.3-.48-.77-.47-1.26-.47H40.32a5.66,5.66,0,0,1-.26-1.88,33.71,33.71,0,0,0-.42-5.68c-.12-.83.35-.82.91-.82h9.1l.08.09c.35.35-.14,1,.51,1.29a8.24,8.24,0,0,0,.09,1.72,13.32,13.32,0,0,0,.14,2A4.53,4.53,0,0,1,50.38,138.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M50.16,133.49c-.93-.1-.35-.82-.51-1.24.31-.21-.2-.53.12-.75.7.52.64,1.25.56,2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M50.25,128.45a3.2,3.2,0,0,1-.26,2.41C49.67,130,50.15,129.25,50.25,128.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M50.61,122.67c0,.48,0,1,0,1.44,0,.23,0,.46,0,.68h-.22v-2.13Q50.49,122.51,50.61,122.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M45.1,97.06c1-.47,1-1.54,1.42-2.38.37.23.11.63.25.93a4,4,0,0,1-.89,3.45c-.32.41-.54,1.1-1.26,1.11-.07.12-.15.12-.23,0l.47-1.91C44.78,97.83,45.1,97.48,45.1,97.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M178.5,28.36a.76.76,0,0,1-.87.21c-1.65-.42-3.28-.91-4.93-1.29-.45-.11-.19-.71-.66-.69a3.29,3.29,0,0,1,2.91.62,1.53,1.53,0,0,0,.9.2,4.7,4.7,0,0,0,1.28.31C177.58,28,178.15,27.93,178.5,28.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M145.21,16.15c.29.44.84.07,1.28.43-2.88.35-5.7,0-8.47.52a.53.53,0,0,1-.23-.46,6.66,6.66,0,0,1,2.47-.17,43.13,43.13,0,0,1,5-.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M81.52,41.53a1.4,1.4,0,0,1-.46,1.28l-4.34,3.27c-.24.07-.3,0-.25-.24a18.11,18.11,0,0,0,2.18-2.11,8,8,0,0,1,1.41-1,3.35,3.35,0,0,0,.85-.87C81.1,41.74,81.16,41.36,81.52,41.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M98.27,29.8a6.33,6.33,0,0,1,2.62-1.2c.55-.19,1.07-.47,1.6-.71.24-.12.55-.28.56.22a17.3,17.3,0,0,1-3,1.77,1.78,1.78,0,0,1-1.55.16A.28.28,0,0,1,98.27,29.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M53,77.43c.68-.16,0-.43,0-.64a1.25,1.25,0,0,1,.65-1h0c.17.21-.29.57.39.76s.06.84-.38,1.15a2.71,2.71,0,0,0-.48,1,.77.77,0,0,1-.48.73c-.52.16-.65,1.09-1.44.7a6.7,6.7,0,0,1,1-1.68C52.51,78.05,52.79,77.76,53,77.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M85.07,38.64a30,30,0,0,1,5.29-3.82.51.51,0,0,1,.48.24c-1.55,1.19-3.33,2-4.77,3.36C85.75,38.55,85.5,39,85.07,38.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M162.23,16.27c-2.79.33-5.56-.17-8.35-.36h2.7c.95,0,1.91,0,2.86,0A14.51,14.51,0,0,1,162.23,16.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M130.35,18a2.7,2.7,0,0,1,3.24.09c-1.87-.2-3.5,1.24-5.41.71.14-.21.38-.27.58-.39a4.57,4.57,0,0,0,1-.09,8.64,8.64,0,0,1,1-.19A.38.38,0,0,1,130.35,18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M232.62,57.1a14.46,14.46,0,0,1,2.92,3.08c-.42,0-.48-.71-1-.46a2.28,2.28,0,0,1-2.15-2.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M72.25,51.81a15.34,15.34,0,0,0-4.48,3.27C68.41,53.23,70.93,51.25,72.25,51.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M55.88,77.19a7.1,7.1,0,0,1-1.66,3.33c-.12.14,0,.57-.42.4s-.32-.42-.15-.71a11.76,11.76,0,0,1,2.23-3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M137.79,16.64a.46.46,0,0,1,.23.46,13.66,13.66,0,0,1-2.56.82,2,2,0,0,1-2-.53c.89-.22,1.72.45,2.6.13-.1-.36-.51,0-.67-.3C136.12,16.72,137,16.94,137.79,16.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M254.59,88.2a13.73,13.73,0,0,1-1.92-3.3c-.09-.17-.18-.39.08-.48a.44.44,0,0,1,.41.12C253.74,85.73,254.55,86.82,254.59,88.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M103.05,28.11c-.83-.34-1.36.67-2.16.49a10.39,10.39,0,0,1,4.22-1.73C104.59,27.79,104.18,28.58,103.05,28.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M76.47,45.84l.25.24c-1.07,1-1.78,2.36-3.26,2.93A17.38,17.38,0,0,1,76.47,45.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M86.09,49.69c-.37.71-1.41.9-1.46,1.86-.77.3-1.43.78-2.18,1.14A9.89,9.89,0,0,1,86.09,49.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M49.41,85.09l1.41-3.35a.56.56,0,0,1,.28.72c-.29,1.05-1,2-1,3.11a.7.7,0,0,1-.67.73C49.15,85.89,49.66,85.49,49.41,85.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M248.67,77.2a10.17,10.17,0,0,1-2-2.94c1.18.3,1.36,1.48,2,2.21a.68.68,0,0,1,.12.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M81.74,41.29c.3-.94,1.18-1.22,1.91-1.68.38-.18.72-.62,1.21-.23a6.88,6.88,0,0,1-3.12,1.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M214.44,32.91a10.64,10.64,0,0,1,3,2.18c-1.16-.62-2.54-.88-3.25-2.17C214.26,32.81,214.35,32.81,214.44,32.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M250.11,79.11c1,1.37,1.39,3,2.25,4.48l-.29.14-2.2-4.39C250,79.26,250,79.11,250.11,79.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M90.84,35.06a.47.47,0,0,1-.48-.24,4.73,4.73,0,0,1,1.91-1.43c.41-.09.55.08.48.48C92.25,34.48,91.43,34.58,90.84,35.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M234.8,60.2a6.88,6.88,0,0,1,1.85,2.31l-.25.21-2.1-2.28C234.3,60,234.51,60,234.8,60.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M110.72,24.53A8.53,8.53,0,0,1,107,26c1-1.1,2.45-1.06,3.72-1.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M51.33,80.06c.68.17.66-1.07,1.44-.7a10.42,10.42,0,0,1-1.45,2.86.74.74,0,0,1,0-1c.39-.46-.3-.37-.25-.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M234.8,60.2a.5.5,0,0,0-.5.24c-.59-.56-1.19-1.1-1.78-1.67-.36-.36-.59-.75-.13-1.21a3.29,3.29,0,0,0,2.15,2.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M121,20.71c0,.85-1.07.66-1.16.62-.7-.32-1.32.11-2,.09h0c.58-.63,1.47-.55,2.15-1C120.34,20.75,120.78,20.34,121,20.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M165.47,33.69c1.21-.62,2.47-.24,3.72-.13C168,33.93,166.69,33.31,165.47,33.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M168.1,16.93a8.31,8.31,0,0,1,3.92.57A13.64,13.64,0,0,1,168.1,16.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M256.8,93.71c-.3-.54-.62-1.07-.91-1.62-.11-.2-.23-.43.1-.58s.41.15.49.34a3.76,3.76,0,0,1,.57,1.39C256.88,93.35,257,93.62,256.8,93.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M95.15,31.71l1.44-.94c.39-.12.73-.49,1.2-.26,0,.78-.93.67-1.2,1.19a2.51,2.51,0,0,1-1.18.18A.56.56,0,0,1,95.15,31.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M186.4,29.8c-1.09.2-2.28,1-3.11-.48h0a17.3,17.3,0,0,0,3.12.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M125.33,27.87c1.17.14,2.22-.66,3.4-.45a8.67,8.67,0,0,1-2.9.7C125.54,28.28,125.32,28.31,125.33,27.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M57.59,69.13a4.19,4.19,0,0,1,1.64-2.37A5.71,5.71,0,0,1,57.59,69.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M92.75,33.87a.81.81,0,0,0-.48-.48,1.7,1.7,0,0,1,1.46-.5c.24,0,.49-.53.73,0A3.23,3.23,0,0,1,92.75,33.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M51.1,80.55c.28.29.5-.2.79-.08-.13.61-.64,1.09-.57,1.75l-.22.24c-.1-.24-.19-.48-.28-.72A2.08,2.08,0,0,1,51.1,80.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M49.41,85.09c.65.41.08.8,0,1.21l-.93,1.43A6.65,6.65,0,0,1,49.41,85.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M176.38,18.49l-3.68-.93.07-.25,3.68.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M64.82,58.91A4.38,4.38,0,0,1,63,60.82C63.56,60.12,63.92,59.26,64.82,58.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M194.81,32.9c.49.06.54.43.65.86a4.07,4.07,0,0,1-1.88-.62c-.19-.36-.08-.52.32-.48S194.49,32.87,194.81,32.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M196.71,32.17a2.93,2.93,0,0,1,1.87.94,4.75,4.75,0,0,1-2.62-.92A.66.66,0,0,1,196.71,32.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M50.61,89.4A9.32,9.32,0,0,1,49.89,92a.54.54,0,0,1-.24-.48,5,5,0,0,1,.72-2.16Q50.49,89.24,50.61,89.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M240,67.27l-1.88-2.49c1,.5,1.45,1.51,2.13,2.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M170.6,34.58c-.25-.37-.84-.19-1.06-.69.59-.57,1.21.36,1.78,0,.18.67,0,.91-.72.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M210.34,54l1.68.83c-1,.55-1.39-.12-1.85-.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M170.6,34.58a.67.67,0,0,0,.72-.71l.48.24a.72.72,0,0,1,.21.33,1.35,1.35,0,0,1,0,.4.58.58,0,0,1-.5.23C171.17,35,170.67,35.22,170.6,34.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M250.11,79.11l-.24.23a10.21,10.21,0,0,1-1.2-2.14h0c.3-.14.36.12.49.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M57.08,74.09l.48-.89a3,3,0,0,1-1,2.8h0l.23-.72C56.66,74.83,57.27,74.54,57.08,74.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M125.14,19.15c.59-.15,1-.54,1.47-.23a.26.26,0,0,1,0,.41C126.2,19.68,125.76,19.49,125.14,19.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M117.19,22.13c-.06.06-.11.16-.17.16-.38.05-.76.55-1.14,0-.1-.15,0-.28.13-.39.49-.39.85-.19,1.18.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M94.46,32.9c-.24-.26-.49.08-.73,0a2.83,2.83,0,0,1,1.42-1.18h.25c.18.5-.38.62-.49,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M49.65,91.56a.49.49,0,0,1,.24.48,1.14,1.14,0,0,1-.46,1.08C49,92.5,49.34,92,49.65,91.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M46.77,95.61c-.39-.23-.2-.61-.25-.93a.68.68,0,0,1,.88-.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M196.71,32.17l-.75,0a3.73,3.73,0,0,1-1.49-.71A3.42,3.42,0,0,1,196.71,32.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M94.91,32.67c0-.42.35-.63.49-1a2.29,2.29,0,0,1,1.19,0A6.4,6.4,0,0,1,94.91,32.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M183.29,38.66a1.2,1.2,0,0,1,1,.42l-.3.29h0C183.69,39.22,182.75,39.69,183.29,38.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M180.94,37.75a.53.53,0,0,0-.52-.29c-.19-.09-.44-.09-.54-.33a.42.42,0,0,1,.36-.32,3.45,3.45,0,0,1,.7.13c.21.28,1,0,.72.77A.8.8,0,0,1,180.94,37.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M97.79,30.51l-1.2.26c.45-.51,1.13-.63,1.68-1l.24.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M211.31,31.47c-.54,0-.86-.47-1.24-.81a1.1,1.1,0,0,1,1.24.57c.07.05.09.11.06.16S211.33,31.47,211.31,31.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M180.19,37l-.25.21c-.3.24-.49-.11-.73-.16l-.93-.31.45-.2h.72C179.74,36.59,180.18,36.42,180.19,37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M217,44.77c-.74.21-1.08-.23-1.34-.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M207,37.4a1.08,1.08,0,0,1,1.29.35s-.08.27-.13.27A1.57,1.57,0,0,1,207,37.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M228.57,54.34c-.41-.21-.84-.4-.89-1C228.35,53.41,228.36,54,228.57,54.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M192,30.12c-.68.65-1.1.07-1.55-.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M203.87,35.75c-.76,0-1.08-.44-1.49-.75A1.91,1.91,0,0,1,203.87,35.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M170.11,26.68c-.2-.38-.74-.09-1-.47h.24a1.74,1.74,0,0,1,1.43,0C170.82,26.71,170.46,26.69,170.11,26.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M213.35,56.3a.78.78,0,0,1-.94-.5s.13-.24.18-.24C213,55.62,213.17,55.91,213.35,56.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M172,34.84l-.24-.25a.5.5,0,0,1,.71,0h.24c.15.3.56.16.83.41A2.11,2.11,0,0,1,172,34.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M45.1,97.06c.39.49,0,.82-.24,1.2C44.35,97.74,44.82,97.42,45.1,97.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M156.75,34a1.21,1.21,0,0,1-1.11,0C156.12,33.67,156.12,33.67,156.75,34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M134.23,25.76H136C135.35,26.33,134.77,25.79,134.23,25.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M170.83,26.21H169.4c0-.2-.22-.55.18-.43S170.5,25.83,170.83,26.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M54.67,73.6h.49a1.13,1.13,0,0,1-.72,1h0C54.47,74.23,54.33,73.86,54.67,73.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M242.25,69.82a2,2,0,0,1,.94,1.44A2.78,2.78,0,0,1,242.25,69.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M184,39.37l1.52.49c-.6.07-1.19.12-1.52-.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M177.05,27.41c0,.17.29.33,0,.51a1.6,1.6,0,0,1-1.21-.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M50.61,89.4h-.24A2.18,2.18,0,0,1,51,88C51.14,88.65,50.75,89,50.61,89.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M48.09,88.66c.09.53-.19.89-.51,1.38A1.73,1.73,0,0,1,48.09,88.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M240.3,65.23c-.63.18-.44-.64-.9-.67.38-.19.61.1.88.18A.33.33,0,0,1,240.3,65.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M206.05,36.5l.82.27c-.44.55-.75.3-1.07,0A.29.29,0,0,1,206.05,36.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M241.41,66.2a2.14,2.14,0,0,1,1.12,1.17A2.14,2.14,0,0,1,241.41,66.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M211.31,31.47v-.24a1.41,1.41,0,0,1,1,.49l0,.24A1.36,1.36,0,0,1,211.31,31.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M62.68,61.3c-.06.57-.17.84-.49,1,0,0-.11,0-.11,0C62,61.83,62.24,61.63,62.68,61.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M56.59,76a1.46,1.46,0,0,1-.71,1.19h0A1.46,1.46,0,0,1,56.59,76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M256.8,93.71c0-.19,0-.38.25-.47.12.35.23.7.35,1.09C256.93,94.31,257,93.9,256.8,93.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M54.44,74.56a1.5,1.5,0,0,1-.72,1.2h0a1.5,1.5,0,0,1,.72-1.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M57.08,74.09c.44.5-.19.79-.26,1.19C56.37,74.76,57,74.49,57.08,74.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M58.14,72.25c.11.12.24.22.23.27a1,1,0,0,1-.24.47c-.15.11-.3,0-.26-.2A3,3,0,0,1,58.14,72.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M80.52,42H81a1.23,1.23,0,0,1-1,.74C80.22,42.5,80.37,42.25,80.52,42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M206.05,36.5l-.25.24a1.12,1.12,0,0,1-.59-.6C205.6,36,205.82,36.28,206.05,36.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M137.77,33.88l1.3-.22c-.39.52-.85.44-1.3.44-.07-.05-.09-.1-.07-.15S137.75,33.88,137.77,33.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M131.83,27.11l-1.3.15A1.07,1.07,0,0,1,131.83,27.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M146.82,22.22a1.6,1.6,0,0,1-1.34,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M122.44,20.47c-.32,0-.7.11-.94-.25l.71-.24a.15.15,0,0,1,.25,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M122.46,20h-.25c.26-.35.63-.2,1-.24h0c0,.14.08.37,0,.41C122.92,20.33,122.71,20.06,122.46,20Z",
    transform: "translate(-8.9 -13.51)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M55,75.78l-.26.28a2,2,0,0,1-.21-.41c0-.07.13-.22.21-.23S55,75.53,55,75.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M110.72,24.53c-.06-.2-.22-.45.19-.47.14,0,.37,0,.35.16s-.31.29-.54.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M124.29,19.38c.37-.21.59,0,.9.24C124.77,19.83,124.56,19.58,124.29,19.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M182.81,29.08c-.29,0-.6-.06-.75-.41.41-.13.7-.07.75.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M186.41,29.8c.21,0,.48-.08.59.2,0,.05-.11.21-.18.22-.32.05-.39-.17-.42-.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M236.66,62.87c.49.23.64.43.73.78C237,63.58,236.85,63.33,236.66,62.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M190,31c.12.07.28.11.36.21a.14.14,0,0,1-.15.21,2.32,2.32,0,0,1-.47-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M47.25,92.27c.07.26.41.5.08.82-.37-.25-.43-.51-.07-.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M172.51,34.58h-.71v-.48C172.14,34.1,172.49,34.1,172.51,34.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M240.3,65.23c0-.16,0-.33,0-.49a1.52,1.52,0,0,1,.73.75C240.64,65.62,240.53,65.26,240.3,65.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M56.56,70.36c.16-.64.33-.84.65-.93C57.28,69.85,57,70,56.56,70.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M53,77.43a1.12,1.12,0,0,1-.73.95A1.1,1.1,0,0,1,53,77.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M123.18,19.74c.4-.45.68-.12,1,.13-.45.21-.71-.18-1-.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M106.15,26.71l-.27-.17a3.87,3.87,0,0,1,.37-.24c.06,0,.16.07.23.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M183.29,29.32a.47.47,0,0,1-.48-.24h0c.24-.07.44-.32.73-.18l-.25.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M200.9,33.64c-.21.29-.37.45-.63.25,0,0,0-.19,0-.19C200.45,33.67,200.64,33.66,200.9,33.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M47.26,92.28c0-.23,0-.48.31-.54,0,0,.12.08.12.14,0,.31-.19.37-.44.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M210.37,55.8c.1.11.24.21.28.35s-.12.19-.2.12a1.36,1.36,0,0,1-.27-.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M53.25,78.63c0-.42,0-.79.48-1A1.42,1.42,0,0,1,53.25,78.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M252.53,187.35c.1.36-.1.74-.27.71-.45-.07,0-.3,0-.47S252.42,187.45,252.53,187.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M219.19,212.19l-.92.5a.39.39,0,0,1-.53,0,4.93,4.93,0,0,1,1.85-1.6C219.66,211.57,219.32,211.85,219.19,212.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M217.74,212.67l.53,0a6.76,6.76,0,0,1-1.61,1.25c0-.76.52-1,.88-1.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M241.39,205.36c.06.45-.22.58-.56.79A.81.81,0,0,1,241.39,205.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M209.87,220.08l-3.14,2.4a37.41,37.41,0,0,0-5.9,3.58,14.64,14.64,0,0,1-3.36,1.73c-.26.12-.3,0-.27-.23l2.85-1.75a7.38,7.38,0,0,0,2.51-1.48c2.33-1.62,4.86-2.92,7.08-4.7C209.82,219.73,210,219.83,209.87,220.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M188.56,232.33l-2.14,1.38a1.1,1.1,0,0,1-.51.82.75.75,0,0,1-.75-.29c.61-.71-.32-1-.43-1.45a2.63,2.63,0,0,0,1.2-.48,9.41,9.41,0,0,0,2.39-.71C188.64,231.76,189.15,231.86,188.56,232.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M194.8,229.23a6.89,6.89,0,0,1-3.6,2.14,1.42,1.42,0,0,1-.76-.51,16.86,16.86,0,0,1,4.08-1.91C194.8,228.87,194.86,229,194.8,229.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M190.44,230.86c.36,0,.74,0,.76.51a6.11,6.11,0,0,1-2.64,1c.25-.36-.07-.52-.24-.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M182.35,225.64l4.15-1.52c-.4.72-.95.72-1.29,1l-2.64.92C182.41,226,182.23,225.88,182.35,225.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M194.8,229.23l-.28-.28a13.63,13.63,0,0,1,2.68-1.39l.27.23-1.48.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M181.37,226.55a4.59,4.59,0,0,1-2.14.69,5.79,5.79,0,0,1,1.92-1.14C181.34,226.2,181.51,226.3,181.37,226.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M181.37,226.55l-.22-.45.7-.29.5-.17.22.43A3,3,0,0,1,181.37,226.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M163.14,231.84c-.4.44-.91.15-1.37.22C162.17,231.62,162.68,231.9,163.14,231.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M262.8,158.82c-.08.64-.17,1.27-.25,1.91h-.22c-.43-1,.22-1.92,0-2.88C263.08,157.89,262.46,158.59,262.8,158.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M260.67,160.25l.45.47c-.32.48-.07,1.27-1.05,1.63C260.59,161.6,260.3,160.87,260.67,160.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M261.85,162.65c-.12.68.1,1.49-.72,1.91h0a3.75,3.75,0,0,1,.49-1.91A.14.14,0,0,1,261.85,162.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M261.85,162.65h-.23c0-.34-.12-.7.23-1a.14.14,0,0,1,.24,0C262.05,162,262.21,162.4,261.85,162.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M262.09,161.69h-.24v-.95h.48C262.29,161.06,262.45,161.44,262.09,161.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M260.17,169.11c-.16,0-.32.27-.49,0,.07-.22-.11-.62.3-.58C260.23,168.55,260.15,168.9,260.17,169.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M260.65,166c0-.26,0-.55.24-.72h0c.06.25.35.46.16.74,0,.06-.26,0-.4,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M260.89,165.28c0-.26-.05-.55.24-.72h0c.13.31.41.67-.24.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M260.65,166l.2.91c-.48-.34-.55-.6-.2-.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M114,235.45c1.3-.18,2.63.22,3.91-.25.8-.47,1.6,0,2.4,0a9.27,9.27,0,0,0,1.38.24c.44.13.89.22,1.33.34s.79.53,1.2.48c.24.09.1-.23.09-.07s0,0-.07,0c-.47,0-.76-.16-.5-.7a1.09,1.09,0,0,1,.73-.11c1.37.12,2.67.6,4,.79s2.62.47,3.95.55c.56.24,1.24-.09,1.77.34l.32-.24a6.67,6.67,0,0,0,2.34.37,12.31,12.31,0,0,0,3.48.24,12.85,12.85,0,0,0,2.48.11h1.48c1.36-.06,2.71.19,4.06,0,.27,0,.51.12.78.11s.75-.08.93,0h-.79a5.09,5.09,0,0,0-2,0,2,2,0,0,1-.8-.06c-2-.16-4,.12-6-.15a12.9,12.9,0,0,1-3.56-.25c-.54,0-1.11,0-1.54-.4a2,2,0,0,1,1.56-.44h35c.53,0,1.15-.2,1.48.47,0,.59-.52.52-.85.69a2.59,2.59,0,0,0-1.23.42c-.34.17-.68.35-1,.49a4.26,4.26,0,0,1-.79.16,1.1,1.1,0,0,0-.91.48.77.77,0,0,1-.3.06c-.15,0-.61-.57-.42.2a1.61,1.61,0,0,1-1.11.25c-.48.12-.89-.22-1.34-.2l.11,0a2.64,2.64,0,0,0,1.3.23c.27.06.56.11.26.48a30,30,0,0,1-6.5,1.4c-2.25.17-4.5.37-6.75.66a6.35,6.35,0,0,1-2.13,0,.9.9,0,0,1-.36-.22c0-.46.31-.57.62-.73a15.46,15.46,0,0,1,3.59-.36,9.42,9.42,0,0,1,1.68-.22,7.15,7.15,0,0,1,1,.08h.28c-1.47-.36-2.91.15-4.37.1a22.77,22.77,0,0,0-4.52.24h-4.27c-2,0-4.06,0-6.09,0a11.27,11.27,0,0,1-1.74-.08c-2-.39-4-.48-6.05-.87-1.65-.09-3.2-.76-4.86-.81-.24,0-.48-.14-.73-.16a6.72,6.72,0,0,1-1.1-.11c-1.36-.31-2.66-.85-4-1.16-.65-.15-1.35-1-2,0-1.07-.22-2.12-.53-3.2-.72-.29,0-.53-.24-.84-.24a2.33,2.33,0,0,1-1-.58.7.7,0,0,1-.1-.47C113.73,235.62,113.88,235.55,114,235.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M184.73,232.79c.33.36.85.31,1.24.57,0,.52-.61.51-.76.89a4,4,0,0,1-2.56,1.51.91.91,0,0,1-.44-.26c-.24-.63-1.25-.46-1.31-1.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M172.53,237.33l.94-.48,2.87-.95c.36.15.79.23.84.74-.1.46-.5.59-.87.71a35.33,35.33,0,0,1-5.46,1.52c-.26-.11-.58-.17-.49-.58a1.23,1.23,0,0,1,.93-.47C171.64,237.49,172.12,237.51,172.53,237.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M177.06,236.62l-.72-.72.51-.23c.52.22.93-.21,1.4-.23a21.86,21.86,0,0,1,2.65-1.22c.32.59,1.4.26,1.43,1.19a.81.81,0,0,1-.46.29,24.21,24.21,0,0,0-2.62.72C178.53,236.62,177.84,237.05,177.06,236.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M120.28,235.43l-2.37-.23-.27-.23a.62.62,0,0,0,0-.73L121,235C121,235.51,120.73,235.61,120.28,235.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M123.46,235.14l1,.49-.77,0c-.11.34-.48.3-.72.46l-1.22-.41c.12-.82.91-.14,1.21-.53a1.49,1.49,0,0,0,0-.21C123.17,234.77,123.3,235,123.46,235.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M122.93,235.18c-.27.46-1,0-1.21.53-.47-.13-1,.12-1.44-.28A.76.76,0,0,0,121,235,4.84,4.84,0,0,0,122.93,235.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M119.88,232.62a2.76,2.76,0,0,1,2.14.52A3.29,3.29,0,0,1,119.88,232.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M114.77,231.38l.25-.26,2,.71A3.35,3.35,0,0,1,114.77,231.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155.51,232.74c.41-.34.89-.15,1.34-.19.15,0,.46-.07.34.26s-.31.19-.51.21C156.34,232.7,155.8,233.24,155.51,232.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M125.8,234l-1.44-.33C125,233.47,125.36,233.39,125.8,234Z",
    transform: "translate(-8.9 -13.51)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M124.41,234.38a1.08,1.08,0,0,1,1.38.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M178.25,235.44c-.44.24-.85.64-1.4.23C177.31,235.58,177.75,235.3,178.25,235.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M117,233.73c-.48,0-.56-.27-.56-.64C116.78,233.18,117.17,233.22,117,233.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155,233l1.19.06c-.38.34-.83.15-1.25.17A.6.6,0,0,0,155,233Z",
    transform: "translate(-8.9 -13.51)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M257.05,177.25l.9-2.33.23.08c-.21.67-.42,1.34-.62,2l-.39.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M271,121c.32,1.18-.47,2.21-.5,3.34h-5.74a.65.65,0,0,1-.44-.64c.13-1.76-.56-3.43-.56-5.17a1.35,1.35,0,0,1,.28-1.1c.1-.65.61-.5,1-.51,1.58,0,3.16,0,4.74,0a1,1,0,0,1,0,1.19l.48.47a3.21,3.21,0,0,0,.11,1.11,7.48,7.48,0,0,1,0,.82,6.4,6.4,0,0,0,0-1,.45.45,0,0,1,.14-.46h.21c.37.4.24.79,0,1.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M265.44,131.53v3.82c-.67-.11-.49-.66-.43-1,.12-.84,0-1.67.12-2.61-.26.79.39,1.61-.4,2.19,0-1,0-1.91,0-2.87C265.34,130.6,265.33,131.16,265.44,131.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M270.8,126.09a1.42,1.42,0,0,1,.05,1.17C270.62,126.93,270.7,126.61,270.8,126.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M271.46,123.63c-.07.32.09.71-.27,1,0-.24,0-.48,0-.72s.09-.34.13-.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M261.61,107.35a3.35,3.35,0,0,1,.46,1.93c-.08.11-.16.11-.24,0a2.61,2.61,0,0,1-.47-1.67C261.28,107.34,261.4,107.3,261.61,107.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M261.61,107.35l-.25.25c-.37-.53-.27-1.15-.51-1.94A1.52,1.52,0,0,1,261.61,107.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M262.56,109.51c-.24.8.62,1.59,0,2.39-.28-.23-.28-.57-.37-.87.1-.5-.29-1,.09-1.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M262.31,109.52l0,1.67a.17.17,0,0,1-.26,0h0l-.24-1.92h.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M270.71,120.27c0-.39,0-.79,0-1.19.17-.65-.42-1.27,0-1.93C270.64,118.19,271.8,119.19,270.71,120.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M270.48,119.08l0,.48c-.07.12-.15.12-.23,0a.6.6,0,0,1,0-1A.54.54,0,0,1,270.48,119.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M261.56,116.2c-.29-.27-.16-.63-.2-1,.11-.1.24-.31.31-.29.32.09.11.38.16.57C261.64,115.71,261.89,116.07,261.56,116.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M262.1,116.45c0,.18,0,.47-.11.52s-.31-.12-.38-.29c.27-.27,0-.68.24-.94C262.13,115.91,262.08,116.19,262.1,116.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M262.09,111.18h.26c.26.17.21.45.24.71C261.92,112,262.15,111.49,262.09,111.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M261.85,115.74c0,.32.13.7-.24.94,0-.16,0-.32-.05-.48s0-.52.27-.67A1.49,1.49,0,0,0,261.85,115.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M262.8,158.82c-.39-.21-.08-.76-.47-1a13.78,13.78,0,0,1,.72-3.11c.42-.08.43.23.48.49C263.65,156.51,263,157.62,262.8,158.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M263.53,155.24l-.48-.49.24-1.67c.45-.13.31.32.47.48C263.7,154.12,264,154.73,263.53,155.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M262.1,150.21c1.13.5,0,1.29.24,1.91a.45.45,0,0,1,0,.11l-.14.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M263.76,153.56l-.47-.48a.5.5,0,0,1,.22-.49c.28-.09.05-.42.25-.55a.2.2,0,0,1,.24.08c0,.16,0,.32,0,.48A1.73,1.73,0,0,1,263.76,153.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M262.39,149.52c-.15-.93.34-1.79.24-2.72l.38,0-.3,2.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M264,148.76v-1.9c.86.73.1,1.34.24,1.9A.14.14,0,0,1,264,148.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M264.25,144.47h.23c-.13.64.39,1.21.15,2C264.05,145.81,264.31,145.1,264.25,144.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M263.78,152.09c0-.3,0-.61,0-.91s0-.48,0-.72l.14-.1a.29.29,0,0,1,.2.25c0,.34.1.69-.09,1l0,.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M264,148.76h.24a1.44,1.44,0,0,1,0,1.2v.49c-.08.1-.17.1-.24,0h0a2,2,0,0,1,0-1.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M264,149c0,.48,0,1,0,1.44h-.24C263.84,150,263.57,149.44,264,149Z",
    transform: "translate(-8.9 -13.51)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M264,150.44h.24c-.06.4.16.85-.22,1.18C264,151.23,264,150.83,264,150.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M264.25,150v-1.2A.82.82,0,0,1,264.25,150Z",
    transform: "translate(-8.9 -13.51)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M265,144c0,.31,0,.63,0,.95-.47-.1-.14-.5-.26-.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M42.69,109.28c-.32-.24-.13-.5,0-.72.67-1,.65-2.3,1.19-3.38.81.38.54,1,.34,1.58.07.54-.63.92-.33,1.52,0,1.33-.57,2.56-.71,3.86a.54.54,0,0,1-.25.49c-.41-.37-.25-.92-.42-1.37a2.11,2.11,0,0,1,0-.71C42.56,110.13,42.88,109.74,42.69,109.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M50.61,122.67h-.24a20.17,20.17,0,0,1,.73-4.36A21.9,21.9,0,0,1,50.61,122.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M42.72,111.17c.4.44.15,1,.22,1.46s.17,1.12-.47,1.43c-.37-.61.09-1.3-.18-1.92A.94.94,0,0,1,42.72,111.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M42.47,112.14c.53.64.08,1.28,0,1.92-.11.17-.2.13-.27,0a5.71,5.71,0,0,1,0-1.89A.22.22,0,0,1,42.47,112.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M265,139.91c.44.89-.33,1.66-.24,2.52,0,.43,0,.87,0,1.31-.5-1.05-.15-2.17-.23-3.25-.06-.75,0-1.5,0-2.26s0-1.59,0-2.38c.67.11.41.65.46,1C265.08,137.89,264.79,138.9,265,139.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M263.52,140.15c-.08,1.13.2,2.29-.47,3.38v-3.62C263.33,139.76,263.39,140,263.52,140.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M263.52,140.15l-.47-.24c.18-1,0-2,.71-2.87v1.19C263.28,138.82,263.64,139.52,263.52,140.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M265,139.91c-.49-.75-.13-1.59-.24-2.38-.08-.56.21-1.17-.23-1.68a5.25,5.25,0,0,0,.23-1.93c.57-.73,0-1.63.38-2.45.33,1.32-.22,2.65.33,3.88-.08.41-.16.81-.23,1.22a5.09,5.09,0,0,0,0,2.36l0,.26C264.92,139.36,265,139.65,265,139.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M263.44,135.16a2.48,2.48,0,0,1,0-1.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M110.2,235.43c-1.58,0-2.9-.85-4.29-1.44-.22-1,.53-.5.77-.42a11.31,11.31,0,0,1,1.79.86,3.66,3.66,0,0,0,2.24.51.24.24,0,0,1,.07.18q0,.09,0,.09C110.6,235.38,110.36,235.29,110.2,235.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M114,235.45l-.16.25a.89.89,0,0,1-.71.14c-.81-.36-1.82-.31-2.41-1.14-.08-.08-.21-.15-.24-.25-.11-.42.22-.2.32-.18C111.92,234.53,112.85,235.28,114,235.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M115.09,234.21c.86,0,1.77-.23,2.34.71A7.38,7.38,0,0,1,115.09,234.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M110.72,234.7a16,16,0,0,1,2.4,1,.22.22,0,0,1-.07.32,3.76,3.76,0,0,1-2.33-.88c0-.06,0-.11,0-.16A1.93,1.93,0,0,0,110.72,234.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M100,231.12a1.68,1.68,0,0,1,1.06.6,1.61,1.61,0,0,1-1.13-.43S100,231.19,100,231.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M93.94,228.75c.32-.15-.29-.38,0-.53l.68.28c.17.28.2.49-.24.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M94.42,229a.46.46,0,0,0,.24-.47c.29.1.54.25.58.6A.62.62,0,0,1,94.42,229Z",
    transform: "translate(-8.9 -13.51)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M98.73,235.43l.51-.25c.21.09.22.28.21.47C99.19,235.66,98.92,235.69,98.73,235.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M96.48,229.55a.56.56,0,0,1-.65-.21c0-.05.09-.12.14-.13C96.18,229.19,96.34,229.28,96.48,229.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M43.91,106.65c.46-.49.3-1,0-1.47a1.09,1.09,0,0,1,0-1.19l.94,1.22a5.05,5.05,0,0,1-.73,2.62C43.86,107.47,44.19,107,43.91,106.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M43.91,106.65c.39.33.18.78.21,1.18l-.22.45C43.08,107.73,44.21,107.19,43.91,106.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M57.8,178.91l-.24.25-2.1-4.09.21-.27a.13.13,0,0,1,.2,0l.25.5A34.12,34.12,0,0,0,57.8,178.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M51,173.48a1.37,1.37,0,0,1-.66-1.55A3,3,0,0,1,51,173.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M74.08,200.94l-.21.23c-.25-.31-.51-.62-.76-.94C73.7,200.1,73.79,200.66,74.08,200.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M145.21,243.56c.43-.45,1-.14,1.49-.28a.66.66,0,0,1,.39-.08c1.4.07,2.8,0,4.2,0a3.68,3.68,0,0,1,.58.08c1.27.28,2.52.4,3.59-.59a.52.52,0,0,1,.53.13c.45.55,1.24-.15,1.67.45h-1.41v.18l1.53.13v.32C153.57,244.48,149.39,243.83,145.21,243.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M193.15,247.73a6.79,6.79,0,0,1-2.79,1.1A5.31,5.31,0,0,1,193.15,247.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M132,249.52l-1.84,0C130.53,249,130.53,249,132,249.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M163.17,243.11c-.1-.38-.06-.42.5-.49.08.08.23.1.24.24l0,.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M143.52,251.9h1.89c-3.73.94-7.36.09-11-.43.12-.19.37-.08.51-.23a37.57,37.57,0,0,0,7.41.46C142.68,252,143.14,251.69,143.52,251.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M186.88,250.5a26.75,26.75,0,0,1-3.6,1.22,2.63,2.63,0,0,0-1.21.15l-.46-.35a8.14,8.14,0,0,1,2.42-.67c.4-.11.85-.07,1.18-.39A1.57,1.57,0,0,1,186.88,250.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M130.36,251a.51.51,0,0,0,0-.65,27,27,0,0,0,4.53.94l-.51.23A15.26,15.26,0,0,1,130.36,251Z",
    transform: "translate(-8.9 -13.51)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M185.21,250.46c-1.06.83-2.37.8-3.6,1.06-.13-.58.4-.46.63-.51C183.22,250.79,184.22,250.64,185.21,250.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M149.26,253.74h-2.7C147.5,253.09,148.37,253.72,149.26,253.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M117.66,248.64l1.44-.08c.45-.23.79.23,1.21.2.21.37.92-.11,1,.55A15.24,15.24,0,0,1,117.66,248.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M162.16,252.94c.52-.43.85-.58,1.32-.48C163.14,252.8,162.77,252.81,162.16,252.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M165.27,252.3a1.49,1.49,0,0,1-1.2,0A1.47,1.47,0,0,1,165.27,252.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M143.52,251.9c-.41,0-.84.11-1.21-.2C142.72,251.74,143.17,251.55,143.52,251.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M169.36,239.93l-1.12-.17c-.17.07-.41.15-.49,0-.15-.39.32-.31.45-.5l.25-.21h.25a2.48,2.48,0,0,1,1.2-.45,2.2,2.2,0,0,1,.91.21l5.34-1.65a1.6,1.6,0,0,0,.91-.49l2.19-.5a7.5,7.5,0,0,0,2.58-.7h.5l.23.21A2,2,0,0,1,181,237c-3.06.91-6.22,1.47-9.24,2.51a.45.45,0,0,1-.45,0l-.2.26A16.26,16.26,0,0,0,169.36,239.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M208.69,235.24l-.74.65-.7.24c-.38-.7.31-.85.64-1.12a9.59,9.59,0,0,1,1.28-.76C209.51,234.82,208.85,234.91,208.69,235.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M163.91,242.86l-.24-.24c1,0,1.9-.49,3-.15A9.38,9.38,0,0,1,163.91,242.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M184.14,237.84c-.29.32-.53.5-.88.4C183.42,237.85,183.72,237.84,184.14,237.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M190,232.57c1.3-.33,2.48-1.32,4-.67a11.86,11.86,0,0,1-2.89,1.36c-.17.17-.39.1-.6.11a.59.59,0,0,1-.27-.14C190.17,233,189.89,232.89,190,232.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M190,232.57l.45.47c-1.07.56-2.3.72-3.33,1.36-.41,0-.76.5-1.22.16a.82.82,0,0,1,.5-.85A13.37,13.37,0,0,0,190,232.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M187.14,234.4c.85-1.07,2.09-1.22,3.33-1.36v.22c-.26.29-.68.28-1,.51l-1.68.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M208.69,235.24l.48-1,1.08-.59C210.11,234.74,209.36,235,208.69,235.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M216.11,229.94a1.6,1.6,0,0,1-1.2.69c-.08,0-.1-.1-.08-.16s0-.08.08-.08c.26-.48.78-.65,1.2-.95A.36.36,0,0,1,216.11,229.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M216.11,229.94v-.5l.25-.24c.47,0,.71-.54,1.19-.49A3.25,3.25,0,0,1,216.11,229.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M214.91,230.39v.24a2.29,2.29,0,0,1-1.26.85C213.89,230.9,214.47,230.73,214.91,230.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M198.39,229.21c.59-.06,1-.6,1.67-.5C199.56,229.06,199.13,229.65,198.39,229.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M189.51,233.77a1.18,1.18,0,0,1,1-.51h.71A3.92,3.92,0,0,1,189.51,233.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M192.66,234.58c-.41.47-.66.6-1,.57C191.79,234.71,192.13,234.79,192.66,234.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M224.94,223a4.07,4.07,0,0,1,1.84-1.53l-.86,1.05-.71.5A.16.16,0,0,1,224.94,223Z",
    transform: "translate(-8.9 -13.51)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M224.94,223l.27,0c-.32.59-1,.79-1.44,1.17A1.4,1.4,0,0,1,224.94,223Z",
    transform: "translate(-8.9 -13.51)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M151.43,241.89a2.34,2.34,0,0,1-1.45.17,25.49,25.49,0,0,0-4.28,0l-2.41,0c-.23-.31-.89.22-.94-.46.43-.37.93-.21,1.4-.22-.42-.07-.83,0-1.22-.07,0,0-.08,0-.11,0s-.1.1,0,.15a.33.33,0,0,1-.1.23c-.12.15-.23.31-.46.16-.52-.36-1.12-.12-1.68-.24.1-.61.58-.15.85-.4-1.43.44-2.81-.19-4.22-.05l-.46,0c.08-.62.17-.65,1.2-.44l1.69,0c2.07.22,4.14,0,6.2.1h4.21c1.55-.1,3.1-.23,4.64-.34s3.05-.53,4.57,0c-.3.7-1,.09-1.42.43l-1.73.19a10.27,10.27,0,0,0-4.16.42c-1.05,0-2.09,0-3.13,0a8.74,8.74,0,0,1-1.7-.06,10.2,10.2,0,0,0,1.66.07c1,.13,2.11-.31,3.09.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M126,238.81a.49.49,0,0,1,.5.19,2.07,2.07,0,0,0,.26.54l0,.15a.4.4,0,0,1-.08.28,18.19,18.19,0,0,1-4.31-1c-.83-.73-2.06-.36-2.73-1,.17,0,.34.18.09.51a4,4,0,0,1-1.65-.49c0-.58.53-.16.69-.41.18-.58.59-.59,1.07-.44l4.93,1.57A1.12,1.12,0,0,0,126,238.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M137.55,240.68c-.41.11-1-.28-1.2.44a37.92,37.92,0,0,0-4.76-.22c0-.64.52-.15.72-.36a8.63,8.63,0,0,1-.88,0,.39.39,0,0,1-.21-.24c0-.26.17-.41.33-.57A57.53,57.53,0,0,1,137.55,240.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M131.55,239.76a.44.44,0,0,1-.23.44c-.36.37-.81.26-1.24.23-.64-.23-1.32-.33-1.91-.58.22.39.8,0,1.05.45-.12.3-.33.29-.57.17a4.25,4.25,0,0,1-1.88-.5v-.24l.15-.15a1.1,1.1,0,0,0-.16.15c-.25-.19-.67-.33-.22-.73C128.27,238.85,129.86,239.66,131.55,239.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M119.82,238.5c0-.32-.22-.47-.45-.71l3.33.78c.16,0,.42.14.21.38-.07.08-.3,0-.45.05a3.39,3.39,0,0,1-1.69-.29c-.22-.13-.41-.35-.71-.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M136.81,241.16a1.93,1.93,0,0,1,1.8-.14,22.8,22.8,0,0,0,2.51.18c-.23.37-.75.05-.94.41A9.87,9.87,0,0,1,136.81,241.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M118.86,237.6l-.69.41-2.19-.68c-.11-.21-.63,0-.47-.49A17.65,17.65,0,0,1,118.86,237.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M141.86,241.85l.48-.21c.2.39.73.1.95.46-.88-.06-1.75.54-2.63,0C141,241.72,141.45,241.92,141.86,241.85Z",
    transform: "translate(-8.9 -13.51)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M116,238.25a4,4,0,0,1,2.17.95,4.58,4.58,0,0,1-2.21-.67A.18.18,0,0,1,116,238.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M116,238.25l0,.28a3.67,3.67,0,0,1-1.78-.78A3.63,3.63,0,0,1,116,238.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M129.89,240.19h1.43a1.69,1.69,0,0,0,0,.23c-.12.14-.45.16-.27.47a.76.76,0,0,1-.72-.18c-.12-.48-1,.27-.92-.59A.49.49,0,0,1,129.89,240.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M100,238.05l.23-.24c.31.43,1.13.1,1.32,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M131.06,240.9c-.14-.28-.11-.47.27-.47h1.29c-.35.4-.85.11-1,.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M110.4,236.06a2.48,2.48,0,0,1,1.53.5A2.09,2.09,0,0,1,110.4,236.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M129.39,240.21c.13.51.89-.13,1,.51-.55-.14-1.18.16-1.69-.26a.6.6,0,0,0,.51-.24C129.23,240.12,129.31,240.12,129.39,240.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M120.06,238.52c.35-.35.6-.31.71.19A.87.87,0,0,1,120.06,238.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M265.18,138.93a2.65,2.65,0,0,1,0-2.36C265.19,137.35,265.19,138.14,265.18,138.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M271.66,131.3c0,.47,0,.94.07,1.41l-.32-.23,0-1.17C271.51,131.18,271.58,131.18,271.66,131.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M42.19,112.16H42c-.11-.6.26-1.11.26-1.69a.32.32,0,0,1,.47,0c0,.24,0,.48,0,.71s-.17.65-.25,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M42.71,110.46l-.47,0c0-.46.3-.8.45-1.2A.78.78,0,0,1,42.71,110.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M129.15,252.15l-1,.07-.69-.1A1.58,1.58,0,0,1,129.15,252.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M271.66,131.3a.81.81,0,0,0-.22,0c0-.49-.16-1,.18-1.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M131.82,237.62a8.69,8.69,0,0,1-4.67-.71C129,236.71,130.39,237.32,131.82,237.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M145.45,240.92c-1.69,0-3.39,0-5.09,0-.37,0-.79.14-1.12-.2h6.2c.09,0,.11.08.09.13S145.48,240.92,145.45,240.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M154.29,240.47a19.68,19.68,0,0,1-4.53.45c-.08,0-.11-.1-.08-.15s.06-.07.08-.07A19.11,19.11,0,0,1,154.29,240.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M149.76,240.7v.22h-4.31a1.27,1.27,0,0,0,0-.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M151.68,241.37a7.1,7.1,0,0,1,4-.28l-3.79.34Q151.76,241.55,151.68,241.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M151.68,241.37l.24.06-.45.4a11.1,11.1,0,0,0-3.15-.19c-.07,0-.1-.1-.08-.16s0-.08.07-.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M157.44,240.9c.37-.47,1,0,1.42-.43.34,0,.71-.13,1.07.28A7,7,0,0,1,157.44,240.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M168.44,239.25c.3.31-.94,0-.2.51a1.31,1.31,0,0,1-1,.18l-.45-.23c-.08,0-.11-.09-.08-.14s.06-.07.08-.07l1.15-.28A.4.4,0,0,1,168.44,239.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M169.88,238.76a1.7,1.7,0,0,1-1.19.24c-.28-.79.53-.42.73-.69C169.54,238.49,170,238.32,169.88,238.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M122.94,236.12l.72-.46c.11.54.7.34,1,.64C124,236.57,123.52,236.08,122.94,236.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M166.77,239.5v.21a3.45,3.45,0,0,1-1.45-.23h0C165.82,238.94,166.29,239.66,166.77,239.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M149.25,237.77a.48.48,0,0,0,0-.17,2.63,2.63,0,0,1,1.27.09A2.41,2.41,0,0,1,149.25,237.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M157.14,237.05h-1.48A1.52,1.52,0,0,1,157.14,237.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M168.44,239.25l-.52,0-.45-.32c.37-.31.66,0,1,.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M113.84,236.1l-.72-.24v-.2l.72,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M165.32,239.48c0,.25-.07.47-.39.45a.25.25,0,0,1-.15-.13c.07-.29.32-.29.55-.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M181.83,235.42a3.34,3.34,0,0,1-2.58.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M270.23,119.57h.23v1.17h-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M151.44,243.56a.45.45,0,0,1,0-.2H154v.2h-2.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M145.7,242.08a10,10,0,0,1,4.28,0A29.12,29.12,0,0,1,145.7,242.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M154.77,242.87a1.92,1.92,0,0,1-1.87,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M142.34,241.4l-.46,0v-.16h2.59s.05,0,.06.08a.36.36,0,0,1,0,.11A4.23,4.23,0,0,1,142.34,241.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M142.34,241.4h2.15c-.67.48-1.44.14-2.15.24A1,1,0,0,1,142.34,241.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M148.31,241.4v.24H146.7l0-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M129.39,240.21h-.23a3.25,3.25,0,0,1-1.76-.5,5.91,5.91,0,0,1,2.49.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M126.76,239.73c0-.24.09-.47.4-.44.06,0,.15.09.14.12-.06.29-.31.29-.53.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M10.36,122.1c.25-2.07.08-4.18.58-6.23a5.26,5.26,0,0,0,.82-2.75c.83-3.59,1.75-7.16,2.79-10.71a94.09,94.09,0,0,1,5.68-14.9,84.21,84.21,0,0,1,7.35-12.67c2-2.71,3.67-5.59,5.81-8.16.58-.38.87-1.11,1.59-1.32.8.44,1.49.47,1.93-.49.31-.48.76-.85,1.06-1.35a1.35,1.35,0,0,1,.62-.46c1.52-1.38,2.51-3.23,4.08-4.57.72.07.75-.38.66-.91a38,38,0,0,1,3.9-3.6c.46-.25,1.15-.22,1.17-1a5.56,5.56,0,0,1,1.72-1.63c3.47-1.85,6.31-4.57,9.51-6.79C67.39,39.19,75.32,34.08,84,30.35c3.84-1.64,7.75-3.11,11.66-4.58C97,25.3,98,24.43,99.21,23.92c2.29-1,4.55-2.17,7.15-2.18a.25.25,0,0,1,0,.42,13.8,13.8,0,0,1-1.92.35c.27,0,.52.6.83-.05.16-.37.75-.08,1.09-.3a1.57,1.57,0,0,1,.26-.19c.8-.19,1.62-.34,2.42-.53l.28-.21c.4-.07.81.23,1.22,0a4.19,4.19,0,0,1,1.15-.27c.46,0,.9-.36,1.37-.08.11.85-.65.73-1.08,1-2.81,1.5-6,2.13-8.78,3.71s-6.12,2.79-8.84,4.7c-3.13,2.2-6.5,4-9.56,6.3-1.23.92-2.18,2.22-3.5,3a37,37,0,0,0-6.67,5.76,1.81,1.81,0,0,1-.24.24c-1.47,1.61-3.31,2.84-4.75,4.48-1.21,1.37-2.29,2.84-3.52,4.17a4.62,4.62,0,0,1-.57.82,2,2,0,0,1-.55.37c-1,.53-1.71,1.36-2.71,1.93.35,0,.68-.31.88.14,0,.75-.58,1.21-1,1.71a74.71,74.71,0,0,0-7.86,12c-.75,1.35-1.45,2.75-2.21,4.1A72.23,72.23,0,0,0,44.41,94c0,.19-.09.38-.16.57-2,5-2.63,10.24-3.53,15.45a36.79,36.79,0,0,0-.42,3.8,53.62,53.62,0,0,0-.7,7.7c-.17,2.85,0,5.7-.1,8.55a72,72,0,0,0,.51,7.6,36.53,36.53,0,0,0,.34,5.82c.08.34.07.71.18,1.05.53,3.1.61,6.28,1.42,9.34.11.48-.06,1.1.6,1.36a3,3,0,0,1,.36.81c1.13,4.67,2.44,9.29,3.86,13.88a1.88,1.88,0,0,1,.12,1.17c-.78.21-1,.69-.64,1.4a2.06,2.06,0,0,0,.28.66c2.23,2.38,2.76,5.59,4.08,8.41.13.41.35.79.44,1.21a1.73,1.73,0,0,0,.4.94,4.37,4.37,0,0,0,.48.37c.66.49.72,1.58,1.72,1.74l.55.89a1.3,1.3,0,0,1,.14.84c-.76.73-.22,1.3.23,1.87a1.51,1.51,0,0,1,.18.26.93.93,0,0,0,.7.86c.59.4.49,1.13.79,1.67a3.24,3.24,0,0,0,.66.86l.63.65c.15.17.36.13.55.15s.41,0,.48-.24a.57.57,0,0,1,.32-.29,2.49,2.49,0,0,0,.79-.37,14.36,14.36,0,0,1,2.46,2.18,20.34,20.34,0,0,0,4.43,4.26,8.85,8.85,0,0,1,1.06,1.26c.08.09.18.21.17.31-.12.91-.15.94.4,1.56A30.92,30.92,0,0,0,73.26,207c2.87,2.06,5.75,4.13,8.59,6.27-1.7.07-2.67-1.58-4.21-1.87-.11-.07-.25-.15-.35,0s.06.18.11.27a36.24,36.24,0,0,0,9.73,6.63,39.5,39.5,0,0,0,9.1,3.21c.82.2,1.74.32,2.22,1.19.08.22,0,.32-.24.28a25.09,25.09,0,0,1-6.58-1.85,2.32,2.32,0,0,0-2-.1c-.63,0-.94-.52-1.39-.82a9.47,9.47,0,0,0-2.7-.92c.87.62,2,.46,2.83,1.05a3.06,3.06,0,0,1,.35.37c.09.28-.1.4-.29.53a10.19,10.19,0,0,0,6.65,2.32,9,9,0,0,1,2.25.59l2,.53a.7.7,0,0,1,.8.15c2.79.17,5.35,1.74,8.24,1.3a2.19,2.19,0,0,1,.7.12c4.08,1,8.27,1,12.42,1.27.36,0,.7.1,1,.15-.11.21-.33.13-.49.19.41.1.84,0,1.25.17,1.1.25,2.22.44,3.31.75a1.91,1.91,0,0,1,1.11.6v4.06a1.06,1.06,0,0,1-1.12.07,45.17,45.17,0,0,0-5.14-1.22,3.83,3.83,0,0,0-1-.25,2,2,0,0,1-.33-.09,2.27,2.27,0,0,1-.57-.32c-.36-.07-.41-.82-1-.43a1.1,1.1,0,0,1-.62,0c-.66-.16-1.32-.46-2,0a1.42,1.42,0,0,1-.68,0,4.36,4.36,0,0,0-1.35-.12c-.61.22-1.14-.38-1.75-.15a20,20,0,0,0-1.94-.76,1.22,1.22,0,0,1-.87-.79c.12-1.14.82-.57,1.27-.48-.86-.36-1.82-.95-2.73.12a1.27,1.27,0,0,1-.34.05c-1.81-.43-3.37-1.5-4.69-2a14.31,14.31,0,0,0,5.2,2.65,2.36,2.36,0,0,0,1.09.11c.42-.11.7.24,1.06.34a3.29,3.29,0,0,1,1.2.48,1.39,1.39,0,0,0,1.24.81c.57.25,1.46.19,1.23,1.23a1,1,0,0,1-.83.2c-.07-.14,0,.09-.11,0s0,0,0,0c.39.06.81.17.86.63,0,.29-.24.45-.54.51a7.12,7.12,0,0,1-2.08-.46,76.81,76.81,0,0,1-10.64-4.14c-1.35-.61-2.92-.46-4.19-1.29a7.41,7.41,0,0,0-1.41-.77,2.48,2.48,0,0,0-.9-.08A10.63,10.63,0,0,1,91.51,226c-.38-.22-.69-.69-1.23-.46-.38.35,0,.76-.09,1.12a.54.54,0,0,1-.39.3c-1.65-.85-3.66-.92-5-2.4-.26-.55-.29-1.4-1.29-1A34.88,34.88,0,0,1,77.38,220a30.65,30.65,0,0,0-2.69-2.41c-.28-.25-.54-.53-.82-.79-.54-.37-.8-1.24-1.71-1a.7.7,0,0,1-.43,0c-.08,0-.12-.13-.2-.09s0,.12,0,.18a1,1,0,0,0,.16.53,6.61,6.61,0,0,0,2,2,7.14,7.14,0,0,1,1,1.22,19.37,19.37,0,0,0,1.69,1.7,45,45,0,0,0,6,3.87l.26.2a5.44,5.44,0,0,0,.78.58l.26.2c1.11.76,2.15,1.61,3.27,2.35.33.21.69.4.64.89a.5.5,0,0,1-.39.33,19.18,19.18,0,0,1-6.9-2.59c-.34-.23-.4-1-1.08-.56-.84,0-1.4-.69-2.2-.73a13.77,13.77,0,0,1-1.53-.65c-.26-.18-.56-.32-.82-.5a.73.73,0,0,0-.55-.15c.16.11.37.12.54.22.34.16.66.38,1,.53a8.06,8.06,0,0,0,1.4.57c1.73.61,3.27,1.62,5,2.35a56.82,56.82,0,0,0,8.91,3.41,2.2,2.2,0,0,1,.54.25c.28.21.56.45.94.24a1.17,1.17,0,0,1,.32,0,7.07,7.07,0,0,1,1.87.92,15.49,15.49,0,0,1,2.3,1.64.46.46,0,0,1-.33.37,3.35,3.35,0,0,1-2.21-.46,3.09,3.09,0,0,0-.56-.26c.06.1.24.08.34.18,1,.63,2.2.83,3,1.76.27.11-.5.29.06.45a3,3,0,0,1,1.9,1.24.69.69,0,0,1,0,.35c-.44.62-.92.24-1.36,0-1.37-.64-2.66-1.41-4-2.13A16.42,16.42,0,0,0,91.56,235c-.16,0-.29-.1-.46-.07a1,1,0,0,0,.51.11,12.81,12.81,0,0,1,2,1.17,54,54,0,0,0,7.69,3.73,97.78,97.78,0,0,0,16.4,6.14c2.32.7,4.74,1,7.07,1.7.74.22,1.59.26,2.09,1a.53.53,0,0,1-.14.55,1.52,1.52,0,0,1-1.14.17c-3.59-.57-7.16-1.27-10.69-2.14-1.06-.3-2.1-.68-3.13-1.07-.82-.44-1.8-.51-2.59-1a25.38,25.38,0,0,0,2.37.94,8.06,8.06,0,0,1,1.21.49c.31.18.65.46.08.77a18.27,18.27,0,0,1-3-.66,18.72,18.72,0,0,1-3.15-.83c-.88-.3-1.74-.64-2.62-.9.9.24,1.75.64,2.64.92a27.87,27.87,0,0,0,2.69.83c1.28.55,2.63.92,3.93,1.4.54.21,1.17.3,1.52.86,0,.08-.06.15-.06.21,0,.21-.83.05-.24.56.11.09-.32.38-.52.56a.85.85,0,0,1-.3.15c-1.28,0-2.42-.69-3.68-.73a16.75,16.75,0,0,0-1.76-.73,1.54,1.54,0,0,0-.32-.15c0,.13.21.2.19.37-.43.61-.94.06-1.41.11a3.68,3.68,0,0,0-1.28-.1,3.75,3.75,0,0,1-1.1-.2c-.18-.14-.35-.34-.63-.27a1,1,0,0,1-.29-.07,2.48,2.48,0,0,0-1-.37c-.54-.12-1.09-.21-1.62-.34s-1.32-.35-2-.49l-.33-.08a1.64,1.64,0,0,0-.93,0c-.28,0,.11.1,0,.18a.69.69,0,0,0,.27.48c1,.07,2,.45,3,.47a1.55,1.55,0,0,1,.31.06,2.31,2.31,0,0,0,1.69.21,5.52,5.52,0,0,1,1,.19,5.45,5.45,0,0,0,1.55.29,7.09,7.09,0,0,1,.92,0,13.26,13.26,0,0,0,2.43.32c.8.2,1.63.25,2.44.38,1.19.18,2.29.72,3.47,1a60.42,60.42,0,0,0,9.41,2.22c.49.07,1.42-.12,1.25,1h-.72c-2.44-.48-4.9-.19-7.36-.17-.35,0-.71,0-1.06.05h-1a4.42,4.42,0,0,0-1.81-.13c-1.38-.23-2.78-.36-4.17-.47a3.48,3.48,0,0,0-1.36-.42,4.89,4.89,0,0,1-.53-.09,3.24,3.24,0,0,0-1.2-.13,5.25,5.25,0,0,0-1.24.19,42.08,42.08,0,0,1-5.46-1.17c-.52-.22-1.1-.13-1.62-.35a4.8,4.8,0,0,0-1-.38,1.55,1.55,0,0,1-.31-.07,2.6,2.6,0,0,0-1.27-.11,2.62,2.62,0,0,1-.68.12c-5.72-1.3-11.12-3.52-16.55-5.66a6.89,6.89,0,0,0-.82-.6,3.54,3.54,0,0,0-1.3-.53,1.51,1.51,0,0,1-.29-.13,3.89,3.89,0,0,0-1.9-.78A45.52,45.52,0,0,1,68,240.62a2.13,2.13,0,0,0-1.55-.78,105.47,105.47,0,0,1-14.29-9.77c-3.24-2.76-6.73-5.23-9.63-8.4s-6.26-6.47-8.83-10.2c-.92-1.35-2.19-2.42-3.15-3.75-1.69-2.33-3-4.89-4.45-7.35A100.32,100.32,0,0,1,20.77,191c-1.23-2.72-2.53-5.42-3.5-8.25a5.79,5.79,0,0,1-.29-1.16,2.89,2.89,0,0,0-.75-1.5,21.91,21.91,0,0,1-1.75-5.29,21.92,21.92,0,0,0-1.43-4.67,5.84,5.84,0,0,1-.39-1.49c-.39-2.58-.49-5.22-1.68-7.63a26,26,0,0,1-1.29-7.23c-.12-3.08-.57-6.15-.61-9.24,0-.79,0-1.59-.06-2.38-.06-.53.13-1.07-.12-1.59v-.48A13.65,13.65,0,0,0,9,137.26a20.51,20.51,0,0,0,.24-2.71,11.18,11.18,0,0,1,.14-2.77,27.8,27.8,0,0,1,.2-4.65,3.58,3.58,0,0,0,.09-1.78,1.39,1.39,0,0,1,.16-1.07C10.31,123.62,10.08,122.8,10.36,122.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.14,18.81c18.7-.59,37.41-.1,56.12-.24a17.15,17.15,0,0,1,5.2,1.27,83.74,83.74,0,0,1,9.81,3.77c2.07.94,4.19,1.78,6.17,2.87a161,161,0,0,1,15.95,9.57A142.93,142.93,0,0,1,239.82,51.1C242,53.28,244,55.72,246,58v44.75a3.23,3.23,0,0,1-2.83.08c-.4-.18-.48-.59-.65-.94-.1-.75-.75-1.31-.77-2.1a2.32,2.32,0,0,0-.29-1.39,32.56,32.56,0,0,0-1.65-4.06c-.18-.46-.45-.87-.65-1.31-.27-.22,0-.83-.6-.81-.71-1.21-1.24-2.51-1.88-3.76a10,10,0,0,0-2.13-3.94c-1.35-1.68-2.4-3.56-3.62-5.34a1.14,1.14,0,0,1-.18-.68c0-.21.07-.42.08-.63a2.29,2.29,0,0,0-.58-1.21c-.82-1.34-1.67-2.66-3.26-3.22A3,3,0,0,1,225.84,72a14.07,14.07,0,0,1-2.06-3.64,7.82,7.82,0,0,1-.57-1c-.15-.44-.11-.78.44-.86a1,1,0,0,1,.65.25c1.41,1.52,2.53,3.27,3.93,4.8a5.58,5.58,0,0,1,1,1.5c.66,1.34,1.85,2.29,2.62,3.54l1.87,2.93c1.24,2,3.18,3.29,4.49,5.17.39.44.58,1,1,1.46.1.12.2.25.29.38.25.47.46,1,.74,1.43a15.16,15.16,0,0,1,1.19,2c-.29-.7-.66-1.37-.91-2.09-.21-.5-.48-1-.72-1.46s-.58-.92-.77-1.44-.54-.94-.74-1.44c-.9-1.46-1.4-3.12-2.41-4.52a5.89,5.89,0,0,0-1-1.2c-1-1.29-2-2.48-2.94-3.79a1.2,1.2,0,0,0-.71-.75,5.43,5.43,0,0,1-1.47-1.89,1.55,1.55,0,0,0-.72-.94,2.33,2.33,0,0,1-.56-.57c-.43-.83-1.28-1.38-1.5-2.35a19.34,19.34,0,0,0-4.29-4.69,12.36,12.36,0,0,1-2.51-2.39c-.23-.29-.55-.5-.76-.82a10.66,10.66,0,0,1-.92-1.31c-1.44-2.06-3.58-3.34-5.43-4.94-1.05-1.18-2.5-1.89-3.58-3a3.25,3.25,0,0,0-1.21-1,2.39,2.39,0,0,1-.8-.78,15.88,15.88,0,0,0-2.38-1.94c-1.5-1.25-3.15-2.3-4.7-3.48-.44-.34-1-.61-.74-1.33.18-.23.38-.13.59,0s.5.32.76.46.28,0,.16-.21c-.31-.33-.74-.53-1-.87a3.77,3.77,0,0,1-.5-.75,1,1,0,0,0-.65-.51,1.64,1.64,0,0,1-.41-.42,3.13,3.13,0,0,0-.95-.74c-1.74-1.17-3.55-2.21-5.37-3.25-.42-.29-.84-.56-1.28-.82a49.43,49.43,0,0,0-9.86-4.39A10.45,10.45,0,0,1,178.73,29a.78.78,0,0,1-.16-.28c-.35-.94-1-.63-1.7-.47-1.85-.53-3.59-1.4-5.55-1.53-.6-.14-1.19-.35-1.77-.54-.26-.21-.87-.15-.59-.77,1.57-.45,3,.21,4.55.44a92.59,92.59,0,0,1,12.73,3,11.4,11.4,0,0,1,1.48.54c-3.86-1.6-13.53-3.65-21.28-4.56a3.18,3.18,0,0,0-1.62-.11,4.18,4.18,0,0,1-1.11-.2c-3.64-1-7.34-1.69-11-2.45-1.82-.12-3.57-.71-5.41-.74a87.24,87.24,0,0,0-15.05-1.22,4.44,4.44,0,0,1-.95-.19c-.4-.08-.82-.05-1.22-.16a1.22,1.22,0,0,1-.44-.22,2.38,2.38,0,0,1-.49-.4A.26.26,0,0,1,129.14,18.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M167.45,254.27H139a.3.3,0,0,1,0-.36c.71-.7,1.52-.25,2.3-.2.16,0-.09-.26,0-.12s0,.07-.1.06c-1.48-.26-3,.11-4.48-.25-.42-.11-1,.1-1.07-.61,1.12-.58,2.39-.41,3.56-.73a3.62,3.62,0,0,1,1,.07,21.78,21.78,0,0,0,5,.1c.4-.09.23-.32.28-.17s0,.09,0,.1a16.17,16.17,0,0,1-3.26.1.34.34,0,0,1-.17-.34,48.45,48.45,0,0,1,4.7-1.36c.41-.14.84-.21,1.25-.33,1.5-.41,3-.95,4.44-1.45a3.34,3.34,0,0,1,2.18-.25,2.24,2.24,0,0,0,1.06.09c10.9,0,21.8,0,32.7,0a7.19,7.19,0,0,1,2,.13,1,1,0,0,1,.35.23c.26.64-.28.75-.65.9A31.23,31.23,0,0,1,186.8,251c-.5.07-1-.28-1.49-.11-1.07.23-2.15.44-3.23.59a.34.34,0,0,1-.16,0l.1.06c.2.2.52.36.19.69a53.32,53.32,0,0,1-5.94,1.52,7.84,7.84,0,0,0-3.73,0,14.58,14.58,0,0,0-1.62.17,1.48,1.48,0,0,1-.35.05,7.37,7.37,0,0,0-1.41.09,1.34,1.34,0,0,1-.35,0C168.36,254.21,167.89,254,167.45,254.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M207.69,210.52c1.16.26,1.88-.55,2.69-1.13l1.83-1.32a2.2,2.2,0,0,1,1-.17c8.2.09,16.4.06,24.6,0,2.15,0,4.3.09,6.45,0a2.29,2.29,0,0,1,1.7.38v.95c-.73,1.29-1.36,2.67-2.85,3.31-7-.14-14,0-21-.06a11.35,11.35,0,0,1-2-.08c-.32-.08-.62-.2-.61-.66-.68.29-1,1.13-1.87.94a18,18,0,0,0-4.4-.22c-2.07,0-4.14,0-6.21,0a2.17,2.17,0,0,1-1-.16.76.76,0,0,1-.28-.25c0-.63.65-.74,1-1.09C207.06,210.88,207.3,210.56,207.69,210.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M215.83,204.49l4.71-4.81a2.91,2.91,0,0,1,1.73-.36h22a2.35,2.35,0,0,1,1.71.38v4.79a2.18,2.18,0,0,1-1.58.38h-27A2,2,0,0,1,215.83,204.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M246,199.71l-25.47,0a26.52,26.52,0,0,1,3.45-4,2.18,2.18,0,0,0,1-.64c.78-1.1,1.84-1.23,3.12-1.21,5.36.09,10.73,0,16.1,0a2.55,2.55,0,0,1,1.82.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M215.83,204.49H246v3.83q-15.9,0-31.81,0a6.37,6.37,0,0,1-2-.26A43.69,43.69,0,0,1,215.83,204.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M229.07,189.19c1.56-2,2.92-4.12,4.3-6.23a1.22,1.22,0,0,1,.79-.2c3.42.14,6.85,0,10.27.06a2.22,2.22,0,0,1,1.58.38v6.22a2,2,0,0,1-1.46.38q-7,0-13.93,0C230.05,189.79,229.4,189.88,229.07,189.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M229.07,189.19a2.22,2.22,0,0,0,1.39.23H246v4.79c-6,0-11.92,0-17.88,0-1.29,0-2.49-.1-3.28,1.17a.9.9,0,0,1-.86.3,10.46,10.46,0,0,0,2.89-3.52A9.19,9.19,0,0,1,229.07,189.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M246,183.2h-9.56a11,11,0,0,1-3.08-.24c1.12-1.58,1.88-3.36,2.85-5a2.37,2.37,0,0,1,1.47-.38h6.87a2,2,0,0,1,1.45.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M246,177.93h-9.79l3.28-6.48a1.86,1.86,0,0,1,1.12-.35c1.43,0,2.86,0,4.29,0a1.53,1.53,0,0,1,1.1.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M246,171.47l-6.51,0a7.17,7.17,0,0,1,.95-3.59c.63-1.53,1.33-3,2-4.53,1.13-1,2.34-.7,3.56-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M246,163.1c-1.18.1-2.4-.24-3.56.23a11.68,11.68,0,0,0,1-4.5c-.15-2.81,1.25-5.17,1.79-7.76a5.68,5.68,0,0,0,0-1.3c0-.68.4-.47.76-.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M243.09,102.56a8.23,8.23,0,0,0,2.92.23v15.32a.3.3,0,0,1-.46,0l0-.48a1.86,1.86,0,0,0,0-1.19c-.63-2.49-.66-5.09-1.42-7.56-.16-.52-.65-.92-.53-1.53-.3-.29-.1-.68-.2-1l-.27-1.69c.35,0,.49.25.66.49.3.67.41,1.4.69,2.08a5,5,0,0,0,.46.85c.14.31,0,.67.21,1l0,0,0-.08a4.4,4.4,0,0,0-.55-1.66,26.56,26.56,0,0,0-1.16-3c-.1-.27-.18-.54-.28-.8S242.85,102.91,243.09,102.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M125.3,254.27c-.26-.83-1-.61-1.6-.69a54.45,54.45,0,0,1-9.17-2.21.55.55,0,0,1-.07-.72.82.82,0,0,1,.35-.2,2.56,2.56,0,0,1,1.2,0c3.59.21,7,1.25,10.57,1.8.39.06.81,0,1.07.39V254c-.42.33-1-.07-1.4.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M243.6,212.39a16.49,16.49,0,0,1,2.41-3.11v1.2a67.87,67.87,0,0,0-5.93,7,17,17,0,0,1-4.85,4.29c-.35-.63.13-1,.5-1.3,1.25-1.17,2.43-2.41,3.64-3.61s2.2-2.47,3.36-3.65A5,5,0,0,1,243.6,212.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M246,149.46c-.3,0-.6,0-.76.31-.38-1,0-2,.17-3A6.7,6.7,0,0,1,246,144Z",
    transform: "translate(-8.9 -13.51)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M176.3,253.6c-.17.21-.5.31-.46.67h-1.68a1.6,1.6,0,0,0-1-.25c-.29,0-.66,0-.67-.44C173.76,253.33,175,252.79,176.3,253.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M134.4,254.27h-1.2a26.8,26.8,0,0,0-2.7-.23c-.34-.06-.73.06-.93-.36a.38.38,0,0,1,.22-.3c.63-.25,1.31,0,1.94-.27a2,2,0,0,1,.78,0,19.35,19.35,0,0,1,3,.56.34.34,0,0,1,.13.34C135.29,254.34,134.77,254,134.4,254.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M129.61,253.58a10.13,10.13,0,0,0,2.62.45c.33,0,.71-.11,1,.24h-4.55c-.1-.43.23-.6.49-.81A.42.42,0,0,1,129.61,253.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M129.61,253.58h-.49c-.32.24-.73.34-1,.7h-.24l0-1.6a1.72,1.72,0,0,1,2,.51.35.35,0,0,1-.07.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M9.29,134.61a6.13,6.13,0,0,1-.14,2.66c-.1.09-.18.08-.25,0v-1.67c.38-.24.14-.66.28-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M135.6,254.05v-.18c.55-.5,1.19,0,1.77-.17.56,0,1.15-.12,1.61.35l0,.22h-3.11A1,1,0,0,1,135.6,254.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M245.55,118.1H246V120A2.73,2.73,0,0,1,245.55,118.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M8.9,137.25l.25,0c-.1.95.23,1.94-.25,2.85Z",
    transform: "translate(-8.9 -13.51)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M128.17,254.27c-.07-.75.42-.74,1-.7,0,.38-.34.45-.47.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M9.12,142H8.9V140.6C9.34,141,9.08,141.56,9.12,142Z",
    transform: "translate(-8.9 -13.51)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M135.6,254.05l.24.22H134.4C134.74,253.89,135.19,254.08,135.6,254.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M40,113.56c.17-2.82.8-5.58,1.18-8.37.77-5.54,3-10.68,4.15-16.1A8.94,8.94,0,0,1,46.15,87c1.78-3.51,3-7.27,5-10.71,2.44-4.28,4.71-8.67,7.41-12.8a57.34,57.34,0,0,1,3.91-5.13,9.46,9.46,0,0,0,.66-1A5.88,5.88,0,0,1,65,55.18l.35-.25a.52.52,0,0,0,.54-.65,44.16,44.16,0,0,1,4.79-5.68c1.19-1.11,2.44-2.15,3.66-3.22.62.38.89-.32,1.35-.43.29-.26.69-.28,1-.5a10.14,10.14,0,0,0,1.57-.9,7.76,7.76,0,0,1-1.42.76c-.29.27-.7.29-1,.52-.49.18-.8.83-1.47.54a33.78,33.78,0,0,1,6.18-5.58,27,27,0,0,0,3.79-3.22c1.49-1.38,3.45-2.15,5.07-3.36,4-3,8.47-5.14,12.83-7.52,2.31-1.26,4.84-2,7.24-3.06A18.38,18.38,0,0,0,113,20.94a.71.71,0,0,1,.77-.33,1.74,1.74,0,0,0,2,.33,12.19,12.19,0,0,0,2.51-.37c-1.15,0-1.15,0-1.23-.56a8.19,8.19,0,0,1,3.44-.37c.46.07,1,0,1.32.41.11.5-.25.54-.6.67-1,.36-2.13.47-3.15.85a5,5,0,0,0-.82.78c-.33.19-.67-.23-1,0-.08.09-.28,0-.29.2a2.5,2.5,0,0,0,.53-.11c.24-.12.53.11.76-.11l.36-.29c.14-.11.7.12.36-.41,1-.58,2.23-.33,3.31-.76a2.57,2.57,0,0,0,1.07-.79c.94-.22,1.91-.06,2.84-.33a3.61,3.61,0,0,1,1.5,0,2,2,0,0,1,1,.47v7.41a3.46,3.46,0,0,1-1.87.63,2.33,2.33,0,0,0-1.62.64,3.29,3.29,0,0,1-.63.29,83.21,83.21,0,0,0-13.46,5.2c-1.72.84-3.4,1.79-5.15,2.54-1.53.66-2.57,2-4.12,2.62a2,2,0,0,0-1.5.88c-.83.63-1.74,1.12-2.6,1.69a12.12,12.12,0,0,0-2.93,2.22,4.12,4.12,0,0,1-1.7,1.07,5.14,5.14,0,0,0-2.74,2.15,6.35,6.35,0,0,1-1.77,1.56,22.42,22.42,0,0,0-2.16,1.74c3.35-2.78,7.06-5.65,10.92-8.29a85.94,85.94,0,0,1,12.34-6.78,3.18,3.18,0,0,0,2.07-1.65,91.12,91.12,0,0,1,10.82-4.34,16.5,16.5,0,0,1,1.93-.59,3.05,3.05,0,0,0,1-.42l.82-.32c.79-.14,1.53-.67,2.39-.35v7.64a2,2,0,0,1-1.27.59c-4.07.75-7.79,2.47-11.57,4.06a17.89,17.89,0,0,0-2.89,1.4,6.1,6.1,0,0,1-1.53.66c-.45.13-1.07.44-1.3,0s.43-.73.81-1a39.06,39.06,0,0,1,6.55-3.15,4.19,4.19,0,0,0,1.52-.93c.37-.11.66-.46,1.1-.41.73.37,1.3-.16,1.9-.38a19.84,19.84,0,0,0,2.08-.86c-1.22.35-2.39,1.25-3.85,1.33-.35-.33-.62,0-.92.11a25.15,25.15,0,0,0-6.66,3.06,37.9,37.9,0,0,1-3.86,2.1,31.37,31.37,0,0,0-3.09,1.78c-.57.27-1.08.65-1.62,1A108.14,108.14,0,0,0,88.22,56c-2.25,2-4.75,3.62-6.83,5.79A68.85,68.85,0,0,0,74,71.12c-.7,1-1.45,2-2.24,2.95a101.55,101.55,0,0,0-7.57,11.18,72,72,0,0,0-7.54,16.21c-.47,1.41-1.5,2.6-2,4l-.47,1.09A32.56,32.56,0,0,1,52.55,110c-.21.42-.44.86-1,.81-2.54-.07-5.07.13-7.61-.11a.78.78,0,0,1-.52-1.09,15.19,15.19,0,0,1,1-2.61c.07-.14.07-.22,0-.08s-.15,0-.23,0a.55.55,0,0,1-.2-.23,4.45,4.45,0,0,1,.61-2.2c.6-1.42.06-2.71,0-4a6.38,6.38,0,0,0,1.9-3.09,2.89,2.89,0,0,0-.07-1.85c.08.59.16,1.14-.28,1.35-1.19.58-1.14,1.7-1.26,2.73,0,.38-.27.65-.33,1-.4,2.61-.21,5.31-1.26,7.81a1.51,1.51,0,0,0-.1,1.16,9.06,9.06,0,0,1-.19,2.89,1.94,1.94,0,0,1-.29.21c-.5.21-.33.92-.84,1.11A1.8,1.8,0,0,1,40,113.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M54.64,105.48a5.75,5.75,0,0,1,1.3-3.13,5.53,5.53,0,0,0,.85-2.21c2-6.39,5.37-12.1,8.82-17.8,2.44-4,5.51-7.59,8.19-11.44,2.81-4,5.65-8,9.38-11.23,3-2.6,6.17-5,9.21-7.56,1.74-1.47,3.75-2.56,5.54-4a25.22,25.22,0,0,1,5.07-3.3.26.26,0,0,1,.29,0c.34.65.85.3,1.31.21s.78-.48,1.19-.68a1.68,1.68,0,0,1,.32-.09c.16-.07.28-.23.48-.21-.2-.09-.29.12-.44.17-.41.13-.83,0-1.24.09a.7.7,0,0,1-.47-.11.19.19,0,0,1,0-.28,24.74,24.74,0,0,1,4.36-2.48c2.76-1.4,5.25-3.32,8.26-4.21a3.33,3.33,0,0,1,1.27-.3c.16.28-.13.4-.21.59a1.83,1.83,0,0,1-1.17.93,37.62,37.62,0,0,0-7.9,3.89,4.84,4.84,0,0,0,2.82-.87c5.06-2.46,10.19-4.7,15.76-5.71q0,11.88,0,23.75c0,.34.12.81-.39.86-1.81.15-3.57.81-5.42.4a.77.77,0,0,0-.63,0,6.42,6.42,0,0,0-3.23.53,43.74,43.74,0,0,1-5.29.75c-2.19.32-4.34.92-6.53,1.3-.81.14-1.51.91-2.46.92-.15-.1-.23,0-.25.13-1.59.51-3.19,1-4.78,1.53-.29.09-.71.2-.82.43-.64,1.42-2,1.58-3.26,1.88-2.42.6-4.92,1.43-6.23,3.44S84.82,74,83,75.18c-.29.19-.8.19-.84.59-.13,1.22-1.1,1.73-1.93,2.28-2.82,1.85-4.87,4.63-7.62,6.51A28,28,0,0,0,67,89.92a39.79,39.79,0,0,0-3.41,4.24.9.9,0,0,0-.32.75c-1.53,1-2.25,2.66-3.37,4a20.49,20.49,0,0,0-2.19,3.16C56.93,103.41,56.34,105,54.64,105.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M141.57,61.87c-1.62-2.28-4-1.65-6.25-1.7s-4.47,0-6.7.11c-.81,0-.69-.41-.69-.88V46.24c0-3.51,0-7,0-10.52a1.56,1.56,0,0,1,1.08-.68,22.68,22.68,0,0,1,5.79-.77c.33.06.7.08.8.51-.73.64-1.7.46-2.53.76-.55-.1-1,.28-1.46.25.66-.21,1.5-.18,2.29-.46,3.6-.84,7.29-1.14,10.94-1.65a8.86,8.86,0,0,1,1.78-.15c.45,0,.92,0,1.26.38a1.86,1.86,0,0,1,.25,1c0,4,0,8.06,0,12.08a2.07,2.07,0,0,1-.13.7c-.2.5-.68.33-1,.42-.39.42-.69-.41-1.07,0a.91.91,0,0,1,.74.26c.07.06.13.16.25.12a.22.22,0,0,1-.06-.3c.34-.23.78,0,1.11-.23s.43,0,.64.05a3.43,3.43,0,0,0,1.58.3,1.45,1.45,0,0,1,.3.06,2.18,2.18,0,0,0,1,.35,5.32,5.32,0,0,0,1.12.17,3,3,0,0,1,.51.08,7,7,0,0,0,1.21.2c.52.13,1.06.16,1.58.26.7.17,1.41.31,2.12.42a1.35,1.35,0,0,1,.36.08c.52.28,1.28.18,1.49.94-.23.58-.7.41-1.1.33a21.44,21.44,0,0,1-2.72-.74,2,2,0,0,1-.35-.07,4.69,4.69,0,0,0-1.18-.26,1.94,1.94,0,0,1-.33-.07,7.13,7.13,0,0,0-1.38-.17,1.53,1.53,0,0,1-.36-.07,13.09,13.09,0,0,0-1.52-.17c-.51-.09-1-.06-1.53-.18-1-.27-1.26.22-1.26,1.11,0,3.73,0,7.46,0,11.19a2.43,2.43,0,0,1-.12,1.28c-1.9-1.25-4.08-1-6.19-1.18A.21.21,0,0,1,141.57,61.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M146.64,33.8,133.7,35.56c-.28,0-.64.34-.72-.23l2.59-.53c.29-.45.76-.3,1.17-.34a2.82,2.82,0,0,1,1.22-.23,2.44,2.44,0,0,0,1.32-.29,2.66,2.66,0,0,1-1.33.28,2.91,2.91,0,0,0-1.24.23,11.54,11.54,0,0,0-1.86.1A25.05,25.05,0,0,0,128,35.72q0-7.74,0-15.49c.79-.59,1.7-.26,2.55-.34a4.43,4.43,0,0,0,1.45-.11,80.18,80.18,0,0,1,12.48.72c1,.11,1.91.44,2.89.47.78.05,1.07.51,1,1.23a3.89,3.89,0,0,1-.21,1.82,3.54,3.54,0,0,1-2,.59c-2.14.31-4.28.65-6.43.93-.15.11.09.3,0,.16s0-.09,0-.11a13.45,13.45,0,0,1,3.29-.18,5.71,5.71,0,0,0,2.54-.5,3.14,3.14,0,0,1,2.1-.14c.72.26.68.89.7,1.47,0,1.21,0,2.43.08,3.64a2.08,2.08,0,0,1,0,.43,13.25,13.25,0,0,0-.09,1.54C148.37,33.67,148.37,33.67,146.64,33.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M94.17,234.4l2.37.52c.33.12.61-.14.8-.11-.11,0-.32-.08-.55-.12a6.61,6.61,0,0,1-2.27-1.48c.59-.46,1.15-.1,1.69.1a3.12,3.12,0,0,0,2.52.19,1.7,1.7,0,0,1,1.27.19c.55.18.92.73,1.54.77a5.32,5.32,0,0,1,.79-.18,22.75,22.75,0,0,1,3.48.67,4.19,4.19,0,0,0,2.62-.1,2.59,2.59,0,0,1,1.52.46c1,.42,2.13.62,3.17,1l.94.32a7,7,0,0,1,1.06.45c1.55.36,3.06.88,4.57,1.36l.32.09a3.59,3.59,0,0,0,.79.17,1.64,1.64,0,0,1,.32.05c.93.24,1.86.46,2.79.69a1.86,1.86,0,0,0,1.61-.12c.58-.39.83,0,1.06.45a1.43,1.43,0,0,1,.28.13c.25.19.59.24.79.51v.67c-.23.3-.52.29-.9.13.3.23.73.06.9.43q0,3.65,0,7.29c-.35.25-.64.07-.91-.14a54.81,54.81,0,0,0-7.24-1.94,85.59,85.59,0,0,1-18.4-6.72A7.89,7.89,0,0,1,99,238.24l0-.24a.59.59,0,0,1,.27-.14c.45,0,.8.4,1.24.32h0l-.07,0a4.91,4.91,0,0,1-1.31-.49A12.26,12.26,0,0,1,97,236.32a22.61,22.61,0,0,1-3.1-1.68C93.87,234.42,93.92,234.31,94.17,234.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M148.05,250.45c-2,.57-3.87,1.43-6,1.43-1.31.69-2.7.18-4,.19a16.75,16.75,0,0,1-3.37-.39,2.91,2.91,0,0,1-.58-.15c-1.16,0-2.23-.53-3.37-.65-.92-.1-1.9.22-2.73-.45v-.76c.74-.49,1.58-.14,2.37-.24a5.82,5.82,0,0,0,1.29.2c-.25.11-.7-.15-1.16-.19a9.58,9.58,0,0,1-2.5-.26v-7.53a8.21,8.21,0,0,1,2.37-.14,14.36,14.36,0,0,1,3.56.67c1,.71,2.21.56,3.33.74a54.33,54.33,0,0,0,8,.55c.93.39,2-.08,2.9.45A17.89,17.89,0,0,1,148.05,250.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M230.25,121.2c-.59.87-.81.44-1-.26q-.71-3.27-1.42-6.54c-.05-.22,0-.49-.42-.54-.13,1,.41,2,.14,3l-.52-1.39c-.29-.27-.62-.61-.56-.95.09-.61-.48-.23-.58-.49-.58-.82-1.4-1.5-1.47-2.6a36,36,0,0,1,0-5.09c0-.19,0-.46.18-.55,1.15-.64.58-1.54.38-2.39a1.25,1.25,0,0,1,0-.43,37.45,37.45,0,0,0,.05-3.82c0-5.94,0-11.88,0-17.83a4.45,4.45,0,0,1,.13-1.54c.14-.39.34-.67.74-.2l3.36,5.74a23.18,23.18,0,0,1,.12,3.33c0,8.13,0,16.26,0,24.39.06.48-.25,1,.25,1.43a.81.81,0,0,1,.48.79c-.12.59.17,1.14.13,1.72a3.27,3.27,0,0,0,.51,3,.87.87,0,0,1,.15.67C230.83,121,230.51,121.06,230.25,121.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M229,113.59V86.42c0-.38-.13-.81.26-1.11a26.47,26.47,0,0,1,3.29,6,11.65,11.65,0,0,0-.3,3.17q0,11,0,22.07c0,.71.21,1.54-.61,2l-.25-.46a1.56,1.56,0,0,1-.34-.6c-.05-.09-.08-.17-.12-.26a3.62,3.62,0,0,0-.42-.74,2.06,2.06,0,0,1-.23-.37c-.09-.31-.46-.53-.31-.92l-.44-.72C229.19,114.29,229.22,113.88,229,113.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M213.89,201.87a23.42,23.42,0,0,1-3.4,4.34,1.71,1.71,0,0,0-.46.67c-.83-.15-.76-.83-.78-1.4-.05-1.79,0-3.58,0-5.37,0-4.29.08-8.59-.07-12.88a.88.88,0,0,1,.2-.41l.26-.28a1.28,1.28,0,0,0,.71-1.42l1-2.61c.92.14.25-.5.36-.75a6.16,6.16,0,0,1,1.22-2.42c.57.27.61.78.61,1.31,0,6.38,0,12.76,0,19.14A3.41,3.41,0,0,0,213.89,201.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M209.37,187a6.2,6.2,0,0,1,.24,1.87q0,8.29,0,16.58c0,.5-.16,1.06.42,1.4a16,16,0,0,1-2.54,3.19.31.31,0,0,1-.16-.25c0-.18.12-.31.16-.48-.12.19-.19.4-.3.59a1.23,1.23,0,0,1-.76.58c-1-.29-.77-1.12-.78-1.79,0-3.55,0-7.1,0-10.65,0-2.59,0-5.18,0-7.78a3.37,3.37,0,0,1,.12-1.18,11.08,11.08,0,0,0,1-.8c.28-.27.49-1,.77,0,.08.27.33.05.45-.08s.48-.52.71-.79S209,186.88,209.37,187Z",
    transform: "translate(-8.9 -13.51)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M194.71,199.92a44.19,44.19,0,0,0,3.2-4,.33.33,0,0,1,.39.16,5.21,5.21,0,0,1,.42,2.67c0,5.64,0,11.28,0,16.91,0,1-.69,1.42-1.3,2-.55.32-1.08.66-1.62,1a1.23,1.23,0,0,1-1.24.14,1.27,1.27,0,0,1-.42-1.07c0-5.66-.14-11.31.06-17A1.46,1.46,0,0,1,194.71,199.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M221.34,104.7c-1-1-1.27-2.51-2.15-3.62-.2-.33-.6,0-.83-.26-.24-.47-.21-1-.5-1.48s-.57-.68-1-.91a2.75,2.75,0,0,1-.33-.79,2.27,2.27,0,0,1,0-.9c.33-1-.24-2.17.63-3,.46-.19.61.21.84.44s.23.23.35.33a.9.9,0,0,1,.17.26s0,0,0,.06-.05-.22-.09-.33a1.08,1.08,0,0,1,0-.31c.11-.34.12-.72.43-1,0-1-.92-1.54-1.19-2.39a2.5,2.5,0,0,0-.91-1.19,1.1,1.1,0,0,1-.21-.22,1.83,1.83,0,0,1-.14-.28,2.7,2.7,0,0,0-.6-1,5.87,5.87,0,0,1-.51-.82,1.38,1.38,0,0,1-.2-.81.67.67,0,0,1,.8-.52c.58.24.8.8,1.15,1.24a23,23,0,0,0,1.58,2.43c.11.12,0,0,.1,0s.1-.1.05-.19c-.2-.35-.45-.66-.67-1-.27-.66-1-1.13-.76-2l.27-.26a3,3,0,0,0,.12-1.41c0-5.45,0-10.9,0-16.34a3.68,3.68,0,0,1,.33-2.09c.4-.48.74-.15,1.08.09.42.64,1.28,1,1.17,2a10,10,0,0,0-.18,2.25q0,9.8,0,19.58a6,6,0,0,0,.46,2.8,1.36,1.36,0,0,1,.06,1.15.68.68,0,0,1-.25.28c-.32.11-.58-.09-.87-.16s0,.13,0,.19a3.54,3.54,0,0,0,.79,1.14c.39.45.37-.22.58-.11.49.27.53.76.63,1.22a1.83,1.83,0,0,1-.1.87,1.81,1.81,0,0,0-.36,1.17.8.8,0,0,0,.37.73c.36.12.54.32.3.7a2.63,2.63,0,0,1-.41.27,5.3,5.3,0,0,0-.17,3.08C221.32,104,221.64,104.3,221.34,104.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M183.75,208.35c1-1.09,2.06-2.21,3.15-3.26.79-.77,1.08-2,2.16-2.5,1-.08,1.24.55,1.31,1.36a1.82,1.82,0,0,1-.12.65,5,5,0,0,1-.37.9c-.14.23-.27.48-.6.49-.16.13,0-.66-.34-.11-.12.2-.39.27-.57.43,0,0,0,.05,0,0s.19-.13.3-.18a.52.52,0,0,1,.69.2,1.65,1.65,0,0,1,.25.91c0,4.73.12,9.46-.05,14.18-.81,1.53-2.34,1.58-3.78,1.82a.57.57,0,0,1-.3-.29,4.56,4.56,0,0,1-.17-1.76c0-3.8,0-7.59,0-11.38-.12-.1.24-.71-.35-.33-.28.19-.56.41-.94.28A.93.93,0,0,1,183.75,208.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M186.14,79.55c-.3,0-.55-.35-1-.08l2.14,2a1.5,1.5,0,0,1-.5,2,12.73,12.73,0,0,1-2.28-2.36A2.2,2.2,0,0,0,183,80a1.15,1.15,0,0,1-.56-1,5.71,5.71,0,0,1,0-.83c.06-5.19,0-10.37,0-15.56a3.39,3.39,0,0,1,.3-1.74c.23-.43.68-.37,1.06-.46a2.41,2.41,0,0,1,1.51.27c.42.41,1.06.61,1.26,1.25-.08,5.25,0,10.51,0,15.76C186.5,78.35,186.63,79,186.14,79.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M183,60.69a6.23,6.23,0,0,0-.25,1.88c0,3.19-.14,6.39.06,9.56.14,2.19-.22,4.34-.05,6.51A2.66,2.66,0,0,0,183,80a10.42,10.42,0,0,1-3.24-2.15c-.18-.15-.07-.94-.58-1.24a2.63,2.63,0,0,1-.38-1.71q0-6.92,0-13.83a2.72,2.72,0,0,1,.44-1.92c.92-.71,1.52.29,2.28.43.11,0,.21.1.32.15C182.26,60.06,182.84,60.12,183,60.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M196.42,82.74c-1.16-.79-2.63-1.07-3.6-2.16-.63-2-.34-4.11-.31-6.17,0-2.67-.1-5.33,0-8a4.1,4.1,0,0,1,.27-1.87.52.52,0,0,1,.89-.17c2.1,2,4.79,3.31,6.73,5.5a.6.6,0,0,1,0,.35.55.55,0,0,1-.29.18c-.58.12-.9-.42-1.38-.56a5.75,5.75,0,0,1-2.33-1.59,23.6,23.6,0,0,0-2.2-1.87c1.18,1.46,2.56,2.54,3.72,3.84a1.82,1.82,0,0,1,.3.7,25.58,25.58,0,0,1-.14,5.32c-.14.41.39.84,0,1.26-.46.17-.71-.28-1.18-.37-.19,1.35,0,2.69-.09,4C196.73,81.71,196.88,82.29,196.42,82.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M231.64,118.58a2.62,2.62,0,0,0,.24-1.51c0-7.83,0-15.67,0-23.51,0-.72.25-1.4.27-2.11,0-.32.25-.2.43-.15.32,1.12,1.29,1.93,1.51,3.1.12,4.18.2,8.36,0,12.54-.78,1.12.3,2,.37,3a4.76,4.76,0,0,0,.79,1.45.45.45,0,0,1,0,.23c-.21.58.51,1.16,0,1.74-.47.34-.32.86-.33,1.31,0,2.69,0,5.37,0,8.06,0,.61.11,1.3-.62,1.65a17.35,17.35,0,0,1-2.51-5.37C231.68,118.89,231.67,118.73,231.64,118.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M220.11,189.89a58.44,58.44,0,0,1-3.59,6.23c-.6.22-.65-.25-.75-.62a6.13,6.13,0,0,1-.07-1.42q0-6.44,0-12.86a15.18,15.18,0,0,0-.1-2,4.61,4.61,0,0,1,.91-3,8.38,8.38,0,0,0,1.23-3.44c.07-.49.1-1.05.63-1.34.66.18.61.75.64,1.24a11.48,11.48,0,0,0,.18,2.34c.47-.49.17-1.55,1.21-1.6,0,1-.77,1.84-.77,2.86-.18.26,0,.59-.17.85-.31.47-.06.87.18,1.26.46.91-.3,1.73-.18,2.61a.44.44,0,0,1,.11.29c-.17.49.31.78.38,1.19C220.15,184.93,219.89,187.42,220.11,189.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M215.79,178.78a3,3,0,0,1,.29,1.62q0,7.28,0,14.54c0,.41-.28,1,.43,1.18a1.26,1.26,0,0,1-.45.72,28.74,28.74,0,0,0-1.65,2.62l0,0c-.13.15-.24.31,0,.43.69.7-.18,1.14-.29,1.71,0,.09-.16.16-.24.24-.91.29-.68-.43-.68-.82,0-2.35,0-4.7,0-7.05,0-3.74.07-7.48,0-11.22,0-1.14.44-2.34-.21-3.44l.76-1.63c.19-.09.35.08.52.07.65-.82.46-2,1.31-2.73a37.63,37.63,0,0,0,1.51-5.72c.26-.05.35.13.44.32a9.48,9.48,0,0,1-.4,3.51c-.39,1.61-1,3.17-1.29,4.82A1.1,1.1,0,0,0,215.79,178.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M128,233.47v-4.08c.37-.29.77-.14,1.15-.07a71.93,71.93,0,0,0,16.5,1.38,8.18,8.18,0,0,1,1.78.09A5.58,5.58,0,0,0,149,231a9.78,9.78,0,0,0,2.59-.13,3.37,3.37,0,0,1,1.64,0c.47.23.38.51.06.8a2.34,2.34,0,0,1-1.2.21,5.31,5.31,0,0,0-1.77.17,39.74,39.74,0,0,1-7.9.36c1.82.09,3.93.56,6.08.58a6.56,6.56,0,0,0,1.65.17c.41,0,.92-.06,1,.56a6.48,6.48,0,0,1-3.1.59c-1.92.26-3.88.22-5.79.36a28.76,28.76,0,0,1-5.66-.3c-.91-.11-1.81.32-2.73.08a2.59,2.59,0,0,1-.71-.29,3.06,3.06,0,0,0-1.46-.49c-.65-.22-1.35-.07-2-.27,0,0,.21,0,.16.15a.5.5,0,0,1-.36.37A1.46,1.46,0,0,1,128,233.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M172.18,73.14l-3.31-1.89c-.43-1.27,0-2.54,0-3.81.71-.61-.45-.55-.35-1a1.33,1.33,0,0,1,0-.4,14.19,14.19,0,0,0,.21-3.44c.08-2.57-.17-5.15.14-7.72.31-.61.78-.38,1.2-.19.85.38,1.69.8,2.52,1.24a1.31,1.31,0,0,1,.62.88c.2,2.86.06,5.73.09,8.59,0,2.19,0,4.38,0,6.57C173.29,72.66,173.3,73.52,172.18,73.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M172.18,73.14c.87,0,.78-.57.78-1.13V56.6c.4-.31.79-.05,1.18,0,1.59.69,1.59.69,2.15-.82.56-.22.94.19,1.39.36.78.62.47,1.28.09,2-.15.14-.35.22-.51.36a2.55,2.55,0,0,0-.32,1.83c0,4.73,0,9.45,0,14.18,0,.62.13,1.29-.39,1.8-.72-1.74-2.26-2.34-3.91-2.8C172.45,73.47,172.33,73.27,172.18,73.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M225.91,79.57c-.23,0-.49-.17-.5.24v22a2.55,2.55,0,0,1-.25,1.51c-.76-.2-.74-1-1.16-1.47a3.91,3.91,0,0,0-.65-.7,3.77,3.77,0,0,1-.6-1.38c-.24-.91.21-1.77.21-2.66.25-.45,0-.79-.22-1.16a2.1,2.1,0,0,1-.21-1.13,11.16,11.16,0,0,0-.13-2.71c0-5,0-10,0-15,0-.64-.18-1.41.68-1.73,1.1.25,1.12,1.34,1.6,2.07A5.47,5.47,0,0,1,225.91,79.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M148.05,63.07a2.39,2.39,0,0,1-.24-1.27c0-3.86,0-7.72,0-11.59,0-1.35,0-1.35,1.37-1.06.65.15,1.36-.11,2,.28.34.28.94-.1,1.17.46a2.71,2.71,0,0,1,.16,1c0,3.83,0,7.65,0,11.47,0,.54.28,1.48-.88,1.39C150.33,64,149.07,64.11,148.05,63.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M176.53,76.31c0-5.7,0-11.4,0-17.11,0-.51-.23-1.21.72-1.16.14.15.36.11.52.21a.29.29,0,0,0-.05-.22c-.25-.53.66-1.23-.24-1.67-.4-.22-.64-.67-1.13-.75a3.81,3.81,0,0,0-1.06-.19,1.29,1.29,0,0,1-.46-.14,4.92,4.92,0,0,0-1.08-.71.36.36,0,0,1-.11-.46c.31-.42.74-.31,1.18-.35a6.44,6.44,0,0,1,4.84,1.64,27.6,27.6,0,0,1,2.89,2.06c.13.49-.17.81-.46,1.12a.76.76,0,0,1-.51.09c-.38-.1-.72-.28-1.09-.41-1-.36-1-.36-.85.74a2.27,2.27,0,0,0-.49,1.65c0,5.33,0,10.66,0,16-.56-.4-1-.76-1.65.06C177.16,77.21,176.84,76.54,176.53,76.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M193.1,64.21c-.52,1.93-.21,3.89-.24,5.83-.06,2.86,0,5.71,0,8.57,0,.66.4,1.32,0,2a9.71,9.71,0,0,0-2.36-1.25,1.43,1.43,0,0,1-1.2-.78,2.53,2.53,0,0,1-.32-1c-.11-4.58-.1-9.17,0-13.75.5-.94-.54-1.29-.76-1.95a.57.57,0,0,1,.11-.33.85.85,0,0,1,.51-.15,17.58,17.58,0,0,1,3.55,1.84C192.68,63.48,193.13,63.67,193.1,64.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M198.65,216c-.48-.36-.29-.88-.29-1.33,0-4.6,0-9.21,0-13.82a25.06,25.06,0,0,0-.24-5c-.24-.76.68-1,.73-1.67.56-1.09,1.62-1.84,2.12-3,.22.09.33-.41.6-.11s.12.61.15.92c.17.86-.45,1.46-.75,2.16a.73.73,0,0,1-.15.4c-.18.39.35.48.36.8a6.43,6.43,0,0,1,.18,2.14c0,5.65,0,11.3,0,17A2.63,2.63,0,0,1,198.65,216Z",
    transform: "translate(-8.9 -13.51)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M128,233.47l1.62.24a10.48,10.48,0,0,1,4.09.43c4.79-.08,9.59.65,14.36-.17a3.82,3.82,0,0,1,.3,2.05c0,.61-.11,1.17.68,1.37.28.07.3.32,0,.52a6.2,6.2,0,0,1-2.71.09,44.22,44.22,0,0,0-5.64-.14,15.81,15.81,0,0,1-3.57-.23c-.67,0-1.29-.28-2-.26a4.92,4.92,0,0,1-.94-.1c-.4-.14-.82-.15-1.21-.31a1.21,1.21,0,0,0-1.28-.14c-1.27-.2-2.65.1-3.78-.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M205.74,189.11a2.83,2.83,0,0,1,.28,1.62q0,9.22,0,18.45c0,.41-.39,1.24.66,1.06a.45.45,0,0,1,.23.41.88.88,0,0,1-.07.32,4.38,4.38,0,0,1-1.1.91v.06c-.09.21-.06.48-.29.64-.67.27-1.14,1.15-2.06.68a2,2,0,0,1-.4-1.46c0-6,0-12,0-18a4.16,4.16,0,0,1,.13-1.06C203.84,191.42,204.36,190,205.74,189.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M169.13,67.16a18.08,18.08,0,0,1-.26,4.09l-2.73-1.19,1.49-.11c-1-1.11-2.45-1.31-3.55-2a2.12,2.12,0,0,1-.08-2.15c1-.68,1.73.38,2.75.34-.68-.33-1.35-.52-1.5-1.28-.17-3.47-.07-7-.06-10.42a1.56,1.56,0,0,1,.3-1,3.27,3.27,0,0,1,3.64,1.29v10.1c0,.59.05,1.2-.48,1.63a.64.64,0,0,1-.29.16c-.11,0-.3-.09-.32.09s.27,0,.4.09S169,66.89,169.13,67.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M151.6,63.8c.73-.12.51-.7.52-1.13,0-4.34,0-8.67,0-13a.32.32,0,0,1,.47,0h.26c.44.3,1-.06,1.42.23h.25a2.73,2.73,0,0,0,1.19.24H156a1.52,1.52,0,0,1,.61,1.46c0,4,0,7.93,0,11.89a1.68,1.68,0,0,1-.37,1.22A19.45,19.45,0,0,1,151.6,63.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M220.39,173.39c-.86.58-.58,1.74-1.29,2.52a8.39,8.39,0,0,1-.4-3,2.14,2.14,0,0,0-.22-1.38c-.54-.65,0-1.38-.16-2.06a5.08,5.08,0,0,0,.06-1.17c0-.17-.08-.33-.1-.5a1.11,1.11,0,0,1,.41-1.1c.47-.8.88-1.6.13-2.48a.55.55,0,0,1,0-.44c.59-2.09-.32-4.27.46-6.34-.09-.71,0-1.43-.08-2.14a2.62,2.62,0,0,1,0-2c1-.7.27-1.55.21-2.34a2.17,2.17,0,0,1,.32-1.41,1.58,1.58,0,0,1,.22-.23,2.52,2.52,0,0,0,.3-.35c.14-.33.08-.75.43-1,.6.07.46.58.48.93.14,1.9.13,3.82.41,5.71a7.55,7.55,0,0,1-.08,3.38c-.25.77.44,1.22.41,1.91a25,25,0,0,1-.43,4.73c-.31,1.39-.54,2.8-.81,4.2a.6.6,0,0,1,.08.29c0,.18-.12.37.05.53.74-.09.38.36.33.65A19.6,19.6,0,0,1,220.39,173.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M189.25,63.33q0,7.31,0,14.59c-.37.13-.61-.16-.89-.3a6.71,6.71,0,0,1-.7-.6,7.67,7.67,0,0,0,.58.56,14.68,14.68,0,0,1,2.25,2.47c0,.77.34,1.63-.53,2.2l-3.81-2.7q0-8.07,0-16.14a5.84,5.84,0,0,1,.24-1.76l.15-.08A7.14,7.14,0,0,1,189.25,63.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M128,237.28v-.73a1,1,0,0,1,.89-.12c1.66.26,3.33.4,5,.64a4.81,4.81,0,0,0,1,.12,12.75,12.75,0,0,0,2.22.22,23.65,23.65,0,0,0,4.75.35h1.72a30.85,30.85,0,0,1,3.72.14c1.21.62,1.46,1.65.76,3.08a2.94,2.94,0,0,1-1.63.22h-6.56a8.53,8.53,0,0,1-2.36-.23,72.87,72.87,0,0,1-7.65-1,3.68,3.68,0,0,1-1.86-.74v-1.67c.42-.12.79-.49,1.22-.31C128.81,236.87,128.4,237.62,128,237.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M156.2,64.72V51.65a2.67,2.67,0,0,0-.24-1.5c1,.27,2.06.54,3.09.83.29.08.54.16.75-.12a.67.67,0,0,1,.58-.31.4.4,0,0,1,.22.44c-.09.3-.34.54-.37.87-.16,4,0,8-.07,12,0,.62.12,1.29-.37,1.81A19.41,19.41,0,0,0,156.2,64.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M159.79,65.68c0-4.37,0-8.74,0-13.1,0-.42-.16-.89.22-1.24a2.28,2.28,0,0,1,1.48,0c.76.44,1.9.29,2.22,1.42a34.42,34.42,0,0,0-.21,5.92c-.06,1.78.08,3.56-.08,5.33-.15.33-.41.65.18.88.32.12.79.23.73.76-.49.69-.12,1.48-.26,2.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M203.12,192.74a2.83,2.83,0,0,1,.26,1.62v17.58c0,.51-.13,1.06.41,1.41.21.45-.21.61-.4.88-.66.39-1.23,1.13-2.14.57-.45-.38-.26-.89-.26-1.34q0-8.28,0-16.55a6.32,6.32,0,0,0-.25-2c-.15-.17,0-.33,0-.49l.22-.22C202.14,194.39,202.41,193.23,203.12,192.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M147.53,231.09a74.29,74.29,0,0,1-19.56-1.7v-.71c.43,0,.32-.46.55-.64a4.37,4.37,0,0,1,3.1-.23A4.91,4.91,0,0,1,133,228c-.24-.19-.72,0-.74-.49l1.18-.1a3.08,3.08,0,0,1,1.64-.19,63.88,63.88,0,0,0,7.82.61,11.81,11.81,0,0,1,5.06,1.52C148.11,230,148.48,230.72,147.53,231.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M183.75,208.35c0,.51-.18,1.09.45,1.41.22-.13.3,0,.37.19a.84.84,0,0,1-.72.86c-.89.11-1.45.79-2.32,1.31.57-.26,1-1,1.29,0,.19,2.67.05,5.34.08,8,0,1.23,0,2.46.07,3.7-.37,1.12-1.49,1-2.32,1.44-.72.15-1.55.55-1.7-.7-.27-3.54-.1-7.08-.1-10.62a1.52,1.52,0,0,1,.56-1.15A25.1,25.1,0,0,1,183.75,208.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M234.23,124.41a2.65,2.65,0,0,0,.29-1.49q0-4.67,0-9.31c0-.3-.1-.68.3-.8.08,0,.26.33.4.51.49.08.23.62.5.84a3,3,0,0,1,.36,1.6,2.91,2.91,0,0,0,.36,2,31.14,31.14,0,0,1,1.14,5c.06.3,0,.61.1.91a8.79,8.79,0,0,0,.15.87,13.47,13.47,0,0,0,.24,1.39,4.14,4.14,0,0,1,.1.87,3.15,3.15,0,0,0,.13,1,4.54,4.54,0,0,1,.09.51,5.11,5.11,0,0,0,.19,1.17,3,3,0,0,1,.06.51,2.44,2.44,0,0,0,.3,1.47,1.11,1.11,0,0,1,.05.54c-.26.75.21,1.65-.45,2.32-.23.05-.32-.1-.42-.26-.16-.36-.26-.74-.4-1.11a1.11,1.11,0,0,1-.07-.29.31.31,0,0,1,0-.19c-.09.06,0,.18-.09.27a3.24,3.24,0,0,1-.13.41,1.38,1.38,0,0,1-.18.39.42.42,0,0,1-.26.12c-.16,0-.21-.18-.31-.27C236,130.42,234.47,127.59,234.23,124.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M168.41,218.88c1.67-.44,2.93-1.71,4.54-2.27a.63.63,0,0,1,.39.5c-.11,2.82.15,5.64-.15,8.45a1,1,0,0,1-.72.59,2.87,2.87,0,0,1-1,.24c-.69,0,.07.19,0,.25a.84.84,0,0,1,0,.52.7.7,0,0,1-.26.28c-1,.34-1.93.85-3,.32a1.83,1.83,0,0,1-.36-1.35c0-2,0-4,0-6.08C167.82,219.78,167.81,219.2,168.41,218.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M233.78,107.4q0-6.2,0-12.38a.66.66,0,0,1,.27-.62,33.5,33.5,0,0,1,3.09,7.72c.28.84.41,1.72.74,2.55.11.25.2.51-.07.73-.64-.14-.91.36-1.26.73a.24.24,0,0,1-.29-.09,11.66,11.66,0,0,1-.64-1.68,12.52,12.52,0,0,0,.48,1.74c.17.53.13,1.15.65,1.52a.47.47,0,0,1,0,.46c-.39.39-.16.77,0,1.19a5.44,5.44,0,0,1,.63,2.37c.06.26,0,.34-.3.27-.83-.77-1.31-1.87-2.33-2.46a.63.63,0,0,1-.45-.44,3.62,3.62,0,0,0-.38-1A.76.76,0,0,1,233.78,107.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M203.88,90.09a1.18,1.18,0,0,0-.83-1.07c-1.69-.46-2.33-1.86-3-3.22a33.24,33.24,0,0,1-.07-5,1,1,0,0,1,.39-.83c1.14-.12,1.59.8,2.22,1.46a2.9,2.9,0,0,0,1.35,1.26,1.17,1.17,0,0,1,.26.17c.24.25.4.58.77.66a.71.71,0,0,1,.48.56,2,2,0,0,0,.82,1.42c.65,1,1.69,1.75,1.94,3-.12.87-.52.8-1,.26a20.79,20.79,0,0,1-1.36-2.13c0,1.06,0,2,0,2.93a1.84,1.84,0,0,1-.37,1.45c-.38.23-.66,0-.94-.21S204,90.46,203.88,90.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M168.41,218.88a2.82,2.82,0,0,0-.24,1.62c0,2,0,4,0,6.05,0,.42-.15.89.31,1.2-.17.51-.61.47-1,.49a2.18,2.18,0,0,0-2.29.57.91.91,0,0,1-1.53-.09,52.4,52.4,0,0,1-.11-7.62,1.39,1.39,0,0,1,.32-.76c1-.49,2-1,2.94-1.49C167.37,218.53,167.87,219,168.41,218.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M219.42,181.29l0-.32c1.09-.05.78-1.25,1.39-1.72a2.85,2.85,0,0,0,.62-1.14c.42-.91,1-1.32,1.82-.46.22-.08.31.11.45.21a.88.88,0,0,1,.69,1c-.27,1.81-.08,3.71-1,5.4a53,53,0,0,1-3.31,5.64c-.54-.28-.44-.78-.44-1.25,0-2.21,0-4.42,0-6.64C219.44,181.81,219.51,181.52,219.42,181.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M173,225.78v-7.45a2.32,2.32,0,0,1,.24-1.37c.06-.46.65-.5.74-.94l2.6-1.3a1.18,1.18,0,0,1,.37,1c0,3.21.13,6.42-.07,9.63-.34,1-1.35.85-2.09,1.15a5.63,5.63,0,0,1-1.91.27.59.59,0,0,1-.41-.34.41.41,0,0,1,.16-.29,1.68,1.68,0,0,1,1-.17C173.4,225.84,173.13,226,173,225.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M205.29,91.08c.49-1.18.15-2.42.24-3.63,0-.47,0-.94,0-1.62a20.18,20.18,0,0,1,1.9,2.81c.11.15.19.42.41.27s.09-.36.12-.55a.57.57,0,0,1,.53.2,17.8,17.8,0,0,1,3.36,5.09c-.22.46-.41,1-1,1a4.53,4.53,0,0,0-.45-.87c.18.17.26.6.52.93.3.52.18,1.16.49,1.68.1.32-.07.79.51.82a.49.49,0,0,1,.28.52.78.78,0,0,1-.24.42,2.24,2.24,0,0,1-.68.45c-.36-.18-.6-.1-.71.3-1.86-2-2.76-4.63-4.44-6.74-.25-.31-.4-.7-.79-.88-.09,0-.13-.08-.1-.13S205.26,91.08,205.29,91.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M52,141.78a11.71,11.71,0,0,1,.51,4.32c-.08.09-.15.1-.23,0a1.62,1.62,0,0,1-.48-1.28,11.9,11.9,0,0,0-1-3.49c-.61-1-.05-2.08-.43-3.08a10.16,10.16,0,0,1-.1-1.83,3.39,3.39,0,0,0-.13-1.14,7.42,7.42,0,0,1-.1-1.49c0-.71.2-1.51-.68-1.91-.35-.11-.74-.1-1-.39-.42-1.15,0-2.24.24-3.34a25.67,25.67,0,0,0,.77-4.76,1.28,1.28,0,0,1,.23-.78.7.7,0,0,1,.78-.05.69.69,0,0,1,.2.35c-.1.61-.06,1.23-.1,1.78.25-.4-.32-1.1.35-1.47.47,0,.64.21.62.64,0,1.7.12,3.39-.09,5.09a33.28,33.28,0,0,1,.2,4,1.56,1.56,0,0,0,0,1.18l.48,5.52A5.6,5.6,0,0,0,52,141.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M147.81,229.41A30.12,30.12,0,0,0,137.66,228c-1.44,0-2.8-.61-4.24-.54a1.38,1.38,0,0,1,1-.45c2.43-.33,4.78-1.06,7.26-1.2,2.06-.11,4.1-.49,6.15-.74.52,0,.56.39.58.72a9.33,9.33,0,0,1-.16,3.49A.32.32,0,0,1,147.81,229.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M50.77,153.75a8.12,8.12,0,0,1,.68,5.2c-.47,2,.18,3.59.61,5.33-.17.14-.45.19-.52,0-.46-1.1-1.48-1.13-2.42-1.32a2.28,2.28,0,0,1-.76-1.31,33.13,33.13,0,0,1-1.45-6.38,5.21,5.21,0,0,1,0-.79,1,1,0,0,1,.24-.53c.88-.1.79.72,1.07,1.05-.14-.56-.71-1.23,0-1.9C49.18,153,50.22,152.43,50.77,153.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M121.23,232a47.17,47.17,0,0,1,6.42,1.42c0,.83,0,1.65,0,2.47-.75.47-1.45,0-2.16-.12s-1.14-.28-1.72-.41c-.42-.08-.88-.59-1.24.18-.08.16-.5.09-.77.05s-.43-.1-.64-.13a15.33,15.33,0,0,1-3.47-.86,2.14,2.14,0,0,1-.55-.35c-.22-.28-.36-.62-.69-.8a.88.88,0,0,0-.42-.11,2.85,2.85,0,0,1-2-.54c.29-.59-.29-.7-.55-1a.7.7,0,0,1,0-.32.4.4,0,0,1,.36-.3c.3-.09.75.46.93-.23,0-.07.36,0,.54.08l.71,0c.81-.17,1.45.41,2.2.48s1.29-.08,1.91.19a.23.23,0,0,1,.18,0c.15.29.77-.13.71.48C121.13,232.25,121.12,232.07,121.23,232Z",
    transform: "translate(-8.9 -13.51)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M60.89,185.79c1.21,1.27,2.22,2.71,3.53,3.91a18.81,18.81,0,0,1,1.94,2.53c.26.33.39.8.89.89.78.57,1,1.67,2,2a4.3,4.3,0,0,1,.9,1.72c.19.76,1,1.24,1.71,1.71a4.38,4.38,0,0,1,.95,1.41.87.87,0,0,1-.16.7.24.24,0,0,1-.33,0c-2.29-2.29-4.9-4.26-6.7-7-.46-.71-1.31-.94-1.86-1.6a51.81,51.81,0,0,1-5.07-7.4c0-.82.54-.75,1.08-.7C60.61,184.29,60.51,185.18,60.89,185.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M176.56,225.57c0-3.62,0-7.23,0-10.85l2.87-1.91a6.74,6.74,0,0,0-.21,1.16c0,3.26,0,6.52,0,9.78a1.35,1.35,0,0,0,.26,1A3.69,3.69,0,0,1,176.56,225.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M163.86,220.34v8.57a.57.57,0,0,1-.34.4.92.92,0,0,1-.85-.09c-.18-.19.11-.32.08-.49a1.41,1.41,0,0,1-.35.21,3.89,3.89,0,0,1-.66.21,2.76,2.76,0,0,1-1.18,0c-.81-.26-.86-.94-.88-1.63-.05-1.77.08-3.55-.14-5.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M48.37,131.5h1.25a2.72,2.72,0,0,1,.28,1.34c0,.37-.12.72.31.91a8.17,8.17,0,0,0,.08,1.78,15.12,15.12,0,0,0,.14,2c0,.56.19,1.1.14,1.67a6.38,6.38,0,0,1-.2,2.34c-.1,1.06.43,2,.39,3.09a8.1,8.1,0,0,1-2.39-.41,12.39,12.39,0,0,1-.67-1.65c.08-3-.85-6-.31-9C47.52,132.82,47.28,131.83,48.37,131.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M210.8,94.65l.92-1a.94.94,0,0,1,.47.41c.54.82.37-.52.73-.25,1.05.41,1.4,1.57,2.32,2.12a2.5,2.5,0,0,1,.76.61,2.29,2.29,0,0,1,.48,1.41c0,.84-1,1.47-.44,2.41a6.7,6.7,0,0,0,.27,1c.1.53.45,1.06,0,1.58-.17.1-.18.26-.18.44,0,.45-.21.47-.55.33l-.23-.24a21.75,21.75,0,0,0-1.22-2.8c.2,1,1.16,1.67,1,2.75-1.2,0-1.2-1.34-1.94-1.86a9,9,0,0,1-1.34-1.79c-.23-.42-.68-.75-.59-1.31a.77.77,0,0,1,.49-.49c.09.06.19.14.28,0s0-.2,0-.3l-.22-.48a.63.63,0,0,1-.52-.67c-.63-.54-.44-1.28-.47-2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M49.16,162.85a9.2,9.2,0,0,0,1.05,0c.68-.08,1.12.14,1.26.85.06.33.18.6.59.58a21.17,21.17,0,0,1,1.37,3.6c0,.17.06.23.19.28l1.54,4.5a3,3,0,0,0,0,.43c.11.7.77,1.22.64,2a.38.38,0,0,1-.36.29c-.57-.28-.72-.88-1-1.37-.25-.1-.12.29-.32.25a1,1,0,0,1-.67,0,1.15,1.15,0,0,1-.72-.75,43.13,43.13,0,0,0-2.42-4.92c-.16-.32-.42-.66-.33-1,.38-1.44-.28-2.64-.78-3.88C49,163.45,48.87,163.14,49.16,162.85Z",
    transform: "translate(-8.9 -13.51)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M48.43,144.19c.78.15,1.69-.37,2.33.47A49.81,49.81,0,0,1,52,151.83c.13.18.14.4-.05.5s-.34-.11-.51-.2a3,3,0,0,1-.68-1.92,2.9,2.9,0,0,1-.33-1.22c0-.24-.24,0-.11-.09s.08,0,.08.09c0,.34.2.68-.05,1-.28,1.3.29,2.51.4,3.76-.74-.88-1.74-.3-2.6-.46a.66.66,0,0,1-.4-.74,2.41,2.41,0,0,0-.11-1.43,10.21,10.21,0,0,1,.2-5.92A1.8,1.8,0,0,1,48.43,144.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M196.93,97.07a7,7,0,0,1-2.43-2.47c-.21-.47-.52-1.08-1.19-1.2-.19-.28,0-.49.14-.71.46-.93.14-1.94.27-2.9.09-.66.1-1.4,1.07-1.38a12.13,12.13,0,0,1,3.55,3.89,7,7,0,0,1,0,4.85c-.73.55-.78-.33-1.16-.55C197.19,96.82,197.34,97.08,196.93,97.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M159.54,222.2c.66.11.48.63.48,1,0,1.53,0,3.07,0,4.6,0,.56.07,1,.77,1.09-.22.72-.87.45-1.34.59a11.37,11.37,0,0,1-2.77.45,1,1,0,0,1-.78-.94,34.6,34.6,0,0,1,0-5.29.77.77,0,0,1,.28-.51C157.18,222.43,158.42,222.51,159.54,222.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M200.67,80.06c-.62.18-.37.7-.4,1.09-.13,1.55.26,3.12-.25,4.65-.5-.59-1.35-.57-1.89-.94a9,9,0,0,1-1.71-2.12c0-1.81,0-3.62,0-5.42,0-.33-.2-.8.22-.95s.45.35.64.58a1.12,1.12,0,0,0,.77.48c.31-.2.53,0,.72.19.65.61,1.16,1.36,1.86,1.93A.32.32,0,0,1,200.67,80.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M127.66,236.52v2.67c-.38.35-.77.14-1.21.11-2.5-.16-4.78-1.11-7.15-1.77-.15-.05,0,0-.11,0s-.11.08-.08.18a.63.63,0,0,1-.85.17,10.69,10.69,0,0,0-2.72-.6c-.48,0-.82-.4-1.26-.51s-.88-.25-1.28-.49a.54.54,0,0,1-.21-.28.54.54,0,0,1,.38-.37,1.55,1.55,0,0,1,.36-.08,9,9,0,0,1,3,.17,1.21,1.21,0,0,0,.93.14,1.45,1.45,0,0,1,.62.07c.36.18.55-.09.76-.29a1.09,1.09,0,0,1,.45-.24,13.42,13.42,0,0,1,4.85,1c.41.06.28-.23.28-.07s0,0-.06,0c-.47.1-.75,0-.71-.58a1,1,0,0,1,.72-.24C125.45,235.83,126.67,235.77,127.66,236.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "M55.68,181.54a.61.61,0,0,0-.9-.36c.46,1.56,1.67,2.63,2.51,3.93.13.53.74.78.79,1.36,0,.19-.2.24-.36.29-1.31-.63-2-1.87-2.93-2.91a6.69,6.69,0,0,1-.64-1.11c-.14-.08-.25-.24-.44-.17l-.23.1a.34.34,0,0,0-.08.43c.05.13.08.26.12.39-.29.43-.54.13-.8-.05-1-.58-1.16-1.67-1.66-2.55S50,179.11,50,178c.71-.19,1,.33,1.37.77.16.28.15.64.4.87a3.22,3.22,0,0,1-.34-1.16,1.43,1.43,0,0,0,.17-1.55c-.28-.77-.54-1.56-.78-2.35-.08-.25-.24-.57.07-.75s.61,0,.81.29c.33.4.52.89.85,1.28a5.14,5.14,0,0,0,1.69,2.22c.64,1.18,1.24,2.38,1.89,3.56a.66.66,0,0,1,0,.34A.32.32,0,0,1,55.68,181.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M221.34,104.7a6.89,6.89,0,0,1-.47-3.62c0-.37-.12-.83.45-.92.45.43.42,1.11.79,1.56.19-.33-.16-.51-.19-.76a1,1,0,0,1-.12-.78c0-.39-.13-.42-.43-.27-.24-.28-.17-.73-.51-1,.1-.42-.28-1,.48-1.19a.55.55,0,0,1,.37.31,13.76,13.76,0,0,0,2.2,3.8,16.57,16.57,0,0,1,.74,2,1.71,1.71,0,0,1,.12.91c.11-.6,0-1,.43-1.31.2.5.42,1,.6,1.52.11.28.14.58-.32.54-.78-.06-.79.45-.79,1a23.78,23.78,0,0,1-.24,4.84C223.36,109.2,222.71,106.79,221.34,104.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M156.2,223.22c0,1.82,0,3.63,0,5.45a1.07,1.07,0,0,0,.73,1.15c-.43.48-1,.35-1.51.29a10.35,10.35,0,0,0-2.36-.17c-.49,0-1.08-.09-1.13-.66-.16-1.79-.51-3.6.21-5.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M50.32,122.65h-.69c-.53-.53-.27-1.21-.36-1.83a39.15,39.15,0,0,1,1.82-9.21c.1-.37.24-.77.71-.88.86-1.34,1.31-2.92,2.37-4.16a11.76,11.76,0,0,1-.9,3.67c-1.59,4.91-1.78,10-1.78,15.05a12.83,12.83,0,0,1-.18,3.66c0-1.55,0-3.1,0-4.65,0-.51,0-1-.72-.93a.77.77,0,0,1-.11-.53c.23-1.31.35-2.62.48-3.93-.06-.17-.25,0-.1,0s.1,0,.09.08A13.13,13.13,0,0,1,50.32,122.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M194.79,88.41a1.32,1.32,0,0,0-.76,1.44c0,.74,0,1.48,0,2.22,0,.38.1.83-.48.9-.47-.12-.78-.52-1.23-.69-1.05-1-2.28-1.86-2.69-3.37.39-.16.38-.47.28-.81a17.22,17.22,0,0,1,0-2.27c0-.48,0-1,.56-1.21s.66.34.94.6c.11.11.19.26.35.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M197.86,97.28a1.68,1.68,0,0,0,.49-1.52c0-1.15,0-2.31,0-3.46a40.76,40.76,0,0,1,6,8.81.56.56,0,0,1-.71,0A10.41,10.41,0,0,1,201.9,99c-.25-.34-.39-.8-.89-.88,0,0-.08-.07-.1-.07s-.11-.12-.09,0,0,.48.14.69l.07.36c.12.2,0,.29-.18.37-.52-.06-.56-.58-.84-.88v0c.23.36.4.75.61,1.12l.26.54c.08.18.17.35.26.52a2.92,2.92,0,0,0,.4.59,1.32,1.32,0,0,1,.16.25.43.43,0,0,1-.22.64c-.42.47-.66.18-.89-.21a30.85,30.85,0,0,0-3-4.55C197.53,97.3,197.65,97.25,197.86,97.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M152.12,223.93v3.58c0,2.11,0,2.11,2.06,2.12a2.73,2.73,0,0,1,1.3.12c-.33.58-.91.42-1.42.46a21.83,21.83,0,0,1-4.64-.24c-.51-.1-1-.13-1.37-.63-.14-1.42.31-2.89-.27-4.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M231.59,85.11c-1.85-2.5-3.68-5-5.54-7.48-.28-.38-.41-1-1.12-.86-.84,0-1-.76-1.31-1.35a2.43,2.43,0,0,1,.39-1.85c.66.47,1.53.6,2.05,1.31.39.5.75,1,1.16,1.51s.57.88.82,1.33.65.65.9,1a7.55,7.55,0,0,0,1.12,1.46,2.53,2.53,0,0,1,.18.27c.36.76.67,1.54,1,2.3a1.43,1.43,0,0,0,.55.69.62.62,0,0,1,.17.25c0,.41.32.78.17,1.21C232,85.11,231.83,85.25,231.59,85.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M190,82.25c.44-.77.19-1.62.26-2.43.59-.08.74.55,1.17.72a13.1,13.1,0,0,1,4.46,6.4C194,85.16,191.75,84,190,82.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M191.74,85.53c-.59,0-.76-1-1.32-.65s-.17,1.1-.21,1.68,0,1.25,0,1.88c-.46.16-.63-.23-.87-.48a16.64,16.64,0,0,0-2.51-4.49c.17-.65.34-1.3.5-2C188.84,82.8,190.57,83.86,191.74,85.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M56,181.48l0-.19c-.52-2-1.77-3.78-2.48-5.74-.17-.46-.54-.9-.17-1.43h.73a.54.54,0,0,1,.42.27,36.85,36.85,0,0,0,4,7.66A12.45,12.45,0,0,1,60,183.86a.42.42,0,0,1-.13.3c-.48,0-1-.06-1.19.51l-.23-.26c-.74-.22-.79-1.15-1.48-1.42l-.69-.85C56.1,182,55.92,181.78,56,181.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M134.15,251.17l.25.22a19.28,19.28,0,0,0,4.21.62c.24,0,.6-.12.59.35a22.17,22.17,0,0,1-3.63.5,1,1,0,0,1-.77.28,41.28,41.28,0,0,0-6.19-.56.83.83,0,0,1-.64-.25v-1.4a10.52,10.52,0,0,1,4.36.31A2.16,2.16,0,0,0,134.15,251.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M120.5,20c-1.18.12-2.4-.17-3.55.29a1,1,0,0,1-1.39,0c3.7-1.66,7.6-1.84,11.57-1.67.55,0,.56.29.49.68a1,1,0,0,1-.87.36,10.42,10.42,0,0,0-3.23.41c-.51,0-1,0-1.53,0A2.3,2.3,0,0,0,120.5,20Z",
    transform: "translate(-8.9 -13.51)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M236.94,88.4l1.84,3.82a1.89,1.89,0,0,1,.44.78c.21.39.47.77.14,1.21-1.47-2-3.35-3.77-4.19-6.22a.94.94,0,0,1-.41-.58c0-.54-.28-1.07-.07-1.62a.61.61,0,0,1,.5-.16C236.19,86.29,236.34,87.48,236.94,88.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M190.21,204a1.79,1.79,0,0,0-1.15-1.43,1.18,1.18,0,0,1,.64-.58c.44.11.57-.3.83-.49l.32-.35c.5-.7,1.11-1.32,1.66-2a3.48,3.48,0,0,1,.54-.38,5.19,5.19,0,0,0,1.51-1.92c.17-.35.5-1,.87-.07-.1,1.67-1.26,2.68-2.31,3.79a20.33,20.33,0,0,0-1.5,2,2,2,0,0,1-.82,1.33C190.62,204,190.44,204.14,190.21,204Z",
    transform: "translate(-8.9 -13.51)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M114.78,247.07c3.54.73,7.07,1.57,10.65,2.08.44.07.87.1,1.31.15s.68-.12.92.23v.91c-1.2.34-2.29-.28-3.45-.36-.47,0-.92-.2-1.39-.28a2.25,2.25,0,0,1-.35-.09c-.71-.24-1.44-.38-2.16-.58l-.51-.08a2,2,0,0,1-.34-.06,1.89,1.89,0,0,1-.34-.09c-1.32-.52-2.78-.52-4.08-1.1a1.41,1.41,0,0,1-.56-.46C114.47,247.13,114.53,247,114.78,247.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M119.07,237.52a.23.23,0,0,1-.12,0,.53.53,0,0,1-.11-.15,2.4,2.4,0,0,1,1.7.22,27.59,27.59,0,0,0,7.11,1.62v1.22c-.37-.06-.86.13-.92-.49a1.29,1.29,0,0,1,.17-.16l-.17.16c-.63.35-1,.31-.71-.49-1.78,1.08-3.37-.18-5-.47,0-.51.3-.31.56-.29.47,0,.89.3,1.25.28-1-.42-2.31-.27-3.43-.8C119.13,238,119.19,237.72,119.07,237.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M128,241.14v-.51c1.11-.48,2.18.09,3.27.14h.39c1.61.12,3.26-.32,4.84.29.27,0,.51.14.78.17,1,0,2,.35,3,.26a2,2,0,0,1,.35,0c.28.08.71.06.65.49s-.4.32-.67.35c-.78.07-1.56,0-2.34,0-2.47.13-4.88-.48-7.31-.72a6.35,6.35,0,0,0-1.74-.11A1.45,1.45,0,0,1,128,241.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M136.54,241.34a23.89,23.89,0,0,0-5-.23c.4-.34.4-.34,1.11-.27-1.59-.15-3.23-.07-4.68-.93v-.72a58.13,58.13,0,0,0,6.15,1.07c1.13.11,2.26.25,3.39.38C137.5,241.3,136.83,241.05,136.54,241.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M127.65,252.66c-3-.12-5.91-1.11-8.88-1.6-1-.16-2,.29-2.89-.34.28-.38.71-.33,1.1-.38a4.16,4.16,0,0,1,1-.15,15.58,15.58,0,0,0,3.13.17,10.76,10.76,0,0,1,1.13,0,2,2,0,0,1,.35.08,2.46,2.46,0,0,1,.62.33,1.6,1.6,0,0,0,1.16.55c1.08.36,2.32.25,3.29,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M220,149.45l-.55,1.47a13.23,13.23,0,0,1-.43-6.59,1.19,1.19,0,0,1,.69,1,18.61,18.61,0,0,1,.36,2.47C220.15,148.35,220.36,148.91,220,149.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M128,252.33a23,23,0,0,1,6.87.55.2.2,0,0,1-.06.32,11.72,11.72,0,0,1-2.29.17l-.77,0a5.81,5.81,0,0,1-1.86,0,3.86,3.86,0,0,0-1.88-.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M195.43,196.81c-.62-.68-.68.17-.77.37a3.41,3.41,0,0,1-1.58,1.86c-.23-.26-.14-.52,0-.79.18-.45.68-.69.78-1.2a4.92,4.92,0,0,1,1.44-1.88c.54-.1.77-.84,1.42-.7A4.28,4.28,0,0,1,195.43,196.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M55.86,188.67c.32-.75.6-.21.83,0a17.64,17.64,0,0,1,2.56,3.57c-.4.35-.75.08-1-.16a1.8,1.8,0,0,0-.94-.45,1,1,0,0,1-.38-.31,7.83,7.83,0,0,1-.83-1.6C55.94,189.41,56,189,55.86,188.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M35,65.46c-.65.25-.83,1.14-1.61,1.22,1.14-1.94,3.14-3.07,4.51-4.79.06-.11.14-.11.22,0l-.3.78a9.94,9.94,0,0,1,0,1.22,1.5,1.5,0,0,1-.8.75c-.35-.23-.59-.08-.86.19S35.58,65.6,35,65.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M123.11,251l-.5-.26a1.41,1.41,0,0,1,.76-.45,4.38,4.38,0,0,1,.88-.23c1.13.32,2.38.18,3.4.91v.71c-1.14.63-2.18-.18-3.27-.24A2.65,2.65,0,0,1,123.11,251Z",
    transform: "translate(-8.9 -13.51)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M51.26,183.92a1.53,1.53,0,0,1-.46-.93c.4-.42-.32-.81,0-1.23a.63.63,0,0,1,.65,0,3.9,3.9,0,0,1,1.07,1.89l1.17,2.15a.76.76,0,0,1-1.17-.47,9.81,9.81,0,0,0-.71-1.21,1.22,1.22,0,0,1-.15-.17c-.12-.16-.13-.37-.26-.51A.31.31,0,0,1,51.26,183.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M134.15,251.17c.11.67-.31.53-.71.48l-5.46-.72v-.5A49.46,49.46,0,0,1,134.15,251.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "M237.32,122.9l-1.13-5.32a.8.8,0,0,1,0-.9c.72,1.93,1.58,3.82,1.58,5.94a.14.14,0,0,1-.18.09C237.41,122.62,237.51,123,237.32,122.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "M214.9,173.72l-.29.88a1.2,1.2,0,0,1-.22.4c-.26.24-.42.58-.74.76-.4-.12-.42-.37-.29-.73.51-1.35,1-2.7,1.49-4.05C215.54,171.88,215.09,172.81,214.9,173.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-443",
    d: "M231.59,85.11l.65-.31c1.19.68,1.54,1.92,2,3.07.05.39.1.77-.26,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M115.56,20.21l1.39,0c.66.23,1.36-.28,2.19.21-1.09.8-2.28.67-3.42.72-.31-.27-.72-.41-1-.71,0-.12,0-.19.14-.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M103.51,224.84a2.47,2.47,0,0,1-1.48-.26c-.7-.25-.07-1-.59-1.3a1.42,1.42,0,0,1,1.1-.26,3.91,3.91,0,0,1,.73.38C103.44,223.86,103.82,224.29,103.51,224.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M127.66,229.38l-4.53-1.18c0-.21,0-.33.24-.25l1.4,0a2.74,2.74,0,0,0,1.24,0c.56.17,1.26-.05,1.65.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M131.74,227.93c-1.14-.32-2.22.22-3.33.25a.29.29,0,0,1-.46,0c-.14-1,.11-1.36,1.2-1a16.52,16.52,0,0,0,2.65.49C131.89,227.79,131.87,227.87,131.74,227.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "M133.93,237.24l-6-.69V236l4,.53a1.46,1.46,0,0,1,1,.19c.41.07.86-.06,1.21.26C134.16,237.17,134,237.18,133.93,237.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "M239.8,135.63c0,1.11,0,2.23,0,3.34,0,.36.16,1.07-.67.93-.61-.83-.3-1.76-.28-2.65a2.71,2.71,0,0,0,.32-1.32.52.52,0,0,1,.43-.69C239.77,135.29,239.93,135.37,239.8,135.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M201.5,99.83a7.37,7.37,0,0,1,1.37,2.32c.15.3.41.74,0,.94s-.73-.12-.86-.55a1,1,0,0,0-.48-.93l-.05,0a3.6,3.6,0,0,1-.33-.9,1.72,1.72,0,0,1,.16-.63A.51.51,0,0,1,201.5,99.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M114.84,20.27a.34.34,0,0,0,0,.22,1.09,1.09,0,0,1-1.08.31c-.3-.11-.55.06-.81.14l-1.38.23c-.45-.2-.8.1-1.17.26-.48.49-.82.15-1.15-.2A18.32,18.32,0,0,1,114.84,20.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M192.61,199.25c-.26.93-1.15,1.36-1.63,2.12-.25-.05-.33-.28-.44-.46a11.05,11.05,0,0,1,2.05-2.66A.71.71,0,0,1,192.61,199.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M72.63,200a4,4,0,0,1-.76-1.37c1.13,1.14,2.65,1.88,3.54,3.29-.17.24-.43.24-.68.27l-.47-.47c-.13-.17-.3-.29-.42-.45a2,2,0,0,0-.82-.67C72.7,200.48,72.78,200.15,72.63,200Z",
    transform: "translate(-8.9 -13.51)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "M238.83,132v-.48l0-.17a2.44,2.44,0,0,1,.2-1.48c.28-.19.4,0,.55.21a9.46,9.46,0,0,1,.43,2.42,2.9,2.9,0,0,1-.31.54.9.9,0,0,1-.4.26.6.6,0,0,1-.32-.07.62.62,0,0,1-.23-.42C238.74,132.52,238.63,132.23,238.83,132Z",
    transform: "translate(-8.9 -13.51)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M211.27,98.51l.74,1.15c.23.6.49,1.2,0,1.78a11.24,11.24,0,0,1-1.42-2.53C210.45,98.18,210.91,98.44,211.27,98.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M127.65,250.93l-3.57-.72c-.24.12-.47-.05-.71,0a1.55,1.55,0,0,1-.31-.06.81.81,0,0,1-.47-.38.26.26,0,0,1,.07-.28l5,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "M217.49,105.91a3,3,0,0,1,.53,1.19c0,.55.63,1,.19,1.65l-.9-.25c-.48-.15-.56-.5-.48-.94l.22-.71C217.36,106.61,216.84,106,217.49,105.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-457",
    d: "M130.82,20.21l-2.85,0v-.74a1.76,1.76,0,0,1,1.91,0l1.34.11C131.28,20,131,20,130.82,20.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "M127.66,236.52l-3.27-.7c-.34-.18-.8-.09-1.06-.46,0-.2.07-.32.29-.29l4,.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M212,101.44c0-.59,0-1.18,0-1.77a4.45,4.45,0,0,1,1.19,1.94c-.06.23.14.65-.26.65A1,1,0,0,1,212,101.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "M214.38,174.83l.23-.23.54.46a6.29,6.29,0,0,1-1.08,3.12l-.36-.47.41-1.68A.86.86,0,0,1,214.38,174.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "M124.33,251.18c1.12.06,2.18.57,3.33.46v.7l-3.53-.73C124,251.36,124.21,251.3,124.33,251.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M127.66,227.46l-2.61-.66a.65.65,0,0,1-.34.1c-.39-.14-.86-.22-.61-.83a17.35,17.35,0,0,1,3.18.77C127.62,226.91,127.7,227.15,127.66,227.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M194.71,199.92l-.2.5c-.66,1-.92,2.33-2.26,2.79a.7.7,0,0,1-.64.12.32.32,0,0,1,0-.45C192.79,202,193.38,200.59,194.71,199.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M57.48,177l-.68-1.22c-.33-.33-.83-.59-.48-1.2.34-.24.61-.3.8.19.26.67.57,1.31.86,2A.67.67,0,0,1,57.48,177Z",
    transform: "translate(-8.9 -13.51)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M53.77,183.79c.59.88,1.57,1.55,1.66,3A4.17,4.17,0,0,1,53.77,183.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M218.44,101.1l.47,1.9c-.67-.32-1-.89-1.41-1.29a1.63,1.63,0,0,1-.21-1.48c1-.77.74.43,1.07.71A.8.8,0,0,1,218.44,101.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M215.86,169.17l-.3,1.75a.16.16,0,0,1-.18.16.91.91,0,0,1-.47-.3,16.42,16.42,0,0,1,.65-3.25A1.82,1.82,0,0,1,215.86,169.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M53.23,156.15l.63,1.7a.92.92,0,0,0,.26.94c0,.23.14.52-.12.64s-.38-.15-.4-.33c-.12-1-.79-1.9-.84-2.95A.32.32,0,0,1,53.23,156.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M57.28,191.57c.33-.18.65-.28.9.13a1.19,1.19,0,0,0,1.07.58c.13,0,.2.11.15.25-.19.3-.12.71-.44,1l-.26.28c-.62-.06-.62-.65-.89-1s-.44-.57-.6-.9A.35.35,0,0,1,57.28,191.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "M237.18,133.19l.2-.24a.22.22,0,0,1,.35.08,5,5,0,0,1,.23,1.89v3c0,.64.12,1.32-.34,1.89a.23.23,0,0,1-.22.06c-.48-.73-.14-1.56-.26-2.34a11.06,11.06,0,0,1-.08-1.91C237,134.82,237.23,134,237.18,133.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M191.38,80.54c-.54,0-.73-.55-1.17-.72l-2.16-2.09c.07-.21.24-.19.41-.17a5.6,5.6,0,0,1,1.07,1l.93.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M237.83,105.4a11.82,11.82,0,0,1-.67-3.28l1.2,3c.07.36.42.86-.39.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "M128,239.91c.7-.36,1.21.3,1.87.33.95.06,1.9.41,3,.43-.41.39-1,0-1.26.44h-.26a6.61,6.61,0,0,0-2.14-.5c-.4-.1-.86-.09-1.16-.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M219.19,153.26c.08.71.16,1.42.23,2.13-.06.25-.12.5-.17.75a.6.6,0,0,1-.74,0,8.43,8.43,0,0,1,.52-2.94.08.08,0,0,1,.08,0S219.17,153.23,219.19,153.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-473",
    d: "M234,88.92V87.76l.1-.11a.6.6,0,0,1,.52.25,1.47,1.47,0,0,1,.2.54c-.12.56.39.94.42,1.46.09.36-.09.48-.43.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M127.65,28.13a4.36,4.36,0,0,0-2.38.7c-.35-.26-.64.06-1,.1a.19.19,0,0,1-.22-.13c.07-.74.71-.78,1.16-.73a5.88,5.88,0,0,0,2.4-.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M56.32,174.6l.48,1.2c-.31.1-.48-.17-.72-.26a.49.49,0,0,1-.35-.51c0-.81-.67-1.39-.85-2.15l.28-.22C55.77,173.18,55.89,174,56.32,174.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M239.55,133l.43-.47c0,1.05.51,2.13-.18,3.15l-.26-.29a.89.89,0,0,1-.23-.35A2.69,2.69,0,0,1,239.55,133Z",
    transform: "translate(-8.9 -13.51)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M203.13,186.73a1.75,1.75,0,0,1,.19-.53c.24-.32.43-1,.89-.7s.37.85-.06,1.26c-.39-.14-.31.32-.52.41s-.36.26-.57.05A.6.6,0,0,1,203.13,186.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-477",
    d: "M59.39,179.59l1.69,2.66a.36.36,0,0,1-.49,0A15.78,15.78,0,0,1,59,179.61.27.27,0,0,1,59.39,179.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M239.55,130.06l-.49-.25c-.23,0-.1.32-.29.37a.39.39,0,0,1-.41-.1l0-.46c.17-.42-.07-.84,0-1.26s-.15-.88.12-1.3l.15-.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "M216.06,108.83a6.11,6.11,0,0,1-1-2.15c.76,0,.8,1,1.5.91.23.32.62.63.12,1C216.31,108.23,216.18,108.53,216.06,108.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M233.78,107.4l.3.43a3.08,3.08,0,0,0,.44,1.17l.24.45c-.26.09-.23.29-.19.5a.21.21,0,0,1-.29,0,12.06,12.06,0,0,0-.9-1.75C232.93,107.7,233.48,107.59,233.78,107.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M55.43,188.72l.19.45a.5.5,0,0,1,.08.31,1.62,1.62,0,0,1-.31.93c-.56.06-.56-.44-.75-.75h0c-.42-.5-1-.95-.64-1.74C54.67,187.85,54.86,188.63,55.43,188.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M55.43,188.72c-.08.21-.14.49-.43.19s-.56-.61-.84-.92c-.07-.05-.1-.1-.08-.16s0-.08.06-.08l.06-1A6.14,6.14,0,0,1,55.43,188.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M242,99.68c.15.73.71,1.31.73,2.08a1.18,1.18,0,0,1,0,1l-.57-1.42c-.06-.14-.18-.25-.23-.4s0-.22-.08-.3c0,.13,0,.2-.14.23l-.18-.3c-.14-.36-.25-.73.14-1A.43.43,0,0,1,242,99.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "M241.77,99.63c-.41.24-.27.64-.32,1-.24-1.13-.47-2.25-.71-3.38.58.34.48,1.09.92,1.51A.76.76,0,0,1,241.77,99.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M130.32,249.5a5.79,5.79,0,0,1-2.34.18v-.5c.87-.49,1.7.19,2.56.1C130.61,249.49,130.57,249.59,130.32,249.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-486",
    d: "M203.88,90.09l.7.36c.07.34.37.58.36,1a.71.71,0,0,1-.13.76,13.07,13.07,0,0,1-1-1C203.55,90.83,203.37,90.43,203.88,90.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M11.76,113.12c.55,1.16-.15,1.95-.82,2.75A10.51,10.51,0,0,1,11.76,113.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M128,241.14l2.89.42c-.11.22-.39.09-.52.25a4.72,4.72,0,0,1-2.36-.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M203.08,189.16a2,2,0,0,1-.69,1.64,1.26,1.26,0,0,1-.58-.25.42.42,0,0,1-.16-.42c.33-.4.49-.93.94-1.24C202.85,188.8,203,188.93,203.08,189.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-490",
    d: "M239.08,107.66a2.46,2.46,0,0,0,.25,1.25c0,.29.35.69-.24.8-.26-.94-.52-1.88-.77-2.82-.09-.25,0-.31.25-.33C238.93,106.84,238.86,107.31,239.08,107.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "M218.21,108.75c-.06-.55-.13-1.1-.19-1.65l.5.93a1.63,1.63,0,0,1,.71,1.54.77.77,0,0,1-.33.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "cls-492",
    d: "M215.14,103.47l-1.26-2.75a3.52,3.52,0,0,1,1.46,2.8A.65.65,0,0,1,215.14,103.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M214.91,170.78l.5.16a4.84,4.84,0,0,1,0,2c-.17.27-.33.54-.49.81,0-.91,0-1.83-.05-2.74A.36.36,0,0,1,214.91,170.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M237.39,137.47c0,.81,0,1.62,0,2.42-.42.21-.49-.07-.5-.37,0-.67,0-1.35,0-2A.33.33,0,0,1,237.39,137.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M219.63,178.36c-1-.3-.9-.8-.26-1.41.5-.11.47.28.55.57A1.28,1.28,0,0,1,219.63,178.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "M219.7,108.5a6.27,6.27,0,0,1,.72,1.89c.11.2,0,.3-.17.37a.64.64,0,0,1-.43-.22,8.12,8.12,0,0,1-.59-.93,1.62,1.62,0,0,1-.11-.62A.7.7,0,0,1,219.7,108.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "cls-496",
    d: "M109,21.44c-.67.73-1.6.52-2.42.69,0-.59.63-.15.74-.52C107.84,21,108.44,21.28,109,21.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M58,186.48c-.23-.45-.93-.67-.68-1.37l1.4.95a.6.6,0,0,1,.08.71C58.4,187,58.16,186.79,58,186.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M128,240.15c1.06.45,2.34.16,3.3,1l-3.31-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "M239.17,137c0,1,0,1.95-.08,2.93h-.24l-.16-.15a13,13,0,0,1-.19-3.47c.05-.37,0-.78.52-1A2.23,2.23,0,0,1,239.17,137Z",
    transform: "translate(-8.9 -13.51)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M57.48,177a.51.51,0,0,1,.5-.27l.69,1.43a.63.63,0,0,1-.45.27A2.09,2.09,0,0,1,57.48,177Z",
    transform: "translate(-8.9 -13.51)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "M220,110.46l.2.24a.3.3,0,0,1,0,.46c-.48.42.32.8,0,1.22a.4.4,0,0,1-.1.55,2.15,2.15,0,0,1-.45-1,9.12,9.12,0,0,1-.35-1,.68.68,0,0,1,.06-.69C219.66,110,219.77,110.33,220,110.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "M217.75,167.11a6,6,0,0,1-.43,2.5l-.27-.28a2.46,2.46,0,0,1,.35-1.73C217.33,167.31,217.36,167.09,217.75,167.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M59.13,186.82A6.13,6.13,0,0,1,60.22,189a4,4,0,0,1-1.28-1.71C58.88,187.11,58.67,186.85,59.13,186.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "M219.7,108.5l-.45.51c-.43-.29-.41-.78-.52-1.22l0-.65c-.12-.27,0-.3.24-.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "cls-503",
    d: "M196.69,194.47c-.5.17-.76.84-1.42.7l1.08-1.22c.18-.2.47-.28.61-.08S196.9,194.32,196.69,194.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "cls-504",
    d: "M172.87,74.85a3.06,3.06,0,0,1-1.72-1.21A1.47,1.47,0,0,1,172.87,74.85Z",
    transform: "translate(-8.9 -13.51)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "M234.28,110l.29,0c.68.29.62.89.62,1.47C234.2,111.36,234.42,110.55,234.28,110Z",
    transform: "translate(-8.9 -13.51)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "cls-506",
    d: "M211.73,181.76c.13.26.74-.07.61.46-.09.33-.19.76-.54.85s-.21-.42-.43-.56A1.26,1.26,0,0,1,211.73,181.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M214.42,199.46a5.17,5.17,0,0,1,1.65-2.62A7.71,7.71,0,0,1,214.42,199.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "cls-507",
    d: "M48.4,53c.22,1,0,1.22-1.17,1A2.81,2.81,0,0,1,48.4,53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "cls-508",
    d: "M203.08,189.16l-.41-.22a.7.7,0,0,1,0-.78,2.54,2.54,0,0,1,.49-1.43c0,.17,0,.34.05.51.46.5.21,1,0,1.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "cls-509",
    d: "M219.94,147.78c-.58-.76-.27-1.63-.28-2.46a3.59,3.59,0,0,1,.46,2.46Q220,147.95,219.94,147.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "cls-510",
    d: "M126.74,19.24l.88,0,0,1c-.33,0-.71.1-.94-.28a.56.56,0,0,1-.14-.44A1,1,0,0,1,126.74,19.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "M225.92,114c1.17-.15.81.92,1.14,1.44l-.45,0c-.19-.11,0-.39-.24-.5A1,1,0,0,1,225.92,114Z",
    transform: "translate(-8.9 -13.51)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "cls-512",
    d: "M127.65,241.64a4,4,0,0,1-2-.6c.78-.34,1.37.15,2,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "cls-513",
    d: "M231.15,121a6.65,6.65,0,0,1-.27-2.08c-.1-.24,0-.33.24-.31l.31,1.41a1,1,0,0,1-.08,1.06A.5.5,0,0,1,231.15,121Z",
    transform: "translate(-8.9 -13.51)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M74.73,202.15c.14-.29.41-.28.68-.27l.87.91c-.12.25-.38.15-.55.24A2,2,0,0,1,74.73,202.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "cls-514",
    d: "M237.39,137.47l-.47,0a1.48,1.48,0,0,1-.2-1.21.14.14,0,0,1,.19-.08c.16-.19,0-.48.19-.65a.2.2,0,0,1,.27,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "M239.8,112.35l-.28-1.17c-.08-.45-.24-.91.07-1.34a5.23,5.23,0,0,1,.49,2.2C240.16,112.3,240.06,112.39,239.8,112.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "cls-516",
    d: "M242.65,102.81l0-1,.41.8c.1.29.19.58.29.87s0,.49-.35.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "M197.86,97.28l-.24.26-.69-.47c.31-.4-.33-.67-.13-1.09C197.39,96.23,197.6,96.77,197.86,97.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "cls-518",
    d: "M210.33,185.12c.57.87.2,1.28-.71,1.42C209.86,186.07,210.09,185.59,210.33,185.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "M217.49,105.91l-.44.94c.16-.71-.47-1.22-.51-1.88a.35.35,0,0,1,.28-.31A3.52,3.52,0,0,1,217.49,105.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "cls-520",
    d: "M237.7,122.66l.09,0a6.74,6.74,0,0,1,.26,1.95.26.26,0,0,1-.42,0c-.28-.2-.25-.49-.21-.77C237.69,123.46,237.28,123,237.7,122.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "cls-521",
    d: "M43.33,57.58c.53.27.4.59.12,1s-.55.18-.78-.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "cls-522",
    d: "M198.84,194.22c.3.79-.69,1-.73,1.67h-.2A1.61,1.61,0,0,1,198.84,194.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "cls-523",
    d: "M218.51,156.14a.45.45,0,0,1,.61,0c.4.38,0,.67-.12,1l-.1.65c-.09,0-.18.08-.24,0s0-.11,0-.17C218.63,157.1,218.31,156.66,218.51,156.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "cls-524",
    d: "M235.72,114.16c-.17-.28-.34-.56-.5-.84.25-.56-.51-1.11,0-1.67A8.65,8.65,0,0,1,235.72,114.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "M236.77,108.08l-.1-.52a1.21,1.21,0,0,1-.43-1.1.7.7,0,0,1,.19-.29.18.18,0,0,1,.14,0c.2.6.45,1.18.59,1.79C237.24,108.27,237,108.32,236.77,108.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "M37.62,63.79c0-.4-.3-.84.2-1.14l.77.41-.42.54C38,63.64,37.88,64,37.62,63.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "cls-527",
    d: "M217.5,99.91v1.8a.83.83,0,0,0-.21-.06.7.7,0,0,1-.41-.29,1,1,0,0,1,0-1.27.75.75,0,0,1,.45-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M103.51,224.84c-.08-.48-.36-.93-.24-1.44.61.14.62.76.78,1.16C104.27,225.11,103.72,224.77,103.51,224.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M58.22,178.45a.45.45,0,0,1,.45-.27l.72,1.41-.41,0-.27-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "cls-529",
    d: "M202.64,188.16l0,.78c-.33.39-.47.92-1,1.18-.06,0-.1,0-.1-.09s0-.08,0-.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "cls-530",
    d: "M192.33,92.28a1.09,1.09,0,0,1,1.23.69.46.46,0,0,0-.25.43C192.77,93.21,192.63,92.68,192.33,92.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "cls-531",
    d: "M189.33,88c.41,0,.55.38.87.48.53,1-.38.31-.56.47C189.49,88.61,189.22,88.34,189.33,88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "cls-532",
    d: "M204.81,92.16l.05-.83c0-.09.1-.1.16,0l.79,1.37A1,1,0,0,1,204.81,92.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "cls-533",
    d: "M238.1,127.91c-.29-.27-.21-.62-.2-1,.21-.3,0-.68.18-1a.18.18,0,0,1,.27.08l.27.89,0,.09C238.32,127.26,238.48,127.73,238.1,127.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M215.86,169.17l-.3-1.64a1.42,1.42,0,0,1,.25-.89c.32.37,0,.88.25,1.26A1.58,1.58,0,0,1,215.86,169.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "cls-535",
    d: "M221.11,170.27l-.1-.52-.33.54c-.31-.37-.18-.77-.08-1.17l0-.32C221.16,169.18,221.68,169.56,221.11,170.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "cls-536",
    d: "M236.9,136.29h-.18l0-2.81.25.18A3.84,3.84,0,0,1,236.9,136.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "cls-537",
    d: "M219.47,110.22v.72c.1.23.11.42-.18.51l-.39-1.19c0-.3,0-.61.08-.92a.49.49,0,0,1,.27.15C219.29,109.74,219.59,109.92,219.47,110.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "cls-538",
    d: "M59,193.49c0-.37-.18-.86.44-1l.27.46C59.62,193.41,59.55,193.83,59,193.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "cls-539",
    d: "M192.61,199.25c0-.33,0-.67,0-1l.49-.47c.19.1.1.34.22.48-.07.26-.15.52-.22.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "cls-540",
    d: "M10.36,122.1a5.31,5.31,0,0,1-.32,2.2s-.07.06-.1,0-.06,0-.09-.07A6.55,6.55,0,0,1,10.36,122.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "cls-541",
    d: "M201.5,99.83l-.06.35a.78.78,0,0,1-.7.21c-.2-.09-.23-.27-.25-.46a.55.55,0,0,1,.27-.5l.27-.3A1.18,1.18,0,0,1,201.5,99.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "cls-542",
    d: "M190.7,201.63c-.3.21-.37,1-1,.38l.72-.88C190.66,201.22,190.8,201.35,190.7,201.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "cls-543",
    d: "M203.17,188.73c0-.5,0-1,0-1.49l.42-.22a.51.51,0,0,1,.09.53A1.13,1.13,0,0,1,203.17,188.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "cls-544",
    d: "M243,104l.35-.52a1,1,0,0,1,.27.74c.09.37.26.75,0,1.12l-.47-.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "cls-545",
    d: "M9.29,134.61H9.18c0-1-.28-1.92.22-2.83C9.36,132.72,9.33,133.67,9.29,134.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "cls-546",
    d: "M216.82,104.66a4.12,4.12,0,0,0-.28.31c-.31-.42-.49-.93-1-1.21a.59.59,0,0,0,.55-.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "cls-547",
    d: "M238.79,141.1a7.37,7.37,0,0,1-.18,2.68v-2.69C238.67,141,238.73,141,238.79,141.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "cls-548",
    d: "M237.62,139.83l0-1.86a.22.22,0,0,1,.32,0,2.17,2.17,0,0,1,.36.86c0,.33.06.65-.27.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "cls-549",
    d: "M203.62,101.12h.71a1.57,1.57,0,0,1,.6,1.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "cls-550",
    d: "M219.92,177.52l-.55-.57c-.06-.28-.31-.63.25-.7C219.8,176.66,220.42,177,219.92,177.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "cls-551",
    d: "M223.73,177.86l-.45-.21.69-1.52A2.65,2.65,0,0,1,223.73,177.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "cls-552",
    d: "M127.66,249.53l-.92-.23c0-.17,0-.34,0-.51l.91.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "cls-553",
    d: "M217.75,167.11l-.35.49c-.65-.37,0-.81-.06-1.21.24,0,.35.11.45.29S217.76,167,217.75,167.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "cls-554",
    d: "M220.1,112.93c0-.18.06-.37.1-.55.75.27.45.81.46,1.4A1.09,1.09,0,0,1,220.1,112.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "cls-555",
    d: "M201.64,190c0,.06.05.12.07.17l.23.26c.13.21,0,.37-.11.53a.54.54,0,0,1-.39.19c-.19-.07-.18.58-.48.14A2.61,2.61,0,0,1,201.64,190Z",
    transform: "translate(-8.9 -13.51)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "cls-556",
    d: "M240,94.15l-.2.26c-.14.09-.23,0-.26-.11a.29.29,0,0,1-.16-.09L239.08,93c.1-.13.2-.12.28,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "cls-557",
    d: "M131.74,227.93l.06-.25.44-.13c.3.23.78.15,1,.54C132.69,228.37,132.24,228,131.74,227.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "cls-558",
    d: "M235.57,91a2.12,2.12,0,0,1,.43,1.52,2.91,2.91,0,0,1-.76-1.43A.24.24,0,0,1,235.57,91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "cls-559",
    d: "M123.37,228l-.24.25a5.71,5.71,0,0,1-.82-.09c-.15,0-.44-.08-.36-.31s.35-.09.53-.13A.86.86,0,0,1,123.37,228Z",
    transform: "translate(-8.9 -13.51)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "cls-560",
    d: "M235.57,91l-.33.09-.44-.73.43-.45A1.09,1.09,0,0,1,235.57,91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M72.63,200l.44.47a1.68,1.68,0,0,1,.83.87c0,.17-.18.24-.33.3l-.24,0c-.21-.32-.55-.54-.69-.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "cls-561",
    d: "M239.59,109.84c0,.45-.05.89-.07,1.34-.15-.49-.29-1-.43-1.47.28-.2.19-.53.25-.8A1.33,1.33,0,0,1,239.59,109.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "cls-562",
    d: "M238.56,106.63l-.24.26c-.27-.28-.25-.66-.35-1,.46-.09.35-.47.39-.77a.89.89,0,0,1,.25.69A.71.71,0,0,1,238.56,106.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "cls-563",
    d: "M173.94,216c.31.75-.46.65-.74.94l-.25-.35A2,2,0,0,1,173.94,216Z",
    transform: "translate(-8.9 -13.51)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M75.73,203c.13-.2.34-.21.55-.24l1,.94A2.3,2.3,0,0,1,75.73,203Z",
    transform: "translate(-8.9 -13.51)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "cls-564",
    d: "M193.3,198.26a.46.46,0,0,1-.22-.48l.75-.73C194.26,197.72,193.41,197.83,193.3,198.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "cls-565",
    d: "M201.69,190.84l.25-.46.45.42-.48,1C201.25,191.61,201.78,191.16,201.69,190.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "cls-566",
    d: "M216.06,167.9c-.39-.36-.14-.84-.25-1.26.06-.23-.11-.55.4-.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "cls-567",
    d: "M216.3,103c.12-.58-.22-1.08-.26-1.63a.29.29,0,0,1,.25-.07,1.07,1.07,0,0,1,.37.42.64.64,0,0,1,.13.4l-.06.47c-.1.14,0,.37-.19.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "cls-568",
    d: "M236.21,116.68c0,.3,0,.6,0,.9-.34-.59-.63-1.18-.11-1.82C236.12,116.07,236.17,116.37,236.21,116.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M60.59,182.25h.49a2.7,2.7,0,0,1,.66,1.21C61.05,183.27,61,182.63,60.59,182.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "cls-569",
    d: "M216.79,102.11l-.26-.26c-.11-.24-.19-.51,0-.7s.34,0,.47.16.17.23.25.34A.52.52,0,0,1,216.79,102.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "cls-570",
    d: "M234.81,88.44a.39.39,0,0,1-.25-.48c-.12-.26-.31-.5-.19-.82a.41.41,0,0,1,.2-.21c.35,0,.21.39.44.47l.16.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "cls-571",
    d: "M128,228.18h.46c.12.29.63.13.64.56-.39.33-.72-.1-1.08-.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "cls-572",
    d: "M231.12,118.59l-.24.31c-.13-.5-.26-1-.4-1.5a.44.44,0,0,1,.27-.17.5.5,0,0,1,.43.16l0,0c.21.34-.22.66,0,1A.58.58,0,0,1,231.12,118.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "cls-573",
    d: "M191.65,202.88l0,.43a1,1,0,0,1-.53.81c-.24,0-.48,0-.4-.34l.93-1.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M53.23,156.15h-.47c-.1-.23-.21-.46-.32-.69l.49-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "cls-574",
    d: "M38.12,61.87a.78.78,0,0,1-.22,0,2.89,2.89,0,0,1,1.16-1.14A1.93,1.93,0,0,1,38.12,61.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "cls-575",
    d: "M88.62,220.8l-.22-.2a.42.42,0,0,1,0-.57c.21.55.87.57,1.18,1l-.25.2C89.12,221.07,88.77,221.1,88.62,220.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M52,141.78a2.53,2.53,0,0,1,0-2.12A7.53,7.53,0,0,1,52,141.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M50.37,150v-1.25a2.42,2.42,0,0,1,.41,1.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "cls-576",
    d: "M231.35,121.06c0-.35.06-.71.08-1.06.16.47.31.94.47,1.43C231.51,121.5,231.45,121.25,231.35,121.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "cls-577",
    d: "M219.89,117.4c-.21-.33-.46-.8-.06-1s.45.35.48.68C220.17,117.2,220.06,117.35,219.89,117.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "cls-578",
    d: "M238.56,106.63l.05-.81a3.06,3.06,0,0,1,.47,1.84A2.07,2.07,0,0,1,238.56,106.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "cls-579",
    d: "M206.75,210.69l-.06-.45c.05-.28.15-.49.48-.49.1-.13.19-.13.27,0s0,.21.05.31a.5.5,0,0,1,.13.19C207.37,210.49,207.2,210.87,206.75,210.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "cls-580",
    d: "M129.88,19.51l-1.91,0a.26.26,0,0,1,0-.21,2.66,2.66,0,0,1,1.65,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "cls-581",
    d: "M237.63,124.57h.42a1.51,1.51,0,0,1,.11.54c-.09.32,0,.71-.32,1C237.51,125.61,237.67,125.07,237.63,124.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "cls-582",
    d: "M85.26,28.74a.85.85,0,0,1,1-.39A.94.94,0,0,1,85.26,28.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "cls-583",
    d: "M239.52,94.3l.26.11c.07.41.36.76.24,1.2C239.71,95.23,239.13,95,239.52,94.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "cls-584",
    d: "M98.21,223l.24-.28,1.32.68A2.78,2.78,0,0,1,98.21,223Z",
    transform: "translate(-8.9 -13.51)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "cls-585",
    d: "M216.61,108.54l-.05.71c-.37.09-.49-.1-.5-.42S216.16,108.12,216.61,108.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "cls-586",
    d: "M126,228.22l.69-.06a.73.73,0,0,1,.93,0v.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "cls-587",
    d: "M238.79,141.1h-.18c-.09-.4-.18-.79-.26-1.18l.08-.12a.41.41,0,0,1,.4,0l0,.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "cls-588",
    d: "M214.38,174.83c-.09.4-.18.8-.26,1.2l-.47-.27C213.8,175.37,213.85,174.91,214.38,174.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "cls-589",
    d: "M239.8,112.35l.28-.31a1.91,1.91,0,0,1,.13,1.42A2.32,2.32,0,0,1,239.8,112.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "cls-590",
    d: "M9.69,125.35a1.68,1.68,0,0,1-.09,1.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "cls-591",
    d: "M240.05,95.9c.64.1.65.49.45,1A1.23,1.23,0,0,1,240.05,95.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "cls-592",
    d: "M79.35,31.63c.15-.49.52-.45,1-.57C80.05,31.53,79.8,31.72,79.35,31.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "cls-593",
    d: "M141.57,61.87l.29,0c0,.2.24.47-.2.45-.22,0-.5,0-.48-.32C141.19,62,141.43,61.92,141.57,61.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "cls-594",
    d: "M127.66,228.19l-.93,0a.57.57,0,0,0,0-.18c.31-.48.64-.17,1,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "cls-595",
    d: "M129.62,19.25l-1.65,0a.36.36,0,0,1,0-.23l1.2,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "cls-596",
    d: "M77.4,211.67a1.2,1.2,0,0,1-.75-.8,1.66,1.66,0,0,1,1,.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "cls-597",
    d: "M201.49,101.61c.52.12.8.37.48.93l-.5-.24A.66.66,0,0,0,201.49,101.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "cls-598",
    d: "M219.94,147.78h.18a.41.41,0,0,1,.08.19,1.48,1.48,0,0,1,0,1.48H220C220,148.89,220,148.34,219.94,147.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "cls-535",
    d: "M220.67,147.94c-.11.42.1.9-.24,1.28-.3-.4-.14-.83-.11-1.26l.21-.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M72.64,200.67a1.16,1.16,0,0,1,.69.91,2.16,2.16,0,0,1-1-.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M201.69,190.84c.34.27-.16.71.22,1l-.2.25c-.35-.24-.21-.62-.27-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "cls-599",
    d: "M58.67,187a.59.59,0,0,0,0-.19c0-.26,0-.52,0-.79.45.07.19.56.44.76-.06.17-.12.34-.19.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "cls-600",
    d: "M128,237.28c.38,0,.71-.36,1.19-.16a1.69,1.69,0,0,1-1.19.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M218.54,100.86c.44-.58.57-.27.65.22l-.75,0h0C218.38,101,218.4,100.9,218.54,100.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "cls-601",
    d: "M209.37,187l-.69.42c.13-.31-.08-1,.68-.63A1.48,1.48,0,0,1,209.37,187Z",
    transform: "translate(-8.9 -13.51)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "cls-602",
    d: "M53.52,183.49l-.35-.29a.61.61,0,0,1,.3-.69h.17c.27.19.12.49.16.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "cls-603",
    d: "M60.12,100l.74-1.11C60.9,99.56,60.76,99.81,60.12,100Z",
    transform: "translate(-8.9 -13.51)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "cls-604",
    d: "M203.69,187.55l-.09-.53c.2,0,0-.85.55-.26C204,187,203.84,187.28,203.69,187.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "cls-605",
    d: "M56,181.48c.1.22.19.44.28.66-.51.11-.49-.32-.62-.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "cls-606",
    d: "M58.12,187.26h.36l.42.94A1.46,1.46,0,0,1,58.12,187.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "cls-607",
    d: "M216.54,103c.06-.15.12-.31.19-.46.1.35.47.63.26,1.07C216.68,103.56,216.66,103.26,216.54,103Z",
    transform: "translate(-8.9 -13.51)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "cls-608",
    d: "M237.09,111.91l.3-.27a.48.48,0,0,1,.1.76C237.4,112.47,237.16,112.14,237.09,111.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M54.12,158.79c-.61-.17-.51-.53-.26-.94C54,158.16,54.19,158.43,54.12,158.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "cls-609",
    d: "M53.8,183.23c-.06-.24-.11-.49-.16-.73l.19-.35.32.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "cls-610",
    d: "M220.32,148c0,.42.07.84.11,1.26l-.28.23,0-1.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "cls-611",
    d: "M220.15,111.16v-.46l.27-.31a.74.74,0,0,1,.15.86S220.3,111.19,220.15,111.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "cls-612",
    d: "M231.14,118.36c-.38-.34-.14-.66,0-1a.87.87,0,0,1,.23.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "cls-613",
    d: "M230.72,120.78l.23.2c.06,1-.48.1-.7.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M53.62,168.16c-.19.05-.43.3-.55,0s.18-.25.36-.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "cls-614",
    d: "M233.53,125.5c.34.37.46.54.43.79C233.52,126.29,233.62,126,233.53,125.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "cls-615",
    d: "M218.69,157.59l.21.19c0,.18,0,.48-.21.4S218.51,157.79,218.69,157.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "cls-616",
    d: "M219.29,111.45l.18-.51c.3.28.17.64.18,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "cls-617",
    d: "M107.34,21.61c-.09.4-.58.22-.74.52h-.21l0-.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "cls-618",
    d: "M241.63,100.92l.14-.32c.27.2.27.5.31.79C241.8,101.36,241.62,101.23,241.63,100.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "cls-619",
    d: "M88.62,220.8a1.22,1.22,0,0,1,.74.43h-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M73.57,201.6l.26-.23a.36.36,0,0,1,.22-.23.52.52,0,0,1,.21.54A.84.84,0,0,1,73.57,201.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "cls-620",
    d: "M190.7,201.63c-.09-.17-.18-.34-.28-.5l.12-.22c.33,0,.4.2.43.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "cls-621",
    d: "M63.25,94.91c-.41-.47-.1-.63.32-.75C63.56,94.45,63.56,94.75,63.25,94.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "cls-622",
    d: "M218.92,106.87l-.24.27a.82.82,0,0,1-.16-.85C218.84,106.37,218.85,106.64,218.92,106.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M214.42,199.92c-.12.17-.31.32-.41.05s.17-.39.39-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "cls-623",
    d: "M103.49,64.43l-.3-.31a.88.88,0,0,1,.28-.16c.29-.06.26.16.27.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M245.57,116.43a.89.89,0,0,1,0,1.19C245.58,117.22,245.57,116.83,245.57,116.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "cls-624",
    d: "M219.89,117.4c0-.25.07-.5.42-.3,0,.2.06.41-.19.47C220.06,117.59,220,117.46,219.89,117.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "cls-625",
    d: "M238.05,139.71l0-1.05.14,0a.33.33,0,0,1,.25.16,1.26,1.26,0,0,1,.09.61.74.74,0,0,1-.19.42l0,.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "cls-626",
    d: "M121.25,60.8c.19-.66.41-.29.63,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "cls-627",
    d: "M51.5,134.14a.85.85,0,0,1,0-1.18A2.25,2.25,0,0,1,51.5,134.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "cls-628",
    d: "M238.08,125.07l0-.28c.35.37.21.83.23,1.26l-.22-.06A.89.89,0,0,1,238.08,125.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "cls-629",
    d: "M205,91.32h-.16c-.13-.28-.38-.52-.28-.87l.71.62a.5.5,0,0,0,0,.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M244.19,112.23a.92.92,0,0,1,.21.82A.56.56,0,0,1,244.19,112.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "cls-630",
    d: "M51.8,110.73c-1,2.35-1.31,4.88-1.92,7.34a22.2,22.2,0,0,0-.3,2.68,7.38,7.38,0,0,0,0,2.61c.37,1.58-.38,3-.63,4.52-.21,1.2-.43,2.41-.59,3.62a1.16,1.16,0,0,0-.47.9,19.48,19.48,0,0,0-.1,6.33,38.4,38.4,0,0,1,.11,4c-.86-.37-.51-1.15-.55-1.76-.08-1.41-.09-1.47-1.5-1.47s-3,0-4.42,0c-.71,0-1,.28-.91,1,.14,1.18.37,2.36.43,3.55,0,.31.2,1.15-.67.58a6.71,6.71,0,0,1-.41-2.69c-.1-3.64-.59-7.27-.7-10.9-.1-3.39-.08-6.8.07-10.21a42.67,42.67,0,0,1,.78-7.31h1.91c.13.08.23.19.35.27a.35.35,0,0,0,.23-.12,9.91,9.91,0,0,0,.56-2.42.81.81,0,0,1,.55-.84c2.32,0,4.64,0,7,0C51,110.46,51.47,110.3,51.8,110.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "cls-631",
    d: "M40.29,144.67c.38.17.5,0,.44-.36-.21-1.36-.39-2.73-.64-4.08-.14-.78.06-1.09.89-1.08,1.91,0,3.82,0,5.72,0,.8,0,1,.28,1,1a5.06,5.06,0,0,0,.19,2.56c.69.29.45.92.52,1.44a14,14,0,0,0-.48,7.18,1.65,1.65,0,0,1,0,1.16c.07.25.13.5.2.76a6.2,6.2,0,0,0,.26,2c-.56-.45-.61-1.16-1.22-1.32-.36.07-.35-.16-.32-.36,0,.26-.15.64.27.84l0,.7a4.77,4.77,0,0,1-2.09.12,3,3,0,0,0-2.44.64c-.24-.21-.17-.5-.21-.77,0-.51-.54-.58-.71-.94C40.78,151.12,40.69,147.87,40.29,144.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "cls-632",
    d: "M42.65,156c0-.36.06-.64.53-.77a10,10,0,0,1,4,0,33.85,33.85,0,0,0,2,7.66c.29.78.63,1.54.86,2.33s.84,1.41.12,2.19c-.07.07,0,.31.07.45q1.59,3.15,3.2,6.3a25.32,25.32,0,0,0,2.2,5,3.25,3.25,0,0,1,.45,2.17,13.3,13.3,0,0,1-1.9-3.59c-.69-.62-.84-1.66-1.71-2.14-.7-.35-.62-1.37-1.57-1.79.43,1.26.76,2.37,1.19,3.44.27.7.28,1.2-.54,1.44a.19.19,0,0,1,.07.2c0,.06,0,.1-.06.1a.18.18,0,0,1-.24-.15L50,177.91l-.13-.1a7.61,7.61,0,0,0-1-1.23,21,21,0,0,1-2.12-4.37c-.11-.29-.24-.61,0-.9-.76-2.66-1.55-5.31-2.28-8C43.81,160.88,43.09,158.45,42.65,156Z",
    transform: "translate(-8.9 -13.51)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M77.45,219.77l6.13,3.67a1.6,1.6,0,0,1,1.26.88c1.42,1.32,3.42,1.44,5,2.44a4.4,4.4,0,0,1,1.54.57,18.17,18.17,0,0,0,2.61,1.4,5.26,5.26,0,0,0,1.49.56c.27.27.68.21.81.34a6.47,6.47,0,0,1-.69-.25,8.55,8.55,0,0,1-1.78-.85,6.33,6.33,0,0,0-2.84-2,1.08,1.08,0,0,1-.83-1.24c.25-.66.57-.1.76,0,1.1.63,2.17,1.31,3.24,2a3.78,3.78,0,0,1,1.58.78,3.57,3.57,0,0,0,1,.72c-.24-.21-.76-.29-.68-.83a.22.22,0,0,1,.29,0c5.84,1.53,11.11,4.65,17,6a8.64,8.64,0,0,1,2.08.36,4.53,4.53,0,0,1,2,.85.34.34,0,0,1-.16.33,18.24,18.24,0,0,1-4.72-.41c-.28,0-.55-.1-.83-.11a4,4,0,0,1-.77-.1c-.73-.26-1.46.18-2.19,0a10.52,10.52,0,0,1-2-.49c-4.64-.31-9-1.95-13.41-3.14-.46-.18-.78.12-1.13.36a1.35,1.35,0,0,1-.79-.1,1.25,1.25,0,0,1-.28-.15c-.53-.58-1.34-.67-1.94-1.11-2-1.3-3.8-2.82-5.87-4h0a1.51,1.51,0,0,0-1-.71h0c-1.59-1.36-3.34-2.5-5-3.84-.33-.28-.72-.5-.86-.95.32-.69.66-.23,1-.08C77.57,220.42,76.64,220.22,77.45,219.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "cls-633",
    d: "M93.23,230.83c3.88,1.25,7.83,2.25,11.8,3.19.64.15,1.25-.42,1.84.07-.14.31-.38.19-.6.15.73.25,1.49.36,2.23.57a.18.18,0,0,1,0,.3c-1.19.82-2.39.14-3.57,0a28.28,28.28,0,0,1-2.86-.68,4.34,4.34,0,0,0-.69-.24c-.41-.12-.85,0-1.24-.24-.72-.08-1.43-.45-2.14.16-.27.24-.67,0-1-.18a7.26,7.26,0,0,0-2.49-.71l-2-1c-.53-.11-1-.27-1.06-.93l.8.18A1.52,1.52,0,0,0,93.23,230.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "cls-634",
    d: "M77.45,219.77c-.31.75.76.75.7,1.36-.57.3-.83-.86-1.47-.37.07.41.07.77-.5.74a7.62,7.62,0,0,1-1.73-1.67c.07-.24.56.07.5-.56s-1-1.23-.17-1.91A13.58,13.58,0,0,1,77.45,219.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "cls-635",
    d: "M74.78,217.36a11.11,11.11,0,0,0,.75,2.85c-.42,0-.64-.51-1.08-.38l-.92-1.11a4.57,4.57,0,0,0-2.15-2.21c-.25-.19-.21-.37,0-.54a.39.39,0,0,1,.25-.2l.45,0c.9-.2,1.19.85,2,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M76.18,221.5l.5-.74,5.39,4.09a.83.83,0,0,1,.35.71A33.24,33.24,0,0,1,76.18,221.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "cls-636",
    d: "M114.82,249.21c-1.78-.9-3.76-1.29-5.58-2.11-.1-.42.24-.44.5-.52a12.34,12.34,0,0,1,3.1.82,2.16,2.16,0,0,1,.9.21,5.77,5.77,0,0,1,1.16.53c.35.32,1,.55.38,1.18A.37.37,0,0,1,114.82,249.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637",
    d: "M108,230.07a7.52,7.52,0,0,1-3.57-1.52c-.78-.67-1.7-1.06-2.45-1.75a42.51,42.51,0,0,1,5.6,2.14,1.38,1.38,0,0,1,.44.58C108.07,229.71,108.19,229.89,108,230.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "cls-638",
    d: "M44.35,195.63c-.55-.67-.49-1.86-1.76-1.94-.21,0-.51-.62-.55-1,0-.58.7-.16,1-.62.18-.31.41.28.55.49.6.92,1.17,1.88,1.74,2.83-.11.29-.14.68-.62.58C44.5,195.93,44.45,195.75,44.35,195.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "cls-639",
    d: "M99,238.24c1,.25,1.42,1.27,2.14,1.89a38,38,0,0,1-7.65-3.84c0-.2,0-.34.24-.21,1.38.7,2.75,1.42,4.14,2.11C98.18,238.36,98.57,238.8,99,238.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "cls-640",
    d: "M90.14,225.27a2,2,0,0,0,1.26,1.11,3.78,3.78,0,0,1,2.5,2.05c0,.16.17.33,0,.51a10.1,10.1,0,0,1-2.67-1.38c-.23-.54-.86-.62-1.19-1S89.53,225.66,90.14,225.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "cls-641",
    d: "M117.39,235.36v-.23c-.68-.33-1.3-.9-2.15-.48-.6-.34-1.36-.22-1.91-.69.17-.16.59-.29.09-.55s-.77-.35-1.17-.53c.21-.22.41-.13.6-.11a9.17,9.17,0,0,1,2.48.49c.38.14.68.15.86-.27l.25.23a10.91,10.91,0,0,0,.73.95.47.47,0,0,1,.46.24c.45.29.36.62.07,1A.29.29,0,0,1,117.39,235.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "cls-642",
    d: "M13,168.61a5.06,5.06,0,0,1-.83-2.67c-.13-1.62-.92-3.12-.83-4.77.63.46.63,1.18.75,1.85A44,44,0,0,1,13,168.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M83.38,226.27c.18-.06.36-.18.55,0l5.45,3.86c-.27.27-.54.09-.81,0s-.9-.24-1.08-.75C86.14,228.3,84.64,227.45,83.38,226.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "cls-643",
    d: "M58.71,230.34c-1,.11-1.06-1-1.72-1.34,1.81.86,3.84,1.32,5.15,3a4.37,4.37,0,0,1-1.73-1c-.42-.31-.72-1-1.45-.67A.15.15,0,0,1,58.71,230.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "cls-644",
    d: "M114.54,250.71v.66l-3.29-1c-.45-.13-.89-.28-1.32-.44a.29.29,0,0,1,.1-.31c1.34-.13,2.51.6,3.79.77A.55.55,0,0,1,114.54,250.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "cls-645",
    d: "M54.63,227.24c-.61-.34-1.23-.61-1.39-1.45a1,1,0,0,0-1-.71c-.26.14-.38-.1-.55-.21s-.49-.41.07-.51c1.26.62,2.73,1,3.12,2.63A.3.3,0,0,1,54.63,227.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "cls-646",
    d: "M65,55.18a8.83,8.83,0,0,1-1.84,2.16L61.78,58l-.19-.24A15,15,0,0,1,65,55.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "cls-647",
    d: "M35,65.46c.43-.39.88-.75,1.27-1.16s.51,0,.68.21.07.33.2.45C36.3,66.27,36,66.34,35,65.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "cls-648",
    d: "M107.79,228.89c.29-.26,1.25-.27-.19-1.22a19.05,19.05,0,0,1,3.6,1.33c-.5.65-1.34-.72-1.72.39C108.78,229.7,108.28,229.3,107.79,228.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "cls-649",
    d: "M47.23,200.18a2.32,2.32,0,0,1-1.37-2,.13.13,0,0,1,.1,0,2,2,0,0,1,.21.1,1.26,1.26,0,0,0,.58,0c.49.4,1.07.74,1.19,1.44S47.42,200,47.23,200.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "cls-650",
    d: "M113.59,247.79l-.75-.39c0-1-1.09-.5-1.43-1,0-.22,0-.36.27-.25l3.1.95-.24.23C114.41,247.83,113.94,247.71,113.59,247.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "cls-651",
    d: "M90.33,245.19a7,7,0,0,0-1.88.1c-.57.19-.76-.23-1-.6-.08-.05-.1-.11-.08-.16s.06-.08.08-.08c1,.06,2.07-.56,2.87.49.06.06.08.11.06.17S90.35,245.19,90.33,245.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "cls-652",
    d: "M28.54,102.79c.63,1-.26,1.89-.42,2.83-.06.31-.33.61-.33,1-.63-.12-.49-.61-.46-1a4.92,4.92,0,0,1,.24-1.36h0C28.05,103.84,28,103.14,28.54,102.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "cls-653",
    d: "M73.08,239.19c-.83.31-1.31-.38-1.92-.69,0-.21.79,0,.25-.5.16-.21.2-.62.64-.3a14.79,14.79,0,0,0,1.27.77C73.55,238.81,72.81,238.83,73.08,239.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "cls-654",
    d: "M36.44,83.89a2.55,2.55,0,0,1,1-1.45c.38.34.2.8.25,1.2l-1,1.89C36,85.06,36.32,84.47,36.44,83.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "cls-655",
    d: "M58.47,61.13a24.18,24.18,0,0,1-2.62,2.44.79.79,0,0,1-.42-.15l-.08-.14,2.91-2.6C58.43,60.79,58.33,61,58.47,61.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "cls-656",
    d: "M99.19,242.79a1.13,1.13,0,0,1,1.22.17c.92.58,1.83,1.18,2.78,1.72a17.82,17.82,0,0,1-4-1.7q-.09-.06-.06-.12C99.15,242.81,99.17,242.79,99.19,242.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "cls-657",
    d: "M92,239.42l4.58,2.14c0,.15-.16.18-.27.24a33.1,33.1,0,0,1-4.54-2.16C91.74,239.44,91.77,239.31,92,239.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "cls-658",
    d: "M33.08,69.52a14.93,14.93,0,0,1,2.05-3C35.36,67.48,34.3,69,33.08,69.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "cls-659",
    d: "M30.21,99c-.58-1.5.31-2.58,1-3.72,0,1.21-.6,2.26-.76,3.42C30.36,98.81,30.34,99,30.21,99Z",
    transform: "translate(-8.9 -13.51)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "cls-660",
    d: "M71.38,216.51s0-.1.06-.1a2.78,2.78,0,0,1,2.09,2.31A8.07,8.07,0,0,1,71.38,216.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "cls-661",
    d: "M114.82,249.21h.42a2.58,2.58,0,0,1,1.48.09.52.52,0,0,1,.3.45c-.19.53-.65.49-1.07.46a1.14,1.14,0,0,0-.88.16c-.45.06-.92.16-1.28-.24C114.26,250,114.1,249.11,114.82,249.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "cls-662",
    d: "M62.53,53.71a10.41,10.41,0,0,1,2.14-1.66c.11-.06.23-.09.28,0s-.1.34-.27.43a5,5,0,0,1-1.93,1.66C62.35,54.18,62.4,54,62.53,53.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "cls-663",
    d: "M107.79,228.89c.63-.06,1.1.43,1.69.5l.73.71a.16.16,0,0,1,.06.17q0,.09-.06.09L109,230a2.24,2.24,0,0,1-1.22-.42l-.23-.68A.54.54,0,0,1,107.79,228.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "cls-664",
    d: "M43.15,216.22a6.7,6.7,0,0,1,2.15,2.37c.08.07.1.13.07.19s0,.09-.08.09a16.43,16.43,0,0,1-2.39-2.4A.3.3,0,0,1,43.15,216.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "cls-665",
    d: "M38.91,187.36c1.18.54.92,1.61,1.28,2.38A2.84,2.84,0,0,1,38.91,187.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M99.19,238H99c-.62-.34-1.22-.72-1.85-1s-.23-.42-.06-.66a4.86,4.86,0,0,1,2.16,1.2C99.2,237.68,99.35,237.84,99.19,238Z",
    transform: "translate(-8.9 -13.51)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "cls-666",
    d: "M24.7,133a.55.55,0,0,1,.22-.5c.3.26,0,.67.24.94a11.39,11.39,0,0,1,0,3.14c-.53,0-.32-.41-.36-.66-.07-.41.12-.85-.12-1.25v-.25A2,2,0,0,1,24.7,133Z",
    transform: "translate(-8.9 -13.51)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "cls-667",
    d: "M118.11,231.78a5.16,5.16,0,0,1-2.13-.7c.62-1,1.28-.15,1.93-.05C118,231.29,118.26,231.47,118.11,231.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "cls-668",
    d: "M106.61,249.27c.48-.2,1,.33,1.45,0s.74,0,1,.29a.36.36,0,0,1-.29.39,15.41,15.41,0,0,1-2.63-.25C106,249.3,106.35,249.31,106.61,249.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "cls-669",
    d: "M51.76,224.36c-.28.16,0,.31,0,.47s.1.12.07.18-.06.09-.09.09c-.75-.6-1.15-1.6-2.15-1.93a.33.33,0,0,1,.27-.27A3.12,3.12,0,0,1,51.76,224.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "cls-670",
    d: "M27.57,104.23c.11.79-.2,1.61.22,2.37a.81.81,0,0,1,0,.22.3.3,0,0,1-.48,0c-.67-.34-.57-.8-.28-1.35S27.24,104.59,27.57,104.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "cls-671",
    d: "M109.74,246.58l-.5.52-2.6-1,0-.16C107.62,246.34,108.75,246.13,109.74,246.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "cls-672",
    d: "M55.36,60.91c-.55-.87.45-1,.71-1.45.28,0,.41-.43.75-.22.44.56-.19.71-.43,1a5.87,5.87,0,0,1-1,.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "cls-673",
    d: "M15.4,166.34c-.51-.66-.1-1.46-.47-2.09-.06-.11,0-.36.22-.33s.36.2.35.25C15.26,164.86,16.09,165.6,15.4,166.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "cls-674",
    d: "M74,216.7c0,.34-.14.4-.43.18-.49-.4-1-.77-1.51-1.15.05-.54.31-.6.68-.26S73.63,216.28,74,216.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "cls-675",
    d: "M23.5,138.43c-.46-1.34,0-2.66.05-4A8.29,8.29,0,0,1,23.5,138.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    className: "cls-676",
    d: "M34.76,179.86c-.5,0-.49-.45-.6-.76s.12-.75.41-1a.31.31,0,0,1,.43,0c.41.38,0,.61-.15.91a3.68,3.68,0,0,0-.08.58A.19.19,0,0,1,34.76,179.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    className: "cls-677",
    d: "M33.56,183c-1-.75-.29-1.76-.32-2.67l.56,1.48C33.51,182.13,34,182.65,33.56,183Z",
    transform: "translate(-8.9 -13.51)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    className: "cls-678",
    d: "M109.12,249.7a2,2,0,0,0-1.06-.41l-.56-.38a3.58,3.58,0,0,1,2.52.75c0,.09,0,.18,0,.26C109.6,250.18,109.29,250.21,109.12,249.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    className: "cls-679",
    d: "M118.11,231.78c0-.27-.56-.38-.2-.75l.68.05c.33.1.72.07,1,.39l.54.28C119.43,231.57,118.78,232.37,118.11,231.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    className: "cls-680",
    d: "M98.72,247.34l2.15.47a.39.39,0,0,1,0,.53c-.59.39-1.13.06-1.68-.11C98.86,248,98.41,247.86,98.72,247.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    className: "cls-635",
    d: "M96.33,241.8l.27-.24a11.19,11.19,0,0,1,2.59,1.23,1.21,1.21,0,0,0,0,.19A13.55,13.55,0,0,1,96.33,241.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    className: "cls-681",
    d: "M30,175.06a5.06,5.06,0,0,1-.45-2.94c.54.34.45.9.69,1.29C29.94,173.93,30.51,174.58,30,175.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    className: "cls-682",
    d: "M34.76,179.86v-.27c.65-.69.65-.69,1.18.77-.17.51-.41.66-.8.18a2.33,2.33,0,0,1-.38-.45A1.69,1.69,0,0,1,34.76,179.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    className: "cls-683",
    d: "M42.12,80.52c.08-1.22.08-1.22,1.18-1.9a3,3,0,0,1-1.12,2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    className: "cls-684",
    d: "M55.35,190.38c.06-.32-.11-.7.24-.95h0a4.47,4.47,0,0,1,.86,2.51.51.51,0,0,1-.39.36c-.59-.41-.2-1.24-.71-1.68-.07-.05-.1-.1-.07-.16S55.33,190.38,55.35,190.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    className: "cls-685",
    d: "M34.52,69.3a6.84,6.84,0,0,1,1.77-2.12,12,12,0,0,1-1.55,2.52C34.32,69.75,34.39,69.54,34.52,69.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M116.19,233c0,.35.06.75-.56.55-.92-.29-1.85-.52-2.78-.77l1,0c.07-.12.16-.12.25,0C114.78,232.8,115.42,233.36,116.19,233Z",
    transform: "translate(-8.9 -13.51)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    className: "cls-686",
    d: "M27.32,106.86l.48,0-.95,2.9c-.41,0-.39-.2-.24-.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    className: "cls-687",
    d: "M26.61,109.25c0,.19,0,.37.24.47-.17.58-.35,1.16-.56,1.84A1.87,1.87,0,0,1,26.61,109.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    className: "cls-688",
    d: "M57.28,191.8a1.16,1.16,0,0,1,.66.79c-.07.47.33.93,0,1.41-.16,0-.34.27-.47-.05s-.41-.49-.56-.77a1.22,1.22,0,0,1,0-.33C57,192.49,57,192.08,57.28,191.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    className: "cls-689",
    d: "M36.22,208.8a7.55,7.55,0,0,1-1.46-2.16h0c.85.27,1.2,1,1.69,1.69C36.3,208.46,36.39,208.69,36.22,208.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    className: "cls-690",
    d: "M23.78,143.25a35.38,35.38,0,0,1-.23-4.36C23.63,140.34,24.31,141.76,23.78,143.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    className: "cls-691",
    d: "M106.39,22.13c-.15.53-1.36-.11-1,.94-.23,0-.66,0-.67-.06-.09-.6-.68-.24-1-.56l2.7-.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    className: "cls-692",
    d: "M98.72,247.34c0,.37.32.46.48.69a.46.46,0,0,1-.39.37c-.43,0-.88.13-1.29-.11-.25-.17-.24-.33,0-.48.1-.24.71,0,.54-.52a.41.41,0,0,1,.41,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    className: "cls-693",
    d: "M111.68,246.12l-.27.25a10.52,10.52,0,0,1-2.66-1.19A10.19,10.19,0,0,1,111.68,246.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    className: "cls-694",
    d: "M23.24,129.57l-.46.48a4.42,4.42,0,0,1,.25-2.13h0c.29.15.6-.34.87,0l-.34.23c-.39.34,0,.77-.13,1.14A.38.38,0,0,1,23.24,129.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "M97.52,248.29l1.45,0a2.14,2.14,0,0,1,1.92.53A9,9,0,0,1,97.52,248.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "M115.27,231.05c-.07.15-.57-.24-.34.24.06.12.36.12.37.45a3,3,0,0,1-1.5-.44.26.26,0,0,1,0-.43A1.68,1.68,0,0,1,115.27,231.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    className: "cls-696",
    d: "M113.51,231.59c0,.06,0,.11,0,.16-.37.4-.76-.38-1.13,0-.43-.18-1.18,0-1-.89.29-.28.53,0,.79.06C112.61,231.21,113.31,230.9,113.51,231.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    className: "cls-697",
    d: "M61.6,55.42c-.55.15-.9,1.32-1.44.66-.37-.45.74-.68,1.09-1.1a.28.28,0,0,1,.11,0A.57.57,0,0,1,61.6,55.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    className: "cls-698",
    d: "M109,253.22a1.5,1.5,0,0,1-1.85.07.16.16,0,0,1-.08-.17c0-.06,0-.09,0-.09.23-.16.54,0,.75-.18C108.25,252.85,108.7,252.75,109,253.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    className: "cls-699",
    d: "M58,194c-.16-.47-.45-.93,0-1.41.26.39.51.79.76,1.18,0,.18,0,.48-.07.52C58.36,194.4,58.16,194.18,58,194Z",
    transform: "translate(-8.9 -13.51)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    className: "cls-700",
    d: "M106.62,245.93c0,.06,0,.11,0,.16a7.68,7.68,0,0,1-2.72-1.06A6.14,6.14,0,0,1,106.62,245.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    className: "cls-701",
    d: "M54.14,187.75l0,.24c-.45.73.55,1,.49,1.67-1-.18-.88-1.09-1.1-1.73C53.44,187.6,53.87,187.6,54.14,187.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    className: "cls-702",
    d: "M44.35,195.63l.24.27c.35.26.85.13,1.16.46-.3.2-.3.86-.76.73C44.28,196.89,44.33,196.22,44.35,195.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    className: "cls-703",
    d: "M84.84,224.32a3.82,3.82,0,0,1-1.26-.88c.28,0,.11-.72.47-.37S85.28,223.48,84.84,224.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    className: "cls-704",
    d: "M85.07,244.21l-.32-.14c-.39-.15-1.08-.2-.8-.76s.71.11,1.08.19c.1,0,.18.14.27.22A.53.53,0,0,1,85.07,244.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    className: "cls-655",
    d: "M39.05,64.21a3,3,0,0,1-1.36,1.34,3.05,3.05,0,0,1,1.15-1.76C39,63.89,39,64.07,39.05,64.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    className: "cls-705",
    d: "M30.44,103.64c-.3-.73.29-1.15.5-1.71C31.25,102.65,30.66,103.08,30.44,103.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    className: "cls-706",
    d: "M35.23,180.34c.23.27.47.37.72,0-.08.5.46.92.14,1.52l-.85-.79A.66.66,0,0,1,35.23,180.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    className: "cls-707",
    d: "M30,175.06c.11-.55-.23-1.15.24-1.65a8,8,0,0,1,.33,1.57C30.52,175.73,30.2,175.34,30,175.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    className: "cls-673",
    d: "M24.94,131a11.39,11.39,0,0,1,.16-2.6c.49.55.25,1,.31,1.44a1.89,1.89,0,0,1-.17,1.17A.22.22,0,0,1,24.94,131Z",
    transform: "translate(-8.9 -13.51)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    className: "cls-708",
    d: "M102.78,249c-.62.31-1.24.59-1.7-.24a.26.26,0,0,1,0-.31,1.42,1.42,0,0,1,1.61.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    className: "cls-709",
    d: "M33.79,205.46a6.87,6.87,0,0,1-1.31-2.19A7.83,7.83,0,0,1,34,205.45C34,205.57,33.88,205.57,33.79,205.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    className: "cls-710",
    d: "M112.14,231l-.74-.12c-.39-.2-.86-.2-1.19-.53v-.26a4.46,4.46,0,0,1,1.92.7c.08,0,.11.09.08.13S112.16,231,112.14,231Z",
    transform: "translate(-8.9 -13.51)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    className: "cls-711",
    d: "M28.29,168.38a5.77,5.77,0,0,1,.2,2.2c-.43-.23-.41-.64-.47-1S27.59,168.64,28.29,168.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    className: "cls-712",
    d: "M70.69,238.26l-.12,0c-.37-.17-.8-.28-.9-.75,0-.08.12-.27.18-.26a1.15,1.15,0,0,1,1,.58C70.82,238,70.87,238.16,70.69,238.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    className: "cls-581",
    d: "M52.72,66.63a1.84,1.84,0,0,1,.81-1c.19-.17.22-.77.62-.35s-.21.51-.4.7A8.87,8.87,0,0,1,52.72,66.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    className: "cls-713",
    d: "M37.84,82.16A.23.23,0,0,1,37.9,82a1.39,1.39,0,0,1,.69-.74c.21-.08.38,0,.28.27a2.32,2.32,0,0,1-1,1.42A.61.61,0,0,1,37.84,82.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    className: "cls-714",
    d: "M62.3,232.74c1-.71,1.36,0,1.68.75-.32.22-.6,0-.88-.08a3.83,3.83,0,0,1-.73-.54C62.35,232.82,62.32,232.78,62.3,232.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    className: "cls-715",
    d: "M112.37,231.78c.36-.57.75.06,1.13,0l1.13.57-.56.4-.25,0C113.73,231.82,112.93,232,112.37,231.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    className: "cls-716",
    d: "M49.12,222.93c-.07,0-.16-.06-.2-.12-.22-.32-.93-.59-.52-1s.72.25,1,.58A.52.52,0,0,1,49.12,222.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    className: "cls-717",
    d: "M24.94,131l.19,0c.25.08.11.37.27.49l-.24,1.91c-.35-.24-.16-.62-.24-.94C24.7,132,25.05,131.5,24.94,131Z",
    transform: "translate(-8.9 -13.51)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    className: "cls-718",
    d: "M28.54,102.79c-.21.55-.22,1.24-.95,1.44C27.89,103.74,27.45,102.76,28.54,102.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    className: "cls-719",
    d: "M75.7,244.25a4.84,4.84,0,0,1-1.89-1A1.91,1.91,0,0,1,75.7,244.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    className: "cls-720",
    d: "M93.7,236.08l-.24.21-1.94-1.15a.27.27,0,0,1,0-.3A7.88,7.88,0,0,1,93.7,236.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    className: "cls-721",
    d: "M107.1,253.08a1.49,1.49,0,0,0,0,.21,6.08,6.08,0,0,1-2.23-.41,1.92,1.92,0,0,1,1.26-.28.8.8,0,0,0,.35.19C106.71,252.86,107,252.86,107.1,253.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    className: "cls-671",
    d: "M112.14,231a1.48,1.48,0,0,1,0-.21l1.68.07v.43l-.29.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    className: "cls-722",
    d: "M87.49,229.35l1.12.55c.2.12.18.26,0,.42-.6.07-1-.34-1.45-.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    className: "cls-723",
    d: "M47.23,200.18c-.07-.62.65-.05.71-.48a.7.7,0,0,1,.44.52c-.07.25.07.57-.25.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    className: "cls-724",
    d: "M43.15,216.22l-.25.25A2.59,2.59,0,0,1,41.69,215l0,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    className: "cls-725",
    d: "M109.12,249.7a.8.8,0,0,0,.85.22,2.39,2.39,0,0,1,1.26.49,10.25,10.25,0,0,1-2.45-.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    className: "cls-726",
    d: "M48.09,221.5A1.63,1.63,0,0,1,47,220.33C47.66,220.52,48,220.79,48.09,221.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    className: "cls-673",
    d: "M15.59,168.37c-.19-.6-.65-1.25.26-1.68a4.25,4.25,0,0,1,.2,1.11A.64.64,0,0,1,15.59,168.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    className: "cls-727",
    d: "M24.44,152.81l-.4,0c0-.33,0-.66,0-1,.28-.36-.08-.79.14-1.16a.24.24,0,0,1,.3-.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    className: "cls-728",
    d: "M90.08,226.52c.57.14,1.2.22,1.19,1a3.92,3.92,0,0,1-1.44-.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    className: "cls-729",
    d: "M98.48,247.33c-.27.26-.46.67-1,.48l-.77-.57C97.51,247.51,98,246.79,98.48,247.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    className: "cls-730",
    d: "M36.44,83.89c.1.54-.24,1.15.23,1.64-.09.2-.11.45-.49.56C36.48,85.34,35.64,84.56,36.44,83.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    className: "cls-731",
    d: "M76.67,245a1.3,1.3,0,0,1-1-.71c.63-.34,1,.14,1.46.42C77.07,244.89,76.87,244.93,76.67,245Z",
    transform: "translate(-8.9 -13.51)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    className: "cls-732",
    d: "M91.52,234.84v.3c-.51.46-.7-.19-1.17-.2C90.83,234.36,91.17,234.49,91.52,234.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    className: "cls-733",
    d: "M33.56,183c.07-.4-.17-.86.24-1.19l.46,1.2c-.16.12,0,.39-.24.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    className: "cls-734",
    d: "M24.71,134.62c.56.53-.1,1.38.48,1.91l.22.24a.58.58,0,0,1-.5.25C24.49,136.25,24.79,135.42,24.71,134.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    className: "cls-735",
    d: "M45.29,218.87v-.28l1.45,1.34-.22.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    className: "cls-736",
    d: "M66.43,235.37l0-.23c.17-.08.34-.19.54-.08s.71.25.53.61-.52.1-.77-.09C66.61,235.5,66.52,235.44,66.43,235.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    className: "cls-737",
    d: "M95.58,228.2l-1.44-.95c.25-.09.47-.41.74,0s.82.35,1,.79C95.87,228.18,95.81,228.32,95.58,228.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    className: "cls-738",
    d: "M24.24,150.64c-.07.41.13.87-.24,1.21-.07-.34-.15-.68-.22-1a4.46,4.46,0,0,0,.09-1.36.61.61,0,0,1,.08-.3.21.21,0,0,1,.28,0h0A2.13,2.13,0,0,1,24.24,150.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M23.71,149l.06-2.61q.09-.16.18,0l.06,1.17a3.07,3.07,0,0,1,0,1.7h0c-.08.12-.15.11-.2,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    className: "cls-739",
    d: "M37.84,82.16l0,.79c0,.26,0,.52-.24.69-.41-.33-.17-.8-.25-1.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    className: "cls-740",
    d: "M83.49,243.36l-1.3-.74C83,242.49,83.35,242.71,83.49,243.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    className: "cls-741",
    d: "M76.57,240.29c.87.07.86.54.94,1C76.78,241.35,77,240.72,76.57,240.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    className: "cls-742",
    d: "M104.24,249l1.16.27c.08,0,.1.08.08.13s-.06.07-.09.07c-.56,0-1.17.22-1.69-.21a.24.24,0,0,1,0-.27C103.86,248.86,104.05,249,104.24,249Z",
    transform: "translate(-8.9 -13.51)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    className: "cls-743",
    d: "M74.53,225.07l-.75-.4c.13-.14.22-.33.38-.41.33-.18.46.1.61.32S74.73,225,74.53,225.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    className: "cls-744",
    d: "M105.39,249.47a1.41,1.41,0,0,0,0-.2c.4-.17.81-.52,1.21,0l-.46.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    className: "cls-745",
    d: "M68,240.34a1.68,1.68,0,0,1-1.39-.6C67.33,239.4,67.64,239.94,68,240.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    className: "cls-746",
    d: "M24.91,137a.58.58,0,0,1,.5-.25c0,.43.18.91-.31,1.32C24.81,137.75,25,137.36,24.91,137Z",
    transform: "translate(-8.9 -13.51)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    className: "cls-747",
    d: "M113.79,250.14h1.44a.53.53,0,0,1,.53,0c-.1.69-.74.17-1,.47l-.2.05-.73-.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    className: "cls-748",
    d: "M49.61,66.42l1.25-1.06c-.29.5-.32,1.32-1.24,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    className: "cls-749",
    d: "M96.32,251.43a3.36,3.36,0,0,1-1.71-.49l.52-.25c.37.25.94,0,1.24.42A.29.29,0,0,1,96.32,251.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    className: "cls-750",
    d: "M16.35,169.54c-.32,0-.51-.1-.53-.44.2-.37,0-.81.19-1.19a.2.2,0,0,1,.29,0l.24,1C16.33,169.05,16.56,169.36,16.35,169.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    className: "cls-751",
    d: "M28.29,168.38c-.43.32-.14.8-.27,1.19-.45-.36-.26-.83-.2-1.27,0-.17-.1-.46.17-.45S28.28,168.14,28.29,168.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    className: "cls-752",
    d: "M101.1,248.56a1.49,1.49,0,0,1,0,.21l-.19,0L99,248.27l.23-.24,1.66.29.12,0A.32.32,0,0,1,101.1,248.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    className: "cls-753",
    d: "M48.13,201c.06-.25,0-.55.25-.73.14.32.73.52.31,1S48.24,201.2,48.13,201Z",
    transform: "translate(-8.9 -13.51)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    className: "cls-691",
    d: "M100.86,248.32v-.51c.53.24,1.19.08,1.67.49a.21.21,0,0,1-.05.32c-.54-.05-1.06-.26-1.61-.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    className: "cls-754",
    d: "M94.34,247a1.84,1.84,0,0,1,1.35.65C95.24,247.57,94.67,247.77,94.34,247Z",
    transform: "translate(-8.9 -13.51)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    className: "cls-755",
    d: "M45.75,196.36c-.44,0-.92.07-1.16-.46.36,0,.43-.38.7-.49C45.45,195.73,45.6,196,45.75,196.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    className: "cls-756",
    d: "M96.79,234.69c.39-.47.68,0,1.07.08-.45.35-.85.55-1.32.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    className: "cls-757",
    d: "M40,84.09c0-1,.61-1.23,1-1.91C41,83.11,40.33,83.34,40,84.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    className: "cls-758",
    d: "M63,233.2l1,.29v.09c0,.18,0,.36,0,.54-.29-.2-.71-.08-.93-.42a.39.39,0,0,1-.12-.25A.47.47,0,0,1,63,233.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    className: "cls-759",
    d: "M55.35,190.38v.24c-1,.22-.84-.37-.72-1C55,189.76,55.06,190.19,55.35,190.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    className: "cls-523",
    d: "M80.28,227a1.3,1.3,0,0,1-1-.44C79.74,226.08,79.93,226.17,80.28,227Z",
    transform: "translate(-8.9 -13.51)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    className: "cls-563",
    d: "M39.54,63.23c.3-.3.59-.61.9-.9,0,0,.13,0,.31,0a4.36,4.36,0,0,1-1.16,1.28A.21.21,0,0,1,39.54,63.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    className: "cls-760",
    d: "M56.07,192.3l.23-.23a.89.89,0,0,1,.78.89L57,193c-.06.1-.09.24-.24.26A1.42,1.42,0,0,1,56.07,192.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    className: "cls-761",
    d: "M24.27,137v-1.82h.12V137Z",
    transform: "translate(-8.9 -13.51)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    className: "cls-762",
    d: "M55.13,63.55l-1.32,1c.45-.87.84-1.27,1.54-1.28v0C55.41,63.52,55.34,63.59,55.13,63.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    className: "cls-763",
    d: "M64.68,52.52c0-.16.3-.32,0-.47l1-.73C65.54,52.06,65.34,52.47,64.68,52.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    className: "cls-764",
    d: "M37.15,65c-.2-.09-.22-.26-.2-.45a1.61,1.61,0,0,0,.67-.72l.55-.19C38,64.2,37.43,64.46,37.15,65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    className: "cls-765",
    d: "M76.67,245a.59.59,0,0,1,.49-.29c.28,0,.55.11.65.43C77.4,245.28,77,245.38,76.67,245Z",
    transform: "translate(-8.9 -13.51)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    className: "cls-766",
    d: "M51.4,64.75l1-1h0l-1,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    className: "cls-767",
    d: "M36.22,208.8c0-.19,0-.37.22-.46.13.39.7.52.64,1.06C36.5,209.58,36.53,209,36.22,208.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    className: "cls-768",
    d: "M41.73,154.24c.31.26.92.3.71.94C41.58,155.33,41.78,154.69,41.73,154.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    className: "cls-769",
    d: "M61.6,55.42a.46.46,0,0,1-.24-.48l.71-.72a.48.48,0,0,1,.24.46A1.46,1.46,0,0,1,61.6,55.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    className: "cls-770",
    d: "M68.7,213.25c.57.09.81.53,1.11.92C69.24,214.08,69,213.64,68.7,213.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    className: "cls-771",
    d: "M30.21,99l.24-.3a1.76,1.76,0,0,1-.84,1.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    className: "cls-772",
    d: "M25.86,113.6v1.82h-.12v-1.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    className: "cls-773",
    d: "M99.18,251.6a1.18,1.18,0,0,1-1.45.1c-.09-.12-.08-.22,0-.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    className: "cls-774",
    d: "M27.12,156.34a1.87,1.87,0,0,1,0,1.74l-.26-1.23C27,156.7,26.91,156.45,27.12,156.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    className: "cls-775",
    d: "M28.89,164.62c-.64-.42-.63-.76-.41-1.28C28.86,163.72,28.8,164.09,28.89,164.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    className: "cls-776",
    d: "M74.53,225.07l.24-.49.71.49a.3.3,0,0,1,0,.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    className: "cls-777",
    d: "M75.49,225.52v-.45c.48.24,1,.49,1.42.74a.45.45,0,0,1,0,.2C76.37,226,76,225.6,75.49,225.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    className: "cls-778",
    d: "M54.63,227.24l.25-.25a1.62,1.62,0,0,1,.73.71.43.43,0,0,1-.23.23A1.37,1.37,0,0,1,54.63,227.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    className: "cls-779",
    d: "M55.38,227.93l.23-.23a1.67,1.67,0,0,1,.83,1.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    className: "cls-780",
    d: "M107.81,229.62A1.49,1.49,0,0,1,109,230c-.33.55-.69-.06-1,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    className: "cls-781",
    d: "M38.87,81.53c-.56-.32-.6.41-1,.47a.83.83,0,0,1,.86-.93C39.18,81.07,39,81.33,38.87,81.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    className: "cls-679",
    d: "M121.23,232c-.21.24-.38.23-.5.06s-.3-.2-.46-.3C120.6,231.8,121,231.73,121.23,232Z",
    transform: "translate(-8.9 -13.51)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    className: "cls-782",
    d: "M70.69,238.26c0-.17,0-.36.2-.45l.52.19.3.43-.55.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    className: "cls-783",
    d: "M58.47,61.13c-.2-.09-.22-.26-.21-.45L59.2,60c.08-.1.15-.1.22,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    className: "cls-784",
    d: "M62.31,54.68a.44.44,0,0,1-.24-.46.45.45,0,0,1,.46-.51l.22.47C62.72,54.44,62.53,54.57,62.31,54.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    className: "cls-785",
    d: "M24,146.35h-.18l0-2.1A4.66,4.66,0,0,1,24,146.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    className: "cls-786",
    d: "M25.11,113.14c.45.69.1,1,0,1.41C24.75,114.11,25,113.77,25.11,113.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    className: "cls-787",
    d: "M25.5,191.2a1.11,1.11,0,0,1,.56,1.08A.89.89,0,0,1,25.5,191.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    className: "cls-788",
    d: "M30.17,200.44c-.21-.34-.57-.59-.57-1.12.47,0,.6.27.63.64A.32.32,0,0,1,30.17,200.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    className: "cls-789",
    d: "M85.07,244.21a.49.49,0,0,1,.23-.49L86,244c.1,0,.13.08.1.12a.14.14,0,0,1-.1.06C85.69,244.24,85.38,244.44,85.07,244.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    className: "cls-790",
    d: "M65.84,54.28l.42.07c-.25.31-.37.83-1,.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    className: "cls-791",
    d: "M63,233.47a.87.87,0,0,1,0,.23c-.48-.14-1-.24-.71-1h0A1.91,1.91,0,0,1,63,233.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    className: "cls-792",
    d: "M57.76,58.19c.22-.15.44-.31.67-.45a4.91,4.91,0,0,1,.46-.18,1.76,1.76,0,0,1-.87.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    className: "cls-793",
    d: "M26.09,122.15c.05.68.14,1.06-.3,1.34C25.59,123,25.88,122.72,26.09,122.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    className: "cls-794",
    d: "M17.21,181.47a1.39,1.39,0,0,1-.62-1.34A2.28,2.28,0,0,1,17.21,181.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    className: "cls-795",
    d: "M85.09,30.8a1,1,0,0,1-1.12.26c.2-.43.64-.32.87-.52C84.92,30.62,85.08,30.64,85.09,30.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    className: "cls-772",
    d: "M83,31.46a1,1,0,0,1-1,.35C82.34,31.46,82.64,31.29,83,31.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    className: "cls-796",
    d: "M69.52,221.86a1.13,1.13,0,0,1-.85-.78C69.3,221,69.29,221.42,69.52,221.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    className: "cls-797",
    d: "M37.74,186c.45.23.4.62.47,1.1C37.79,186.7,37.57,186.42,37.74,186Z",
    transform: "translate(-8.9 -13.51)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    className: "cls-798",
    d: "M114.87,253.89a1.11,1.11,0,0,1-1.19,0A.88.88,0,0,1,114.87,253.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    className: "cls-799",
    d: "M39.54,63.23c0,.11,0,.23.05.34l-.54.64c-.19-.08-.19-.25-.21-.42A1,1,0,0,1,39.54,63.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    className: "cls-800",
    d: "M55.13,63.55l.23-.24a.52.52,0,0,1,.49.26c-.17.22-.27.56-.63.49C55.16,64.05,55.16,63.73,55.13,63.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    className: "cls-772",
    d: "M62.55,215.5l-.09,0h-.09c-.45-.06-.78-.28-1.12-1.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    className: "cls-801",
    d: "M95.82,228c-.31-.26-.79-.33-.94-.78a3.08,3.08,0,0,1,1.45.73L96,228C96,228.05,95.9,228.06,95.82,228Z",
    transform: "translate(-8.9 -13.51)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    className: "cls-802",
    d: "M41.69,215a2.17,2.17,0,0,1-.95-1.21c.55.4.93.66,1,1.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M82.42,225.56c.71-.29.85.19,1,.71A1.63,1.63,0,0,1,82.42,225.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    className: "cls-792",
    d: "M55.36,60.91c0,.54-.42.79-1,1.21a2,2,0,0,1,1-1.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    className: "cls-803",
    d: "M49.12,222.93a.62.62,0,0,1,.26-.51l.49.48-.27.27A.52.52,0,0,1,49.12,222.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    className: "cls-724",
    d: "M39.14,85.27c-.08-.49.08-.82.78-1.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    className: "cls-787",
    d: "M26.82,156.64c-.32-.33-.21-.74-.16-1.12,0-.15.16-.31.33-.13a.85.85,0,0,1,.1.33C26.82,156,27.15,156.4,26.82,156.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    className: "cls-804",
    d: "M16.09,167.89c-.08.41.17.88-.27,1.21-.07-.24-.15-.48-.23-.73l.26-.48A.14.14,0,0,1,16.09,167.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    className: "cls-805",
    d: "M33.79,205.46H34c.24.4.48.8.71,1.2h0C34.14,206.49,34,206,33.79,205.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    className: "cls-806",
    d: "M49.62,66.41c-.86-.66.14-.72.3-1.25.19.64-.41.84-.31,1.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    className: "cls-807",
    d: "M86,244.19a.54.54,0,0,0,0-.18,2.09,2.09,0,0,1,1.47.44v.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    className: "cls-808",
    d: "M110.45,21.43c.33-.36.67-.67,1.17-.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    className: "cls-809",
    d: "M36.27,182.58c.29.34.55.58.31,1C36.19,183.38,36.17,183.07,36.27,182.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    className: "cls-810",
    d: "M73.08,239.19c-.25-.35.1-.5.24-.72.2.11.57.2.48.39S73.33,239.08,73.08,239.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    className: "cls-811",
    d: "M27.23,115.93c.14.63-.12.91-.22,1.37C26.71,116.76,27,116.45,27.23,115.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    className: "cls-812",
    d: "M92,239.42l-.23.22-.92-.6A1.14,1.14,0,0,1,92,239.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    className: "cls-813",
    d: "M50.4,181.74l.46.06c-.16.39.57.82-.06,1.19C50.67,182.57,50.54,182.15,50.4,181.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    className: "cls-814",
    d: "M85.09,30.8l-.25-.26c.34,0,.62-.4,1-.16C85.75,30.83,85.38,30.73,85.09,30.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    className: "cls-815",
    d: "M75.45,240.38c-.14,0-.34,0-.29-.23s.17-.31.25-.31a.37.37,0,0,1,.37.36C75.8,240.43,75.59,240.36,75.45,240.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    className: "cls-816",
    d: "M51.75,225.1l0-.27.47.25.43.65C52.14,225.73,52,225.38,51.75,225.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    className: "cls-817",
    d: "M29.11,172.06c-.1-.41-.23-.73.18-1C29.54,171.45,29.25,171.7,29.11,172.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    className: "cls-791",
    d: "M16.87,170a1.5,1.5,0,0,1-.08,1.25C16.4,170.8,16.74,170.53,16.87,170Z",
    transform: "translate(-8.9 -13.51)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    className: "cls-818",
    d: "M90.68,246.24a.79.79,0,0,1,1,.21C91.26,246.75,91,246.44,90.68,246.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    className: "cls-819",
    d: "M16.09,167.89h-.24v-1.2a2.14,2.14,0,0,1,.45,1.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    className: "cls-820",
    d: "M27.19,166.5a.82.82,0,0,1,0-.79.38.38,0,0,1,.27.1C27.61,166.11,27.44,166.32,27.19,166.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    className: "cls-806",
    d: "M102.54,248.51v-.21c.38,0,.88-.18,1,.46-.18.22-.4.17-.63.12A.59.59,0,0,1,102.54,248.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    className: "cls-821",
    d: "M102.79,248.77h.94a.15.15,0,0,1,.07.15c0,.06,0,.08,0,.08s0,.18,0,.27l-.92-.25h0c-.07-.06-.09-.11-.06-.17S102.77,248.77,102.79,248.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    className: "cls-822",
    d: "M58.71,230.34H59l.48.46c.11.1.11.2,0,.28A.68.68,0,0,1,58.71,230.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    className: "cls-586",
    d: "M119.55,231.47l-1-.39A.62.62,0,0,1,119.55,231.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    className: "cls-823",
    d: "M25.4,131.48l-.27-.49c.12-.37-.12-.83.28-1.13v0a1.41,1.41,0,0,1,.06,1.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    className: "cls-824",
    d: "M23.78,149.19l.2,0c-.07.54.2,1.12-.2,1.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "M24,149.22c0-.57,0-1.14,0-1.7.36.52.16,1.13.22,1.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    className: "cls-826",
    d: "M96.32,251.16c-.34-.3-.88-.1-1.19-.47a2.29,2.29,0,0,1,1.43.24C96.6,251.13,96.55,251.24,96.32,251.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    className: "cls-827",
    d: "M124.72,232.14c.73-.15,1.1-.22,1.46.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    className: "cls-828",
    d: "M96.32,251.16l.24-.23.25,0c.21.19.6.25.46.68a1.37,1.37,0,0,1-1-.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    className: "cls-829",
    d: "M97.27,251.63l-.46-.68a1.17,1.17,0,0,1,1,.46,2.5,2.5,0,0,0,0,.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    className: "cls-830",
    d: "M46.75,198.26c0,.16,0,.4-.25.4s-.24-.23-.33-.38C46.34,197.69,46.55,198,46.75,198.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "M90.33,245.19v-.25a1.13,1.13,0,0,1,.81.38A.6.6,0,0,1,90.33,245.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    className: "cls-778",
    d: "M34.52,69.3c0,.15,0,.33.22.4a.66.66,0,0,1-.46.54h0A.64.64,0,0,1,34.52,69.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    className: "cls-831",
    d: "M74.21,239.65l.21.26c-.09.05-.21.17-.25.14a.62.62,0,0,1-.28-.32C73.85,239.6,74,239.57,74.21,239.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    className: "cls-832",
    d: "M42.18,80.58c0,.15,0,.4-.07.42-.26.09-.25-.2-.32-.33s-.24-.37.1-.39c.07,0,.15.16.23.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    className: "cls-833",
    d: "M90.29,246a1.05,1.05,0,0,1-.34.14c-.18,0-.28-.12-.19-.28a.32.32,0,0,1,.29-.09C90.13,245.74,90.19,245.85,90.29,246Z",
    transform: "translate(-8.9 -13.51)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    className: "cls-834",
    d: "M25.46,117.56c0-.56-.13-.87.1-1.18A1.21,1.21,0,0,1,25.46,117.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    className: "cls-835",
    d: "M91.53,232.24l.92.12C92.06,233,91.78,232.69,91.53,232.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    className: "cls-836",
    d: "M30.05,167.56c.22.15.42.41.29.56-.28.3-.33,0-.35-.23A1.05,1.05,0,0,1,30.05,167.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    className: "cls-837",
    d: "M24.24,126.55c-.09.12-.13.27-.21.29s-.27-.12-.24-.28a.3.3,0,0,1,.21-.21C24.06,126.34,24.14,126.47,24.24,126.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    className: "cls-566",
    d: "M23.55,128.61c-.09.25,0,.57-.28.72a.83.83,0,0,1,.28-1.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    className: "cls-838",
    d: "M103.75,249a1.79,1.79,0,0,0,0-.23c.13-.18.31-.28.5-.17s0,.27,0,.41C104.07,249.29,103.91,249,103.75,249Z",
    transform: "translate(-8.9 -13.51)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    className: "cls-825",
    d: "M24.24,150.64v-1.43c.43.42.19.95.21,1.43h-.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    className: "cls-839",
    d: "M51.26,183.92l.14-.53a.93.93,0,0,1,.37.77A.52.52,0,0,1,51.26,183.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    className: "cls-840",
    d: "M25.08,143a1.59,1.59,0,0,1,0,1.22A1.25,1.25,0,0,1,25.08,143Z",
    transform: "translate(-8.9 -13.51)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    className: "cls-788",
    d: "M24.7,133v1.42A1.07,1.07,0,0,1,24.7,133Z",
    transform: "translate(-8.9 -13.51)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    className: "cls-841",
    d: "M107.1,253.08c-.27,0-.55,0-.73-.24a1.07,1.07,0,0,1,1,0l.49,0C107.65,253.12,107.37,253.08,107.1,253.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    className: "cls-842",
    d: "M36.93,88.69a.6.6,0,0,1-.32.57.31.31,0,0,1-.26-.16c-.07-.22.11-.33.28-.43A.17.17,0,0,1,36.93,88.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    className: "cls-843",
    d: "M56.78,193.28,57,193c.16.31.52.52.49.93A1.49,1.49,0,0,1,56.78,193.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    className: "cls-844",
    d: "M108,22.62c-.21,0-.6,0-.61-.07,0-.3.22-.13.36-.16a.76.76,0,0,1,.31.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    className: "cls-845",
    d: "M26.07,112.93c-.26-.3-.13-.55-.17-1A1,1,0,0,1,26.07,112.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    className: "cls-846",
    d: "M35.23,180.34v.75a1.57,1.57,0,0,1-.47-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    className: "cls-847",
    d: "M23,127.92c-.33-.27-.29-.6-.14-1,.27.33.09.68.13,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    className: "cls-848",
    d: "M26.36,162.71c0-.28,0-.56.05-.85a1,1,0,0,1,.17,1C26.48,163.08,26.4,162.84,26.36,162.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    className: "cls-849",
    d: "M88.24,225.22c.09.08.25.16.29.28s-.11.15-.21.1-.31-.1-.3-.29C88,225.28,88.14,225.26,88.24,225.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    className: "cls-850",
    d: "M71.65,215.77l-.25.2c0-.25-.54-.37-.22-.62C71.32,215.23,71.56,215.54,71.65,215.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    className: "cls-851",
    d: "M34,183.46c0-.19,0-.38.24-.48,0,.29.36.5.17.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    className: "cls-598",
    d: "M26.82,156.64c.13-.3-.13-.7.27-.92l0,.62-.22.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    className: "cls-852",
    d: "M73.23,223.21a1.4,1.4,0,0,1,.25.35c0,.15-.1.2-.21.11a1.72,1.72,0,0,1-.28-.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    className: "cls-653",
    d: "M25.46,131l-.06-1.17A.78.78,0,0,1,25.46,131Z",
    transform: "translate(-8.9 -13.51)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    className: "cls-853",
    d: "M76.15,210.35c0,.18-.07.29-.2.2a.83.83,0,0,1-.29-.33c0-.15.1-.18.2-.13A1.89,1.89,0,0,1,76.15,210.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    className: "cls-854",
    d: "M59.42,231.07l0-.28c.2.19.41.38.67.6C59.65,231.57,59.57,231.26,59.42,231.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    className: "cls-855",
    d: "M30.17,200.44l.06-.48c.2.11.46.25.37.51S30.31,200.61,30.17,200.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    className: "cls-856",
    d: "M36.93,88.69l-.3,0c.08-.24.1-.66.42-.54S37.09,88.52,36.93,88.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    className: "cls-857",
    d: "M24.38,116.65a.56.56,0,0,1,0-.73C24.57,116.16,24.42,116.41,24.38,116.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    className: "cls-834",
    d: "M24.14,119.67a.82.82,0,0,1-.06-.87C24.31,119,24.23,119.27,24.14,119.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    className: "cls-858",
    d: "M94.17,234.4l-.23.24a.77.77,0,0,1-.57-.37A.57.57,0,0,1,94.17,234.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    className: "cls-664",
    d: "M81.64,242.39c.16,0,.19.1.16.21s.11.33-.14.34c0,0-.13-.09-.15-.15S81.47,242.48,81.64,242.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    className: "cls-859",
    d: "M107.34,252.82l-1,0-.22-.24C106.55,252.64,107,252.46,107.34,252.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    className: "cls-772",
    d: "M24.33,123.89a.78.78,0,0,1,0-.82A.67.67,0,0,1,24.33,123.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    className: "cls-860",
    d: "M23.15,123.76a1,1,0,0,1,0,.89A.84.84,0,0,1,23.15,123.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    className: "cls-861",
    d: "M34.55,89.86l-.3.33c0-.08-.13-.18-.11-.24a2.82,2.82,0,0,1,.24-.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    className: "cls-778",
    d: "M34.28,70.24a1,1,0,0,1-.56.57c-.12-.52.26-.51.57-.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    className: "cls-862",
    d: "M59.42,60H59.2a1,1,0,0,1,.59-.59C59.93,59.73,59.66,59.84,59.42,60Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    className: "cls-863",
    d: "M30.83,170.1c-.26-.24-.18-.49-.09-.76C31.06,169.56,31,169.81,30.83,170.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    className: "cls-864",
    d: "M56.82,59.24c-.28,0-.38.52-.75.22C56.29,59.27,56.39,58.74,56.82,59.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    className: "cls-865",
    d: "M16.35,169.54c0-.24-.09-.51.19-.68C16.43,169.08,17.08,169.5,16.35,169.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    className: "cls-866",
    d: "M24.1,125.57a.79.79,0,0,1,0-.83A.71.71,0,0,1,24.1,125.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    className: "cls-867",
    d: "M178.75,28.81l2.36,1.24c.58.42,1.4.45,1.82,1.12a.69.69,0,0,1,0,.47c-.5.31-.07.68-.06,1a27.75,27.75,0,0,1,0,3.41c0,.51,0,1-.55,1.33a1.08,1.08,0,0,1-.75,0,10.75,10.75,0,0,1-1.43-.54,11.2,11.2,0,0,0,1.08.45c.31.13.71.17.63.67a.65.65,0,0,1-.5.15c-.67-.15-1.3-.46-2-.59a1.82,1.82,0,0,1-.9-.44c0-.65-.95-.51-1-1.16a49.08,49.08,0,0,1-.06-5.69,2.06,2.06,0,0,1,.35-1.12A.73.73,0,0,1,178.75,28.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    className: "cls-868",
    d: "M199.82,41.79c-.23.7.39.87.77,1.17,1.54,1.24,3.29,2.2,4.72,3.59-.69.4-1-.38-1.68-.45-.46.77.05,1.74-.36,2.54-.13.19-.3.24-.62.08.4.27.78.39.85.82-.06.59.06,1.26-.71,1.53a1.09,1.09,0,0,1-.36,0c-1.34-.65-2.66-1.33-4-2a1,1,0,0,1-.45-.83c.13-2.1-.2-4.22.2-6.31.2-.37.78-.26.91-.72A.67.67,0,0,1,199.82,41.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    className: "cls-869",
    d: "M213.22,53.24c2,1.52,4.14,2.84,5.5,5-.72.21-1.06-.35-1.49-.73A10,10,0,0,0,215.46,56c-.48.7-.16,1.47-.41,2.12s.55.84.42,1.38-.17,1.17-.76,1.49a1.63,1.63,0,0,1-1.2-.63c-1.07-1.18-2.49-2-3.58-3.14-.33-.43-1-.59-1.12-1.17,0-.26.22-.35.45-.4a2.68,2.68,0,0,1,1,.15c.17.08,0,0,0,0a.46.46,0,0,1,0-.26,1.14,1.14,0,0,1,.34-.67c.36-.18.65.08,1,.18-.42-.31-1-.41-1.19-.94a2.21,2.21,0,0,1-.08-.35c0-.74-.27-1.69.48-2.06s1.11.52,1.62.9A3.26,3.26,0,0,1,213.22,53.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "M168.8,25.48l.76.51c.18.42,0,.64-.41.57s-.77-.17-1.17-.23c.62.13,1.27.21,1.43,1a24.93,24.93,0,0,1-.16,6.28,5,5,0,0,1-3.83,0,2.51,2.51,0,0,1-.25-1.38q0-2.79,0-5.58a2.33,2.33,0,0,1,.37-1.58.87.87,0,0,1,.58-.28C167,24.92,168.05,24.69,168.8,25.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    className: "cls-871",
    d: "M228.76,69.78l.48.5c.25.3.5.6.73.93l1.42,1.9a1.71,1.71,0,0,1,.69.72A30.9,30.9,0,0,1,235,77.66a35.07,35.07,0,0,1,3.37,6c.11.44.53.94-.23,1.21-1.47-1.81-3.44-3.17-4.61-5.24a7.45,7.45,0,0,0-1.86-2.92c-.87-1.19-2-2.15-2.67-3.53.14-.73.47-.34.79-.16-.4-.45-.78-.93-1.16-1.41a1.9,1.9,0,0,1-.66-1.33C228.13,69.93,228.32,69.65,228.76,69.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    className: "cls-872",
    d: "M214.88,58.27a5.3,5.3,0,0,1,.34-2.69c1.46.5,2.06,2.15,3.5,2.7a4.31,4.31,0,0,1,1,1.2,22.14,22.14,0,0,0-.16,3.73,3.39,3.39,0,0,1-.31,1.83.68.68,0,0,1-.28.25c-.53,0-.82-.45-1.26-.59A15,15,0,0,1,215.85,63c-.15-.83-1.23-1.12-1.22-2.05l.69-1.43c.1-.12.44.24.34-.08S215,58.72,214.88,58.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    className: "cls-873",
    d: "M203.14,48.71c0-.84,0-1.67,0-2.51,0-.64.18-1,.83-.39a2.39,2.39,0,0,0,1.33.74,9.69,9.69,0,0,1,2.43,1.89,19.58,19.58,0,0,0-.18,3.9,4.48,4.48,0,0,1-.14,1.41c-.63.67-1,0-1.48-.26a20.46,20.46,0,0,0-2.63-1.81c-.3-.19-.8-.26-.63-.83.82-.18.25-1.05.7-1.42.24-.12.4,0,.55.19a1.93,1.93,0,0,0,.28.36c0-.15-.18-.17-.21-.3C203.87,49.21,203,49.4,203.14,48.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    className: "cls-874",
    d: "M207.21,53.92V49.64c0-.48,0-1,.53-1.2l.67.75c.44.26.75.7,1.2,1,1.16,1.09,2.63,1.8,3.61,3.1a5.05,5.05,0,0,1-1.76-1.18c-.67-.56-.81-.15-.87.37a17.57,17.57,0,0,0,0,1.78c0,.24.2.47,0,.71,0,.27,0,.56-.25.73-.7.28-1.14-.39-1.74-.48C208,54.89,207.36,54.67,207.21,53.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    className: "cls-875",
    d: "M152.84,21.75c3.68.75,7.38,1.41,11,2.51a1.66,1.66,0,0,1-1.56.34,40.18,40.18,0,0,0-8.77,0,1.52,1.52,0,0,1-.47,0,.69.69,0,0,1-.5-.38A3.88,3.88,0,0,1,152.84,21.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    className: "cls-876",
    d: "M152.84,21.75c-.13.77.31,1.62-.29,2.33a6.19,6.19,0,0,1-4.5,0,14.91,14.91,0,0,1,0-1.77,1.13,1.13,0,0,0-.73-1.29C149.21,21,151,21.55,152.84,21.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    className: "cls-877",
    d: "M231,78.38a29,29,0,0,0,2.94,4.79l.78,1.18a.35.35,0,0,1,.16.44.37.37,0,0,1-.3.14,2.49,2.49,0,0,1-.93-.74c-2.32-2.49-3.6-5.72-5.81-8.3-.13-.15-.24-.31-.36-.47-.66-1.09-1.57-2-2.16-3.14a.65.65,0,0,1,0-.34c.25-.32.5-.52.78,0l1.07,1.48a11.4,11.4,0,0,1,3.24,3.83A6.79,6.79,0,0,1,231,78.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    className: "cls-878",
    d: "M220.37,60.2c.8.81,1.61,1.61,2.42,2.42a.59.59,0,0,1,.39.55,18.8,18.8,0,0,0-.08,2.25c-.26.32-.66.39-1,.58-.52,0-.47-.51-.72-.75a4,4,0,0,0-.49-.43,8,8,0,0,1-.87-.67c-.75-1.14-.47-2.39-.32-3.61C219.74,60.23,220,60,220.37,60.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    className: "cls-879",
    d: "M223,65.44a2.74,2.74,0,0,1,0-2.37c.37-.15.51.15.64.37.84,1.37,2.24,2.26,3.11,3.6a1.07,1.07,0,0,0,.48.35c.19,1,1.23,1.45,1.51,2.39l-.75.47c-.54.08-.72-.37-1-.68a18.68,18.68,0,0,0-2.42-2.69,3.94,3.94,0,0,0-1-.52A1.31,1.31,0,0,1,223,65.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    className: "cls-878",
    d: "M226.09,71.92a.49.49,0,0,0-.64,0,.25.25,0,0,1-.32,0c-1.67-1.78-3.61-3.28-5.13-5.2a.77.77,0,0,1-.17-.43.84.84,0,0,1,1.12-.7c.41.15.71.47,1.1.65.86.46,1.08,1.54,1.94,2A22.61,22.61,0,0,0,226.09,71.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    className: "cls-880",
    d: "M192.35,35.3a40,40,0,0,1,5.55,3.34.43.43,0,0,1-.32.33c-.34,0-.67-.33-1,0-.69-.36-1.18-1.07-2-1.09a20.1,20.1,0,0,1-3.46-2.13c-.46-.47-1.35-.53-1.36-1.43a.69.69,0,0,1,.48-.17,1.09,1.09,0,0,1,.62.27A4.71,4.71,0,0,0,192.35,35.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    className: "cls-881",
    d: "M165.8,24.72l.5.3-.55.07c-1.27.54-2.55-.14-3.83,0a27.14,27.14,0,0,0-4.32-.22c-1.56-.07-3.13.26-4.67-.22a.28.28,0,0,1-.09-.39,63.91,63.91,0,0,1,11,0l1,.19A.94.94,0,0,1,165.8,24.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    className: "cls-882",
    d: "M220.85,65.7l-1,.5a.67.67,0,0,1-.58-.13.73.73,0,0,1-.33-.81c.46-1.4.19-2.84.25-4.27,0-.56,0-1.12.5-1.51l.69.72c-.11,0-.31.08-.32.13-.13,1.32-.52,2.66.34,3.9,0,.14,0,.29,0,.43C220.42,65.07,221.05,65.21,220.85,65.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    className: "cls-883",
    d: "M190.69,34.56a.49.49,0,0,0-.47-.23c-.67-.14-1.25-.68-2-.49a2.54,2.54,0,0,1-1.27-.51c-1.31-.86-2.92-1.14-4.16-2.11-.46-.54-1.33-.48-1.68-1.17a17,17,0,0,1,4.66,1.68c1.79,1,3.89,1.4,5.45,2.83A.33.33,0,0,1,190.69,34.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    className: "cls-884",
    d: "M196.68,38.89c.3-1.4.65.32,1,0a2.41,2.41,0,0,1,1.15.52l.28.37c.23.21.52.37.61.69a1.89,1.89,0,0,0,.51.79c.08.25.77.47.05.77l-.43-.23-.75-.49c-.21.1-.29.43-.61.33a7.06,7.06,0,0,1-1.78-1.34A.81.81,0,0,1,196.68,38.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    className: "cls-885",
    d: "M224.68,66.6c1.34,1,2.14,2.51,3.33,3.65l.78,1.19c.1.14.15.31,0,.42-.31.25-.48-.13-.72-.2a29,29,0,0,1-3.82-4.87C224.26,66.44,224.48,66.55,224.68,66.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    className: "cls-886",
    d: "M171.3,26.52c2.08-.14,3.86.88,5.75,1.5.28-.07.47,0,.53.31a.63.63,0,0,1-.34.41,1.3,1.3,0,0,1-1-.12,2.84,2.84,0,0,0-2.13-.54,2,2,0,0,1-1.14-.23c-.53-.41-1.37-.27-1.7-1A.35.35,0,0,1,171.3,26.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    className: "cls-887",
    d: "M230.23,77.41c-.77-1.53-2.12-2.62-3.07-4,1.87.31,2.49,1.88,3.32,3.25a.83.83,0,0,1,.06.72A.19.19,0,0,1,230.23,77.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    className: "cls-882",
    d: "M227.25,67.39c-.67.28-.79-.35-1.07-.67-1.07-1.2-2.11-2.43-3.16-3.65l-.23-.45A17.77,17.77,0,0,1,227.25,67.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    className: "cls-888",
    d: "M224,68.25c-.07.13.1.61-.31.21-.67-.65-1.07-1.54-1.9-2-.07-.24.05-.38.24-.5.1-.64.62-.4,1-.47l.66.75c.22.14.2.3,0,.46-.32,0-.52.16-.32.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    className: "cls-889",
    d: "M238.14,83.6a45.17,45.17,0,0,0-2.68-4.87,2,2,0,0,1-.47-1.07c1.18.72,1.64,2,2.23,3.12.45.87.88,1.76,1.33,2.65C238.44,83.56,238.38,83.79,238.14,83.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M232.83,57.34a14,14,0,0,1,2.92,3.08c-.42,0-.48-.72-1-.46a2.29,2.29,0,0,1-2.15-2.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    className: "cls-890",
    d: "M171.3,26.52a1,1,0,0,0,0,.17c-.64.8-1.38.68-2.16.24-.59-.46-1.52,0-2.1-.74.69-.48,1.32-.13,1.9.08.39.15.55.11.63-.28A3.69,3.69,0,0,1,171.3,26.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    className: "cls-891",
    d: "M240.67,87.73c.36.78.73,1.56,1.08,2.34.08.2.26.47-.07.6s-.36-.15-.4-.31A25.62,25.62,0,0,0,240,88C240,87.36,240.39,87.67,240.67,87.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M214.65,33.15a10.5,10.5,0,0,1,3,2.18c-1.16-.62-2.54-.88-3.25-2.17C214.47,33.05,214.56,33.05,214.65,33.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M235,60.43a6.56,6.56,0,0,1,1.84,2.32l-.24.2-2.1-2.27C234.51,60.25,234.72,60.27,235,60.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    className: "cls-879",
    d: "M228.07,71.66c.16-.34.69.56.72-.22a12.76,12.76,0,0,1,1.56,2c-.62.23-.75-.92-1.36-.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    className: "cls-892",
    d: "M238.14,83.6l.41-.17.71,1.43c-.2.48.36,1.08-.22,1.5-.49-.4-.59-1-.91-1.52C238.6,84.43,238.19,84,238.14,83.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    className: "cls-893",
    d: "M234.8,84.91l-.12-.56a8.59,8.59,0,0,1,2.26,4.05l-1.68-2.6C234.94,85.59,234.61,85.39,234.8,84.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M235,60.43a.52.52,0,0,0-.5.25c-.59-.56-1.19-1.11-1.78-1.68-.36-.35-.59-.75-.13-1.21A3.33,3.33,0,0,0,234.75,60C234.84,60.11,234.92,60.27,235,60.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    className: "cls-894",
    d: "M231.66,76.68c1.43.46,1.49,1.79,1.86,2.92A15.88,15.88,0,0,1,231.66,76.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M183.5,29.56a17.17,17.17,0,0,0,3.12.48h0c-1.09.2-2.28,1-3.11-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    className: "cls-895",
    d: "M240.67,87.73c-.17.23-.55-.06-.68.27a4.43,4.43,0,0,1-.74-1.45.78.78,0,0,1,.71-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M238.45,65a6.88,6.88,0,0,1,2,2.43A9.23,9.23,0,0,1,238.45,65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M195,33.14c.47.08.62.38.6.86a4.07,4.07,0,0,1-1.82-.62c-.19-.36-.08-.52.32-.48S194.7,33.11,195,33.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M196.92,32.41a2.93,2.93,0,0,1,1.87.94,4.75,4.75,0,0,1-2.62-.92A.66.66,0,0,1,196.92,32.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    className: "cls-896",
    d: "M177.59,28.31l-.54-.29c.49-.82,1,0,1.55,0,.26,0,.43.35.09.62A.82.82,0,0,1,177.59,28.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    className: "cls-897",
    d: "M200.25,42c.33-.37-.21-.46-.23-.71a.3.3,0,0,1,.27-.27c.39.33.9.5,1.19,1,.11.47-.27.45-.53.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    className: "cls-898",
    d: "M240,86.31a.55.55,0,0,1-.71.24l-.21-.19c.13-.49-.16-1,.22-1.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M196.92,32.41l-.75,0a2.11,2.11,0,0,1-1.3-.7A3.18,3.18,0,0,1,196.92,32.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M207.2,37.75a.9.9,0,0,1,1.3.25s0,.18-.05.19C208,38.41,207.69,38,207.2,37.75Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    className: "cls-899",
    d: "M177.59,28.31l1.1.31.06.19-.76.27c-.41.11-.71,0-.72-.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M211.52,31.71c-.54-.05-.86-.47-1.24-.81a1.1,1.1,0,0,1,1.24.57c.07.05.09.11.06.16S211.54,31.71,211.52,31.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M215.86,44.19l1.51,1C216.4,45.28,216.11,44.73,215.86,44.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M228.78,54.58c-.41-.21-.84-.41-.89-1C228.56,53.64,228.57,54.21,228.78,54.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M202.68,35.07l1.57.84c-1,.16-1.23-.42-1.71-.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M192.45,30.36c-1,.31-1,.31-1.76-.15.23-.31.44,0,.66,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    className: "cls-900",
    d: "M190.69,34.56h.53a2.33,2.33,0,0,1,1.13.74A2.27,2.27,0,0,1,190.69,34.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    className: "cls-901",
    d: "M130.82,20.21c0-.32.22-.43.4-.59l.75.16A1.27,1.27,0,0,1,130.82,20.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    className: "cls-902",
    d: "M230.23,77.41h.22c.45-.16.49.31.72.48,0,.2,0,.39-.21.48C230.5,78.22,230.4,77.79,230.23,77.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M242.24,70a1.27,1.27,0,0,1,.94,1.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M240.51,65.46c-.59.13-.53-.53-1.07-.69.55-.17.78.12,1.05.2A.33.33,0,0,1,240.51,65.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M242.59,67.55a1.75,1.75,0,0,1-.9-1.26C242.16,66.8,242.53,67,242.59,67.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M211.52,31.71v-.24a1.41,1.41,0,0,1,1,.49c0,.08,0,.16,0,.24A1.36,1.36,0,0,1,211.52,31.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    className: "cls-903",
    d: "M231.17,77.9l-.72-.48,0-.77A2.06,2.06,0,0,1,231.17,77.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M206.26,36.74l.82.27c-.43.55-.75.3-1.07,0A.28.28,0,0,1,206.26,36.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    className: "cls-904",
    d: "M198.8,39.4c-.5.07-.8-.29-1.15-.52l.25-.24C198.22,38.86,198.66,39,198.8,39.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    className: "cls-905",
    d: "M200.29,41l-.27.27a.78.78,0,0,1-.46-.75c.07-.1.1-.25.26-.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    className: "cls-873",
    d: "M209.61,50.14c-.61,0-.9-.51-1.2-1A2,2,0,0,1,209.61,50.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M206.26,36.74,206,37a1.12,1.12,0,0,1-.59-.6C205.81,36.28,206,36.51,206.26,36.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    className: "cls-906",
    d: "M201,42.53l.53-.54c.26.21.33.49.09.71S201.12,42.73,201,42.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    className: "cls-907",
    d: "M199.82,40.29l-.26.27-.48-.79C199.5,39.7,199.78,39.82,199.82,40.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M183,29.32a1,1,0,0,1-.8-.39c.46-.15.75-.09.8.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M186.62,30c.21,0,.48-.08.59.21a.33.33,0,0,1-.18.21c-.32.05-.39-.17-.42-.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M189.87,31.35a.56.56,0,0,1,.7,0,.21.21,0,0,1,0,.2C190.29,31.74,190.13,31.54,189.87,31.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M240.51,65.46c0-.16,0-.32,0-.49a1.55,1.55,0,0,1,.73.76C240.86,65.86,240.74,65.49,240.51,65.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    className: "cls-879",
    d: "M230,71.21a1.18,1.18,0,0,1-.73-.93A1.11,1.11,0,0,1,230,71.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M236.92,63.2c.46.09.57.33.69.68C237.15,63.8,237,63.56,236.92,63.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    className: "cls-882",
    d: "M223.71,66.65c0-.15,0-.3,0-.46l1,.41-.43.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M183,29.33c.24-.08.44-.33.73-.19l-.25.42h0a.47.47,0,0,1-.48-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M200.79,33.82l.22.2a1.48,1.48,0,0,1-.37.2s-.14-.13-.21-.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    className: "cls-879",
    d: "M232.08,73.83a1.71,1.71,0,0,1-.69-.72A.65.65,0,0,1,232.08,73.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    className: "cls-633",
    d: "M225.89,229.82a100.27,100.27,0,0,1-9.26,6.73c-.32.2-.59.55-1,.48-2-.22-4-.06-6-.11a2.83,2.83,0,0,1-1.71-.32c-.51-1,.55-.9.87-1.32a9.75,9.75,0,0,0,1-.57,1.1,1.1,0,0,0,.15-.16c-.17-.09-.25.1-.38.12a4.59,4.59,0,0,0-2.3,2.11,5.3,5.3,0,0,1-1.77.16H186.91a3.83,3.83,0,0,1-2-.27c-.58-.5-.13-.74.27-.94.86-.42,1.78-.7,2.6-1.2a5,5,0,0,1,2-.8c.5-.2,1.05-.28,1.55-.48a24.43,24.43,0,0,1,2.27-1c-1.28-.27-2.26.57-3.39.84s-2.25,1.18-3.59.93c.19-1.19,1.3-1.24,2.08-1.7a24.56,24.56,0,0,0,2.61-.93c1.43-.35,2.47-1.38,3.64-2.18a1.93,1.93,0,0,1,.87-.27c.88.15,1.77.09,2.65.22.73.24,1.37-.38,2.09-.23,4.54.21,9.08,0,13.62.1.66,0,1.37-.14,1.91.41.23.74-.44.83-.81,1.15s-.58.59-.82.64a3.12,3.12,0,0,0,.6-.47,6.81,6.81,0,0,0,1.21-.86c.56-.41,1-1,1.81-.93,2.19.13,4.37,0,6.55.09C225.15,229.07,226,228.82,225.89,229.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M216.07,229.84c-.18-.72-.77-.44-1.19-.44q-6.56,0-13.13,0a2.8,2.8,0,0,1-1.51-.25c-.62-.38-1,.61-1.63.25a9.08,9.08,0,0,1-2.89-.24c.23-1,1.28-.89,1.87-1.4,3.08-1.25,5.54-3.52,8.45-5,.62-.32,1.17-.86,2-.65,4.51,0,9,0,13.51,0,1,0,2,.1,2.48,1.23.11.27.16.62.6.31a6.87,6.87,0,0,0,.75-.68c.46-.43.85-1,1.58-.91,1.86.13,3.72,0,5.57.08.6,0,1.31-.05,1.52.78a48.93,48.93,0,0,1-8.13,6.93c-.16-.65-.68-.42-1.07-.43-1.9,0-3.8,0-5.7,0a2.41,2.41,0,0,1-1.37-.25c-.62,0-.91.58-1.42.78A.22.22,0,0,1,216.07,229.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M207.68,236.32c1.08.49,2.21.18,3.31.23s2.32,0,3.47,0c.45,0,.9,0,1.13.47a67,67,0,0,1-9.81,5.76c.16-.82-.34-.84-.95-.84-4.39,0-8.78,0-13.17,0-5.95,0-11.89,0-17.83,0-.66,0-1.38.15-1.91-.44-.23-.64.19-1,.65-1.23a10.35,10.35,0,0,0,1.49-1,5.86,5.86,0,0,1,1.57-.6c1.89-.31,3.6-1.21,5.46-1.62a11.93,11.93,0,0,0,2.1-.67c.46-.18.93-.46,1.44-.12a2.55,2.55,0,0,0,1.38.28h20.33c.38,0,.81.13,1.11-.25C207.54,236.23,207.61,236.22,207.68,236.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    className: "cls-908",
    d: "M234,222.89a1.74,1.74,0,0,0-1.41-.45H228a2.52,2.52,0,0,1-1.38-.24c-.73,0-.91.71-1.41,1s-.68.69-1.22.65c-.43-1.29-1.37-1.48-2.61-1.46-4.15.07-8.3,0-12.45,0-.42,0-.89.16-1.23-.25.41-1.09,1.5-1.44,2.29-2.12a5.59,5.59,0,0,0,1.67-1.65,6.66,6.66,0,0,1,5.24-2.12c7,.09,14,0,20.93,0,.6,0,1.4-.29,1.73.6a38.94,38.94,0,0,1-3.68,3.7,1.66,1.66,0,0,0-.64,1.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    className: "cls-909",
    d: "M172,241.11c.2.79.84.46,1.29.47h33.62c-.22.75-1,.65-1.13,1.2l-3.15,1.66c-.81.28-1.5.79-2.29,1.11a2.12,2.12,0,0,1-1.35.24H168.07a7.7,7.7,0,0,1-3.39-.5c-.45-.56,0-.77.41-1,.61-.28,1.27-.44,1.89-.71a2.76,2.76,0,0,0,1.2-.59,1.36,1.36,0,0,1,.24-.24,6.74,6.74,0,0,0,2.2-1.3A1.25,1.25,0,0,1,172,241.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M184.23,252.13c-.26,0-.55,0-.74-.22.83-1,2-.92,3.11-1a25,25,0,0,0,4.09-1.64,2.37,2.37,0,0,1,1.32-.58c.51-.11,1-.6,1.56-.12A51.74,51.74,0,0,1,184.23,252.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M199.31,245.65c1.14-.3,2.06-1.23,3.32-1.2a21.69,21.69,0,0,1-6.47,3.32c-.22-.13-.37-.28-.18-.55A9.28,9.28,0,0,1,199.31,245.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    className: "cls-909",
    d: "M196,247.35c.05.14.1.28.16.42l-2.59.78c-.55-.11-1,.28-1.47.39a.37.37,0,0,1-.27-.23c.27-.65.89-.61,1.43-.72C194.23,248,195,247.1,196,247.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    className: "cls-910",
    d: "M196,247.35a9.36,9.36,0,0,1-2.73.92c-1-.47-1.63.48-2.44.73l-.16,0q-17.55,0-35.1,0c-.44,0-1.08.33-1.29-.45.61-1,1.77-.71,2.62-1.16a18.62,18.62,0,0,0,6.22-2.42c.48-.19,1-.44,1.45,0a7.21,7.21,0,0,0,2.87.5h30.5c.46,0,1-.18,1.37.22A18.81,18.81,0,0,1,196,247.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    className: "cls-911",
    d: "M148.05,250.45c0-2.15-.21-4.3,0-6.46a1.43,1.43,0,0,1,1.42-.29c.8.16,1.62.14,2.42.29.71.37.85,1.08,1.05,1.76a.85.85,0,0,1,0,.36,2.25,2.25,0,0,0-.46,1.77c0,.38.23.78-.08,1.13A19.16,19.16,0,0,1,148.05,250.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    className: "cls-912",
    d: "M152.36,249a9.49,9.49,0,0,1-.26-1.84,1.22,1.22,0,0,1,.75-1.28,2.19,2.19,0,0,0,.21-.23l-.21.23a5.3,5.3,0,0,1-.73-1.65,1.77,1.77,0,0,1,1.79-.24,3.9,3.9,0,0,0,2.09,0,1.21,1.21,0,0,1,1,.22c.17,1.14.57,2.27-.05,3.4-.79.58-1.83.44-2.64,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M139.2,252.36c-1.2-.44-2.48-.2-3.71-.46-.42-.09-.88,0-1.09-.51a51.73,51.73,0,0,0,7.67.49v.17c-.57.49-1.25.33-1.9.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    className: "cls-913",
    d: "M140.17,252.39a7.23,7.23,0,0,1,1.9-.34h3.57C143.81,252.24,142,253,140.17,252.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    className: "cls-910",
    d: "M186.6,250.89l-3.11,1a2.5,2.5,0,0,0-1.21.15l-.46-.35a7.86,7.86,0,0,1,2.42-.67c.4-.12.85-.07,1.18-.4C185.9,250.33,186.23,250.72,186.6,250.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-914",
    d: "M185.42,250.64c-1.06.84-2.37.81-3.6,1.07-.14-.58.4-.46.63-.51C183.43,251,184.43,250.82,185.42,250.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M149.44,254h-2.75C147.32,253.53,147.32,253.53,149.44,254Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M163.79,252.7a2.33,2.33,0,0,1-1.66.26C162.8,252.79,163.16,252.49,163.79,252.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-915",
    d: "M164.34,252.39l1.56-.09A1.46,1.46,0,0,1,164.34,252.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-910",
    d: "M191.89,248.77l.21.17-1.41.31a1.64,1.64,0,0,0,0-.22v0C191.06,248.82,191.4,248.4,191.89,248.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-916",
    d: "M239.55,217c-.39-.42-.9-.24-1.35-.24-7.16,0-14.32,0-21.48,0a5.62,5.62,0,0,0-4.4,1.62,4.34,4.34,0,0,1-.77.56c-.36.3-.66.71-1.23.59-2.59-.46-5.21-.13-7.82-.23a11.32,11.32,0,0,1-1.54-.05c-.39-.07-.81-.16-.72-.73s.66-.69,1-1.07a8.58,8.58,0,0,0,.75-1c.27-.4.59-.75.83-1.16a21.78,21.78,0,0,1,2.64-2.79c.06-.19.06-.41.33-.43.51.49,1.12.22,1.7.22h9a2.35,2.35,0,0,1,1.56.47.28.28,0,0,1,.06.3c-.11.21-.35.3-.48.49.24-.24.57-.37.77-.65.39-.29.73-.69,1.29-.63h22.1a6.2,6.2,0,0,1,1.87.24A38.94,38.94,0,0,1,239.55,217Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M218,212.88l0-.25c.65-.33.95-1.16,1.78-1.27.16.31-.17.51-.14.78l-1.15.75A.41.41,0,0,1,218,212.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M241.72,205.53a1.18,1.18,0,0,1-.87.88A1.36,1.36,0,0,1,241.72,205.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-917",
    d: "M243.62,105.29l0-1.12a14.37,14.37,0,0,1,1.22,3.15.32.32,0,0,1-.26.09c-.09,0-.13-.33-.3-.08C243.79,106.75,244,105.91,243.62,105.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-918",
    d: "M244.59,107.33h.28c.51.54.36,1.3.62,1.93a.27.27,0,0,1-.43,0,2,2,0,0,1-.28-1.14C244.73,107.84,244.43,107.64,244.59,107.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-919",
    d: "M244.59,107.33c.06.26.13.51.19.77a.89.89,0,0,1-.47-.77c0-.1.06-.27.1-.27C244.61,107,244.54,107.23,244.59,107.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-920",
    d: "M245.06,109.24h.43c0,.22.13.56-.13.59S245.08,109.49,245.06,109.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-921",
    d: "M114.74,250.66c.23-.34.78,0,1-.46a2.18,2.18,0,0,1,1.16-.1c.38,0,.45.26.29.58l-1.28,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-922",
    d: "M129.86,253.35l1.86,0a4.17,4.17,0,0,1-1.86.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-923",
    d: "M108.75,36C99.89,40,92.07,45.65,84.6,51.8l-.22-.27a11.57,11.57,0,0,1,1.43-1.29c1.83-1.19,3.16-2.92,4.77-4.35a3.84,3.84,0,0,1,1.57-.8,2.14,2.14,0,0,0,1.74-1.38c.06-.21.4-.36.63-.5l4.65-2.93c.43-.4,1-.53,1.46-.9A79.86,79.86,0,0,1,120.18,30a18.35,18.35,0,0,1,3.43-.95.15.15,0,0,1,.06.17c0,.06,0,.09,0,.09-2.08.87-4.29,1.39-6.36,2.32s-4.37,1.84-6.56,2.75C110.26,35.17,109.06,35.06,108.75,36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-600",
    d: "M53.69,76c.14.2-.31.6.33.7.47.06.27.58.07.86-1.2,1.65-1.92,3.57-3,5.3a5.13,5.13,0,0,0-1,2.62c0,.78-.59,1.2-1.41,1.55a6.65,6.65,0,0,1,.9-2.1c.8-1.85,1.16-3.86,2.17-5.61a2.89,2.89,0,0,1,1-1.27c.27-.16.71-.42.35-1-.21-.34.17-.81.59-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M44.1,106.86c.34-.14.58-.11.42.33-.28.78-.59,1.54-.88,2.31a.55.55,0,0,1-.74,0c-.51,0-.45-.33-.26-.65a11,11,0,0,0,1.18-5.08c.07-1.16.38-2.24.53-3.36q.12-.15.24,0c.11,1.07,1,2,.51,3.2-.17.39-.64.82-.1,1.34.15.15,0,.47-.36.31l-.2-.08c.65.71-.42,1.09-.33,1.69-.14.1-.15.26-.21.4C44,107.14,44,107,44.1,106.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-924",
    d: "M44.59,100.4h-.24c.59-.44.22-1.22.17-1.55-.27-1.77,2.07-2.1,1.7-3.83,1.27,1.35.39,2.56,0,3.72A3,3,0,0,1,44.59,100.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-925",
    d: "M83.38,40.81c-2,1.46-3.58,3.51-5.71,4.87l-1,.64c-.07-.06-.1-.11-.08-.17s.05-.09.07-.09c2-2.2,4-4.53,6.71-6a.83.83,0,0,1,.07.13A.76.76,0,0,1,83.38,40.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-926",
    d: "M87.21,37.21a56.9,56.9,0,0,1,6.46-4.55c.59-.36.63.32,1.19.35-2.68,1.48-5,3.22-7.64,4.45-.08-.05-.1-.11-.08-.16S87.19,37.21,87.21,37.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-927",
    d: "M103.51,28.36c-1.78.76-3.31,2.09-5.35,2.25-.45,0-.89.25-1.36.32a18.58,18.58,0,0,1,4.06-2.09c.89-.19,1.57-1.06,2.59-.8A.21.21,0,0,1,103.51,28.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-928",
    d: "M51.81,86.18c-.76,2.37-1.6,4.72-2.38,7.1C49.52,90.7,50.83,88.5,51.81,86.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-667",
    d: "M72.1,52.06a15.87,15.87,0,0,0-4.52,3.45C68.69,53.18,71,51.45,72.1,52.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "M117.88,21.67c1.13-.88,2.57-.9,3.83-1.44a.31.31,0,0,1,.47,0c.36.57,0,.75-.46.89a23.93,23.93,0,0,1-3.85.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-930",
    d: "M122.18,20.24h-.47c-.33-.41-.81-.16-1.21-.27.46-.32,1-.16,1.47-.17a3,3,0,0,0,1.66,0,5.3,5.3,0,0,1,3.11-.52l0,.33c-.43.58-1.12.1-1.62.39A6,6,0,0,1,122.18,20.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M87.21,37.21v.25A5.25,5.25,0,0,1,86,38.91c.08.19,0,.28-.19.34-.29.26-.82.16-1,.6h0a3,3,0,0,1-.77.41.65.65,0,0,1-.66-.17h0A23.4,23.4,0,0,1,87.21,37.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "M55.84,77.42a7.17,7.17,0,0,1-1.65,3.33c-.12.14-.06.57-.43.39a.43.43,0,0,1-.14-.7,13.68,13.68,0,0,1,2.22-3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-931",
    d: "M42.9,109.49h.74c0,.31-.25.63,0,1a15.58,15.58,0,0,0-.71,3c-.07.36-.11.69-.48.86a1.93,1.93,0,0,1,.23-1.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M119.07,37c1.48-.13,2.63-1.29,4.16-1.42a5,5,0,0,1-4.15,1.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-928",
    d: "M110.69,24.77a8.19,8.19,0,0,1-3.87,1.47c1.15-1.11,2.6-1.06,3.87-1.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-932",
    d: "M108.75,36c-.09-.21-.63-.37,0-.65s1.33-.66,2-1C110.48,35.43,109.68,35.79,108.75,36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-933",
    d: "M76.67,46.06v.26c-.85.75-1.35,1.86-2.44,2.37a.35.35,0,0,1,0-.43A7.06,7.06,0,0,1,76.67,46.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-934",
    d: "M113.81,20.8c.28-.38.7-.27,1.08-.31a.66.66,0,0,1,.83.69C115,21.3,114.23,22,113.81,20.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637",
    d: "M54.4,74.79c-.16-1.29.92-1.86,1.55-2.69a4.29,4.29,0,0,1-1.55,2.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-935",
    d: "M59.18,67.44l-1.86,2.47A2.69,2.69,0,0,1,59.18,67.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M56.56,76.23a4.18,4.18,0,0,1,1-2.64h0a2.72,2.72,0,0,1-1,2.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-936",
    d: "M76.67,44.14,78.79,43c-.36,1-1.32,1.26-2.11,1.69A.39.39,0,0,1,76.67,44.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-937",
    d: "M103.51,28.36a1.93,1.93,0,0,1,0-.24.33.33,0,0,1,0-.48c.59.25.71-1,1.4-.33A1.24,1.24,0,0,1,103.51,28.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-938",
    d: "M96.06,35.32l2.49-.85A3.08,3.08,0,0,1,96.06,35.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-939",
    d: "M66.29,58c-.3-1-.3-1,1-1.14C67.13,57.32,66.71,57.56,66.29,58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-929",
    d: "M103.5,27.64v.48c-1-.19-1.68.79-2.64.72A6.61,6.61,0,0,1,103.5,27.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-940",
    d: "M63.22,61A2.74,2.74,0,0,1,62,62.47C62.22,61.9,62.28,61.24,63.22,61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-715",
    d: "M116.44,22.62c-.39.39-.82.23-1.35.16a1.48,1.48,0,0,1,1.11-.64C116.64,22.12,116.57,22.36,116.44,22.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-941",
    d: "M71.05,50.66c.32-.93.56-1.42,1.45-.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-942",
    d: "M100.63,39.38a1.42,1.42,0,0,1-1.46.9C99.37,39.52,100,39.4,100.63,39.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-943",
    d: "M74.3,45.37l1.41-.74a.35.35,0,0,1,0,.51c-.47.12-.79,1.09-1.43.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-944",
    d: "M42.67,112.36a5.34,5.34,0,0,1-.23,1.91h-.25a2,2,0,0,1,.23-1.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-945",
    d: "M73.81,49c-.36.81-.84,0-1.29.13.13-.44.54-.44.82-.62C73.47,48.66,73.74,48.72,73.81,49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M96.45,32.09c-.4.19-.66.55-1.1.38,0,0-.09-.25,0-.29A.75.75,0,0,1,96.45,32.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637",
    d: "M117.87,21.66c.55,1-.56.4-.72.72h0c-.07-.54.18-.77.72-.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-946",
    d: "M83.39,40.09h.71a.29.29,0,0,1,.24.26,1.41,1.41,0,0,1-1,.46A.63.63,0,0,1,83.39,40.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-947",
    d: "M75.72,45.14v-.51l1-.49v.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-948",
    d: "M42.42,112.36a5.2,5.2,0,0,0-.23,1.92c-.29-.17-.23-.46-.25-.72C42.06,113.14,41.66,112.52,42.42,112.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-635",
    d: "M47.55,90.38c-.11-.77.24-1.11.54-1.69C48.2,89.4,47.84,89.74,47.55,90.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-949",
    d: "M104.46,43.93v.25a.82.82,0,0,1-1.14.71l-.32,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-950",
    d: "M125.09,20c.48-.4,1.11-.13,1.62-.39V20Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-951",
    d: "M116.44,22.62a.52.52,0,0,0-.24-.48c.48-.57.66.08,1,.24h0C117,22.66,116.7,22.61,116.44,22.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-952",
    d: "M116,30.31c.26-.39.59-.28,1-.17C116.69,30.41,116.44,30.65,116,30.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-953",
    d: "M118.14,37.53l.21-.59c.25-.21.51-.41.72.05v0A1.36,1.36,0,0,1,118.14,37.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-954",
    d: "M85.51,42.19a3.38,3.38,0,0,1-1.46.86A1.92,1.92,0,0,1,85.51,42.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-955",
    d: "M73.81,49c-.31,0-.48-.16-.47-.49l.92-.21c0,.14,0,.29,0,.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-928",
    d: "M55.84,77.42a1.47,1.47,0,0,1,.72-1.19h0a1.47,1.47,0,0,1-.72,1.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-951",
    d: "M54.4,74.79a1.5,1.5,0,0,1-.71,1.2h0a1.49,1.49,0,0,1,.72-1.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-956",
    d: "M110.69,24.78c-.06-.21-.22-.46.18-.48.15,0,.37,0,.35.16s-.31.29-.53.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-957",
    d: "M123.62,29.3V29l.48-.24.25,0c.24-.14.25,0,.22.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-958",
    d: "M47.22,92.5c.06.26.4.49.08.81-.37-.25-.43-.51-.08-.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M57.52,73.59c.14-.22.16-.54.52-.61.21.55-.2.55-.52.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-959",
    d: "M84.34,40.35l-.24-.26c.17-.28.46-.22.72-.24A.46.46,0,0,1,84.34,40.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-960",
    d: "M55,76c-.08.11-.08.35-.27.27s-.17-.25-.18-.4.15-.21.22-.21S55,75.78,55,76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-961",
    d: "M84.82,39.85c0-.61.65-.46,1-.72.08.06.11.11.08.16s0,.08-.08.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-937",
    d: "M105.79,26.86c.19-.23.36-.36.61-.32a.26.26,0,0,1,0,.18C106.29,26.88,106.12,26.94,105.79,26.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-962",
    d: "M124.56,29l-.22-.19c.3-.25.61-.43.93,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-963",
    d: "M117.72,30c.37-.3.62-.17,1-.2C118.35,30.17,118.1,30,117.72,30Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-964",
    d: "M47.22,92.5c0-.23,0-.47.31-.54,0,0,.12.09.13.14,0,.32-.2.37-.44.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-897",
    d: "M85.78,39.37v-.24L86,38.9c.17,0,.44,0,.35.29S86,39.35,85.78,39.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-965",
    d: "M103.32,44.89a2.78,2.78,0,0,0,1.14-.71l.45-.06a1.61,1.61,0,0,1,1.08.3c-.78,1-1.91,1.11-3.13,1.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-966",
    d: "M106,44.42a1.81,1.81,0,0,1-1.08-.3c.41-.5.82.07,1.22,0,.08.06.1.12.08.18s0,.09-.07.09l-.07,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-967",
    d: "M106.14,44.4v-.27a1.13,1.13,0,0,1,1-.38C106.91,44.15,106.48,44.2,106.14,44.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-968",
    d: "M148.53,48.23l-.48-.24c-.08.09-.16.09-.24,0V33.89c1.42-.72,2.9-.33,4.37-.29,1.31.44,1.31.44.71,1.29a2.2,2.2,0,0,0-.39,1.7c0,3.46,0,6.93,0,10.39a2.68,2.68,0,0,1-.32,1.73.72.72,0,0,1-.6.13,2.3,2.3,0,0,1-1.13-.37h-.21A8.1,8.1,0,0,1,148.53,48.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M151.88,48.71c.4-.35.24-.82.24-1.23q0-5.9,0-11.79c0-.56-.09-1.17.78-1.13a6.33,6.33,0,0,1,4.25,0c-.74,1.17-.58,2.48-.58,3.77,0,3.16,0,6.33,0,9.5a3.61,3.61,0,0,1-.22,1.75.27.27,0,0,1-.39.1,3,3,0,0,1-1.68-.24c-.35-.29-.83,0-1.18-.23h-.48C152.47,48.87,151.82,49.33,151.88,48.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M156.2,49.65c0-4.53,0-9.07,0-13.6a1.23,1.23,0,0,1,1-1.43.86.86,0,0,1,.36-.27,2,2,0,0,1,1.94.3,1.38,1.38,0,0,1,.2.68c0,3.85.14,7.69-.06,11.54-.24.75-.71.49-1.16.24.29.58,1.31-.21,1.41.75-.36.74,0,1.65-.52,2.35a1.22,1.22,0,0,1-1-.07h-.24A18.45,18.45,0,0,0,156.2,49.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-876",
    d: "M152.32,33.89h-4.51l-1.17-.09c1.33,0,1.56-.79,1.44-1.93-.06-.52-.24-1.12.22-1.59s1.28,0,1.92-.13a11,11,0,0,0,2,.43c.32.13.66.22.83.58a4.31,4.31,0,0,1,.1,2.08C153.07,33.65,153,34.14,152.32,33.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-838",
    d: "M146.85,48.22c.16.28.48.21,1.05.39-1.11.23-1.83-.43-2.6-.18-.06,0-.21-.11-.24-.2s.08-.32.21-.37a1.24,1.24,0,0,1,1.58.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-969",
    d: "M133,35.33c.18.28.48.17.72.23a19.85,19.85,0,0,1-3.22.68C131.3,35.3,132.21,35.51,133,35.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-970",
    d: "M156.2,49.65a2.75,2.75,0,0,1,1.91.49,5,5,0,0,1-2.16-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-971",
    d: "M158.35,50.14h1c.42,0,.78,0,1,.48a.48.48,0,0,1-.47.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-701",
    d: "M148.53,48.23c.57.08,1.19-.22,1.7.24C149.59,48.87,149.07,48.47,148.53,48.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-972",
    d: "M137.1,48.18a.73.73,0,0,1,1.09.2C137.74,48.49,137.43,48.55,137.1,48.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-849",
    d: "M134.85,34.55a3.88,3.88,0,0,1,1.94-.2c.06,0,.08.1.06.14s0,.07-.07.07l-1.21.24C135.39,34.52,135.09,34.63,134.85,34.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-643",
    d: "M136,47.7c-.26.42-.59.28-1,.22C135.34,47.61,135.59,47.41,136,47.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-973",
    d: "M144.36,48.15c-.45.08-.75.17-1.06-.2C143.7,47.66,144,47.86,144.36,48.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-701",
    d: "M150.44,48.47a1.49,1.49,0,0,1,1,.25c.08.05.1.1.08.14s-.05.07-.08.07C151,48.9,150.53,49.11,150.44,48.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-701",
    d: "M142,48c-.09-.07-.26-.13-.29-.23s.13-.25.27-.23a.55.55,0,0,1,.35.22C142.43,48,142.18,47.93,142,48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-974",
    d: "M155.71,50.14c-.49.37-.82,0-1.19-.24A1.83,1.83,0,0,1,155.71,50.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-761",
    d: "M154.27,49.9c-.47-.07-1,.2-1.42-.23C153.32,49.74,153.85,49.46,154.27,49.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-740",
    d: "M152.59,49.66h-.47c-.32,0-.7.11-1-.24C151.65,49.5,152.18,49.23,152.59,49.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-975",
    d: "M151.41,48.93v-.21h.47l.73.47A1.75,1.75,0,0,1,151.41,48.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M153.09,49.19c.4.05.85-.17,1.18.23C153.87,49.36,153.42,49.59,153.09,49.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-860",
    d: "M147.81,48h.24c-.33.41-.79.18-1.2.23h0C147.1,47.88,147.48,48,147.81,48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-976",
    d: "M148.3,30c-.53-1.28-.11-2.63-.25-3.93,0-.44.19-1-.53-1.12.19-.6.72-.54,1.18-.56.91,0,1.82,0,2.73,0,1.57.09,1.78.28,1.77,1.81a16.62,16.62,0,0,1-.16,4.11.6.6,0,0,1-.52.36,15.54,15.54,0,0,1-1.66-.28C150.06,30,149.12,30.41,148.3,30Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-977",
    d: "M151.35,24.76a14.47,14.47,0,0,0-3.83.23,5.14,5.14,0,0,0-2.36.51c-1.07.56-2.41.23-3.63.32a7.71,7.71,0,0,1-2.39-.31A81.54,81.54,0,0,1,148.05,24l4.5,0a2.9,2.9,0,0,1,.29.19v.24C152.39,24.85,151.82,24.48,151.35,24.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-978",
    d: "M141.27,29.26c-.72.06-1.32.19-1.86-.28C140,28.9,140.62,28.59,141.27,29.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-979",
    d: "M148.3,30c.87.09,1.77-.21,2.62.18-.2.28-.45.19-.7.07-.64.47-1.28-.15-1.92,0A1,1,0,0,1,148.3,30Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-939",
    d: "M134.4,26H136C135.5,26.52,134.94,26,134.4,26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-980",
    d: "M146.93,22.51a1.8,1.8,0,0,1-1.35,0A1.8,1.8,0,0,1,146.93,22.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-924",
    d: "M130.94,27.47c.36-.37.71-.36,1.29-.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M129.45,27.72c-.64.21-.93.21-1.12-.16C128.68,27.25,128.89,27.61,129.45,27.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-635",
    d: "M138,34.11l1.29-.21c-.38.52-.85.44-1.29.44-.08-.05-.1-.1-.08-.15S138,34.11,138,34.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-981",
    d: "M138,34.11a.88.88,0,0,1,0,.23l-1.21.22a1.48,1.48,0,0,0,0-.21C137.13,34,137.58,34.15,138,34.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M119.07,237.52a.49.49,0,0,1,.24.48c.15.24.89.1.48.72L115,237.3c.07-.21.32-.08.43-.22a8.87,8.87,0,0,1,2.71.47C118.44,237.67,118.77,237.94,119.07,237.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-982",
    d: "M119.79,238.72c.22-.49-.61-.29-.48-.72a15.13,15.13,0,0,1,3.9,1c-.92.31-1.54-.48-2.23-.06h-.24a.79.79,0,0,0-.71-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-983",
    d: "M116,238.72c.9-.39,1.51.2,2.52.72a4.92,4.92,0,0,1-2.52-.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-984",
    d: "M100.15,233.94a3.49,3.49,0,0,1,1.44,0,.74.74,0,0,1,0,.94A2.87,2.87,0,0,1,100.15,233.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-983",
    d: "M116,238.72c-.71.05-1.21-.45-1.8-.71.69,0,1.42-.07,1.8.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "M99.19,238c0-.15-.27-.32,0-.47a2.61,2.61,0,0,1,1.43.72h0C100.06,238.65,99.65,238.18,99.19,238Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-985",
    d: "M110.93,235.33c-.32,0-.71-.17-.92.26a4,4,0,0,0-1.5-.47,1.7,1.7,0,0,0,0-.22.34.34,0,0,1,.3-.12c.58,0,1.15.1,1.73.1a1,1,0,0,1,.32.14.2.2,0,0,1,.09.19Q111,235.33,110.93,235.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-986",
    d: "M113,236.54l.09-.41,1.19.46c0,.23,0,.36-.29.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-987",
    d: "M114,236.85l.29-.26,1.15.49-.43.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-988",
    d: "M124.34,240.61a1.58,1.58,0,0,1,1.11.25c-.4.45-.76-.05-1.11,0-.08,0-.11-.1-.08-.16S124.31,240.61,124.34,240.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-989",
    d: "M124.34,240.61v.24l-1.31-.3C123.55,240.2,123.94,240.44,124.34,240.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-990",
    d: "M101.6,234.88v-.94c.32,0,.47.17.49.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M120,238.72c.39-.38.62-.29.71.23C120.48,239,120.2,239,120,238.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-695",
    d: "M100.63,238.24c.23,0,.48,0,.54.32,0,0-.09.12-.14.12-.32,0-.38-.2-.4-.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-991",
    d: "M130.34,241.81l.52-.25c2.44.11,4.86.57,7.31.53,2.24.37,4.47-.26,6.71-.13a8.78,8.78,0,0,1,2.23.14c.46.29.25.55-.11.63a2.8,2.8,0,0,0-1.3.73,47.29,47.29,0,0,1-11.26-.9,1.5,1.5,0,0,1-.54-.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-992",
    d: "M156,244.22a2.9,2.9,0,0,1-2.41,0,6.13,6.13,0,0,0-1.42,0l-4.07-.25c-1-.11-1.94.21-2.87-.25.36-.66,1-.39,1.57-.52a2.57,2.57,0,0,1,.4.06,19.19,19.19,0,0,0,4.08.1.61.61,0,0,1,.35.07,6,6,0,0,0,2.31.19c-.32-.08-1,.06-1.57,0-.3,0-.67.08-.78-.36.13-.49.55-.54.93-.55a13.28,13.28,0,0,1,3.15.08.77.77,0,0,1,.31.19A2,2,0,0,0,156,244.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-993",
    d: "M146.9,243.48c-.56.14-1.21-.21-1.72.26a54.4,54.4,0,0,1-10.88-.93c-.31-.05-.58-.05-.4-.47,2.08.13,4.1.7,6.21.79,1.93.09,3.86-.24,5.78.1C146.3,243,146.68,242.91,146.9,243.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-994",
    d: "M138.71,249.23a.73.73,0,0,1-1.06.09.49.49,0,0,1,0-.42c.19-.4.58-.39.94-.36.54.05,1.12-.19,1.61.2C139.75,249.09,139.12,248.85,138.71,249.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-995",
    d: "M138.71,249.23c.26-.82,1-.29,1.45-.49C139.83,249.33,139.25,249.21,138.71,249.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-996",
    d: "M130.32,249.5l.22-.22,1.48.28C131.43,249.7,130.85,249.91,130.32,249.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-997",
    d: "M225.2,103.51a2.55,2.55,0,0,1-.37,1.46,2,2,0,0,1-.37-1,4.45,4.45,0,0,0-.44-1.67c-.1-.19-.46-.59.16-.69.33.55.66,1.1,1,1.66A.62.62,0,0,0,225.2,103.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-998",
    d: "M230.19,116.91l-.19,0c.1-.56-.65-1.09,0-1.66.22.27.57.48.49.92C230.55,116.47,230.79,116.83,230.19,116.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-999",
    d: "M229,113.59a1.35,1.35,0,0,1,.52.92c-.07.09-.1.42-.23.2A4,4,0,0,1,229,113.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1000",
    d: "M227.5,109.63c.29.17.39.37.2.68C227.55,110.1,227.29,110,227.5,109.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1001",
    d: "M230.19,116.91c.31-.18.24-.49.27-.76l.23.25a.9.9,0,0,1,0,1l-.22,0A.56.56,0,0,1,230.19,116.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1002",
    d: "M211.16,204.86c-.17-.36-.08-.6.15-.65s.14.17.09.29S211.28,204.68,211.16,204.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-852",
    d: "M207.44,209.76h-.27a1.72,1.72,0,0,1,1-1.11C208.09,209.2,207.6,209.39,207.44,209.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1003",
    d: "M192.12,203.06c1.33-.4,1.31-2,2.39-2.64q0,8.46,0,16.92c0,.45-.32,1.09.47,1.28-.13.84-1,.78-1.48,1.19-.49.22-1,.56-1.54.34-.51-.41-.46-1-.47-1.54,0-4.3,0-8.6,0-12.9A4.81,4.81,0,0,1,192.12,203.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1004",
    d: "M193.53,219.56l1.47-.94,2.31-1.25c.88.08.75.8.85,1.36.06.4-.12.89.46,1.05.42.84-.19,1.35-.72,1.65a8.89,8.89,0,0,0-2.4,2.25c-.25.3-.49.65-1,.53a1.1,1.1,0,0,1-.74-1A29.71,29.71,0,0,1,193.53,219.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1005",
    d: "M198.57,219.81c-.37.25-.73.6-.71-.28s.24-1.6-.55-2.16l1.34-1.36,2.6-1.21c.86.1,1.45-.49,2.12-.85.29.59-.34.86-.45,1.31s-.56.74-.74,1.18a6.09,6.09,0,0,0-2,2.09A2.63,2.63,0,0,1,198.57,219.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1006",
    d: "M223.74,75.53l-.08,0h-.07c-.93-.16-.81.5-.81,1,0,4.53,0,9.06,0,13.59a11.93,11.93,0,0,0,.21,3.67c.14.44-.18.84-.22,1.27a.24.24,0,0,1-.3,0,6.73,6.73,0,0,1-.66-1.09c.25.43.41.91.66,1.34.14.27.26.55.41.83s.23.54.37.8L223,99.72c-.66-.11-.69-.71-.92-1.16a4.86,4.86,0,0,0-.74-1.79,2.42,2.42,0,0,0-.47-1.16c-.51-.25-.76-.61-.5-1.19a.82.82,0,0,0,.09-1.18,3.4,3.4,0,0,1-.56-2.37q0-10.56,0-21.12a2,2,0,0,1,.46-1.66c.35-.17.45.16.63.31s.49.53.71.82a5,5,0,0,0,.74.93,9.78,9.78,0,0,0,.75.95,11.57,11.57,0,0,1,.94,1.27,1.73,1.73,0,0,1,.27.79.49.49,0,0,1-.23.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M214.63,60.91c.41.68,1.35,1,1.4,1.92-.06.61.95.86.54,1.59a6.78,6.78,0,0,0-.14,1.55c0,5.62,0,11.23,0,16.85a3,3,0,0,0,.62,1.76c.38.58.94,1.12.72,1.93h-.26c-1.11-.38-1.29-1.59-2-2.28a3.53,3.53,0,0,0-.48-1c-.39-.62-.91-1.13-1.34-1.71a2.25,2.25,0,0,1-.74-1.58c-.12-5.93,0-11.85,0-17.77,0-.71-.13-1.56.78-1.95Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M217.74,86.51a3.17,3.17,0,0,0-.43-.84c-1.44-1.35-1.25-3.1-1.24-4.82,0-5.16,0-10.32,0-15.48,0-.5-.14-1.06.47-1.35,1,.41,1.83.91,1.94,2.1a6.61,6.61,0,0,0-.27,2.12q0,8.9,0,17.8C218.2,86.14,218.72,87.2,217.74,86.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1007",
    d: "M217.47,93.7c-.52.5-.42,1.15-.45,1.77,0,.46.19,1-.24,1.34a.68.68,0,0,1-.77-.18c-.62-.68-1.18-1.41-1.74-2.14-.22-.34-.45-.66-.65-1a2.09,2.09,0,0,1-.35-1.42c.2-1.31-.12-2.64.22-4,.2-.35.5-.33.82-.19a5.78,5.78,0,0,1,.67.53c.24.18.34.55.74.5.49.32.1,1.3,1,1.32.2.06.4.17.43.37a3.19,3.19,0,0,0,.63,2C218,92.94,217.85,93.43,217.47,93.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1008",
    d: "M210.55,79.63c1.75,1.8,3.17,3.89,5,5.61a1.2,1.2,0,0,1,.48.8.7.7,0,0,0-.68.47c-.34.14-.47-.16-.67-.3a1.84,1.84,0,0,1-.28-.39,4.43,4.43,0,0,0-1.27-1.55c-.63-.48-1-1.22-1.66-1.66l-.2-.24a13.07,13.07,0,0,1-1.1-1.36,1.16,1.16,0,0,1-.08-.32A1.07,1.07,0,0,1,210.55,79.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1009",
    d: "M217.47,93.7c0-.52.49-1.14-.45-1.43-.37-.12-.3-.59-.12-.94a.66.66,0,0,0-.35-1c-.24-.41-.38-.79.25-1h.06c.41.38.56,1,1.12,1.23.41.88,1.21,1.55,1.42,2.54a.14.14,0,0,1,0,.1l-.2,0c-.57.23-.71.89-1.21,1.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1010",
    d: "M216.13,96.56l.65.25c0,.31,0,.63,0,.94a3.94,3.94,0,0,1-.5,3.64l-.26,0c-.31-.26-.18-.62-.22-1-.29-.9.66-1.57.48-2.46l-.5-1.34C215.88,96.45,216,96.44,216.13,96.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1011",
    d: "M218.49,66.12a7.92,7.92,0,0,0-1.94-2.1c0-.46-1-.52-.52-1.19l1.67,1.64c.36.21.63.54,1,.72a.63.63,0,0,0,.22.07l.52.71a.61.61,0,0,1,.11.49c-.08.17-.18.3-.39.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1012",
    d: "M216.8,89.38c-.36.25-.22.63-.25,1-.18.69-.46.18-.54,0a12.74,12.74,0,0,1-.46-1.4c-.23-.22-.53-.39-.54-.76a2.19,2.19,0,0,1,.2-.8c.1-.15.21-.26.41-.17l.47.74c.22.41.28.91.7,1.21A1.55,1.55,0,0,1,216.8,89.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1013",
    d: "M220.37,94.42c.16.4.33.79.5,1.19,0,.24,0,.47-.05.84-.5-.73-1.54-.94-1.36-2a.51.51,0,0,1,.67-.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1008",
    d: "M217,87.25c.62.29.76,1,1.24,1.41.31.21.54.51.86.71s.2.58,0,.75-.42-.13-.54-.28A10,10,0,0,1,217,87.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1014",
    d: "M218.54,100.86l-.08.24c-.52-.24-.53-.88-1-1.19h0a1.2,1.2,0,0,1-.41-.92.59.59,0,0,1,.12-.31c.46-.13.54.31.78.52C218.55,99.64,218.43,100.29,218.54,100.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1015",
    d: "M217.27,98.73V99c-.08.4.09.84-.23,1.2s-.05.76,0,1.13c-.58-.2-.44.28-.51.54-.08-.15-.15-.31-.23-.46a10.72,10.72,0,0,0,.5-3.64c.25.19.21.47.23.73C217.13,98.55,217.26,98.58,217.27,98.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1016",
    d: "M219.17,66.67l.3-.3a3.17,3.17,0,0,1,1.75,2c-.06.18-.14.32-.37.24s-.33-.32-.49-.49A4.77,4.77,0,0,1,219.17,66.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M222,102.05a2.57,2.57,0,0,1-.72-1.89l.48,0c.09.23.19.45.28.68C222.2,101.26,222.41,101.67,222,102.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-864",
    d: "M218,94.41c-.21-.8.87-.84.9-1.5.1.11.21.21.31.31-.4.2-.07.76-.47,1-.25.07-.3.35-.49.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1017",
    d: "M221.34,96.77c.77.32.85,1,1,1.73-.49.19-.39-.51-.76-.5l-.22-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1018",
    d: "M218,90.6c-.92.09-1-.62-1.12-1.23C217.54,89.5,217.74,90.07,218,90.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1019",
    d: "M215.62,87.21l-.27.27c-.61,0-.62-.53-.8-.91a.5.5,0,0,1,.31-.54l.5.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1008",
    d: "M216.79,89.16c-.81-.07-.7-.67-.7-1.21A1.5,1.5,0,0,1,216.79,89.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1020",
    d: "M219.13,89.37c-.54.08-.67-.35-.86-.71l.21-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1006",
    d: "M220.13,94.38l-.67.05a.42.42,0,0,1-.24-.48C219.55,94.05,220,93.94,220.13,94.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1021",
    d: "M217.27,98.73l-.24-.25c.77-.35.81.28,1,.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-864",
    d: "M218.69,94.42l.38,1.17a1.21,1.21,0,0,1-.64-.91C218.36,94.44,218.46,94.36,218.69,94.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1022",
    d: "M220.86,99c.69,0,.42.6.51,1A1.16,1.16,0,0,1,220.86,99Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1023",
    d: "M218.69,94.42l-.26.26-.21,0c.08-.25-.15-.81.49-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1024",
    d: "M192.12,203.06c-.49,5.24-.14,10.49-.22,15.73,0,.45-.31,1.1.49,1.27-.46,1.2-1.6,1.42-2.62,1.82a.66.66,0,0,1-.51-.09q0-7,0-14.11a2.63,2.63,0,0,0-.24-1.51c-.07-.22,0-.31.24-.24l.48-.49a5.79,5.79,0,0,1,.62-.45,3.75,3.75,0,0,0,.77-1,.89.89,0,0,1,.5-.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M183.74,210.72a1.69,1.69,0,0,0,.72-.68c.23-.36.4-.81,1-.76a2.68,2.68,0,0,1,.24,1.5c0,4.12,0,8.24,0,12.37a3,3,0,0,1-2.87,1,6.21,6.21,0,0,1-.25-1.87c0-3.52,0-7,0-10.55A1.44,1.44,0,0,1,183.74,210.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1025",
    d: "M189.26,221.79l.47-.06c.9-.23.76.5.79.94.1,1.11,0,2.22,0,3.34a7.51,7.51,0,0,0,.14,1.42c.22.57-.21.83-.52,1.17a10.73,10.73,0,0,1-2.07,1.68c-1.11.51-1.36.39-1.53-.79a8,8,0,0,0-.29-1.37,1.07,1.07,0,0,0-.5-1c-.25-.7.25-1.34.15-2,.19-.34-.14-.52-.25-.77a1.16,1.16,0,0,1,.21-1.18C187,222.62,188.24,222.5,189.26,221.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1026",
    d: "M185.9,223.19v1.4a.56.56,0,0,1-.28.4c-1,.4-2.08.72-3.09,1.16l-.31.14c-.49.12-.95.53-1.47.11-.21-.44-.44-.88-.14-1.37l2.17-.92,2.87-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1027",
    d: "M191.12,204a1.1,1.1,0,0,1-.65,1.28c-.31-.14-.23-.55-.5-.72l.24-.49.48-.24A.42.42,0,0,0,191.12,204Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1028",
    d: "M185.42,209.28l-1,.76-.26-.28a5.52,5.52,0,0,1,1-.81C185.69,208.71,185.44,209.1,185.42,209.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1029",
    d: "M190,204.51c.5,0,.48.37.5.72-.19.26-.47.22-.74.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1030",
    d: "M188.53,206.42l-.92.7a1.08,1.08,0,0,1,.69-.94A.26.26,0,0,1,188.53,206.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1031",
    d: "M188.53,206.42l-.23-.24c.31-.11.44-.93.95-.25l-.24.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1032",
    d: "M181.58,58.51h.48a4.68,4.68,0,0,1,3.29,1.89.63.63,0,0,1-.16.51,4.33,4.33,0,0,0-1.43-.23,15.63,15.63,0,0,1-1.91-.72h-.26A1.08,1.08,0,0,1,181.58,58.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1033",
    d: "M185.19,60.91v-.47a.9.9,0,0,1,1.25.62c-.61.13.15.4-.06.57v0C185.77,61.73,185.5,61.28,185.19,60.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1034",
    d: "M181.85,60a2.92,2.92,0,0,1,1.91.72c-.24.37-.49.07-.74,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1035",
    d: "M181.58,58.51c0,.48,0,1,0,1.44l-1.92-1a.82.82,0,0,1-.39-1.21c.3-.48.71,0,1.05.1S181.27,58.08,181.58,58.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1036",
    d: "M197.64,76.46a34.62,34.62,0,0,0,.23-5.76c.31-.12.49.09.7.24a1.45,1.45,0,0,1,.22.21,5.6,5.6,0,0,0,.45.4,7.11,7.11,0,0,0,1.45.92c.85.73,1.92,1.27,2.09,2.55a21.3,21.3,0,0,0-.27,4,1.86,1.86,0,0,1-.26,1.24c-.42.34-.75.07-1-.2C200,78.86,198.8,77.69,197.64,76.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M202.63,74.81a9.54,9.54,0,0,0-2.13-2.17c-.39-.25-.68-.61-1-.89a2.29,2.29,0,0,0-.87-.56h0a2.7,2.7,0,0,0-1-1c-1.45-1.34-3-2.56-4-4.4a15.23,15.23,0,0,1,2.91,2.26,3.71,3.71,0,0,0,2.23,1.42c.31.42.49,1,1.23.73h.21a1.81,1.81,0,0,0,1.19.5,5.86,5.86,0,0,1,1.49,1.36,6.33,6.33,0,0,0,1,2.27,1.2,1.2,0,0,1,.13.33c.05.38.05.74-.39.92C203.15,75.58,202.71,75.41,202.63,74.81Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1037",
    d: "M201.44,70.74c-.72.59-1,.24-1.19-.5,0-.08,0-.16,0-.25A1.65,1.65,0,0,1,201.44,70.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1038",
    d: "M200,70.25c-.89.56-1.16.09-1.23-.73C199.27,69.69,199.48,70.27,200,70.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1039",
    d: "M197.62,70.24a1,1,0,0,1,1,1l-.72-.5C197.79,70.55,197.7,70.4,197.62,70.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1040",
    d: "M219.42,181.29c.62.06.14.48.25.71-.14,0-.38.1-.4.07A.58.58,0,0,1,219.42,181.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1041",
    d: "M148.05,240.86c-.1-1,.37-2.09-.72-2.8.54-.37,1.14-.09,1.7-.18h1.52a9,9,0,0,1-1.16,0l-.13-.11c-.24-.29-.57-.21-.87-.23s-.6-.09-.51-.35c.37-1.06,0-2.14.16-3.2l3.08-.31c.37-.33.75-.57,1.17-.08a21.39,21.39,0,0,1-.06,7A4.76,4.76,0,0,1,148.05,240.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1042",
    d: "M148.51,233.25a21.74,21.74,0,0,1-6.65-.95l8.6-.56a3.71,3.71,0,0,1,1.72,0,1.07,1.07,0,0,1,0,1.26C151,233.65,149.75,233.26,148.51,233.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1043",
    d: "M148.05,229.34a23.64,23.64,0,0,0,6,.5.8.8,0,0,1,.12.92c-.21.36-.6.14-.88.27l-1.64.07c-.88.23-1.8-.09-2.68.18-.47-.1-1,.08-1.43-.19.53-.49.18-1.12.28-1.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1044",
    d: "M152.12,233v-1.24c-.08-.11-.05-.17.08-.18l1.13-.07a2.35,2.35,0,0,1,2.38-.31c.35.66.71,1.3,1.6,1.35a.41.41,0,0,1,.4.48c0,.3-.29.33-.53.36a12.78,12.78,0,0,0-2-.07C154.12,233.18,153.07,233.59,152.12,233Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1045",
    d: "M152.12,233l3.16,0c.21.12.32.27.13.5a4.31,4.31,0,0,1-3.29,0l-1,.15c-.8-.57-1.8.11-2.61-.41C149.71,233.09,150.94,233.39,152.12,233Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1046",
    d: "M155.71,231.28l-2.39.22c.06-.16.25-.34,0-.47l.76-.22a2.4,2.4,0,0,1,1.83-.3c.31,0,.78.06.76.41C156.58,231.42,156.13,231.41,155.71,231.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-989",
    d: "M133.68,234.14a12.84,12.84,0,0,1-4.09-.43l.24-.21c.28-.34.6,0,.9-.05a9.33,9.33,0,0,1,2.45.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-641",
    d: "M133.18,233.93a11,11,0,0,1-2.56-.29c.3-.63.79-.2,1.19-.22S132.88,233.34,133.18,233.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1046",
    d: "M149,231.28a8.06,8.06,0,0,1,2.68-.18C150.77,231.52,149.85,231.22,149,231.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1047",
    d: "M131.81,233.42c-.39.12-.84-.13-1.19.22l-.79-.14s-.09,0-.11-.05a.62.62,0,0,1-.1-.16A3.8,3.8,0,0,1,131.81,233.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1046",
    d: "M152.19,231.57a.75.75,0,0,0-.08.18h-1.65C151,231.35,151.61,231.59,152.19,231.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M163.62,52.54l-2.16-1a.23.23,0,0,1,0-.3,1.07,1.07,0,0,1,.82-.14l.33.07a3.58,3.58,0,0,0,1.81-.06c.84-.09,1.48.51,2.24.69a10.17,10.17,0,0,0,4.72,1.46,1.42,1.42,0,0,1,1.26.55,2.45,2.45,0,0,1-.17,2.29l-3.35-1.45a9.34,9.34,0,0,0-3.36-1.42A1.93,1.93,0,0,1,163.62,52.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1048",
    d: "M172.48,56.13l0-2.4a.23.23,0,0,1,0-.29,1.13,1.13,0,0,1,1.16.79l.23.22a1.75,1.75,0,0,1,.7.62,1.57,1.57,0,0,1-.43,1.78L173,56.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1049",
    d: "M168.4,66.9c-.22-.11-.71.24-.68-.22,0-.74.6-.24.93-.27a1.85,1.85,0,0,1,0,.23A.3.3,0,0,1,168.4,66.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1050",
    d: "M168.4,66.9l.26-.26c.29.06.6.07.76.38l-.29.14C168.87,67.12,168.58,67.17,168.4,66.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M174.16,56.85a5,5,0,0,0,.24-1.91c.27-.16.34.09.47.22h.49c.3.22.76,0,1,.42a.24.24,0,0,1,0,.29c0,2.19,0,2.19-2,1.14A.65.65,0,0,1,174.16,56.85Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1051",
    d: "M176.32,55.88v-.23a.37.37,0,0,1,.23-.23,2.18,2.18,0,0,1,1,.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1052",
    d: "M177.75,58l.68.4a1.08,1.08,0,0,1-1.15-.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M223.71,101.84c-.05-.22-.1-.45-.16-.68a.58.58,0,0,1,.63.46c-.36.38,0,.67.17.92a1.6,1.6,0,0,1,.11,1.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1053",
    d: "M222.77,96.34l-.46-.74c.13-.13,0-.39.25-.48h.22l.25.94C223.12,96.33,223,96.39,222.77,96.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1054",
    d: "M222.77,96.34l.26-.27a.71.71,0,0,1,.23,1A.72.72,0,0,1,222.77,96.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1055",
    d: "M224,100.16l-.45-1a1.14,1.14,0,0,1,.69,1C224.15,100.26,224.07,100.25,224,100.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1056",
    d: "M224,100.16h.24a.61.61,0,0,1,.29.62C224.14,100.73,224.13,100.38,224,100.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1057",
    d: "M182.52,57.64a26.9,26.9,0,0,1,3.14,1c1.3.7,2,2.08,3.17,2.91l-.52,0c-.39.2-.76-.23-1.15-.05a.69.69,0,0,1-.78-.45c-.22-.53-.82-.42-1.19-.69a13.61,13.61,0,0,0-3.13-1.93C182,58.13,182.35,57.92,182.52,57.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1058",
    d: "M176.55,55.42l-.23.23-1-.48A1.73,1.73,0,0,1,176.55,55.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1059",
    d: "M174.87,55.16l-.47-.22-.51-.49C174.35,54.51,174.8,54.57,174.87,55.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1060",
    d: "M186.38,61.13a1.42,1.42,0,0,0,.91.27,1.59,1.59,0,0,1,1,.49c.29.49,1.36.48,1,1.44l-2.87-1.7C186.51,61.47,185.56,61.3,186.38,61.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1061",
    d: "M189.53,78.61a2.44,2.44,0,0,1-1-.85.19.19,0,0,1,0-.32l.71.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1062",
    d: "M188.29,61.89a2.19,2.19,0,0,1-1-.49c.48-.58.67.2,1,.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1063",
    d: "M192.5,72.56c-.44,0-.58-.22-.76-.55C192.15,72,192.31,72.19,192.5,72.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1064",
    d: "M200.74,194.43c.25.16,0,.32,0,.49l-.37.07C200.26,194.66,200.54,194.57,200.74,194.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1065",
    d: "M143.53,238h-1.69c-.32-.34-1,.32-1.19-.44a39.89,39.89,0,0,1,5.78.19C145.49,238.11,144.48,237.69,143.53,238Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-696",
    d: "M143.53,238c.93-.44,1.94,0,2.9-.24l2.83,0,0,0c.09.06.12.11.08.15a.18.18,0,0,1-.11.05l-1.87.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1066",
    d: "M140.65,237.53c.28.46.89,0,1.19.44a22.32,22.32,0,0,1-4.82-.47c-.07,0-.09-.09-.07-.13s.05-.07.07-.07A17,17,0,0,0,140.65,237.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1067",
    d: "M137,237.3a.67.67,0,0,1,0,.2,4.33,4.33,0,0,1-2.17-.19c0-.15.18-.17.26-.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1068",
    d: "M133,236.76c-.34,0-.7.11-1-.19C132.41,236.23,132.76,236.16,133,236.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-957",
    d: "M135.11,237.05l-.26.26-.92-.07.26-.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1069",
    d: "M202.92,215.26c-.16-.54.37-.85.45-1.31l.42-.6,1.64-1A13.13,13.13,0,0,1,202.92,215.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1070",
    d: "M163.62,52.54l2.15.72a2.65,2.65,0,0,0-.23,1.5V65.21a2.81,2.81,0,0,1-2.4-.72c0-3.43,0-6.87,0-10.31A2.29,2.29,0,0,1,163.62,52.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1071",
    d: "M163.14,64.49c.88,0,1.57.58,2.4.72.46.2.93.39,1.39.6.21.09.46.18.31.51s-.32.28-.58.18l-2.32-.81c-.37-.42-.94-.49-1.36-.81S162.88,64.54,163.14,64.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1072",
    d: "M218.49,169.34c0-.23-.46-.16-.36-.49.42,0,0-.73.51-.69A1.25,1.25,0,0,1,218.49,169.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1073",
    d: "M220.6,169.12c0,.39.05.78.08,1.17C220.21,169.93,220.31,169.53,220.6,169.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1074",
    d: "M218.64,168.16c-.24.18-.1.64-.51.69.14-.32,0-.74.32-1C218.51,168,218.57,168.06,218.64,168.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1075",
    d: "M147.31,242.37l-8-.09a2,2,0,0,1-1.16-.19h3c-.35-.42-.73-.19-1-.27.09-.75.66-.06.87-.4-1.28.59-2.63-.52-4,.16l-.51-.24c0-.65.77-.31,1-.7a6.36,6.36,0,0,0,2.17.24,9.94,9.94,0,0,0,2.83.1c3,0,6,.14,8.92-.09.48,0,.91-.32,1.4-.22a.49.49,0,0,1,.38.4c0,.66-.88.42-1.07.93a1.69,1.69,0,0,1-1.61.64C149.46,242.52,148.35,242.92,147.31,242.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1076",
    d: "M153.08,240.88c-4.12.48-8.26.12-12.4.22-.34,0-.73.11-1-.22l8.37,0a20.52,20.52,0,0,0,4.07-.24,1.64,1.64,0,0,1,1.9,0C153.93,241.37,153.49,241.07,153.08,240.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1077",
    d: "M130.81,237.52a1.85,1.85,0,0,1,1.36.31,5.35,5.35,0,0,1-2,.18l.6-.49Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1077",
    d: "M130.81,237.52l-1.7.22c.54-.32,1.08-.76,1.7-.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M162.42,51.33h-1c-.61.42-.67-.25-1-.48l-.24-.24-1-.48c.26-.78-.54-1.77.48-2.39.2-.52-.41-.25-.48-.49V34.6c.58-.52,1.26-.33,1.92-.27a16,16,0,0,0,2.58.17c.38.06,1-.15,1,.64-.15.06,0,0-.1.07-1.87.63-1.87.63-1.87,2.64,0,3.89,0,7.78,0,11.67C162.79,50.14,162.92,50.81,162.42,51.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1078",
    d: "M160.51,50.86c.54-.28.42.75,1,.48v.23a3.92,3.92,0,0,1-1.44-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1079",
    d: "M180.61,225a4.42,4.42,0,0,1,.25,1.48,1.42,1.42,0,0,1-.05.16.76.76,0,0,1-.35.29,1.44,1.44,0,0,0-.33.16c.11,0,.22-.07.33-.08a.69.69,0,0,1,.44.13,2.79,2.79,0,0,1,.39,2.56c-.15.26-.33.48-.68.41-.21-.23-.25-.88-.78-.35-.79.77-1.82,1.38-2,2.65a1.4,1.4,0,0,1-.83,1.07c-.41.25-.83.48-.8,1.06a.53.53,0,0,1-.47.48c-.4,0-.57-.25-.65-.6a47.87,47.87,0,0,1-.52-8.2l2-.68,2.89-.81c.15.13-.56.53.14.47A7.35,7.35,0,0,0,180.61,225Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-744",
    d: "M183.74,210.72l-1.2,1c-.52.23-.82.87-1.61.85a13.43,13.43,0,0,1,2.6-2.12C183.67,210.3,183.72,210.57,183.74,210.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1080",
    d: "M239.17,137l-.16-1.41c-.32.18-.12.5-.22.74a.25.25,0,0,1-.31-.07,3.6,3.6,0,0,1-.34-1c0-.32-.06-.63.24-.84.54-.72-.15-1.68.45-2.39v1a7.38,7.38,0,0,1,.1,1.83c.17-.41-.18-1,.14-1.6h.22c.33.6-.07,1.29.23,1.89v.27C239,135.78,240,136.59,239.17,137Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M238.38,134.37v1c0,.7.35,1.4,0,2.11a.29.29,0,0,1-.38,0,5.57,5.57,0,0,1-.18-2.11c.15-.48-.34-1.17.46-1.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M236.9,136.29c0-.87,0-1.75,0-2.63h.14a2.91,2.91,0,0,1,.1,1.91c0,.27,0,.54,0,.81,0,.11,0,.22-.18.12S236.92,136.37,236.9,136.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1081",
    d: "M238.36,130.08h.44a1.74,1.74,0,0,1,0,1.43h0C238,131.26,238.5,130.56,238.36,130.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1082",
    d: "M238.33,133.94c-.45.4-.09.95-.25,1.41a.2.2,0,0,1-.31-.11,5.43,5.43,0,0,1,0-.57c.07-.58-.14-1.17.13-1.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1083",
    d: "M237.18,135.57c0-.64-.06-1.27-.1-1.91,0-.15.07-.31.1-.47.43.77.13,1.59.19,2.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1084",
    d: "M238.1,127.91c.09-.34.09-.72.5-.88,0,.45,0,.9,0,1.35a.27.27,0,0,1-.44,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1085",
    d: "M237.88,133l0,1.89c-.07.12-.14.13-.21,0l0-1.91c-.09-.24,0-.28.23-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1086",
    d: "M238.14,128.39h.44c0,.42.16.89-.24,1.24A1.81,1.81,0,0,1,238.14,128.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1087",
    d: "M238.08,125.07c0,.31,0,.62,0,.92s.09.7-.23,1l-.06-.88C237.92,125.74,237.74,125.35,238.08,125.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M237.7,122.66c-.16.36.1.83-.28,1.14,0-.3-.06-.6-.1-.9s.12-.34.17-.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1083",
    d: "M237.85,132.71l-.23.23h-.24v-1C237.82,132.1,237.84,132.4,237.85,132.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1088",
    d: "M167.49,228.08l1-.33c1,.05,1.83-.48,2.78-.53.67.11.53.68.61,1.11a29.7,29.7,0,0,1,.25,5,5.74,5.74,0,0,0,.08,1.31,1.19,1.19,0,0,1-.06.59.89.89,0,0,1-.4.39,3.21,3.21,0,0,0-1.59,1.39c.53-.09.93-.56,1.5-.5.38.22.35.57.29.94a1.62,1.62,0,0,1-.34.63,2.82,2.82,0,0,1-.89.59c-.59,0-1.18.29-1.7.19a17.61,17.61,0,0,0,2.2-.22c.59,0,.81.25.74.81a.78.78,0,0,1-.19.33,4.92,4.92,0,0,1-3.22.46c-.84,0-.45-.92-.85-1.27a8.34,8.34,0,0,1-.27-3.58,3.91,3.91,0,0,1,.3-.83.73.73,0,0,1,.21-.22c0-.05.48.06.07-.18a1.17,1.17,0,0,1-.24-.21,3.36,3.36,0,0,1-.41-2.19A18,18,0,0,1,167.49,228.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1089",
    d: "M171.52,235.37l.49,0,.13.07a.76.76,0,0,0,.59,0c.72-.18.09-.43,0-.56s-.47.16-.72,0c-.47-1.07-.19-2.19-.22-3.28a18,18,0,0,0-.51-4.39,1.09,1.09,0,0,1,0-.17c.31-.64.91-.48,1.44-.5l1.84-.3c.65,1.12.24,2.39.44,3.58.24,1.49.11,3.06.32,4.58-.43.07-.65-.41-1.16-.43.37.64.62,1.28,1,1.87a5.69,5.69,0,0,0,0,2.53,10.2,10.2,0,0,1-2.28,1.16,1,1,0,0,1-1.1-.09c0-.31.09-.75-.5-.5-.1-.21-.63,0-.46-.48a.7.7,0,0,1,.7-.47,2,2,0,0,1,1-.43c.05,0-.13-.23-.08-.07s0,.08-.06.1c-.22.05-.44.11-.63-.09,0-.33.11-.7-.24-.95S171.28,235.77,171.52,235.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1090",
    d: "M172.68,226.25a.58.58,0,0,0-.17.06,1,1,0,0,1-1.25.26c-.1-.08-.5-.08-.14-.29a4.3,4.3,0,0,1,1.11-.28C172.47,225.91,172.72,225.82,172.68,226.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1091",
    d: "M171.26,226.57l1.25-.26.25.24-1.44.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1092",
    d: "M172.68,226.25l-.45-.25c.2-.23.47-.19.73-.22l1,.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1093",
    d: "M236.43,106.17a1.48,1.48,0,0,1,0,.21c-.28.16-.37-.14-.55-.23a6.53,6.53,0,0,1-.62-2.63A4.07,4.07,0,0,1,236.43,106.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1094",
    d: "M235.89,106.15l.55.23c.07.39.15.78.23,1.18C235.81,107.42,236,106.68,235.89,106.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M234.52,109c-.56-.23-.45-.72-.44-1.17A1.46,1.46,0,0,1,234.52,109Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1095",
    d: "M203,81.73l-1.11-1.39c.5-.34.3-.85.31-1.29.05-1.43-.15-2.88.46-4.24l1,.71a2.93,2.93,0,0,1,1.11.83c.26.28.55.54.82.82a1.25,1.25,0,0,1,.36,1c0,1.6,0,3.19,0,4.78a2.43,2.43,0,0,1-.21,1.27c-.21.21-.36.24-.38-.12l-.44-.49c-.38-.1-.53-.46-.78-.71l-.23,0C203.54,82.52,203,82.29,203,81.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1096",
    d: "M203,81.73a1.66,1.66,0,0,1,.87,1.18c-.7-.12-1-.67-1.4-1.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1097",
    d: "M206.26,85.31l-.28.3c-.37-.43-1-.72-.69-1.48l.24.24C206,84.52,206.34,84.75,206.26,85.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1098",
    d: "M204.07,82.93a1.59,1.59,0,0,1,.78.71C204.24,83.79,204.2,83.32,204.07,82.93Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1099",
    d: "M167.69,235.13a22.83,22.83,0,0,0,.24,4.05c0,.73-.69.63-1.07.92a3.57,3.57,0,0,1-1,.55c-.34,0-.67.14-1,.2a1.15,1.15,0,0,1-.52-.06,2.59,2.59,0,0,1-1-2.06,2.63,2.63,0,0,0-.25-1.14.53.53,0,0,1,.36-.66c.77-.2.15-.5.08-.76a17.09,17.09,0,0,1,.09-7l.25-.21a1.25,1.25,0,0,0,1.37-.73c.38-.65,1.46-.62,2.26-.1.44,1.34.14,2.72.18,4.08a3.87,3.87,0,0,0,.5,2,.14.14,0,0,1,.05.16s0,.08-.06.08h-.23a7.36,7.36,0,0,1-1.62.94C166.87,235.13,167.23,234.71,167.69,235.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1100",
    d: "M210.8,94.65c-.29-.35-.67-.65-.68-1.22a1.21,1.21,0,0,1,.68,1.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M211.27,96.61c.17.23.35.45.52.67,0,.13-.07.41-.23.29S210.92,97.06,211.27,96.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1101",
    d: "M212,97.76c.3.18.67.46.32.77s-.54-.15-.57-.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1102",
    d: "M209.15,94a1.23,1.23,0,0,1,.64,1.09A1.48,1.48,0,0,1,209.15,94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M50.32,122.65c.28-1.36.18-2.8.77-4.11a23.5,23.5,0,0,1-.52,4.35c-.08.11-.16.11-.23,0A1.94,1.94,0,0,0,50.32,122.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M50.13,133.7c-.12-.2-.64.19-.54-.41a10.57,10.57,0,0,0,0-1.78,2.19,2.19,0,0,1,.67,2.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M50.23,128.67a3.23,3.23,0,0,1-.29,2.41A4.67,4.67,0,0,1,50.23,128.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M49.59,123.36a3.47,3.47,0,0,1,0-2.61c0,.64,0,1.27.05,1.9C49.62,122.89,49.6,123.12,49.59,123.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M50.34,122.89h.23V125h-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1103",
    d: "M47.16,154.49c-1-.15-.17-.82-.33-1.22.13.25.26.49.38.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1104",
    d: "M117.64,235.36c0-.32.22-.64,0-1,1.23.07,2.31.89,3.58.72,0,.22.13.38.38.36l.29.09a6.08,6.08,0,0,1,1.75.26c.13.49.61.42.92.65-1.84-.11-3.6-.82-5.45-.88C118.6,235.61,118.06,235.82,117.64,235.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1105",
    d: "M123.62,235.07l-.22.28c-.48.67-1.1.35-1.7.25h0c-.09-.06-.11-.11-.08-.16s.06-.07.09-.07h1c-.05-.38-.55-.2-.55-.65A3,3,0,0,1,123.62,235.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-940",
    d: "M122,233.28a3.4,3.4,0,0,1-2.21-.43A2.94,2.94,0,0,1,122,233.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-948",
    d: "M117.17,234.17c-.44-.17-.82-.38-.73-.95C116.88,233.38,117.23,233.62,117.17,234.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1106",
    d: "M125.74,234.14l-1.36-.33C125,233.67,125.32,233.59,125.74,234.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1107",
    d: "M125.72,234.83l-1.11-.23A.76.76,0,0,1,125.72,234.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1108",
    d: "M116.3,232c.1-.16.24-.14.38-.07s.31.09.22.28-.2.06-.31.05S116.3,232.18,116.3,232Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1109",
    d: "M121.72,235.38a1.69,1.69,0,0,0,0,.23c-.25-.06-.54.13-.73-.12,0,0,.15-.24.23-.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1110",
    d: "M163.61,229.12c.12,2.48-.23,5,.25,7.44-.12.38-.51.41-.78.6s0,.25.06.36c.34,0,.52.24.47.56a3.61,3.61,0,0,0,.77,2.57c-.21.73-.91.5-1.39.69s-.86.13-1.28.24a4.83,4.83,0,0,1-1,.09h-1.62a6.77,6.77,0,0,1-1.62-.11c-.2-.08-.37-.2-.36-.44a.8.8,0,0,1,.51-.29c.79-.12,1.6,0,2.39-.07a.44.44,0,0,1-.43-.28,5.26,5.26,0,0,1-.19-2.89c.1-2.57.13-5.15,0-7.73a2,2,0,0,1,0-.59c.44-.24,1,0,1.42-.36l1.14,0c.25.07.38.47.73.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M162.66,229.15a1.39,1.39,0,0,1-.39.22c-.18,0-.45.06-.55,0s.52-.1.21-.44a1,1,0,0,1,.95-.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1112",
    d: "M212.54,93.68a.49.49,0,0,1,0-.21.74.74,0,0,1,.51-.27,1.08,1.08,0,0,1,.9.3c.18.27.48.48.48.86.22.59,1,1,.72,1.74-1-.46-1.41-1.48-2.2-2.15C212.8,93.86,212.64,93.82,212.54,93.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-971",
    d: "M215.12,96.1c0-.68-.7-1.07-.72-1.74a9.72,9.72,0,0,1,1.73,2.2l-.33,0C215.47,96.58,215.36,96.26,215.12,96.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M212.54,93.68c.17,0,.33.08.38.27a.3.3,0,0,1-.08.08c-.26.31.46.83-.12,1s-.49-.5-.71-.78C212.44,94.29,212.51,94,212.54,93.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1113",
    d: "M216.3,98c.26.9-.4,1.63-.48,2.46C215.11,99.42,216.23,98.79,216.3,98Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M57.77,179.12l-.24.24-2.11-4.08.21-.28a.13.13,0,0,1,.2,0l.25.5A33.41,33.41,0,0,0,57.77,179.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1114",
    d: "M48,152.53c0-.39,0-.77,0-1.16A.82.82,0,0,1,48,152.53Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1115",
    d: "M159.37,229.28c.51.24.42.71.42,1.14,0,2.39.09,4.79,0,7.18a17.9,17.9,0,0,0,0,3,.72.72,0,0,1-.66.23,2.1,2.1,0,0,1-1-.37c-.28-.22-.36-.73-.88-.65-.86.11-1.13-.38-1.13-1.13a2.35,2.35,0,0,1,.21-1.38c.26-.25.57-.11.79-.14-.2-.1-.56.09-.8-.18-.16-1.27-.88-2.53,0-3.79a.77.77,0,0,1,.8,0c.1,0,.29,0,.31-.1.16-.4-.19-.38-.38-.35-1.16.15-1.48-.45-1.35-1.47l1-.47H154v-1l1.44-.09,1.43.07A7.76,7.76,0,0,1,159.37,229.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1116",
    d: "M117.64,235.36c.48.08,1-.17,1.46.25l-.27.25c-.24.08-.4.4-.72.22h-.74c-.24-.15-.48,0-.72,0-1.09-.47-2.25-.1-3.36-.26-.53-.43-1.41-.33-1.67-1.15l5.77.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1117",
    d: "M111.62,234.67c.49.49,1.4.36,1.67,1.15h-.17c-.26-.12-.55,0-.81-.15-.46-.16-.91-.36-1.38-.53h-.27c-.13-.3-.11-.51.28-.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1109",
    d: "M121.7,235.6a2.92,2.92,0,0,0,1.7-.25l1,.47-.76,0A2.23,2.23,0,0,1,121.7,235.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1118",
    d: "M118.11,236.08l.72-.22c-.16.22-.15.62-.54.59C118.22,236.44,118.17,236.21,118.11,236.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1119",
    d: "M116.65,236.08c.24-.28.48-.33.72,0C117.13,236.19,116.89,236.44,116.65,236.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1120",
    d: "M112.38,235.59c.26,0,.55,0,.73.23l-.24.2-.72-.25C112.13,235.58,112.17,235.47,112.38,235.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M52.45,175.56c1.34.1,1.21,1.37,1.71,2.14A3.07,3.07,0,0,1,52.45,175.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1121",
    d: "M51.53,178.89a.49.49,0,0,1,0-.24c.35.5.94.93.5,1.66C51.8,179.86,51.28,179.51,51.53,178.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1122",
    d: "M51.53,178.89c.17.48.33,1,.5,1.42a1.43,1.43,0,0,1-.73-1.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1123",
    d: "M53.47,182.51l-.3.69a.44.44,0,0,1-.13-.61C53.14,182.41,53.28,182.27,53.47,182.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1124",
    d: "M222,102.05c0-.4,0-.79,0-1.19a1.5,1.5,0,0,1,.45,1.28C222.51,102.33,222.5,102.33,222,102.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1125",
    d: "M200.76,99.43a.53.53,0,0,1-.27.5,6.56,6.56,0,0,1-1.07-2.22C200.29,98.22,200.42,98.91,200.76,99.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1126",
    d: "M200.74,100.39c.17-.27.44-.23.7-.21-.05.15-.11.31-.17.47s-.15.22-.3.24A.55.55,0,0,1,200.74,100.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1127",
    d: "M201,100.89l.3-.24c.06.31.12.63.17.94A.78.78,0,0,1,201,100.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1128",
    d: "M227.58,75.22a33,33,0,0,1,3.51,5,27.93,27.93,0,0,0,2.77,4c.13.42-.09.58-.46.63a1.63,1.63,0,0,1-1.15-.82,11.07,11.07,0,0,0-2.27-3.4l0-.31c-.55-.45-.72-1.16-1.12-1.71-.2-.37-.49-.67-.7-1s-.71-.77-1-1.25a1.3,1.3,0,0,1,0-.34A1,1,0,0,1,227.58,75.22Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1129",
    d: "M232.42,83.87l-.56-.22h0c-.39-.13-.39-.7-.84-.75-.36-.78-.71-1.56-1.07-2.35A5.29,5.29,0,0,1,232.42,83.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1130",
    d: "M224.17,73.6l.07-.44a.63.63,0,0,1,.55-.37,2.05,2.05,0,0,1,1.22,2.1l-.12.13C225.49,74.34,224.34,74.56,224.17,73.6Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1131",
    d: "M227.29,76.23a2.47,2.47,0,0,1,1,1.18c.09.4-.08.54-.46.45-.22-.49-.73-.82-.75-1.42C227,76.25,227.12,76.2,227.29,76.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1132",
    d: "M227.29,76.23l-.2.21a3.31,3.31,0,0,1-1.2-1.42v0c1.12-.68,1.13.36,1.44.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1133",
    d: "M229,78.44c.31.61.63,1.21,1,1.81-.69-.21-.84-.9-1.22-1.39C228.67,78.64,228.55,78.37,229,78.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1134",
    d: "M229,78.44c-.21.07-.23.25-.27.42l-.87-1,.46-.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1135",
    d: "M123.63,19.76a1.54,1.54,0,0,1-1.66,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1136",
    d: "M234.53,87c-.14-.91-.91-1.52-1.18-2.37a.49.49,0,0,0,.51-.47l.62.67a1.76,1.76,0,0,1,.27,1c.09.54.18,1.08.26,1.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1137",
    d: "M234.75,85.79a.76.76,0,0,1-.27-1l.31.09.47.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1138",
    d: "M116.94,249.7l-.27-.21c.22-1,1-.64,1.66-.7.4,0,.81.34,1.21,0h.24a1.52,1.52,0,0,0,1.29.5,1.15,1.15,0,0,1,.31.11c.41.2.91,0,1.28.35l.48.25c.15.62-.46.47-.69.69h-1.19c-1.2-.32-2.45-.34-3.66-.63A.93.93,0,0,1,116.94,249.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1139",
    d: "M119.54,248.77c-.12.69-.57.44-1,.34a1.83,1.83,0,0,0-1.89.38,2.29,2.29,0,0,1-1.43-.27c.4-.6-.35-.61-.48-.93a.8.8,0,0,1,.55-.26c1.32.26,2.65.48,4,.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1140",
    d: "M119.28,248.76a11.17,11.17,0,0,1-4-.5c-.31-.14-.5-.33-.26-.68C116.41,248,118,248,119.28,248.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1141",
    d: "M115,247.58c.09.23.17.46.26.68l-.5,0-1.18-.5,1-.49C114.73,247.34,114.91,247.38,115,247.58Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1142",
    d: "M120.29,248.79c.69.32,1.51.26,2.17.7a1.43,1.43,0,0,1-1.23,0h0C121,249.09,120,249.83,120.29,248.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1139",
    d: "M120.29,248.79c0,.67.75.29.94.69-.53-.14-1.42.44-1.45-.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1139",
    d: "M121.23,249.48h1.43v.25C122.18,249.65,121.64,249.92,121.23,249.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1143",
    d: "M126.73,239.92c0-.24.08-.47.4-.44.05,0,.15.09.14.12-.06.29-.32.29-.54.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-931",
    d: "M137.05,241.58c.11-.69.66-.5,1-.45a20.18,20.18,0,0,0,3.38.23c-.48.4-1,0-1.32.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-921",
    d: "M117.63,249.74c1.23.26,2.52.22,3.63.93a10.38,10.38,0,0,1-3.38-.23C117.67,250.25,116.93,250.25,117.63,249.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1144",
    d: "M117.63,249.74c-.28.36.12.48.25.7l-.72.24c-.25-.86-1-.32-1.45-.48l-.48,0c.46-.57,1.27.19,1.71-.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1145",
    d: "M124.33,251.18l-.21.43c-.44-.06-.88-.11-1-.65C123.55,250.84,123.92,251.12,124.33,251.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1146",
    d: "M122.45,250.67l.69-.69.26,0a.31.31,0,0,1,0,.46c-.19.29-.49.21-.77.24h-.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1147",
    d: "M57.08,193l-.78-.89c-.24-.88-.47-1.76-.7-2.65l.23.06c.45.59.79,1.25,1.22,1.86l.23.23v.23C57.2,192.18,57.43,192.62,57.08,193Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1148",
    d: "M57.05,191.34a3.69,3.69,0,0,1-1.22-1.86l.47.15C56.37,190.28,57,190.67,57.05,191.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1149",
    d: "M123.38,250.46c0-.15,0-.3,0-.46.27-.07.47.11.68.21C123.93,250.53,123.63,250.43,123.38,250.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M74.05,201.14l-.22.23c-.25-.31-.5-.63-.76-.94C73.67,200.29,73.76,200.86,74.05,201.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M239.08,133.19v1.64h-.24V133Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-598",
    d: "M238.82,131.51c0-.48,0-1,0-1.43,0-.17.07-.34.11-.51l.15.24C239,130.38,239.28,131,238.82,131.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1150",
    d: "M239.53,135.07c-.45-.58-.12-1.26-.23-1.89l.25-.23C239.54,133.66,239.54,134.37,239.53,135.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-865",
    d: "M239.41,131a1.1,1.1,0,0,1,.06.9A.86.86,0,0,1,239.41,131Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-723",
    d: "M237.64,134.85h.21c0,.17,0,.34,0,.51a6,6,0,0,1,0,2.6l-.21,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1148",
    d: "M234,87.7c0-.36,0-.68.48-.7-.15.33.31.63.05,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1151",
    d: "M219.23,109.48h.12c.17.34.59.53.6,1l-.48-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1152",
    d: "M238.6,136.3h.19c0,1.17,0,2.34,0,3.51h-.45c0-.13,0-.25,0-.38A12.1,12.1,0,0,1,238.6,136.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1153",
    d: "M217,100.18c.06-.41-.18-.87.23-1.2a1.63,1.63,0,0,1,.26.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1154",
    d: "M237.85,138c0-.86,0-1.73,0-2.6h.19c0,.71,0,1.43,0,2.14a1,1,0,0,1,0,1.2l0,0C237.81,138.49,237.89,138.2,237.85,138Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1155",
    d: "M238.6,136.3c-.15,1,.24,2.11-.23,3.12l0-.74a1.45,1.45,0,0,1,0-1.19c0-.72,0-1.44,0-2.16C238.68,135.61,238.55,136,238.6,136.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-802",
    d: "M238.34,137.49v1.19h-.22c0-.4,0-.8,0-1.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1156",
    d: "M44.32,154c-.43-.68-.13-1.42-.25-2.41a2.12,2.12,0,0,1,.5,1.46C44.31,153.34,44.64,153.77,44.32,154Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1157",
    d: "M43.86,152.77a1.93,1.93,0,0,1,0-1.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1158",
    d: "M44.61,153.72c.22.26.34.59.1.83s-.3-.12-.34-.33C44.52,154.09,44.4,153.83,44.61,153.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1159",
    d: "M44.61,153.72l-.24.5a1.17,1.17,0,0,1,0-.2c.09-.31-.12-.71.25-1C44.58,153.29,44.6,153.51,44.61,153.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M50.52,172.33l.63,1.4C50.4,173.27,50.23,172.89,50.52,172.33Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1160",
    d: "M50,177.91c-.43-.35-.89-.69-.88-1.34A1.77,1.77,0,0,1,50,177.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1161",
    d: "M45.89,161.05c-.39-.31-.42-.59-.23-.89a.23.23,0,0,1,.2,0A.79.79,0,0,1,45.89,161.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1162",
    d: "M88.65,230.32c0-.14,0-.28,0-.42l.77.19c.61.41,1.54.31,1.88,1.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1163",
    d: "M108.77,234.88l-.25,0a2.75,2.75,0,0,1-2.24-.65l.59-.16,1.9.57c.08.05.11.1.08.15S108.8,234.88,108.77,234.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1164",
    d: "M93.94,228.94c0-.18-.33-.32,0-.51a3,3,0,0,1,1.7,1h0C95,229.39,94.39,229.46,93.94,228.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-926",
    d: "M115.24,234.65c.93-.8,1.55-.18,2.15.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1165",
    d: "M108.77,234.88v-.22c.73.24,1.43-.58,2.17-.07-.23.11-.25.33-.28.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1166",
    d: "M95.82,228a.64.64,0,0,0,.2,0l1.49,1.09a2.83,2.83,0,0,1-1.93-.85Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1167",
    d: "M93.23,230.83c.46,1.31-.45.7-1,.67C92.34,230.91,92.79,230.87,93.23,230.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1168",
    d: "M99.89,231.46c.45-.18.75.07,1.07.33C100.45,232.09,100.25,231.53,99.89,231.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1164",
    d: "M95.6,229.39c.3,0,.62,0,.85.35a.81.81,0,0,1-.85-.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M102.79,248.77V249a3.67,3.67,0,0,0-1.68-.45l-.22-.23a3.89,3.89,0,0,1,1.66.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1169",
    d: "M63,233.47a1.67,1.67,0,0,1-.71-.73.71.71,0,0,1,.71.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1170",
    d: "M177.27,28.62l.72.46c-.51,2.38-.11,4.79-.24,7.18-.69.36-1.39,0-2.08,0s-1.27.16-1.51-.83c-.13-.53-1.3-.35-1.47-1.19a52,52,0,0,1-.08-5.58,1.26,1.26,0,0,1,.35-1l1.21.24c.8-.19,1.39.52,2.14.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1171",
    d: "M182.79,31.22a17.52,17.52,0,0,1,4.31,1.92,32.15,32.15,0,0,0-.14,4.6c0,.93-.33,1.43-1.34,1.23a16.07,16.07,0,0,1-3-1c-.26-.17-.57-.3-.55-.68.64-.1.5-.61.51-1,0-1.34,0-2.68,0-4,.2-.1.22-.29.24-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1172",
    d: "M178.49,36.94l.92.31a.2.2,0,0,1,.07.18c0,.07,0,.1,0,.1-.53.17.08,1.12-.75,1.08a32.6,32.6,0,0,0-4-.68,6,6,0,0,0-2.57,0,1.77,1.77,0,0,1-.76,0,1.15,1.15,0,0,1-.61-.43,1.8,1.8,0,0,1,.21-1.41,1.1,1.1,0,0,1,1.1-.23c.13,0,.25.15.4.08a.23.23,0,0,1-.2-.33.84.84,0,0,1,1-.13,16.52,16.52,0,0,0,4.32,1A1.72,1.72,0,0,1,178.49,36.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1173",
    d: "M178.49,36.94c-1.81-.42-3.63-.83-5.44-1.26-.27-.06-.52-.23-.75.07s-.45.2-.58-.07.09-.51.34-.66a1.7,1.7,0,0,1,1.3.19c.18.13.16-.2.1-.05s0,0-.08,0c-.31-.07-.52-.2-.42-.56.42.12.84.23,1.24.38.18.07.78,0,.23.51-.31.31.18.28.35.31,1,.17,2,.31,3,.47C178,36.49,178.82,36.1,178.49,36.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1174",
    d: "M180.33,30.89a1.74,1.74,0,0,1,1.52.68A1.31,1.31,0,0,1,180.33,30.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1175",
    d: "M179.42,37.44a1.21,1.21,0,0,0,0-.19,4.44,4.44,0,0,1,1.93.72.19.19,0,0,1-.06.27,3.41,3.41,0,0,1-1.59-.4A.52.52,0,0,1,179.42,37.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1176",
    d: "M182,37.24l.53.43a.47.47,0,0,1-.31.38.42.42,0,0,1-.46-.14.65.65,0,0,0-.66-.47c-.08-.22,0-.32.23-.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1177",
    d: "M181.36,37.19l-.23.25-1.4-.62A2.12,2.12,0,0,1,181.36,37.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1178",
    d: "M182.78,31.72c.13.26.18.49-.24.48-.2-.16-.42-.34-.25-.62C182.31,31.54,182.61,31.67,182.78,31.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1179",
    d: "M181.79,37.91h.5a.41.41,0,0,1,0,.53.68.68,0,0,1-1-.33.76.76,0,0,0,0-.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M198.57,65.94l-4.28-3.14a4.75,4.75,0,0,0-1-2.44,1.73,1.73,0,0,1,.31-.22c.66-.37.52-1,.53-1.59,0-3.46,0-6.91,0-10.37a4.84,4.84,0,0,1,.14-1.65c.41-.65,1-.38,1.32-.05.75.77,1.7,1.27,2.47,2l.53.45c.22,2.53.08,5.06.09,7.6,0,2.06.07,4.12,0,6.17-.37.85.2,1.36.68,1.9a.71.71,0,0,1,.1.31c-.46.88-.83.17-1.18,0C198.44,65.18,199,65.41,198.57,65.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1036",
    d: "M198.35,63.31c0-4.35,0-8.7,0-13,0-.45-.19-1,.26-1.34a18.77,18.77,0,0,1,3.8,2,1.24,1.24,0,0,1,.17.8c-.08,4.47,0,8.93,0,13.4a3.28,3.28,0,0,1-.23,1.52c-.27.42-.6.4-1,.14s-.57-.52-.88-.75a2.38,2.38,0,0,1-.36-.35,9,9,0,0,1-.81-.93h0C199.19,64.13,198.48,63.91,198.35,63.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1095",
    d: "M201.94,66.91a2.7,2.7,0,0,0,.24-1.51c0-4.25,0-8.5,0-12.75a5.74,5.74,0,0,1,.25-1.75l.26,0c1,1,2.39,1.39,3.37,2.39a66.21,66.21,0,0,0-.14,6.9c-.06,3.45.11,6.91-.09,10.36-.21.75-.63.55-1,.2-.74-.65-1.42-1.37-2.1-2.08-.27-.26-.3-.64-.46-1S201.79,67.25,201.94,66.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1180",
    d: "M198.09,48.48c-.83-.38-1.75-.54-2.24-1.51-.2-.4-.81-.57-1.33-.62a.48.48,0,0,1-.47-.23,4.4,4.4,0,0,1,.27-3.11c.22-.61-.66-.78-.54-1.35.06-.93.18-1.85.18-2.78,0-.46,0-1,.56-1.18,1-.21,1.56.57,2.16,1.19a1.39,1.39,0,0,1,.48.32c.09.15-.1.14-.2.14-.92,0-.47.42-.18.68.57.53,1.2,1,1.81,1.5.07,0,.09.1.07.15s0,.09-.07.09c-.52,1.45-.09,2.95-.25,4.42C198.26,47,198.61,47.77,198.09,48.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1181",
    d: "M203.87,49.66l-.49-.23-.77-.62.53-.1c.09.54,1,.3,1,.94C204,49.74,204,49.74,203.87,49.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1182",
    d: "M198.59,41.77v-.24c.22,0,.15-.51.48-.23l.19.86Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M205.52,71c0-5.49,0-11,0-16.49,0-.45-.3-1.1.5-1.26l1.16.68,1.41,1c.23.13.49.24.57.54.26.37-1,0-.28.6l1.19,1a57.94,57.94,0,0,0-.11,6.18c0,3.33,0,6.66,0,10a3.29,3.29,0,0,1-.3,1.85.51.51,0,0,1-.71.16q-1.12-1.27-2.37-2.46C206.16,72.24,205.51,71.82,205.52,71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M209.37,75.27a2.67,2.67,0,0,0,.24-1.5c0-5.08,0-10.16,0-15.24,0-.52-.18-1.14.49-1.46a30,30,0,0,1,3.52,3.14,3.46,3.46,0,0,0-.43,1.94q0,9.08,0,18.14c-1-.5-1.31-1.64-2-2.43a11.48,11.48,0,0,0-.94-1,2.63,2.63,0,0,1-.39-.49C209.69,76,209.2,75.78,209.37,75.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1183",
    d: "M214.88,58.27a11.15,11.15,0,0,1,.89.79c.25.27.8.61.41.95s-.6-.28-.86-.53C215.27,59,214.58,58.84,214.88,58.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1184",
    d: "M210.57,54.92c-.08-.24-.39-.47,0-.71l1.5.76C211.5,55.84,211.06,54.83,210.57,54.92Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1185",
    d: "M209.15,55.4l-.53-.45c.69-.07,1.06.64,1.7.7v.24h0c-.32.25-.64,0-1,0S209.26,55.55,209.15,55.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1186",
    d: "M213.54,56.56c-.58.06-.79-.33-1.12-.51C213,55.8,213,55.8,213.54,56.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1187",
    d: "M209.15,55.4a.52.52,0,0,1,.22.49c-.18,0-.36,0-.46.2l-.88-.53C208.38,55.11,208.84,56,209.15,55.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1185",
    d: "M210.32,55.89a.93.93,0,0,1,.57.56c-.52.12-.5-.26-.56-.57Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1188",
    d: "M164.87,35c-1.2-.45-2.52.14-3.7-.43a6.17,6.17,0,0,0,.55-3.77,28.62,28.62,0,0,1-.09-5.32,1.25,1.25,0,0,1,.31-.75,27,27,0,0,1,3.81.32,3.72,3.72,0,0,0-.21,2c0,2.19,0,4.38,0,6.56.27.38.69,0,1,.2a.63.63,0,0,1,0,.3c-.36.31.14.76-.19,1.07a1.69,1.69,0,0,1-.86.15A.83.83,0,0,1,164.87,35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1189",
    d: "M173,34.59c.08.4.55.37.76.65a2,2,0,0,1-1.48-.17c-.18.11-.25,0-.3-.16s.2-.28-.06-.38a3.22,3.22,0,0,0-.54-.1,1.85,1.85,0,0,1-1.07-.21c.25.27.7.25.63.69-.27.51-.66.33-1,.17a4.1,4.1,0,0,1-.74-.41.53.53,0,0,1-.13-.45c0-.2.33-.34.14-.6V26.93c.72-.06,1.47.17,2.16-.24.37.64,1.26.37,1.67.95Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1190",
    d: "M169.13,33.62c.13,0,.35,0,.3.2s-.19.2-.3.3c-.63.42-1.28,0-1.91.05a1.21,1.21,0,0,1-.73-.29c-.3-.14-.82.59-1-.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1191",
    d: "M218.71,65.19c-.53,0-.77-.34-1-.72A1.29,1.29,0,0,1,218.71,65.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1192",
    d: "M203.87,49.66h.22a2.36,2.36,0,0,1,1,1C204.43,50.37,204,50.26,203.87,49.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1193",
    d: "M221.12,68.3a8.24,8.24,0,0,0-1.65-1.93c0-.14,0-.27,0-.4l.39.23c1.69,2.08,3.85,3.7,5.61,5.71l0,.25a.74.74,0,0,1-.68.33,2.6,2.6,0,0,1-.86-.68c-.24-.27-.5-.51-.72-.79a5,5,0,0,0-.75-1c-.4-.28-.51-.79-.87-1.1A1.36,1.36,0,0,1,221.12,68.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M224.7,72.4l.7-.24a17.72,17.72,0,0,1,2.18,3.06l-.25.76c-.49-.3-.51-1.32-1.44-.94a3,3,0,0,0-1.18-2.15A.35.35,0,0,1,224.7,72.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1194",
    d: "M220.85,65.7c0-.52-1.22-.39-.67-1.22.4-.28.62.23.95.24l.43.26c.4.85-.11.82-.7.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-882",
    d: "M220.86,65.71c.32-.16.9-.07.7-.73.42.18.12.72.46.93l-.24.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1195",
    d: "M221.13,64.72c-.43.35-.58-.39-.95-.24l.21-.25A.88.88,0,0,1,221.13,64.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1196",
    d: "M185.41,38.66c1.08.29,1.3-.21,1.22-1.2s0-2.27,0-3.41c0-.39-.09-.83.48-.91l1.19.5a2.26,2.26,0,0,1,1.43.71c.32.58,1.05.69,1.44,1.2a.74.74,0,0,1-.54.34,1.82,1.82,0,0,1-1-.43,12.16,12.16,0,0,0-1.38-.85,9,9,0,0,1,1.51,1c.33.34.86.32,1.2.66a8.14,8.14,0,0,0-.38,3.1,1.47,1.47,0,0,1-.4,1.3,1.18,1.18,0,0,1-.94,0,19.05,19.05,0,0,0-2.81-1.15C186,39.34,185.43,39.28,185.41,38.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1197",
    d: "M190.68,35.78a.49.49,0,0,1,.48-.23l3.36,2.15c-.49,1.4-.06,2.91-.49,4.32-1.41-.34-3-.28-4.09-1.44.57-.95.21-2,.23-3a2.12,2.12,0,0,1,.53-1.35A.32.32,0,0,1,190.68,35.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1171",
    d: "M189.72,34.35a2.85,2.85,0,0,1-1.43-.71c.9-.46,1.33.34,1.93.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1198",
    d: "M151.35,24.76c.46-.32,1-.12,1.49-.25l4.79.07a1.28,1.28,0,0,1,.35,1c0,1.75.11,3.5-.06,5.25a1,1,0,0,0,0,1.34c0,.79.41,1.68-.46,2.3l-.28.17-4.25-.06c.55-.85-.6-.26-.58-.67.55-.07.52-.48.52-.87V31c.17-.24.37-.21.6-.1-.2-.13-.54-.1-.6-.43,0-1.42-.09-2.85,0-4.27C153,25,152.52,24.58,151.35,24.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1199",
    d: "M157.63,31.23V24.58a18.83,18.83,0,0,1,4.31.19c0,1.75-.12,3.52,0,5.25a12.24,12.24,0,0,1,0,3.82c-.11.55-.27.78-.8.77h-1.86l-1.88-.15c.41-.8.11-1.66.2-2.49a.57.57,0,0,1,.73-.13c.52.3.26-.25.41-.34.48-.22.65.26,1,.42a1,1,0,0,0,1,.15c-.13-.67-.78-.35-1.14-.59-.26,0-.47-.23-.74-.25C158.42,31,158,31.31,157.63,31.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1200",
    d: "M176.31,28.38c-.84.41-1.39-.46-2.14-.5C175,27.48,175.66,28,176.31,28.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M186.13,234.76a.88.88,0,0,0-.71-.32c-.16-.15.24-.54-.27-.55a1.47,1.47,0,0,1-.93-.37.35.35,0,0,1-.05-.33,1.28,1.28,0,0,1,.56-.41,24.47,24.47,0,0,1,3.72-1.12c.44.16.88.33.32.86l-2.14,1.38A1,1,0,0,1,186.13,234.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M195,229.42a6.89,6.89,0,0,1-3.6,2.14,1.34,1.34,0,0,1-.79-.57,8.72,8.72,0,0,1,4.13-2.16C195,229,195.15,229.12,195,229.42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M190.23,232.76c1.3-.33,2.48-1.32,4.05-.67a11.86,11.86,0,0,1-2.89,1.36c-.18.17-.39.1-.6.11a.7.7,0,0,1-.27-.14C190.38,233.22,190.1,233.08,190.23,232.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M190.65,231.05c.37,0,.74,0,.76.51a6.11,6.11,0,0,1-2.64,1c.25-.36-.07-.52-.24-.73A2.1,2.1,0,0,1,190.65,231.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M190.23,232.76l.45.47c-1.07.56-2.3.72-3.33,1.37-.41,0-.76.49-1.22.16a.82.82,0,0,1,.5-.86A13.48,13.48,0,0,0,190.23,232.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M187.35,234.6c.85-1.08,2.09-1.23,3.33-1.37v.22c-.26.29-.68.28-1,.51l-1.68.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M207.68,236.32h-.23c-.32-.79.42-.9.81-1.21a10.15,10.15,0,0,1,1.11-.66c.35.57-.31.66-.47,1S208,235.9,207.68,236.32Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M195,229.42l-.25-.49a1.7,1.7,0,0,1,.89-.72c.58-.15,1.06-.6,1.7-.59a.5.5,0,0,1,.33.36l-2,1.17Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M208.9,235.43c.16-.33.32-.66.47-1l1.09-.59C210.32,234.93,209.57,235.15,208.9,235.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M216.07,229.84h.21c.15.08.16.18,0,.29a1.6,1.6,0,0,1-1.2.69c-.08,0-.1-.1-.08-.16s.05-.08.08-.08C215.29,230.15,215.74,230.07,216.07,229.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M215.12,230.58v.24a1.58,1.58,0,0,1-1.58.76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M216.32,230.13a2.89,2.89,0,0,0,0-.29c.44-.34.71-1,1.47-.7Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M198.61,229.39c.57.09,1-.84,1.63-.25C199.67,229.08,199.26,230,198.61,229.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M189.72,234a1.18,1.18,0,0,1,1-.51h.71A3.92,3.92,0,0,1,189.72,234Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M192.87,234.77c-.41.47-.66.6-1,.57C192,234.9,192.34,235,192.87,234.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M197.68,228l-.28-.22a.8.8,0,0,1,.51-.61c3.92-2.1,7.45-4.8,11.21-7.15a1.39,1.39,0,0,1,.65-.27c.25.1.4.26.31.55l-2.39,1.91a54.76,54.76,0,0,0-6.67,4.07A13.9,13.9,0,0,1,197.68,228Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M225.15,223.16a7.32,7.32,0,0,1,1.76-1.7c.1.4-.26.51-.3.75l-1.19,1C225.33,223.27,225.24,223.26,225.15,223.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1201",
    d: "M225.15,223.16l.27,0c-.39.42-.67,1.07-1.44.7C224.41,223.72,224.61,223.16,225.15,223.16Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1088",
    d: "M172,241.11a3.59,3.59,0,0,0-1.91,1.26c-.43.62-1.2.25-1.67.68a12.09,12.09,0,0,1-.79-2c.23-.53.76-.58,1.21-.63,1-.11,1.93-.49,2.91-.62.82-.05,1.52-.88,2.42-.34C173.75,240.39,172.49,240.25,172,241.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1202",
    d: "M174.17,239.44l-2.41.42c-.08-.05-.11-.1-.08-.15s0-.08.07-.08a.37.37,0,0,1,0-.18c1.25,0,2.19-.91,3.35-1.19a2,2,0,0,1,1.83-.36c.3.34,0,.45-.23.6s-.82.25-1.19.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M184.29,238.07a.79.79,0,0,1-.85.36A.7.7,0,0,1,184.29,238.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1203",
    d: "M167.68,241.11c.86.41.7,1.21.74,1.94a1.49,1.49,0,0,1,0,.21c-.38.2-.81.27-1.19.48-.73.72-1.85.58-2.64,1.18l-1.43.27c-.61-.42-.53-1.08-.56-1.69,0-.44-.18-.84-.23-1.26a.7.7,0,0,1,.63-.46q1.92-.34,3.81-.81A.88.88,0,0,1,167.68,241.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1204",
    d: "M167.21,243.74a1.39,1.39,0,0,1,1.19-.48A1.32,1.32,0,0,1,167.21,243.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M191.89,248.77l-1.21.24a3.8,3.8,0,0,1,2.32-1.18c.4-.11.49.1.27.44A2.72,2.72,0,0,0,191.89,248.77Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1115",
    d: "M162.4,242.3c.58.07.52.51.5.9a5.58,5.58,0,0,0,.24,2,13.24,13.24,0,0,1-6.22,2.39c.19-1.12-.39-2.23,0-3.35a.37.37,0,0,1,.13-.15c0-.21-.22-.05-.32-.11s-.43-.07-.49-.28.18-.29.37-.3a8.31,8.31,0,0,1,1.19,0s-.21-.27-.15-.12a3,3,0,0,1-1.69,0c0-.06,0-.13,0-.19l.11-.15a5.71,5.71,0,0,1,1.22-.36c.72-.16,1.47,0,2.19-.21a1.47,1.47,0,0,1,.88,0c.2.74.41.13.62,0a1.39,1.39,0,0,1,.27-.21,1.15,1.15,0,0,1,.33-.1A.92.92,0,0,1,162.4,242.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1205",
    d: "M149.75,246.8a1.65,1.65,0,0,1-1.45.26C148.85,246.61,148.85,246.61,149.75,246.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1206",
    d: "M157.14,244.21l-.23,0h-1c-.06-.32-1-.64,0-1h1.88v.19l-1.41.1c.2.32.5.13.74.21A.29.29,0,0,1,157.14,244.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1207",
    d: "M152.85,245.89v-.24a.6.6,0,0,1,.53-.67c.1,0,.29.05.3.11.07.38-.21.56-.48.73a1,1,0,0,1-.35.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1208",
    d: "M210.55,219.3l-.71.52c-4.11,2.7-8.07,5.64-12.44,7.94-.59.14-1.06.62-1.7.64a22.41,22.41,0,0,0-2.84-.12c-.5,0-1.06.06-1.35-.52-.1-.42.17-.66.42-.92a21.33,21.33,0,0,1,2.81-2.73c1-1,1.6-2.29,3-2.88a1.26,1.26,0,0,0,.84-1.42,16.12,16.12,0,0,0,2.33-2.62,1.47,1.47,0,0,1,1.28-.75l-.7,1c-.39.14-.61.52-1,.71-.28.75.19.73.72.73h7.5A3,3,0,0,1,210.55,219.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M218,212.88h.53A4.5,4.5,0,0,1,217,214,2.27,2.27,0,0,1,218,212.88Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1005",
    d: "M200.52,218.13c.27-.3.37-.84,1-.71A1.26,1.26,0,0,1,200.52,218.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1209",
    d: "M44.1,106.86v.69c-.09-.24-.76-.5,0-.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    className: "cls-705",
    d: "M159.31,47.26c.28,0,.65-.06.78.28.07.17-.16.19-.3.21-.52-.44-1.33-.13-1.86-.7C158.46,46.84,158.85,47.28,159.31,47.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1210",
    d: "M150.22,30.29l.7-.07,1.44.32c0,.23,0,.36-.29.25C151.42,30.75,150.72,30.87,150.22,30.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1211",
    d: "M152.07,30.79l.29-.25.48,0,.93.44-.93.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1212",
    d: "M112.38,235.59l-.23.18-1.22-.44v-.19A2.29,2.29,0,0,1,112.38,235.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1213",
    d: "M147.31,242.37l3.62-.07c.14.45.91.93-.07,1.32a26.39,26.39,0,0,1-3.77-.11.58.58,0,0,0-.19,0c-.28-.31-.68-.16-1-.25-.2-.37-.26-.66.32-.69C146.58,242.53,147,242.67,147.31,242.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1214",
    d: "M151.16,243.47c.21-.44-.54-.7-.23-1.17.52.15.78-.31,1.16-.49a.75.75,0,0,1,.56-.16c1.2.26,2.36-.22,3.54-.23a4.16,4.16,0,0,1,1.17.05,7,7,0,0,0,1.77-.09h1.6c.09.43-.57.36-.5.78a1.09,1.09,0,0,1-.31.08c-.92,0-1.79.39-2.71.43A8,8,0,0,1,156,243v.08c-1.13,0-2.26,0-3.39,0-.36,0-.83-.12-.91.46h0l-.26,0C151.29,243.61,151.21,243.6,151.16,243.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-993",
    d: "M151.16,243.47l.24.07a8.85,8.85,0,0,1-4.31,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1215",
    d: "M151.66,243.51h2.76a3.31,3.31,0,0,1-2.77,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1216",
    d: "M194.74,224.11a15.86,15.86,0,0,1-3.11,3.33.74.74,0,0,1-.91.28c-.66-.1-.51-.61-.51-1,0-1.35,0-2.7,0-4,0-.38.12-.84-.47-.92a12.26,12.26,0,0,0,2.66-1.67l1.14-.5a6.57,6.57,0,0,1,.5,3.07C194,223.26,194.09,223.81,194.74,224.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M222.56,95.12c0,.19-.05.39-.25.48-.33-.7-.66-1.41-1-2.12C222.13,93.77,222.34,94.45,222.56,95.12Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-706",
    d: "M224.7,72.4c0,.16,0,.32,0,.49l-.47.27-.26-.72a.57.57,0,0,1,0-.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1217",
    d: "M224,71.65l0,.79a5.06,5.06,0,0,1-1-1.23c-.05-.23.05-.32.28-.26A1.7,1.7,0,0,1,224,71.65Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1218",
    d: "M221.59,68.79c.48.28.63.82,1,1.21a.3.3,0,0,1-.25.25,1.17,1.17,0,0,1-.72-.94A.37.37,0,0,1,221.59,68.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1219",
    d: "M222.3,70.25l.25-.25a1.23,1.23,0,0,1,.73,1l-.28.26C222.6,71,222.49,70.6,222.3,70.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1220",
    d: "M221.59,68.79v.52a1.9,1.9,0,0,1-.73-.73l.27-.28Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1221",
    d: "M222.82,74.67a.67.67,0,0,1,.56.49.38.38,0,0,1-.2.07C223,75.16,222.88,75,222.82,74.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "M211.28,77.66l1.9,2.63c0,.53.51.78.73,1.19s0,.39-.23.5A20.45,20.45,0,0,1,211,77.89C211,77.69,211.06,77.58,211.28,77.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1222",
    d: "M213.68,82c.08-.17.15-.34.23-.5.37.58,1.07.93,1.2,1.68-.15.14-.33,0-.5,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1223",
    d: "M214.61,83.21c.14-.32.33-.07.5,0a.83.83,0,0,1,.47,1C215.06,84,214.88,83.57,214.61,83.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1003",
    d: "M194.27,46.11l.25.24c0,4.34,0,8.68,0,13,0,1-.22,1.37-1.21,1.05a4.77,4.77,0,0,0-1.44-1.18c.42.36,1.06.62,1.42,1.2,1.05.49,1.53,1.21,1,2.36l-3.63-2.27a2,2,0,0,1-.59-1.62q0-6.27,0-12.53a2.26,2.26,0,0,1,.31-1.37c1.27-.6,2.28.22,3.35.65A2.76,2.76,0,0,1,194.27,46.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M185.91,58.51l-3.12-2.17a2.51,2.51,0,0,1-.39-1.6c0-3.74,0-7.49,0-11.23,0-.66-.1-1.4.72-1.74a1.59,1.59,0,0,1,.43-.06,11.5,11.5,0,0,1,3,1.07.88.88,0,0,1,.66.89c0,4.41,0,8.83,0,13.24,0,.65.16,1.39-.6,1.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M186.62,58.71a2.26,2.26,0,0,0,.23-1.38q0-6.3,0-12.6c0-.45-.19-1,.3-1.32.91-.37,1.58.35,2.36.55.37.33,1.1.2,1.16.92a2.39,2.39,0,0,0-.24,1.27q0,6.48,0,13a4.36,4.36,0,0,0,.22,1.4A27.59,27.59,0,0,1,186.62,58.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1224",
    d: "M210.55,79.63l-.24,1.17c-.8,0-.9-.84-1.37-1.23a2.22,2.22,0,0,0-1.15-.63.62.62,0,0,1-.31-.5c0-.34,0-.68-.3-.92a6.65,6.65,0,0,1-1.13-1.45.84.84,0,0,1,.2-.85l.25.27a14.79,14.79,0,0,0,1.23,1A20.61,20.61,0,0,1,210.55,79.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1225",
    d: "M199.3,64.73c.36.2.8.27.94.74-.13,1,1,1.44,1,2.34a.56.56,0,0,1-.58.26,9.61,9.61,0,0,1-2.14-2.13c.08-.7-.79-.85-.88-1.5.52,0,.77.34,1.1.58S199.27,65.07,199.3,64.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1226",
    d: "M205.52,71l1.27,1.64a.57.57,0,0,1-.3.15c-.79-.12-1-.89-1.53-1.31l-2.79-2.9a.58.58,0,0,1,.5-.27Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1227",
    d: "M206.48,72.64h.31c.76.75,1.72,1.32,2.09,2.4-.23.13-.48-.13-.72,0-.38-.35-.91-.54-1.17-1C206.9,73.53,206.11,73.3,206.48,72.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M202.67,68.3c-.1.23-.29.26-.5.27l-.41-.21a.58.58,0,0,1-.53-.52c-.37-.51-.76-1-1.11-1.52-.21-.3-.39-.64.12-.85.09.08.17.17.25.25a5.35,5.35,0,0,0,1.9,1.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1228",
    d: "M204.85,73.89A4.12,4.12,0,0,1,206,75c.2.33.07.7.11,1a1.1,1.1,0,0,1,0,.36c-.35.27-.52,0-.73-.22a10.16,10.16,0,0,1-.72-1,1.89,1.89,0,0,1-.09-.34C204.54,74.52,204.51,74.15,204.85,73.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1229",
    d: "M206.48,72.64c-.12.56.87.73.51,1.38a6,6,0,0,1-2-2.55C205.65,71.63,205.88,72.37,206.48,72.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1230",
    d: "M203.86,74.54a2.3,2.3,0,0,1-.93-2.44l1,.93C204,73.54,204.35,74.06,203.86,74.54Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1231",
    d: "M203.86,74.54c0-.5,0-1,0-1.51.32.28.63.57.94.86,0,.37,0,.75,0,1.13-.61.45-.75-.06-.94-.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1232",
    d: "M208.16,75.05c.22-.77.49.07.72,0l.49.24.71,1c-.44.38-.63-.21-1-.26A2.79,2.79,0,0,1,208.16,75.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1233",
    d: "M211.28,77.66l-.28.23a2.59,2.59,0,0,1-.92-.94c0-.23,0-.35.28-.25A2.73,2.73,0,0,1,211.28,77.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1234",
    d: "M201.23,67.84l.53.52c-.3.47-.34.46-1-.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1235",
    d: "M210.36,76.7l-.28.25a3.36,3.36,0,0,1-1-1c.41-.24.59.39,1,.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1236",
    d: "M207.73,76.48a1.54,1.54,0,0,1-1.23-1A1.91,1.91,0,0,1,207.73,76.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1236",
    d: "M206,76.21V75l.23.22c0,.33,0,.66,0,1C206.19,76.3,206.11,76.3,206,76.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1237",
    d: "M213,93.45l-.44,0q-1.22-1.91-2.44-3.81c-.16-.27-.23-.54.06-.78.27-.08.42.1.57.27a3.23,3.23,0,0,0,.36.45c.17-.28-.12-.42-.16-.64a1.71,1.71,0,0,0-.41-.65,3.83,3.83,0,0,1-1.07-1.59c.26-1.34-.24-2.74.4-4a1.72,1.72,0,0,1,1.81,1,25.11,25.11,0,0,1,2,3.35,1.06,1.06,0,0,1,.05.87c-.14,1.44.3,2.9-.26,4.31C213.09,92.59,213.88,93.36,213,93.45Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1238",
    d: "M213.68,88l-.24-.71c.22-.43.64-.36,1-.39a.49.49,0,0,1,.28.17c.11.4.68.65.38,1.18l.43.74c-.34.24-.45-.12-.64-.26s-.15-.55-.53-.48Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1239",
    d: "M213,93.45c.46-.29.27-.6.12-1s.17-.23.35-.19c.17.42.33.83.5,1.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1240",
    d: "M214.38,88.2l.14-.29a1.06,1.06,0,0,1,.39.77A.77.77,0,0,1,214.38,88.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1226",
    d: "M214.4,87l-1,.25c-1.05-1.57-1.74-3.39-3.32-4.58a2.81,2.81,0,0,1-1.3-1.85c.58-.46-.4-.82-.08-1.27.08-.16.18-.28.39-.2l1.18,1.46a1.74,1.74,0,0,0,.05.22c.33.46.32,1.24,1.16,1.2a1.55,1.55,0,0,1,0,.22,12.38,12.38,0,0,1,2,3c0-.49-.59-.85-.31-1.38a2.59,2.59,0,0,1,1.42,1.68C214,86.08,214.66,86.62,214.4,87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1241",
    d: "M213.2,84.09c.14.48.59.87.38,1.63-.73-1.17-1.69-2-2.05-3.28C212.37,82.71,212.66,83.53,213.2,84.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1224",
    d: "M211.52,82.22c-.23.21-.44.56-.74.06a1.82,1.82,0,0,1-.42-1.26Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1224",
    d: "M214.4,87c-.1-.2-.2-.41-.32-.62-.37-.69,0-.68.54-.6l.24.26-.22.49a.33.33,0,0,1,0,.47h-.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1242",
    d: "M214.64,87v-.47l.71,1c0,.26.07.56-.23.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M190.72,227.72l.91-.28c.17.8.81.42,1.27.51.93.18,2-.43,2.8.45-.31.18-.51.55-.94.53a38,38,0,0,0-4.11,2.12l-2.12.74a24.12,24.12,0,0,1-3.82,1.18c.17-1.31,1.5-1.44,2.25-2.16.28-.27.72-.44,1.06-.71Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1243",
    d: "M188,230.1a9.49,9.49,0,0,1-2.31,1.92,2.54,2.54,0,0,0-1,.95l-.51.25c-1.06.59-1.43.43-1.5-.71,0-.9-.11-1.8-.07-2.7.23-.55.78-.55,1.24-.71a1.43,1.43,0,0,0,.78-.52c.22-.15.47-.23.7-.37s.62-.48,1-.26a1.63,1.63,0,0,1,.46,1.42C186.82,230.29,187.18,230.57,188,230.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1244",
    d: "M181.1,229.63c.42-.85-.34-1.59-.24-2.41a.36.36,0,0,1,.13-.43c.32-.46,1.07-.17,1.31-.76h0a20.8,20.8,0,0,0,3.36-1.06.42.42,0,0,1,.47.09c.32.76-.25,1.42-.24,2.14a.24.24,0,0,1-.29,0c-.28-.53-.62-.27-.95-.07a11.29,11.29,0,0,1-2,1.35c-.15.11-.35.1-.5.21a1.26,1.26,0,0,1,.54.1C182.67,229.78,182.48,229.88,181.1,229.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1245",
    d: "M185.64,227.2h.25c.21,0,.44-.31.63,0s-.05.52-.13.77l-1,.47a.91.91,0,0,1-.13-1.11A.28.28,0,0,1,185.64,227.2Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1246",
    d: "M187.5,226c-.08.47-.27.62-.65.65s-.48,0-.43-.36a.62.62,0,0,1,.7-.5C187.32,225.8,187.52,225.84,187.5,226Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1247",
    d: "M186.13,225.07h-.47c-.07,0-.09-.1-.07-.16s0-.08.06-.08l.25-.24c.2,0,.46-.33.6,0S186.21,224.85,186.13,225.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1248",
    d: "M185.65,224.83v.24c-1,.58-2.06,1.26-3.36,1A9.77,9.77,0,0,1,185.65,224.83Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1248",
    d: "M182.3,226c.28.56-.2.68-.49.64s-.49.19-.71.32c-.18-.11-.36-.21-.23-.47h0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1249",
    d: "M199.55,71.67a2.4,2.4,0,0,1,.95,1c-.64-.06-.94-.65-1.42-.94A.31.31,0,0,1,199.55,71.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1039",
    d: "M199.55,71.67l-.47,0-.49-.51C199.13,70.91,199.33,71.32,199.55,71.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1230",
    d: "M203.86,74.55c.28.24.5.57.94.47l0,.24c.17.46.57,1-.25,1.21a2.73,2.73,0,0,1-1-1C204,75.27,203.82,74.89,203.86,74.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1250",
    d: "M156.43,237.29a7.22,7.22,0,0,1,0,1c-.16,1,.17,1.43,1.2,1.11a.85.85,0,0,1,.1.94,1.16,1.16,0,0,1-1,.28c-.49-.34-.84.15-1.25.24a1.62,1.62,0,0,1-1.4-.26l-1.92,0v-7.11c1.12-.18,2.28.19,3.38-.27a.71.71,0,0,1,.93,0c-.62,1.26.33,2.51,0,3.77-.18.19-.42.11-.64.13C156,237.19,156.25,237.1,156.43,237.29Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1251",
    d: "M149.2,238a.64.64,0,0,0,0-.2,3.48,3.48,0,0,1,1.52.13A4.1,4.1,0,0,1,149.2,238Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1252",
    d: "M156.43,233.26l-.93,0-.22-.22c.62,0,1.27-.31,1.85.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1253",
    d: "M164.87,35l.67.05a1.63,1.63,0,0,1,.36,1.22c0,4,.08,8,0,12,.06.32-.45.63,0,.95s1.42.26,1.66,1.09a.55.55,0,0,1-.25.2.61.61,0,0,1-.48,0,1.53,1.53,0,0,0-.37,0,.71.71,0,0,1,.42.12.72.72,0,0,1,.11.31,1.45,1.45,0,0,1-.43,1.12c-.79,0-1.34-.8-2.17-.71a3.45,3.45,0,0,1-1.91,0h0V36.79c0-1.95-.15-1.71,1.73-1.73Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1254",
    d: "M166.5,52.05l.23-1.19c.86-.21,1.42.67,2.24.59a.81.81,0,0,1,.29.12,4.39,4.39,0,0,0,1.17.72c.35.18.7.37,1.07.52s.57,0,.79.23a.59.59,0,0,0,.19.54.77.77,0,0,1,0,.15A11.1,11.1,0,0,1,166.5,52.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    className: "cls-970",
    d: "M162.42,51.34h1.91A1.78,1.78,0,0,1,162.42,51.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M183.52,42c-.92,0-.73.63-.74,1.15q0,6.6,0,13.19c-1.07-.85-2.45-1-3.6-1.71a2.41,2.41,0,0,1-.38-1.59c0-3.58,0-7.15,0-10.73a2,2,0,0,1,.51-1.76A5.37,5.37,0,0,1,183.52,42Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M176.79,53.24,173,51.53a2.47,2.47,0,0,1-.38-1.59q0-4.77,0-9.54a2.52,2.52,0,0,1,.38-1.71c1.08-1,2.31-.39,3.49-.36a12.45,12.45,0,0,1,3,.75c.38.12.89.26.55.87a1.57,1.57,0,0,1-1.32-.09,2.86,2.86,0,0,0-1.26-.21c-.74.21-.52.83-.52,1.3,0,2.47,0,4.94,0,7.41a5,5,0,0,1-.13,1.54c-.32.28,0,.54,0,.8A7.22,7.22,0,0,1,176.79,53.24Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M173.21,38.62a2.78,2.78,0,0,0-.25,1.5V51.53c-.72-.12-1.37-.61-2.15-.43a.35.35,0,0,1-.31.09,6.67,6.67,0,0,1-1.14-.47,1,1,0,0,1-.46-.84c.13-3.48.1-7,.11-10.43a5,5,0,0,1,.15-1.76c.18-.41.53-.34.87-.32a3.1,3.1,0,0,1,1.06.36c.45.15.92.15,1.38.26C172.76,38.14,173.19,38.15,173.21,38.62Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M176.79,53.24c-.44-.84-.15-1.75-.24-2.62.12-.13.28,0,.4-.06a.88.88,0,0,1-.4-.43c0-3.33,0-6.67,0-10,0-.72.07-1.22,1-.76.3.23.72.08,1,.3s.68.31,1,.49a.32.32,0,0,1,.14.41c-.62.28-.48.84-.48,1.34V54.63Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1255",
    d: "M169.13,50.14a.87.87,0,0,0,.49.49,2.27,2.27,0,0,0,1,.47h.23c.2.57.83.66,1.18,1.06.21.24.79.38.3.88-.25,0-.52.36-.77,0-.25-.56-.82-.57-1.29-.77a2,2,0,0,1-1.1-.68h0c-.73-.24-1.6-.26-1.89-1.19h.23a4.64,4.64,0,0,1,1-.59C168.77,49.69,169,49.87,169.13,50.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1256",
    d: "M154,240.64h1.69a.32.32,0,0,1,0,.31.72.72,0,0,1-.36.33,11.94,11.94,0,0,1-1.58.18,1.8,1.8,0,0,1-.32.06.48.48,0,0,1-.42-.17v-.46C153.41,240.83,153.79,241,154,240.64Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1257",
    d: "M153.09,241.34h.47c-.05.69-.64.37-1,.52l-.49-.06C152.05,240.87,152.79,241.57,153.09,241.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M144.41,241.79h-1.59v-.12h1.61Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1258",
    d: "M148.52,241.68a2.41,2.41,0,0,1-1.62,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1259",
    d: "M178.43,237.55l-1.33.46-2,.25c-.46-1.36-.46-1.36,0-2.41a3,3,0,0,1,.7-.95.52.52,0,0,0,.26-.49c.69-.63,1.29-1.44,2.41-1.18.53.4-.12,1.4.71,1.57.58.12,1.1-.36,1.66-.55a2.46,2.46,0,0,1,.47-.1,1.09,1.09,0,0,1,.66.15c.19,1-.72,1.11-1.2,1.58a1.31,1.31,0,0,0-1,.58,5.6,5.6,0,0,0-.51.76C179.08,237.51,178.66,237.28,178.43,237.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1260",
    d: "M178.47,233.21c-1,.08-1.47,1-2.39,1.2-.38-.75.29-.87.69-1a1.29,1.29,0,0,0,.87-1.35c0-1.1,1.13-1.39,1.62-2.15.26-.42.88-.63,1.35-.93.34.44-.12.8,0,1.16l.09.12a.59.59,0,0,1-.1.28,4.18,4.18,0,0,0-.37.65c-.27.42-.29,1-.91,1.18-.36-.13-.45.21-.65.36a.92.92,0,0,0-.15.4Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1261",
    d: "M180.62,230.31a1.48,1.48,0,0,1,0-.21l.47-.47c.42-.37,1.43.44,1.44-.72a.32.32,0,0,1,0-.47,8,8,0,0,1,2.75-1.92c.67-.27.2.46.36.68l-.21.05a3.46,3.46,0,0,0-.64.84c-.15.45-.93.61-.59,1.29l-1.42.26a2.44,2.44,0,0,1-1.19.93C181.2,230.77,180.82,230.84,180.62,230.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1260",
    d: "M175.82,234.9c.13.59-.29.76-.7.95-.27-.08-1.41.62-.5-.56.08-.1-.23-.67-.48-.82s-.61-.42-.27-.79.65-.06.92.15a6.25,6.25,0,0,1,.57.58A.43.43,0,0,0,175.82,234.9Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1262",
    d: "M180.87,226.52l.23.47-.24.23c-.53-.07-.94.34-1.61.44C179.66,226.93,180.35,226.83,180.87,226.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1263",
    d: "M162.4,242.3h-.93c0-.6.55-.57.9-.71.76-.31,1.56-.49,2.33-.76.36-.14.73-.27,1.1-.43l.93-.49c.58-.17,1.14.21,1.71,0,1.14.34,2.2-.24,3.31-.31,0,.08,0,.15,0,.23-1.34.47-2.78.65-4.08,1.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1264",
    d: "M171.52,235.37v1.19a4.55,4.55,0,0,1-2.2,1C170.15,236.68,170.5,235.71,171.52,235.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1265",
    d: "M172,234.89c.28-.18.71-.72.78-.51.16.47.66.56.76.92,0,.17-.28.46-.59.46-.09,0-.18-.12-.26-.18s-.5,0-.68-.2v0C172,235.2,172,235,172,234.89Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1266",
    d: "M167.69,235.13c-.75-.12-1.16.55-2,1a2.75,2.75,0,0,1,2.21-1.71C167.92,234.67,168,235,167.69,235.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1267",
    d: "M170.81,238.47l.46.48c-.8-.19-1.62.44-2.57,0A3,3,0,0,1,170.81,238.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1268",
    d: "M168.44,239.94a1.56,1.56,0,0,1-1.71,0c.31-.39,1-.24,1.2-.73.56.12.54.11.27.55C168.07,239.94,168.35,239.87,168.44,239.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1269",
    d: "M171.76,237.51l.71,0,0,.15-1,.3C171.53,237.8,171.56,237.61,171.76,237.51Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1270",
    d: "M168.16,234.41a1.93,1.93,0,0,0,0-.24c.14,0,.33-.1.41,0a.26.26,0,0,1-.05.4C168.38,234.64,168.25,234.55,168.16,234.41Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1271",
    d: "M172,235.38c.24,0,.51-.08.68.2-.19.11-.2.49-.5.4S172,235.6,172,235.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1272",
    d: "M208.89,80.79l1.23,1.87c-.49.46-.23,1-.26,1.58a8.82,8.82,0,0,1-.25,2.71s-.07.08-.09.07-.18,0-.14.08c.35.58,1.05,1,.91,1.81-.25.2-.19.49-.22.75l-3.81-4.35-.73-.94c0-1.78,0-3.57,0-5.35,0-.38-.13-.81.23-1.12.38,0,.8.12,1.07-.3a.53.53,0,0,1,.44.16,3.25,3.25,0,0,1,.41.67.44.44,0,0,0,.22.43.34.34,0,0,1,.16.23,1,1,0,0,1,0,.3c0,.47.44.56.69.81S209,80.54,208.89,80.79Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1273",
    d: "M206.94,77.68c-.21,1-.68.65-1.17.22l-.48-.71c-.16-.44-.56-.92.23-1.18l.49.46C206.52,76.72,207.05,77,206.94,77.68Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1236",
    d: "M205.52,76c-.39.33-.16.79-.23,1.18a1.62,1.62,0,0,1-.72-.72c.41-.33.19-.8.25-1.21A1.36,1.36,0,0,1,205.52,76Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1274",
    d: "M164.82,240.87c-1,.72-2.3.8-3.35,1.43l-.1,0h-.11a.42.42,0,0,1-.16-.27c0-.43.41-.5.59-.76.86-.35,1.85-.2,2.69-.65l.43,0c.09,0,.12.09.09.13S164.85,240.87,164.82,240.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1275",
    d: "M163.14,237.52c-.19,0-.47.14-.54.06-.24-.26.06-.39.24-.5s.68-.35,1-.52.42-.33.6,0-.08.36-.26.43C163.82,237.1,163.33,237,163.14,237.52Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1276",
    d: "M164.82,240.87c0-.06,0-.13,0-.2a1.18,1.18,0,0,1,1-.27A1.43,1.43,0,0,1,164.82,240.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1277",
    d: "M152.58,241.87c.18-.44.77-.13,1-.52h0c.78-.29,1.65.07,2.42-.29.39,0,.8-.25,1.17.05l.24.24c.08.05.11.09.08.14s-.05.07-.08.07C155.79,241.7,154.22,242.26,152.58,241.87Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1278",
    d: "M157.15,241.11l-1,.23c-.19-.22-.52,0-.71-.23l.26-.24a1.73,1.73,0,0,1,.71-.31,3.16,3.16,0,0,0,1.52-.18h.15a1.69,1.69,0,0,1,1,.26c-.28.73-1,.09-1.43.46Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1279",
    d: "M157.64,241.1c.37-.49,1.07,0,1.43-.46l.72,0c.29.21.59.45-.07.48S158.34,241.11,157.64,241.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1280",
    d: "M161.69,241.3l-.48.76a.81.81,0,0,1-.94,0c-.36-.58.37-.42.46-.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1278",
    d: "M157.39,241.56v-.21l1.74,0A3.45,3.45,0,0,1,157.39,241.56Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1281",
    d: "M162.18,232.06h1C162.84,232.39,162.52,232.22,162.18,232.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1110",
    d: "M157.63,240.38v-.94c.44.17.5.54.48.94v0A.32.32,0,0,1,157.63,240.38Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1282",
    d: "M156.43,237.29l-.53-.06v-.13l.53-.07.76.06v.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1283",
    d: "M185.41,38.66c1.17.8,2.66.88,3.82,1.72,0,.23-.13.32-.31.38a26.08,26.08,0,0,1-4.18-1.14,9,9,0,0,0-1.31-.48c-.41-.2-1-.2-1.12-.75,0-.16,0-.31,0-.47l.27-.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1284",
    d: "M169.13,50.14l-.73-.23c-.83.32-1.44-.33-2.16-.48-.24-.16-.53-.24-.7-.49V35.09l1,0a2.6,2.6,0,0,1,1.3,0A11.42,11.42,0,0,1,171,36a3.36,3.36,0,0,1-.24,1.4c-.07.2-.24.15-.39.15-.35-.06-.68-.26-1-.1-.09,3.1.1,6.19-.11,9.28A13.86,13.86,0,0,1,169.13,50.14Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1285",
    d: "M182.31,38.39l1.19.51c-.07.44.42.62.49,1a2.58,2.58,0,0,1-.25,2.05l-.22,0-3.85-1.43-.23-.25c-.14-.47.33-.27.48-.43.26-.45-.16-.43-.37-.49-1-.27-2-.52-3-.78a17.55,17.55,0,0,1-1.78-.37c-.36-.08-.35-.13-.12-.58a14.29,14.29,0,0,1,4.29.76c.77.27.78-.2.72-.74l1.68.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1286",
    d: "M171,36a21.16,21.16,0,0,1-3.34-.73.21.21,0,0,1,0-.31,3.27,3.27,0,0,1,1.23-.3c.28.1.61-.06.87.15s.65.45,1,0c.21-.27.49-.46.71-.71l.49.24a.32.32,0,0,1,0,.47l.24.25c-.08.23-.94.53.06.68a.52.52,0,0,1,.5.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1287",
    d: "M174.66,37.67c-.26.54.21.43.46.51l1.44.44c-1.12.05-2.24-.44-3.35,0l-.73-.48c-.13-.17-.61,0-.47-.43A3.22,3.22,0,0,1,174.66,37.67Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1288",
    d: "M178.05,37.66a10.46,10.46,0,0,1-3.14-.85A3.59,3.59,0,0,1,178.05,37.66Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1289",
    d: "M179.67,37.69c.28.27.6.64.32,1s-.71,0-1-.22c0-.39-.57-1.07.47-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1290",
    d: "M172,37.71l.47.43c-.51.12-.94-.21-1.42-.25,0-.22,0-.34.28-.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1291",
    d: "M171.34,37.66l-.28.23-1-.22c0-.22,0-.35.26-.24l.44,0Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M198.35,63.31c.41.42,1.2.58,1,1.43C198.9,64.32,198,64.21,198.35,63.31Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    className: "cls-649",
    d: "M202.39,67.63a2.11,2.11,0,0,1-1.9-1.91l1.45,1.19Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1292",
    d: "M200.21,64.55c.5.23.76.42.84.81C200.61,65.34,200.45,65.06,200.21,64.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1293",
    d: "M190.68,44.88l-1.24-.69a8.13,8.13,0,0,1,.13-3,.4.4,0,0,1,.49-.21,16.2,16.2,0,0,1,4.7,2.07c-.84.92-.5,2-.49,3.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1294",
    d: "M194.76,43l-5-2c-.42.11-.69,0-.78-.46l.28-.22.71.2c1.29.7,2.85.6,4.09,1.44C194.16,42.44,195.17,42.22,194.76,43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1295",
    d: "M169.84,34.82h-1c-.36.28-.84-.06-1.2.23,0,.08,0,.15,0,.22a1.88,1.88,0,0,1-1.21-.23c-.62-.32-.87-.64,0-.94.35-.26.71.08,1.06,0a2.24,2.24,0,0,1,1.57.47C169.39,34.6,169.67,34.54,169.84,34.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1296",
    d: "M167.45,34.34l-.95-.23c0-.08,0-.16,0-.23h.72C167.35,34,167.6,34.07,167.45,34.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1297",
    d: "M171.52,34.11c.06.53-.18.77-.71.71-.25-.36-.83-.2-1.07-.68C170.34,33.56,171,34.49,171.52,34.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    className: "cls-870",
    d: "M167.45,34.34l-.24-.46c.67-.14,1.27.21,1.92.24v.46A5.06,5.06,0,0,0,167.45,34.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1173",
    d: "M172,34.82v-.47c.21,0,.55-.06.57.18C172.62,35,172.22,34.77,172,34.82Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1298",
    d: "M189.49,35.78c-.43-.7-1.39-.72-1.9-1.54a6.18,6.18,0,0,1,2.13,1.07C189.87,35.58,189.93,35.81,189.49,35.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1299",
    d: "M189.49,35.78c.2-.09.23-.27.23-.47l1,.47c0,.16,0,.32,0,.48A1.37,1.37,0,0,1,189.49,35.78Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1300",
    d: "M157.63,31.23a.78.78,0,0,1,1.22-.23.34.34,0,0,1,0,.48c.16,1.56-.91.05-1.2.48-.09-.29-.6-.24-.51-.63C157.14,31.26,157.45,31.26,157.63,31.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1301",
    d: "M156.88,34.35l-1-.06C156.21,33.43,156.56,34.34,156.88,34.35Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1302",
    d: "M159.54,31.23c.41.09.83.14,1.24.26.6.17.53.54.22.94-.42-.43-1.21-.06-1.54-.7A.42.42,0,0,1,159.54,31.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1303",
    d: "M159.55,31.72c.4.41,1.25-.1,1.45.71-.49,0-1,.11-1.43-.26A.28.28,0,0,1,159.55,31.72Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1304",
    d: "M159.55,31.72c0,.15,0,.3,0,.45l-.74-.69c0-.16,0-.32,0-.48l.69.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1305",
    d: "M180.57,235.8l1.51-1.39a.6.6,0,0,1,.25-.42,3.1,3.1,0,0,1,1.82-.55c.61,0,1.13.39,1.73.23.16.51-.42.46-.46.77l-1.85.95A6.54,6.54,0,0,0,182,236a8.51,8.51,0,0,1-1.24.06A.4.4,0,0,1,180.57,235.8Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M181.81,235.84a2.69,2.69,0,0,1,1.76-.45l-2.47,1.7-2.67.46.76-.51a3.65,3.65,0,0,0,.49-.74c.22-.32.38-.72.89-.5l.09.06C181.05,236.21,181.43,235.71,181.81,235.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1306",
    d: "M184.15,233.44l-1.85.74c-.3.12-.66,0-1,.23-.54.22-1.07.47-1.63.66-.82.28-1.46.26-1.26-.91a6,6,0,0,0,0-.95h0c.15-.14,0-.38.18-.53s.35-.32.56-.45c.68-.11.39-.95.9-1.2.49,0,.17-.58.52-.67v-.05c1,.55,1.39-.61,2.16-.67a5.48,5.48,0,0,1,.22,2.54c-.11,1,.24,1.33,1.2,1A1.74,1.74,0,0,1,184.15,233.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1307",
    d: "M166.73,242.74l-3.32.52A4.83,4.83,0,0,1,166.73,242.74Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1308",
    d: "M157.16,242.55c1-.08,1.85-.83,2.89-.47.18.46-.49.18-.44.52a7.74,7.74,0,0,1-2.44.25.2.2,0,0,1-.07-.2C157.12,242.58,157.14,242.55,157.16,242.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1309",
    d: "M159.61,242.6c-.23-.5.45-.21.44-.52a.81.81,0,0,0,.22,0c.31,0,.63-.26.94,0a2.56,2.56,0,0,1,0,.27,1,1,0,0,0-.11.17c-.19.25-.42.2-.66.09Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1310",
    d: "M160.49,242.59l.67-.09c-.24.52-.75.54-1.22.8C160,242.81,160.35,242.81,160.49,242.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1311",
    d: "M157.16,242.55v.3A2,2,0,0,1,156,243,3.1,3.1,0,0,1,157.16,242.55Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1312",
    d: "M157.14,244.21l0-.45c.21,0,.57-.09.58.17S157.38,244.17,157.14,244.21Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1313",
    d: "M149.58,243c-.31.08-.51.11-.66,0s0-.18,0-.2C149.19,242.55,149.37,242.71,149.58,243Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1314",
    d: "M193.31,60.44a4.31,4.31,0,0,1-2-1.71c.81.4,1.75.63,2,1.69Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1315",
    d: "M189,40.6l.78.46c-.15,1,.31,2.13-.29,3.13l-2.28-.78L183.74,42V39.62a.34.34,0,0,1,.45,0,2.13,2.13,0,0,0,1,.49,2.06,2.06,0,0,1-1-.54c.11-.29.3-.31.53-.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1316",
    d: "M206.94,77.68,206,76.47v-.26h.25c.55.26.81.79,1.16,1.24.19.28.19.48-.23.47Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1317",
    d: "M207.94,79.07a.76.76,0,0,0,0-.21,1.21,1.21,0,0,1,1.22.48l-.28.27C208.38,79.72,208.13,79.44,207.94,79.07Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1318",
    d: "M207.2,77.92a.48.48,0,0,0,.23-.47c.67.17.21.64.26,1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1012",
    d: "M210.29,88.91l-1.5-2.34.82.38,1.17,1.25c.12.42.44.87-.2,1.15Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1319",
    d: "M211.05,88.91c.18.29.37.57.53.86s.08.4-.16.44-.31-.17-.39-.35A.86.86,0,0,1,211.05,88.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1272",
    d: "M211.05,88.91c0,.32,0,.63,0,1a.7.7,0,0,1-.45-.51c.37-.33.16-.76.2-1.15C211.1,88.35,211,88.65,211.05,88.91Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1320",
    d: "M207.94,79.07l.91.54c.16.26.33.52.49.79s.34.33.11.48-.37,0-.56-.09l-.25-.5c-.27-.29-.81-.38-.71-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1025",
    d: "M184.69,227.94c0-.45.26-.71.74-.69,0,.39,0,.78,0,1.17-.17.29-.46.24-.72.25A.55.55,0,0,1,184.69,227.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1321",
    d: "M184.69,227.94v.73a.7.7,0,0,1-.5.71C183.26,228.53,184.49,228.41,184.69,227.94Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1322",
    d: "M182.53,228.44v.47c-.25-.22-.71.59-.79-.11S182.25,228.54,182.53,228.44Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1323",
    d: "M157.63,240.38l.47,0a1.69,1.69,0,0,1-1.65.24c-.06-.06-.08-.11-.06-.17s0-.08.06-.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1324",
    d: "M156.45,240.39v.25c-.18.26-.45.23-.72.23v-.24C155.81,240.1,156.11,240.18,156.45,240.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1144",
    d: "M166.25,49.18l2.15.73c-.07.65-.58.42-1,.47-.51-.56-1.33-.52-1.9-1C165.6,48.83,166,49.11,166.25,49.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1325",
    d: "M167.22,50.38l1.89,1.19c-1,.43-1.58-.49-2.38-.71v-.23c-.08-.06-.11-.11-.08-.16s0-.08.08-.08Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1326",
    d: "M166.73,50.39v.24a1.18,1.18,0,0,1-1.14-.54C166.1,49.83,166.32,50.51,166.73,50.39Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1327",
    d: "M166.25,49.18c-.26,0-.54,0-.7.24-.11-.09-.3-.17-.32-.28s.18-.17.31-.2S166.08,48.9,166.25,49.18Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1328",
    d: "M170.33,52.05c.45.26,1.29,0,1.19,1l-1.19-.49A.32.32,0,0,1,170.33,52.05Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1329",
    d: "M170.33,52.05v.48c-.41-.3-1.1-.26-1.2-1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1330",
    d: "M176.55,50.13l1.21.65c-.53.25-.86,0-1.21-.16C176.53,50.46,176.29,50.3,176.55,50.13Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1331",
    d: "M179.92,39.89l-.48.43-.95-.48c-.07-.22,0-.32.23-.25Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1332",
    d: "M178.72,39.59l-.23.25c-.31-.2-.74-.13-1-.47C177.92,39.41,178.37,39.24,178.72,39.59Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1333",
    d: "M170.58,51.1c-.51.21-.74-.11-1-.47A1.29,1.29,0,0,1,170.58,51.1Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1334",
    d: "M170.36,37.43l-.26.24c-.28.08-.5-.11-.73-.21C169.68,37.05,170,37.18,170.36,37.43Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1335",
    d: "M155.47,241.11c.26,0,.54-.05.71.23h-2.62C154.15,240.87,154.84,241.22,155.47,241.11Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1336",
    d: "M177.14,236.14a.8.8,0,0,1,1.11-.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1270",
    d: "M179.68,236.3c.22.5-.23.55-.49.74A.76.76,0,0,1,179.68,236.3Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1337",
    d: "M181.35,234.41c.28-.26.56-.45,1-.23l-.22.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1338",
    d: "M180.63,230.36a2.4,2.4,0,0,1-.08.77c-.22.47-.36.23-.44-.1S180.13,230.33,180.63,230.36Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1339",
    d: "M179.21,232.23c0,.31-.17.5-.5.51s-.3,0-.23-.24C178.74,232.48,178.83,232,179.21,232.23Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1259",
    d: "M178.48,232.5l.23.24a.47.47,0,0,1-.24.47C178.3,233,177.84,232.73,178.48,232.5Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    className: "cls-809",
    d: "M207.93,79.34c.23.32.47.64.71,1C208.16,80.16,207.6,80.09,207.93,79.34Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1340",
    d: "M184.7,39.37a.54.54,0,0,0-.48.24h-.48c-.33-.16-.79-.27-.24-.72A2.13,2.13,0,0,1,184.7,39.37Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1341",
    d: "M167.69,35.06c.34-.39.8-.18,1.2-.23C168.56,35.23,168.09,35,167.69,35.06Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M181.81,235.84c-.38.15-.76.51-1.15,0C181.05,236,181.42,235.43,181.81,235.84Z",
    transform: "translate(-8.9 -13.51)"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1340",
    d: "M184.22,39.61a3.71,3.71,0,0,1,1.72.76c-.8-.2-1.39-.15-1.72-.76Z",
    transform: "translate(-8.9 -13.51)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareCoLogo);
export default __webpack_public_path__ + "static/media/softwareCo-logo.d037273882c5bc031052b312892a20c2.svg";
export { ForwardRef as ReactComponent };